export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ApiDealStatusType: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Decimal2: { input: any; output: any; }
  Decimal4: { input: any; output: any; }
  Decimal6: { input: any; output: any; }
  Duration: { input: any; output: any; }
  ExchangeJSON: { input: any; output: any; }
  GraphQLUBigInt64: { input: any; output: any; }
  IntersectionOperation: { input: any; output: any; }
  JSON: { input: any; output: any; }
  StringOrInt: { input: any; output: any; }
  Upload: { input: any; output: any; }
  _text: { input: any; output: any; }
  bigint: { input: any; output: any; }
  interval: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** The account info for the caller, derived from their API key. */
export type AccountForCaller = {
  __typename?: 'AccountForCaller';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type AccountNetworkCreateParams = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  account_uid?: InputMaybe<Scalars['String']['input']>;
  allow_third_party_fees_platform_share_read?: InputMaybe<Scalars['Boolean']['input']>;
  allow_third_party_fees_platform_share_write?: InputMaybe<Scalars['Boolean']['input']>;
  allow_third_party_fees_read?: InputMaybe<Scalars['Boolean']['input']>;
  allow_third_party_fees_write?: InputMaybe<Scalars['Boolean']['input']>;
  dmp_sources?: InputMaybe<Scalars['String']['input']>;
  dsp_restriction?: InputMaybe<Array<DspRestrictionInput>>;
  dsp_restriction_mode?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization_type?: InputMaybe<Scalars['String']['input']>;
  partner_uid?: InputMaybe<Scalars['String']['input']>;
  retargeting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  third_party_partners?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AccountNetworkUpdateParams = {
  allow_third_party_fees_platform_share_read?: InputMaybe<Scalars['Boolean']['input']>;
  allow_third_party_fees_platform_share_write?: InputMaybe<Scalars['Boolean']['input']>;
  allow_third_party_fees_read?: InputMaybe<Scalars['Boolean']['input']>;
  allow_third_party_fees_write?: InputMaybe<Scalars['Boolean']['input']>;
  dmp_sources?: InputMaybe<Scalars['String']['input']>;
  dsp_restriction?: InputMaybe<Array<DspRestrictionInput>>;
  dsp_restriction_mode?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  partner_uid?: InputMaybe<Scalars['String']['input']>;
  retargeting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  third_party_partners?: InputMaybe<Array<Scalars['String']['input']>>;
};

export const AdFormat = {
  Banner: 'Banner',
  Video: 'Video'
} as const;

export type AdFormat = typeof AdFormat[keyof typeof AdFormat];
export type AdvertiserForCaller = {
  __typename?: 'AdvertiserForCaller';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type AgeRange = {
  __typename?: 'AgeRange';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type AgeRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Search result for a single input name.
 * - match: ID of the app group when a case-insensitive exact match exists, null otherwise.
 * - suggestions: up to suggestion_limit fuzzy matches ordered by descending similarity.
 */
export type AppGroupSearchResult = {
  __typename?: 'AppGroupSearchResult';
  input: Scalars['String']['output'];
  match?: Maybe<Scalars['ID']['output']>;
  suggestions: Array<AppGroupSuggestion>;
};

/** Single fuzzy-match suggestion (pg_trgm similarity) for an App Group input name. */
export type AppGroupSuggestion = {
  __typename?: 'AppGroupSuggestion';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AudiencePricingInput = {
  operator: Scalars['String']['input'];
  pricing_by_org?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  totals?: InputMaybe<Scalars['ExchangeJSON']['input']>;
};

export type AudienceReportStatusResponse = {
  __typename?: 'AudienceReportStatusResponse';
  id: Scalars['uuid']['output'];
  report_status?: Maybe<Scalars['String']['output']>;
};

export type AudienceShare = {
  __typename?: 'AudienceShare';
  account_id?: Maybe<Scalars['String']['output']>;
  account_uid?: Maybe<Scalars['String']['output']>;
  audience_external_openaudience_id?: Maybe<Scalars['String']['output']>;
  cpm_cap?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instance_uid?: Maybe<Scalars['String']['output']>;
  modified_date?: Maybe<Scalars['String']['output']>;
  recipient_account_id?: Maybe<Scalars['String']['output']>;
  recipient_account_name?: Maybe<Scalars['String']['output']>;
  revenue_method?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  segment_account?: Maybe<Scalars['String']['output']>;
  segment_id?: Maybe<Scalars['String']['output']>;
  segment_provider?: Maybe<Scalars['String']['output']>;
  third_party_revenue?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  v?: Maybe<Scalars['String']['output']>;
};

export type AudienceShareCreateParams = {
  audience_external_openaudience_id: Scalars['String']['input'];
  cpm_cap?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  recipient_account_id: Scalars['String']['input'];
  revenue_method?: InputMaybe<Scalars['String']['input']>;
  third_party_revenue?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceShareDeleteResult = AudienceShareDeleted | Error;

export type AudienceShareDeleted = {
  __typename?: 'AudienceShareDeleted';
  deletedUID: Scalars['uuid']['output'];
};

export type AudienceShareResult = AudienceShare | Error;

export type AudienceShareUpdateParams = {
  third_party_revenue: Scalars['String']['input'];
  uid: Scalars['uuid']['input'];
};

export type AudienceUsedByDeal = {
  __typename?: 'AudienceUsedByDeal';
  audience_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  obj: Scalars['ExchangeJSON']['output'];
};

export type AudienceUsedByOutput = {
  __typename?: 'AudienceUsedByOutput';
  deals: Array<AudienceUsedByDeal>;
};

export type Audience_Categories_Reach_All = {
  __typename?: 'Audience_Categories_Reach_All';
  connectedtv?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  cookiesWithRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  desktop?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  display?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  idlXiWithRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  idlXyWithRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  ip?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  ipWithRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  mobileDevicesWithRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  mobileapp?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  mobileweb?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  sfAccountId?: Maybe<Scalars['String']['output']>;
  sfAccountName?: Maybe<Scalars['String']['output']>;
  tablet?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  total?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalmaid5?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalmaip?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalmau?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  uniqueConnectedTVDeviceIDsWithRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  uniqueUsersViaConnectedTVWithRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  video?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
};

export type AuditTrailEntry = {
  __typename?: 'AuditTrailEntry';
  account_uid?: Maybe<Scalars['String']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  api_version?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Scalars['ExchangeJSON']['output']>;
  instance_uid?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  obj_id?: Maybe<Scalars['String']['output']>;
  obj_type?: Maybe<Scalars['String']['output']>;
  obj_type_full?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['ExchangeJSON']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  real_name?: Maybe<Scalars['String']['output']>;
  real_user?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  trace_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AuditTrailUser>;
  virtual_workas?: Maybe<Scalars['String']['output']>;
};

export type AuditTrailOutput = {
  __typename?: 'AuditTrailOutput';
  has_more: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  objects: Array<AuditTrailEntry>;
  offset: Scalars['Int']['output'];
};

export type AuditTrailUser = {
  __typename?: 'AuditTrailUser';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BaseSegment = {
  account_id?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['timestamptz']['output'];
  deleted: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  type_full: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
};

/**
 * Delivery for one Aqua advertiser (the owning account). No pacing: an
 * advertiser has no goal or flight.
 */
export type BidderAdvertiserDelivery = {
  __typename?: 'BidderAdvertiserDelivery';
  /** The requested advertiser id this row answers for. */
  id: Scalars['ID']['output'];
  /**
   * Always present on an answered row: an advertiser with no delivery reads as
   * zero counters.
   */
  metrics?: Maybe<DeliveryMetrics>;
};

/**
 * A BidderCreative represents ad creative assets including banners, video, and audio creatives
 * with associated markup and metadata.
 */
export type BidderCreative = {
  __typename?: 'BidderCreative';
  /** The parent account ID. */
  account_id: Scalars['String']['output'];
  /** The parent account UID. */
  account_uid: Scalars['String']['output'];
  /** The format of the creative asset. */
  ad_format: AdFormat;
  /** The advertiser's primary domain. */
  advertiser_domain?: Maybe<Scalars['String']['output']>;
  /** The date when the creative was created. */
  created_date: Scalars['timestamptz']['output'];
  /** external id of creative */
  crid: Scalars['String']['output'];
  /**
   * Delivery counters for this creative, from the Aqua fact tables' per-creative
   * grain. Creatives have no flight, so FULL_FLIGHT is null.
   */
  delivery_metrics?: Maybe<DeliveryMetrics>;
  /** Height in pixels. Required for banner creatives, null for video/audio. */
  height?: Maybe<Scalars['StringOrInt']['output']>;
  /** List of IAB taxonomy categories. Uses @setApiField to convert from ox-api-core Set format. */
  iab_categories?: Maybe<Array<Scalars['String']['output']>>;
  /** The unique identifier for the BidderCreative. */
  id: Scalars['String']['output'];
  /**
   * List of industries (brand groups) this creative belongs to, as ids from
   * market_brand_group_options. Same vocabulary as the exchange's
   * creativeinfo.industries.
   */
  industries?: Maybe<Array<Scalars['String']['output']>>;
  /** The instance this object lives on. */
  instance_uid?: Maybe<Scalars['String']['output']>;
  /** ISO 639-1 language code. */
  language?: Maybe<Scalars['String']['output']>;
  /** The raw markup or tag payload. */
  markup_payload: Scalars['String']['output'];
  /** The type of markup or tag used. */
  markup_type: MarkupType;
  /** The date when the creative was last modified. */
  modified_date: Scalars['timestamptz']['output'];
  /** The creative name or label. */
  name: Scalars['String']['output'];
  /** The current status of the creative. */
  status: BidderCreativeStatus;
  /** The unique identifier (uid) for the BidderCreative. */
  uid: Scalars['String']['output'];
  /** Width in pixels. Required for banner creatives, null for video/audio. */
  width?: Maybe<Scalars['StringOrInt']['output']>;
};


/**
 * A BidderCreative represents ad creative assets including banners, video, and audio creatives
 * with associated markup and metadata.
 */
export type BidderCreativeDelivery_MetricsArgs = {
  range?: InputMaybe<DeliveryRange>;
};

export type BidderCreativeCreateParams = {
  /** The parent account UID. Optional — inferred from API key session when omitted. */
  account_uid?: InputMaybe<Scalars['String']['input']>;
  /** The format of the creative asset. */
  ad_format: AdFormat;
  /** The advertiser's primary domain. */
  advertiser_domain?: InputMaybe<Scalars['String']['input']>;
  /** external id of creative */
  crid: Scalars['String']['input'];
  /** Height in pixels. Required for banner creatives (1-10000), not applicable for video/audio. */
  height?: InputMaybe<Scalars['StringOrInt']['input']>;
  /** List of IAB taxonomy categories. */
  iab_categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of industries (brand groups), as ids from market_brand_group_options. */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO 639-1 language code. Defaults to 'en'. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The raw markup or tag payload. */
  markup_payload: Scalars['String']['input'];
  /** The type of markup or tag used. */
  markup_type: MarkupType;
  /** The creative name or label. Must be unique within the account. */
  name: Scalars['String']['input'];
  /** status */
  status: BidderCreativeStatus;
  /** Width in pixels. Required for banner creatives (1-10000), not applicable for video/audio. */
  width?: InputMaybe<Scalars['StringOrInt']['input']>;
};

/** basic api response for listing bidder creatives supports pagination */
export type BidderCreativeMgmtResponse = {
  __typename?: 'BidderCreativeMgmtResponse';
  has_more: Scalars['Boolean']['output'];
  limit: Scalars['StringOrInt']['output'];
  objects: Array<BidderCreative>;
  offset: Scalars['StringOrInt']['output'];
};

export const BidderCreativeStatus = {
  Active: 'Active',
  Paused: 'Paused'
} as const;

export type BidderCreativeStatus = typeof BidderCreativeStatus[keyof typeof BidderCreativeStatus];
export type BidderCreativeUpdateParams = {
  /** The format of the creative asset. */
  ad_format?: InputMaybe<AdFormat>;
  /** The advertiser's primary domain. */
  advertiser_domain?: InputMaybe<Scalars['String']['input']>;
  /** Height in pixels. */
  height?: InputMaybe<Scalars['StringOrInt']['input']>;
  /** List of IAB taxonomy categories. */
  iab_categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of industries (brand groups), as ids from market_brand_group_options. */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO 639-1 language code. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The raw markup or tag payload. */
  markup_payload?: InputMaybe<Scalars['String']['input']>;
  /** The type of markup or tag used. */
  markup_type?: InputMaybe<MarkupType>;
  /** The creative name or label. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The current status of the creative. */
  status?: InputMaybe<BidderCreativeStatus>;
  /** Width in pixels. */
  width?: InputMaybe<Scalars['StringOrInt']['input']>;
};

/**
 * Server-computed delivery state for a BidderOrder or BidderLineItem.
 * Stamped on save from user-intent status, flight dates, archive flag, and
 * upstream delivery blockers. Read-only — clients cannot set this directly.
 */
export const BidderDeliveryStatus = {
  /** Currently delivering (within flight, no upstream blockers). */
  Active: 'active',
  /** User soft-deleted. */
  Archived: 'archived',
  /** Flight ended; cannot be resumed. */
  Completed: 'completed',
  /** Off, flight has not started. A never-activated order or line item is never paused. */
  Draft: 'draft',
  /** In-flight and on, but with delivery issues (e.g. one or more child line items stalled). */
  LiveWarning: 'live_warning',
  /** User paused an in-flight order or line item. */
  Paused: 'paused',
  /** User intent is Active and start_date is in the future. */
  Scheduled: 'scheduled',
  /** Within flight dates but blocked by an upstream gate (e.g. paused parent, expired deal, no active creatives, no active children). */
  Stalled: 'stalled'
} as const;

export type BidderDeliveryStatus = typeof BidderDeliveryStatus[keyof typeof BidderDeliveryStatus];
/** A BidderLineItem represents a line item within a bidder order for programmatic campaigns. */
export type BidderLineItem = {
  __typename?: 'BidderLineItem';
  /** The parent account ID. */
  account_id: Scalars['String']['output'];
  /** The parent account UID. */
  account_uid: Scalars['String']['output'];
  /** The ad format for the line item. */
  ad_format?: Maybe<AdFormat>;
  /** The bid scheme. */
  bid_scheme?: Maybe<BidderLineItemBidScheme>;
  /** The parent bidder order UID. */
  bidder_order_uid: Scalars['String']['output'];
  /** The daily budget for the line item. */
  budget_daily?: Maybe<Scalars['Decimal']['output']>;
  /** The total budget for the line item. */
  budget_total?: Maybe<Scalars['Decimal']['output']>;
  /** The date when the line item was created. */
  created_date: Scalars['timestamptz']['output'];
  /** Day parting reference frame. Null on line items created before day parting existed. */
  daypart_mode?: Maybe<DaypartMode>;
  /** Weekly day parting allow grid. Null or empty means the line item delivers 24/7. */
  daypart_schedule?: Maybe<DaypartSchedule>;
  /** The single IANA time zone the day parting schedule is anchored to for pacing. */
  daypart_timezone?: Maybe<Scalars['String']['output']>;
  /** The associated deal ID. */
  deal_id?: Maybe<Scalars['String']['output']>;
  /**
   * Delivered actuals, read on this entity's own grain: every figure is its
   * own, even where sibling line items share a deal. Distinct from
   * delivery_status, which is lifecycle state.
   */
  delivery_metrics?: Maybe<DeliveryMetrics>;
  /** Delivered actuals against this entity's goal, full-flight-to-date. */
  delivery_pacing?: Maybe<DeliveryPacing>;
  /**
   * Server-computed delivery state. Derived on save from status, flight dates,
   * archive flag, parent order state, linked deal state, and linked creatives state. Read-only.
   */
  delivery_status: BidderDeliveryStatus;
  /**
   * Server-computed reason explaining the current delivery_status. Populated for
   * stalled (specific blocker), scheduled (flight not started), and completed
   * (flight ended); null otherwise. Read-only.
   */
  delivery_status_reason?: Maybe<BidderLineItemDeliveryStatusReason>;
  /** The end date of the line item. */
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  /** Frequency capping settings for the line item. */
  frequency_capping: Array<FrequencyCapping>;
  /** The unique identifier for the BidderLineItem. */
  id: Scalars['String']['output'];
  /** The instance this object lives on. */
  instance_uid?: Maybe<Scalars['String']['output']>;
  /** The optional max bid price, stored in micro-dollars. */
  max_bid_price?: Maybe<Scalars['String']['output']>;
  /** The date when the line item was last modified. */
  modified_date: Scalars['timestamptz']['output'];
  /** The line item name. */
  name: Scalars['String']['output'];
  /** Parent visible to the caller; null when missing, deleted, or inaccessible. */
  order?: Maybe<BidderOrder>;
  /** The pacing strategy. */
  pacing_strategy?: Maybe<BidderLineItemPacingStrategy>;
  /** Whether this is a programmatic guaranteed line item. */
  programmatic_guaranteed: Scalars['Boolean']['output'];
  /** The region for the line item. */
  region?: Maybe<BidderLineItemRegion>;
  /** The seat ID. */
  seat_id?: Maybe<Scalars['String']['output']>;
  /** The start date of the line item. */
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  /** The current status of the line item. */
  status: BidderLineItemStatus;
  /** The strategy and KPI type. */
  strategy_and_kpi_type?: Maybe<BidderLineItemStrategyType>;
  /** The strategy and KPI value. */
  strategy_and_kpi_value?: Maybe<Scalars['String']['output']>;
  /** The target type. */
  target_type?: Maybe<Scalars['String']['output']>;
  /** The target value. */
  target_value?: Maybe<Scalars['String']['output']>;
  /** The unique identifier (uid) for the BidderLineItem. */
  uid: Scalars['String']['output'];
};


/** A BidderLineItem represents a line item within a bidder order for programmatic campaigns. */
export type BidderLineItemDelivery_MetricsArgs = {
  range?: InputMaybe<DeliveryRange>;
};

export const BidderLineItemBidScheme = {
  Dynamic: 'dynamic',
  Fixed: 'fixed'
} as const;

export type BidderLineItemBidScheme = typeof BidderLineItemBidScheme[keyof typeof BidderLineItemBidScheme];
export type BidderLineItemCreateParams = {
  /** The parent account UID. */
  account_uid?: InputMaybe<Scalars['String']['input']>;
  /** The ad format for the line item. */
  ad_format: AdFormat;
  /** The bid scheme. */
  bid_scheme?: InputMaybe<BidderLineItemBidScheme>;
  /** The parent bidder order UID. */
  bidder_order_uid: Scalars['String']['input'];
  /** The daily budget for the line item. */
  budget_daily?: InputMaybe<Scalars['String']['input']>;
  /** The total budget for the line item. */
  budget_total?: InputMaybe<Scalars['String']['input']>;
  /** Day parting reference frame. Only meaningful when daypart_schedule is set. */
  daypart_mode?: InputMaybe<DaypartMode>;
  /** Weekly day parting allow grid. Omit for 24/7 delivery. */
  daypart_schedule?: InputMaybe<DaypartScheduleInput>;
  /**
   * A single IANA time zone for day parting (e.g. America/Chicago). Required
   * whenever daypart_schedule is set, in both modes.
   */
  daypart_timezone?: InputMaybe<Scalars['String']['input']>;
  /** The associated deal ID. */
  deal_id?: InputMaybe<Scalars['String']['input']>;
  /** The end date for the line item. */
  end_date: Scalars['timestamptz']['input'];
  /** Frequency capping settings for the line item. */
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  /** The optional max bid price, stored in micro-dollars. */
  max_bid_price?: InputMaybe<Scalars['String']['input']>;
  /** The line item name. */
  name: Scalars['String']['input'];
  /** The pacing strategy. */
  pacing_strategy?: InputMaybe<BidderLineItemPacingStrategy>;
  /** Whether this is a programmatic guaranteed line item. */
  programmatic_guaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The region for the line item. */
  region?: InputMaybe<BidderLineItemRegion>;
  /** The seat ID. */
  seat_id?: InputMaybe<Scalars['String']['input']>;
  /** The start date for the line item. */
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The initial status of the line item. */
  status?: InputMaybe<BidderLineItemStatus>;
  /** The strategy and KPI type. */
  strategy_and_kpi_type?: InputMaybe<BidderLineItemStrategyType>;
  /** The strategy and KPI value. */
  strategy_and_kpi_value?: InputMaybe<Scalars['String']['input']>;
  /** The target type. */
  target_type?: InputMaybe<Scalars['String']['input']>;
  /** The target value. */
  target_value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * What a line item needs to know about the deal it links, by exchange deal ID,
 * whether or not OA manages that deal. Resolved server side so deals created
 * outside OA (e.g. a publisher-created programmatic guaranteed deal) are
 * recognised; only these facts are exposed.
 */
export type BidderLineItemDealSummary = {
  __typename?: 'BidderLineItemDealSummary';
  /** The exchange deal ID, as stored in BidderLineItem.deal_id. */
  deal_id: Scalars['String']['output'];
  /** Region the deal's tracking runs in. A tracking-enabled deal requires the line item region to match. */
  delivery_region?: Maybe<BidderLineItemRegion>;
  /** Whether OA created and manages the deal, as opposed to a deal pasted in from elsewhere. */
  managed_by_oa: Scalars['Boolean']['output'];
  /**
   * True for a Real Time Guaranteed deal: a line item delivering it is
   * programmatic guaranteed, with bidding, pacing and dayparting governed by
   * the deal rather than by the line item.
   */
  programmatic_guaranteed: Scalars['Boolean']['output'];
  /** Whether the exchange runs delivery tracking for the deal; only then does delivery_region apply. */
  tracking_enabled: Scalars['Boolean']['output'];
};

/** Delivery for one requested line item, keyed back by its id. */
export type BidderLineItemDelivery = {
  __typename?: 'BidderLineItemDelivery';
  /**
   * The fields of this row that failed to resolve, among the ones this
   * operation selected, so a null `metrics` or `pacing` can be told from
   * an honest null: an unknown id, a not-started flight on FULL_FLIGHT, no
   * goal. Empty when nothing failed. Only the selected fields are resolved,
   * so selecting this alone is not a health check.
   */
  failed_fields: Array<DeliveryField>;
  /** The requested line item id this row answers for. */
  id: Scalars['String']['output'];
  /** Null when the id resolved to no line item or its metrics failed. */
  metrics?: Maybe<DeliveryMetrics>;
  /** Null per the delivery_pacing rules (e.g. no goal), or on failure. */
  pacing?: Maybe<DeliveryPacing>;
};

/**
 * Server-computed reason explaining a BidderLineItem's current delivery_status.
 * Populated for stalled (the specific blocker), scheduled (flight not started),
 * and completed (flight ended). Null for active / paused / draft / archived where the
 * status itself is self-explanatory.
 */
export const BidderLineItemDeliveryStatusReason = {
  /** The linked deal's end_date is in the past. */
  DealEnded: 'deal_ended',
  /** The linked deal is not Active. */
  DealNotActive: 'deal_not_active',
  /** The linked deal does not exist (or is archived). */
  DealNotFound: 'deal_not_found',
  /** The linked deal's start_date is in the future. */
  DealNotStarted: 'deal_not_started',
  /** The line item's own end_date is in the past. */
  FlightEnded: 'flight_ended',
  /** The line item's own start_date is in the future. */
  FlightNotStarted: 'flight_not_started',
  /** No deal_id is set on the line item. */
  MissingDealId: 'missing_deal_id',
  /** The parent order is missing or could not be loaded. */
  MissingParentOrder: 'missing_parent_order',
  /** No Active, non-archived creative is linked to the line item. */
  NoActiveCreative: 'no_active_creative',
  /** The parent order's user-intent status is not Active. */
  ParentOrderNotActive: 'parent_order_not_active'
} as const;

export type BidderLineItemDeliveryStatusReason = typeof BidderLineItemDeliveryStatusReason[keyof typeof BidderLineItemDeliveryStatusReason];
/**
 * Forecast for a prospective or saved line item, per the Forecaster API Schema
 * (v1). The three forecast fields are null when no forecast was possible;
 * there is no separate status field.
 */
export type BidderLineItemForecast = {
  __typename?: 'BidderLineItemForecast';
  available_bid_requests?: Maybe<ForecastVolumeBand>;
  cpm?: Maybe<ForecastCpmBand>;
  meta: ForecastMeta;
  /**
   * Parts of the received targeting document the forecast did not use, plus
   * the line-item-level fields the forecaster never sees (frequency capping,
   * day parting). The union of the two split lists below.
   */
  unforecasted_fields: Array<Scalars['String']['output']>;
  /** Line-item fields the forecaster never sees (frequency capping, day parting). */
  unforecasted_line_item_fields: Array<Scalars['String']['output']>;
  /** Targeting dimensions the forecaster received but did not use. */
  unforecasted_targeting_fields: Array<Scalars['String']['output']>;
  viability?: Maybe<ForecastViability>;
  warnings: Array<ForecastWarning>;
};

/**
 * Line-item context for a draft forecast. Mirrors the bidder line item fields
 * and units: dates as datetimes, monetary values as micro-dollar integers
 * passed as strings.
 */
export type BidderLineItemForecastContextParams = {
  /** Micro-dollars for budget-type line items; impression count for impressions-type. */
  budget_total: Scalars['String']['input'];
  /** Only feeds unforecasted_fields; the forecaster never sees day parting. */
  daypart_schedule?: InputMaybe<DaypartScheduleInput>;
  end_date: Scalars['timestamptz']['input'];
  /** Only feeds unforecasted_fields; the forecaster never sees frequency caps. */
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  /** Optional max bid price in micro-dollars; the forecaster applies its own fallback when absent. */
  max_bid_price?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  strategy_and_kpi_type?: InputMaybe<BidderLineItemStrategyType>;
  /** Target cost-per metric in micro-dollars; only used with a target_* strategy. */
  strategy_and_kpi_value?: InputMaybe<Scalars['String']['input']>;
  /** The budget constraint type: budget or impressions. */
  target_type: Scalars['String']['input'];
  /** Required when target_type is impressions. */
  target_value?: InputMaybe<Scalars['String']['input']>;
};

export const BidderLineItemPacingStrategy = {
  Asap: 'asap',
  Even: 'even'
} as const;

export type BidderLineItemPacingStrategy = typeof BidderLineItemPacingStrategy[keyof typeof BidderLineItemPacingStrategy];
export const BidderLineItemRegion = {
  Asia: 'ASIA',
  Eu: 'EU',
  Us: 'US'
} as const;

export type BidderLineItemRegion = typeof BidderLineItemRegion[keyof typeof BidderLineItemRegion];
export const BidderLineItemStatus = {
  Active: 'Active',
  Paused: 'Paused'
} as const;

export type BidderLineItemStatus = typeof BidderLineItemStatus[keyof typeof BidderLineItemStatus];
export const BidderLineItemStrategyType = {
  MaximizeClicks: 'maximize_clicks',
  MaximizeCompletedViews: 'maximize_completed_views',
  MaximizeConversions: 'maximize_conversions',
  MaximizeImpressions: 'maximize_impressions',
  TargetCpa: 'target_cpa',
  TargetCpc: 'target_cpc',
  TargetCpcv: 'target_cpcv',
  TargetCpm: 'target_cpm'
} as const;

export type BidderLineItemStrategyType = typeof BidderLineItemStrategyType[keyof typeof BidderLineItemStrategyType];
export type BidderLineItemUpdateParams = {
  /** The ad format for the line item. */
  ad_format?: InputMaybe<AdFormat>;
  /** The bid scheme. */
  bid_scheme?: InputMaybe<BidderLineItemBidScheme>;
  /** The parent bidder order UID. */
  bidder_order_uid?: InputMaybe<Scalars['String']['input']>;
  /** The daily budget for the line item. */
  budget_daily?: InputMaybe<Scalars['String']['input']>;
  /** The total budget for the line item. */
  budget_total?: InputMaybe<Scalars['String']['input']>;
  /** Day parting reference frame. Only meaningful when daypart_schedule is set. */
  daypart_mode?: InputMaybe<DaypartMode>;
  /**
   * Weekly day parting allow grid. Send an empty object to clear day parting
   * (the line item then delivers 24/7); omit the field to leave it unchanged.
   */
  daypart_schedule?: InputMaybe<DaypartScheduleInput>;
  /**
   * A single IANA time zone for day parting (e.g. America/Chicago). Required
   * whenever daypart_schedule is set, in both modes.
   */
  daypart_timezone?: InputMaybe<Scalars['String']['input']>;
  /** The associated deal ID. */
  deal_id?: InputMaybe<Scalars['String']['input']>;
  /** The end date for the line item. */
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Frequency capping settings for the line item. */
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  /** The optional max bid price, stored in micro-dollars. */
  max_bid_price?: InputMaybe<Scalars['String']['input']>;
  /** The line item name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The pacing strategy. */
  pacing_strategy?: InputMaybe<BidderLineItemPacingStrategy>;
  /** Whether this is a programmatic guaranteed line item. */
  programmatic_guaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The region for the line item. */
  region?: InputMaybe<BidderLineItemRegion>;
  /** The seat ID. */
  seat_id?: InputMaybe<Scalars['String']['input']>;
  /** The start date for the line item. */
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The status of the line item. */
  status?: InputMaybe<BidderLineItemStatus>;
  /** The strategy and KPI type. */
  strategy_and_kpi_type?: InputMaybe<BidderLineItemStrategyType>;
  /** The strategy and KPI value. */
  strategy_and_kpi_value?: InputMaybe<Scalars['String']['input']>;
  /** The target type. */
  target_type?: InputMaybe<Scalars['String']['input']>;
  /** The target value. */
  target_value?: InputMaybe<Scalars['String']['input']>;
};

/** A BidderOrder represents an advertising order that groups line items for bidding. */
export type BidderOrder = {
  __typename?: 'BidderOrder';
  /** The parent account ID. */
  account_id: Scalars['String']['output'];
  /** The parent account UID. */
  account_uid: Scalars['String']['output'];
  /** The advertiser identifier. */
  advertiser_id?: Maybe<Scalars['String']['output']>;
  /** The daily budget for the order. */
  budget_daily?: Maybe<Scalars['Decimal']['output']>;
  /** The total budget for the order. */
  budget_total: Scalars['Decimal']['output'];
  /** The budget type for the order. */
  budget_type: BidderOrderBudgetType;
  /** The date when the order was created. */
  created_date: Scalars['timestamptz']['output'];
  /**
   * Delivered actuals, read on this entity's own grain: every figure is its
   * own, even where sibling line items share a deal. Distinct from
   * delivery_status, which is lifecycle state.
   */
  delivery_metrics?: Maybe<DeliveryMetrics>;
  /** Delivered actuals against this entity's goal, full-flight-to-date. */
  delivery_pacing?: Maybe<DeliveryPacing>;
  /**
   * Server-computed delivery state. Derived on save from status, flight dates,
   * archive flag, and child line item state. Read-only.
   */
  delivery_status: BidderDeliveryStatus;
  /** The end date of the order. */
  end_date: Scalars['timestamptz']['output'];
  /** Frequency capping settings for the order. */
  frequency_capping: Array<FrequencyCapping>;
  /** The unique identifier for the BidderOrder. */
  id: Scalars['String']['output'];
  /** The instance this object lives on. */
  instance_uid?: Maybe<Scalars['String']['output']>;
  /** The date when the order was last modified. */
  modified_date: Scalars['timestamptz']['output'];
  /** The order name or label. */
  name: Scalars['String']['output'];
  /** Notes or description for the order. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The start date of the order. */
  start_date: Scalars['timestamptz']['output'];
  /** The current status of the order. */
  status: BidderOrderStatus;
  /** The unique identifier (uid) for the BidderOrder. */
  uid: Scalars['String']['output'];
};


/** A BidderOrder represents an advertising order that groups line items for bidding. */
export type BidderOrderDelivery_MetricsArgs = {
  range?: InputMaybe<DeliveryRange>;
};

export const BidderOrderBudgetType = {
  TotalImpressions: 'total_impressions',
  TotalSpend: 'total_spend'
} as const;

export type BidderOrderBudgetType = typeof BidderOrderBudgetType[keyof typeof BidderOrderBudgetType];
export type BidderOrderCreateParams = {
  /** The parent account UID. Optional — inferred from API key session when omitted. */
  account_uid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The advertiser identifier. Deprecated: the advertiser is now the owning
   * account (account_uid). Retained for backward compatibility and will be removed.
   */
  advertiser_id?: InputMaybe<Scalars['String']['input']>;
  /** The daily budget for the order. */
  budget_daily?: InputMaybe<Scalars['Decimal']['input']>;
  /** The total budget for the order. */
  budget_total: Scalars['Decimal']['input'];
  /** The budget type for the order. */
  budget_type: BidderOrderBudgetType;
  /** The end date of the order. */
  end_date: Scalars['timestamptz']['input'];
  /** Frequency capping settings for the order. */
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  /** The order name or label. */
  name: Scalars['String']['input'];
  /** Notes or description for the order. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the order. */
  start_date: Scalars['timestamptz']['input'];
  /** The current status of the order. */
  status?: InputMaybe<BidderOrderStatus>;
};

/** Delivery for one requested order, keyed back by its id. */
export type BidderOrderDelivery = {
  __typename?: 'BidderOrderDelivery';
  /**
   * The fields of this row that failed to resolve, among the ones this
   * operation selected, so a null `metrics` or `pacing` can be told from
   * an honest null: an unknown id, a not-started flight on FULL_FLIGHT, no
   * goal. Empty when nothing failed. Only the selected fields are resolved,
   * so selecting this alone is not a health check.
   */
  failed_fields: Array<DeliveryField>;
  /** The requested order id this row answers for. */
  id: Scalars['String']['output'];
  /** Null when the id resolved to no order or its metrics failed. */
  metrics?: Maybe<DeliveryMetrics>;
  /** Null per the delivery_pacing rules (e.g. no goal), or on failure. */
  pacing?: Maybe<DeliveryPacing>;
};

export const BidderOrderStatus = {
  Active: 'Active',
  Paused: 'Paused'
} as const;

export type BidderOrderStatus = typeof BidderOrderStatus[keyof typeof BidderOrderStatus];
export type BidderOrderUpdateParams = {
  /** The advertiser identifier. */
  advertiser_id?: InputMaybe<Scalars['String']['input']>;
  /** The daily budget for the order. */
  budget_daily?: InputMaybe<Scalars['Decimal']['input']>;
  /** The total budget for the order. */
  budget_total?: InputMaybe<Scalars['Decimal']['input']>;
  /** The budget type for the order. */
  budget_type?: InputMaybe<BidderOrderBudgetType>;
  /** The end date of the order. */
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Frequency capping settings for the order. */
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  /** The order name or label. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes or description for the order. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the order. */
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The current status of the order. */
  status?: InputMaybe<BidderOrderStatus>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export const BudgetMode = {
  Cadence: 'CADENCE',
  CampaignFlightTime: 'CAMPAIGN_FLIGHT_TIME'
} as const;

export type BudgetMode = typeof BudgetMode[keyof typeof BudgetMode];
export const BudgetType = {
  Impressions: 'IMPRESSIONS',
  Spend: 'SPEND'
} as const;

export type BudgetType = typeof BudgetType[keyof typeof BudgetType];
export type BulkRboConfigInput = {
  deal_id: Scalars['String']['input'];
  rbo_config?: InputMaybe<RboConfigUpdateParams>;
};

export type BulkRboUpdateError = {
  __typename?: 'BulkRboUpdateError';
  deal_id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type BulkRboUpdateResult = BulkRboUpdateError | BulkRboUpdateSuccess;

export type BulkRboUpdateSuccess = {
  __typename?: 'BulkRboUpdateSuccess';
  deal_id: Scalars['String']['output'];
  instance_uid: Scalars['String']['output'];
  rbo_config?: Maybe<RboConfig>;
};

export const CacheControlScope = {
  Private: 'PRIVATE',
  Public: 'PUBLIC'
} as const;

export type CacheControlScope = typeof CacheControlScope[keyof typeof CacheControlScope];
export type Cadence = {
  __typename?: 'Cadence';
  budget?: Maybe<Scalars['Decimal']['output']>;
  type?: Maybe<CadenceType>;
};

export type CadenceParams = {
  budget?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<CadenceType>;
};

export const CadenceType = {
  Daily: 'DAILY',
  Weekly: 'WEEKLY'
} as const;

export type CadenceType = typeof CadenceType[keyof typeof CadenceType];
export type CheckUserPermissionsResponse = {
  __typename?: 'CheckUserPermissionsResponse';
  forceRefreshToken?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ContextualEstimateResult = {
  __typename?: 'ContextualEstimateResult';
  impressions: ContextualHllEstimate;
  marketRequests: ContextualHllEstimate;
};

export type ContextualHllEstimate = {
  __typename?: 'ContextualHllEstimate';
  bound: Scalars['BigInt']['output'];
  estimate: Scalars['BigInt']['output'];
};

/**
 * The format a package request to MGMT API works in, for its contextual segment targeting
 * (MGMT API's contextual_segment_format). `new`: writes take targeting.contextual_segment as the
 * source and regenerate the deprecated `ctx_` custom variables from it; reads leave those variables
 * out of targeting.custom. `legacy`: writes take the `ctx_` custom variables as the source and
 * ignore targeting.contextual_segment; reads return both. Omitted, MGMT API uses `legacy`.
 */
export const ContextualSegmentFormat = {
  Legacy: 'legacy',
  New: 'new'
} as const;

export type ContextualSegmentFormat = typeof ContextualSegmentFormat[keyof typeof ContextualSegmentFormat];
export type CumulativeBundleSegment = CumulativeSegment & {
  __typename?: 'CumulativeBundleSegment';
  metrics: CumulativeMetrics;
  noOfResults: Scalars['Int']['output'];
  reach: Scalars['Float']['output'];
  resultIds?: Maybe<Array<Scalars['String']['output']>>;
  results?: Maybe<Array<Maybe<InventoryBundle>>>;
  segment: Scalars['String']['output'];
};

export type CumulativeDomainSegment = CumulativeSegment & {
  __typename?: 'CumulativeDomainSegment';
  metrics: CumulativeMetrics;
  noOfResults: Scalars['Int']['output'];
  reach: Scalars['Float']['output'];
  resultIds?: Maybe<Array<Scalars['String']['output']>>;
  results?: Maybe<Array<Maybe<InventoryDomain>>>;
  segment: Scalars['String']['output'];
};

export type CumulativeMetrics = {
  __typename?: 'CumulativeMetrics';
  avgBidCpm?: Maybe<Scalars['Float']['output']>;
  avgOxWinRate?: Maybe<Scalars['Float']['output']>;
  avgPubWinRate?: Maybe<Scalars['Float']['output']>;
  avgViewability?: Maybe<Scalars['Float']['output']>;
  relevance?: Maybe<Scalars['Float']['output']>;
  totalBidSpendInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprMarketRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalImpressions?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
};

export type CumulativeSegment = {
  metrics: CumulativeMetrics;
  noOfResults: Scalars['Int']['output'];
  reach: Scalars['Float']['output'];
  resultIds?: Maybe<Array<Scalars['String']['output']>>;
  segment: Scalars['String']['output'];
};

export type CuratedDealBuyerDiscountInput = {
  /** Filters for discounts assigned to a specific Demand Partner ID. */
  applied_to_demand_partner_id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filters for discounts assigned to specific Received Seat IDs within a Demand Partner.
   * This parameter must be paired with "applied_to_demand_partner_id".
   * Accepts multiple IDs separated by commas (e.g., "received-seat-1,received-seat-2").
   */
  applied_to_received_seat_ids?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filters by a list of Demand Partner IDs.
   * Accepts multiple IDs separated by commas (e.g., "demand-partner-id-1,demand-partner-id-2").
   */
  demand_partner_id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filters by a search phrase.
   * The search will be performed against the following fields: Name, ID, Received Seat ID.
   */
  q?: InputMaybe<Scalars['String']['input']>;
  seat_ids__has_any?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specifies the column and direction for sorting the list of Curated Deal Buyer Discounts.
   * Provide the name of the column to sort by (e.g., "name", "modified_date").
   * To sort in descending order, prefix the column name with a hyphen (e.g., "-modified_date").
   */
  sort?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique identifier of a specific Curated Deal Buyer Discount to retrieve.
   * If this 'uid' is provided, all other parameters ('limit', 'offset', 'sort', 'q') will be ignored.
   */
  uid?: InputMaybe<Scalars['ID']['input']>;
};

/** A resolved, inclusive date range. */
export type DateWindow = {
  __typename?: 'DateWindow';
  /** Last day included, as YYYY-MM-DD. */
  end_date: Scalars['String']['output'];
  /** First day included, as YYYY-MM-DD. */
  start_date: Scalars['String']['output'];
};

/**
 * Day parting reference frame. `local` gates each viewer by their own local
 * time (resolved from geo at bid time); `advertiser` gates everyone by the
 * configured daypart_timezone.
 */
export const DaypartMode = {
  Advertiser: 'advertiser',
  Local: 'local'
} as const;

export type DaypartMode = typeof DaypartMode[keyof typeof DaypartMode];
/**
 * Weekly day parting allow grid. Each weekday lists the whole clock hours (0-23)
 * during which bidding is allowed; 16 means 16:00-16:59, so 9am-5pm is [9..16].
 * A weekday that is absent or empty is fully blocked. A line item without a
 * grid delivers 24/7.
 */
export type DaypartSchedule = {
  __typename?: 'DaypartSchedule';
  Fri?: Maybe<Array<Scalars['Int']['output']>>;
  Mon?: Maybe<Array<Scalars['Int']['output']>>;
  Sat?: Maybe<Array<Scalars['Int']['output']>>;
  Sun?: Maybe<Array<Scalars['Int']['output']>>;
  Thu?: Maybe<Array<Scalars['Int']['output']>>;
  Tue?: Maybe<Array<Scalars['Int']['output']>>;
  Wed?: Maybe<Array<Scalars['Int']['output']>>;
};

/**
 * Weekly day parting allow grid input. See DaypartSchedule for cell semantics.
 * A grid that allows no hours on any day is rejected upstream; omit the field
 * for 24/7 delivery, or send an empty object on update to clear day parting.
 */
export type DaypartScheduleInput = {
  Fri?: InputMaybe<Array<Scalars['Int']['input']>>;
  Mon?: InputMaybe<Array<Scalars['Int']['input']>>;
  Sat?: InputMaybe<Array<Scalars['Int']['input']>>;
  Sun?: InputMaybe<Array<Scalars['Int']['input']>>;
  Thu?: InputMaybe<Array<Scalars['Int']['input']>>;
  Tue?: InputMaybe<Array<Scalars['Int']['input']>>;
  Wed?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DealByIdOutput = {
  __typename?: 'DealByIdOutput';
  _package: PackageByIdOutput;
  /** The associated Account object, resolved from account_id. */
  account?: Maybe<Account>;
  account_id: Scalars['String']['output'];
  created_date?: Maybe<Scalars['String']['output']>;
  created_with?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  exchange_deal?: Maybe<Scalars['ExchangeJSON']['output']>;
  exchange_deal_id?: Maybe<Scalars['String']['output']>;
  exchange_deal_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package?: Maybe<Scalars['ExchangeJSON']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_direct_deal?: Maybe<Scalars['Boolean']['output']>;
  modified_date?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publisher_name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DealCreateInput = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  agency_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  amazon_do_sync?: InputMaybe<Scalars['Boolean']['input']>;
  brand_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  deal_creation_context?: InputMaybe<Scalars['String']['input']>;
  deal_id?: InputMaybe<Scalars['String']['input']>;
  deal_participants: Array<ExchangeDealParticipantsCreateParams>;
  deal_price?: InputMaybe<Scalars['Decimal']['input']>;
  deal_source?: InputMaybe<Scalars['String']['input']>;
  enable_dv360_inventory_package?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  expected_ad_category?: InputMaybe<Scalars['String']['input']>;
  fixed_cpm_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  package_id?: InputMaybe<Scalars['String']['input']>;
  package_uid: Scalars['String']['input'];
  pdp_config?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  pmp_deal_type: Scalars['String']['input'];
  rbo_config?: InputMaybe<RboConfigCreateParams>;
  start_date: Scalars['timestamptz']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  third_party_fees_config?: InputMaybe<Array<ExchangeThirdPartyFeesConfigCreateParams>>;
  third_party_revenue?: InputMaybe<ExchangeThirdPartyRevenueCreateParams>;
};

export type DealEntry = {
  __typename?: 'DealEntry';
  deal_id: Scalars['String']['output'];
  impressions: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ox_deal_id: Scalars['Int']['output'];
};

export type DealGroupInfoOutput = {
  __typename?: 'DealGroupInfoOutput';
  count: Scalars['Int']['output'];
  deal_id: Scalars['String']['output'];
};

export type DealLandingOutput = {
  __typename?: 'DealLandingOutput';
  has_more: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  objects: Array<DealLandingOutputItem>;
  offset: Scalars['Int']['output'];
};

/**
 * Deal item returned by the dealLanding query.
 * Contains selected deal-level parity fields (account_uid, type, pmp_deal_type,
 * monetizing_uid, lifetime_impression_goal)
 * plus enriched landing page metrics from deal_metrics table.
 * The full raw deal object is available through the exchange_deal scalar.
 *
 * All metric fields are nullable since deal_metrics data may not exist for every deal.
 * Revenue visibility is enforced by the /deal/landing endpoint based on session permissions:
 * - internal/ox network users see all revenue fields
 * - publishers see publisher_revenue and publisher_cpm
 * - partners see partner_revenue
 * - others see no revenue data
 */
export type DealLandingOutputItem = {
  __typename?: 'DealLandingOutputItem';
  _package: PackageByIdOutput;
  /** The associated Account object, resolved from account_id. */
  account?: Maybe<Account>;
  account_id: Scalars['String']['output'];
  account_uid?: Maybe<Scalars['String']['output']>;
  buyer_names?: Maybe<Array<Scalars['String']['output']>>;
  cpm?: Maybe<Scalars['Float']['output']>;
  cpm_delta?: Maybe<Scalars['Float']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  created_with?: Maybe<Scalars['String']['output']>;
  deal_participants?: Maybe<Array<ExchangeDealParticipants>>;
  dsp_names?: Maybe<Array<Scalars['String']['output']>>;
  end_date?: Maybe<Scalars['String']['output']>;
  exchange_deal?: Maybe<Scalars['ExchangeJSON']['output']>;
  exchange_deal_id?: Maybe<Scalars['String']['output']>;
  exchange_deal_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package?: Maybe<Scalars['ExchangeJSON']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  health_score?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  impressions?: Maybe<Scalars['BigInt']['output']>;
  impressions_delta?: Maybe<Scalars['Float']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_direct_deal?: Maybe<Scalars['Boolean']['output']>;
  lifetime_impression_goal?: Maybe<Scalars['String']['output']>;
  modified_date?: Maybe<Scalars['String']['output']>;
  monetizing_uid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  package_name?: Maybe<Scalars['String']['output']>;
  partner_revenue?: Maybe<Scalars['Float']['output']>;
  partner_revenue_delta?: Maybe<Scalars['Float']['output']>;
  pmp_deal_type?: Maybe<Scalars['String']['output']>;
  publisher_cpm?: Maybe<Scalars['Float']['output']>;
  publisher_cpm_delta?: Maybe<Scalars['Float']['output']>;
  publisher_revenue?: Maybe<Scalars['Float']['output']>;
  publisher_revenue_delta?: Maybe<Scalars['Float']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  spend_delta?: Maybe<Scalars['Float']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type DealPromptConversation = {
  __typename?: 'DealPromptConversation';
  audienceSearchParams?: Maybe<Scalars['JSON']['output']>;
  draftDeal?: Maybe<Scalars['JSON']['output']>;
  inventorySearchParams?: Maybe<Scalars['JSON']['output']>;
  messages: Array<DealPromptMessage>;
  sessionId: Scalars['String']['output'];
};

export type DealPromptMessage = {
  __typename?: 'DealPromptMessage';
  invocationId: Scalars['String']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  role: DealPromptRole;
  suggestedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
};

export const DealPromptRole = {
  Agent: 'AGENT',
  User: 'USER',
  Widget: 'WIDGET'
} as const;

export type DealPromptRole = typeof DealPromptRole[keyof typeof DealPromptRole];
export type DealPromptSession = {
  __typename?: 'DealPromptSession';
  createdAt: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DealRboInfoOutput = {
  __typename?: 'DealRboInfoOutput';
  id: Scalars['String']['output'];
  score_name: Scalars['String']['output'];
  threshold: Scalars['String']['output'];
};

export type DealTroubleshootingAgentAsyncQueryResponse = {
  __typename?: 'DealTroubleshootingAgentAsyncQueryResponse';
  deal_id: Scalars['String']['output'];
  invocation_id: Scalars['String']['output'];
  session_id: Scalars['String']['output'];
  trace_id?: Maybe<Scalars['String']['output']>;
};

export type DealTroubleshootingAgentRegisterFeedbackResponse = {
  __typename?: 'DealTroubleshootingAgentRegisterFeedbackResponse';
  message: Scalars['String']['output'];
};

export type DealTroubleshootingAgentSession = {
  __typename?: 'DealTroubleshootingAgentSession';
  last_updated?: Maybe<Scalars['String']['output']>;
  session_display_name?: Maybe<Scalars['String']['output']>;
  session_id: Scalars['String']['output'];
};

export type DealTroubleshootingAgentSessionEndpointsMetadata = {
  __typename?: 'DealTroubleshootingAgentSessionEndpointsMetadata';
  deal_id: Scalars['String']['output'];
  trace_id?: Maybe<Scalars['String']['output']>;
};

export type DealTroubleshootingAgentSessionHistoryMessage = {
  __typename?: 'DealTroubleshootingAgentSessionHistoryMessage';
  messages: Array<Scalars['ExchangeJSON']['output']>;
  metadata: DealTroubleshootingAgentSessionEndpointsMetadata;
  session_id: Scalars['String']['output'];
};

export type DealTroubleshootingAgentSessionListMessage = {
  __typename?: 'DealTroubleshootingAgentSessionListMessage';
  metadata: DealTroubleshootingAgentSessionEndpointsMetadata;
  sessions: Array<DealTroubleshootingAgentSession>;
};

export type DealUpdateInput = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  agency_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  amazon_do_sync?: InputMaybe<Scalars['Boolean']['input']>;
  brand_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  deal_participants?: InputMaybe<Array<ExchangeDealParticipantsUpdateParams>>;
  deal_price?: InputMaybe<Scalars['Decimal']['input']>;
  deal_source?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  exchange_deal_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  expected_ad_category?: InputMaybe<Scalars['String']['input']>;
  fixed_cpm_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  id: Scalars['String']['input'];
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  package_id?: InputMaybe<Scalars['String']['input']>;
  pdp_config?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  pmp_deal_type?: InputMaybe<Scalars['String']['input']>;
  rbo_config?: InputMaybe<RboConfigUpdateParams>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['ApiDealStatusType']['input']>;
  third_party_fees_config?: InputMaybe<Array<ExchangeThirdPartyFeesConfigUpdateParams>>;
  third_party_revenue?: InputMaybe<ExchangeThirdPartyRevenueUpdateParams>;
};

export type DealsOutput = {
  __typename?: 'DealsOutput';
  has_more: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  objects: Array<DealByIdOutput>;
  offset: Scalars['Int']['output'];
};

/**
 * Raw additive delivery counters, safe to sum across deals, days and entity
 * levels. Rates are never stored here; they are derived from summed counters.
 */
export type DeliveryCounters = {
  __typename?: 'DeliveryCounters';
  clicks: Scalars['BigInt']['output'];
  fills: Scalars['BigInt']['output'];
  impressions: Scalars['BigInt']['output'];
  /** Impressions carrying a click macro. The denominator for ctr. */
  impressions_with_click_macro: Scalars['BigInt']['output'];
  non_zero_bids: Scalars['BigInt']['output'];
  requests_qualified: Scalars['BigInt']['output'];
  /** Spend in integer micro-dollars (1 USD = 1,000,000), on every source. */
  spend: Scalars['Float']['output'];
  video_completed: Scalars['BigInt']['output'];
  video_started: Scalars['BigInt']['output'];
  /** See viewables. */
  viewability_measures: Scalars['Float']['output'];
  /**
   * Float rather than BigInt: integral in the current source, but other OpenX
   * surfaces report viewability fractionally and BigInt throws on non-integers.
   */
  viewables: Scalars['Float']['output'];
};

/** A field of a bulk delivery row that failed to resolve. */
export const DeliveryField = {
  Metrics: 'METRICS',
  Pacing: 'PACING'
} as const;

export type DeliveryField = typeof DeliveryField[keyof typeof DeliveryField];
/**
 * Delivered actuals for one entity over one date range, read from the Aqua
 * fact tables keyed by the entity itself: every figure is the entity's own.
 */
export type DeliveryMetrics = {
  __typename?: 'DeliveryMetrics';
  /** Non-zero bids over qualified requests, capped at 1. */
  bid_rate?: Maybe<Scalars['Float']['output']>;
  counters: DeliveryCounters;
  /** Spend per click, in micro-dollars. Null when there are no clicks. */
  cpc?: Maybe<Scalars['Float']['output']>;
  /** Spend per thousand impressions, in micro-dollars. Null when there are no impressions. */
  cpm?: Maybe<Scalars['Float']['output']>;
  /** Clicks over impressions with click macro. Null with no denominator. */
  ctr?: Maybe<Scalars['Float']['output']>;
  /** Latest report day included, as YYYY-MM-DD. Null when there is no data. */
  last_updated?: Maybe<Scalars['String']['output']>;
  /**
   * Counters for the equal-length window immediately preceding this one, for
   * period-over-period comparison. Null for FULL_FLIGHT.
   */
  previous?: Maybe<DeliveryCounters>;
  /** Bounds of the preceding window. Null whenever previous is null. */
  previous_window?: Maybe<DateWindow>;
  /** The range requested. */
  range: DeliveryRange;
  /** Video completions over video starts, capped at 1. */
  vcr?: Maybe<Scalars['Float']['output']>;
  /** Viewables over viewability measures, capped at 1. */
  viewability?: Maybe<Scalars['Float']['output']>;
  /** Impressions over fills, capped at 1. */
  win_rate?: Maybe<Scalars['Float']['output']>;
  /**
   * Resolved bounds. Always present, and always ends yesterday: the source is a
   * daily batch, so including today would read as a delivery dip.
   */
  window: DateWindow;
};

/**
 * Delivered actuals measured against the flight's goal, full-flight-to-date.
 * Distinct from BidderLineItemPacingStrategy, which is configured intent.
 */
export type DeliveryPacing = {
  __typename?: 'DeliveryPacing';
  /** Delivered to date, in the same unit as goal. */
  delivered: Scalars['Float']['output'];
  /** delivered as a percentage of goal. Exceeds 100 when over-delivering. */
  delivered_pct: Scalars['Float']['output'];
  /** The goal scaled by the elapsed fraction of the flight, in the same unit as goal; may be fractional. */
  expected: Scalars['Float']['output'];
  /** Percentage of the flight elapsed, 0-100. */
  flight_elapsed_pct: Scalars['Float']['output'];
  /** The goal: micro-dollars for total_spend, an impression count for total_impressions. */
  goal: Scalars['Float']['output'];
  /** Which counter the goal is expressed in. */
  goal_type: BidderOrderBudgetType;
  /**
   * Percentage ahead of or behind expected pace. Null before the flight starts,
   * when pace is undefined.
   */
  vs_pace_pct?: Maybe<Scalars['Float']['output']>;
  /**
   * The flight-to-date window these figures cover. Null until a day of the flight
   * has completed.
   */
  window?: Maybe<DateWindow>;
};

export const DeliveryRange = {
  /** The entity's own flight to date. Differs per entity. */
  FullFlight: 'FULL_FLIGHT',
  /** The seven complete days ending yesterday. */
  Last_7Days: 'LAST_7_DAYS',
  /** The thirty complete days ending yesterday. */
  Last_30Days: 'LAST_30_DAYS',
  /** The single most recent complete day. */
  Yesterday: 'YESTERDAY'
} as const;

export type DeliveryRange = typeof DeliveryRange[keyof typeof DeliveryRange];
export type DspRestriction = {
  __typename?: 'DspRestriction';
  dsp_id: Scalars['String']['output'];
  seat_ids: Array<Scalars['String']['output']>;
};

export type DspRestrictionInput = {
  dsp_id: Scalars['String']['input'];
  seat_ids: Array<Scalars['String']['input']>;
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
};

export type ExchangeDeal = {
  __typename?: 'ExchangeDeal';
  agency_salesforce_id?: Maybe<Scalars['String']['output']>;
  amazon_do_sync?: Maybe<Scalars['Boolean']['output']>;
  brand_salesforce_id?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['timestamptz']['output'];
  curated_deal_buyer_discount_enabled?: Maybe<Scalars['Boolean']['output']>;
  currency: Scalars['String']['output'];
  deal_id: Scalars['String']['output'];
  deal_participants?: Maybe<Array<Maybe<ExchangeDealParticipants>>>;
  deal_price?: Maybe<Scalars['Decimal']['output']>;
  deal_source?: Maybe<Scalars['String']['output']>;
  enable_dv360_inventory_package?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['ExchangeJSON']['output']>;
  expected_ad_category?: Maybe<Scalars['String']['output']>;
  fixed_cpm_enabled?: Maybe<Scalars['Boolean']['output']>;
  frequency_capping: Array<Maybe<FrequencyCapping>>;
  id: Scalars['String']['output'];
  /** The instance this object lives on. */
  instance_uid?: Maybe<Scalars['String']['output']>;
  modified_date: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  pacing?: Maybe<Pacing>;
  package?: Maybe<Package>;
  pdp_config?: Maybe<ExchangePdpConfig>;
  pmp_deal_type: Scalars['String']['output'];
  rbo_config?: Maybe<RboConfig>;
  segment_partner_platform_share?: Maybe<Array<Maybe<ExchangeSegmentPartnerPlatformShare>>>;
  segment_partner_revenue_method?: Maybe<SegmentPartnerRevenueMethod>;
  start_date: Scalars['timestamptz']['output'];
  status: Scalars['String']['output'];
  third_party_fees?: Maybe<Array<ExchangeThirdPartyFee>>;
  third_party_fees_config?: Maybe<Array<Maybe<ExchangeThirdPartyFeesConfig>>>;
  third_party_revenue?: Maybe<ExchangeThirdPartyRevenue>;
  uid: Scalars['String']['output'];
};

export type ExchangeDealCreateParams = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  agency_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  amazon_do_sync?: InputMaybe<Scalars['Boolean']['input']>;
  brand_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  curated_deal_buyer_discount_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency: Scalars['String']['input'];
  deal_creation_context?: InputMaybe<Scalars['String']['input']>;
  deal_id?: InputMaybe<Scalars['String']['input']>;
  deal_participants: Array<ExchangeDealParticipantsCreateParams>;
  deal_price?: InputMaybe<Scalars['Decimal']['input']>;
  deal_source?: InputMaybe<Scalars['String']['input']>;
  enable_dv360_inventory_package?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  expected_ad_category?: InputMaybe<Scalars['String']['input']>;
  fixed_cpm_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  name: Scalars['String']['input'];
  pacing?: InputMaybe<PacingParams>;
  package_id?: InputMaybe<Scalars['String']['input']>;
  package_uid?: InputMaybe<Scalars['String']['input']>;
  pdp_config?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  pmp_deal_type: Scalars['String']['input'];
  rbo_config?: InputMaybe<RboConfigCreateParams>;
  segment_partner_platform_share?: InputMaybe<Array<InputMaybe<ExchangeSegmentPartnerPlatformShareCreateParams>>>;
  segment_partner_revenue_method?: InputMaybe<SegmentPartnerRevenueMethod>;
  start_date: Scalars['timestamptz']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  third_party_fees_config?: InputMaybe<Array<ExchangeThirdPartyFeesConfigCreateParams>>;
  third_party_revenue?: InputMaybe<ExchangeThirdPartyRevenueCreateParams>;
};

export type ExchangeDealForecastingDealParams = {
  created_with?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deal_id?: InputMaybe<Scalars['String']['input']>;
  deal_participants: Array<ExchangeDealParticipantsCreateParams>;
  deal_price?: InputMaybe<Scalars['Decimal']['input']>;
  deal_source?: InputMaybe<Scalars['String']['input']>;
  enable_dv360_inventory_package?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pmp_deal_type: Scalars['String']['input'];
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  third_party_fees_config?: InputMaybe<Array<ExchangeThirdPartyFeesConfigCreateParams>>;
  third_party_revenue?: InputMaybe<ExchangeThirdPartyRevenueCreateParams>;
};

export type ExchangeDealParticipants = {
  __typename?: 'ExchangeDealParticipants';
  brand_ids?: Maybe<Scalars['ExchangeJSON']['output']>;
  buyer_ids?: Maybe<Scalars['ExchangeJSON']['output']>;
  demand_partner: Scalars['String']['output'];
  main_buyer_id?: Maybe<Scalars['String']['output']>;
};

export type ExchangeDealParticipantsCreateParams = {
  brand_ids?: InputMaybe<Array<Scalars['StringOrInt']['input']>>;
  buyer_ids?: InputMaybe<Array<Scalars['StringOrInt']['input']>>;
  demand_partner: Scalars['StringOrInt']['input'];
  main_buyer_id?: InputMaybe<Scalars['String']['input']>;
};

export type ExchangeDealParticipantsUpdateParams = {
  brand_ids?: InputMaybe<Array<Scalars['StringOrInt']['input']>>;
  buyer_ids?: InputMaybe<Array<Scalars['StringOrInt']['input']>>;
  demand_partner: Scalars['StringOrInt']['input'];
  main_buyer_id?: InputMaybe<Scalars['String']['input']>;
};

export type ExchangeDealUpdateParams = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  agency_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  amazon_do_sync?: InputMaybe<Scalars['Boolean']['input']>;
  brand_salesforce_id?: InputMaybe<Scalars['String']['input']>;
  curated_deal_buyer_discount_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  deal_participants?: InputMaybe<Array<ExchangeDealParticipantsUpdateParams>>;
  deal_price?: InputMaybe<Scalars['Decimal']['input']>;
  deal_source?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  expected_ad_category?: InputMaybe<Scalars['String']['input']>;
  fixed_cpm_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency_capping?: InputMaybe<Array<FrequencyCappingInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pacing?: InputMaybe<PacingParams>;
  package_id?: InputMaybe<Scalars['String']['input']>;
  pdp_config?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  pmp_deal_type?: InputMaybe<Scalars['String']['input']>;
  rbo_config?: InputMaybe<RboConfigUpdateParams>;
  segment_partner_platform_share?: InputMaybe<Array<InputMaybe<ExchangeSegmentPartnerPlatformShareUpdateParams>>>;
  segment_partner_revenue_method?: InputMaybe<SegmentPartnerRevenueMethod>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  third_party_fees_config?: InputMaybe<Array<ExchangeThirdPartyFeesConfigUpdateParams>>;
  third_party_revenue?: InputMaybe<ExchangeThirdPartyRevenueUpdateParams>;
};

export type ExchangePdpConfig = {
  __typename?: 'ExchangePdpConfig';
  media_spend_goal?: Maybe<Scalars['Decimal']['output']>;
  min_daily_avails?: Maybe<Scalars['Int']['output']>;
  min_win_rate?: Maybe<Scalars['Decimal']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Decimal']['output']>;
};

export type ExchangeSegmentPartnerPlatformShare = {
  __typename?: 'ExchangeSegmentPartnerPlatformShare';
  partner_id: Scalars['String']['output'];
  share: Scalars['Decimal']['output'];
};

export type ExchangeSegmentPartnerPlatformShareCreateParams = {
  partner_id: Scalars['String']['input'];
  share: Scalars['Decimal']['input'];
};

export type ExchangeSegmentPartnerPlatformShareUpdateParams = {
  partner_id: Scalars['String']['input'];
  share: Scalars['Decimal']['input'];
};

export type ExchangeThirdPartyFee = {
  __typename?: 'ExchangeThirdPartyFee';
  cpm_cap?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fee_type?: Maybe<Scalars['String']['output']>;
  partner_id: Scalars['String']['output'];
  revenue_method: Scalars['String']['output'];
  share?: Maybe<Scalars['String']['output']>;
};

export type ExchangeThirdPartyFeesConfig = {
  __typename?: 'ExchangeThirdPartyFeesConfig';
  gross_cpm_cap?: Maybe<Scalars['String']['output']>;
  gross_share?: Maybe<Scalars['String']['output']>;
  partner_id: Scalars['String']['output'];
  platform_partner_id?: Maybe<Scalars['String']['output']>;
  platform_share?: Maybe<Scalars['String']['output']>;
  revenue_method: Scalars['String']['output'];
};

export type ExchangeThirdPartyFeesConfigCreateParams = {
  gross_cpm_cap?: InputMaybe<Scalars['Decimal']['input']>;
  gross_share?: InputMaybe<Scalars['Decimal']['input']>;
  partner_id: Scalars['String']['input'];
  platform_partner_id?: InputMaybe<Scalars['String']['input']>;
  platform_share?: InputMaybe<Scalars['Decimal']['input']>;
  revenue_method: ThirdPartyFeeConfigRevenueMethod;
};

export type ExchangeThirdPartyFeesConfigUpdateParams = {
  gross_cpm_cap?: InputMaybe<Scalars['Decimal']['input']>;
  gross_share?: InputMaybe<Scalars['Decimal']['input']>;
  partner_id: Scalars['String']['input'];
  platform_partner_id?: InputMaybe<Scalars['String']['input']>;
  platform_share?: InputMaybe<Scalars['Decimal']['input']>;
  revenue_method: ThirdPartyFeeConfigRevenueMethod;
};

export type ExchangeThirdPartyRevenue = {
  __typename?: 'ExchangeThirdPartyRevenue';
  cpm_cap?: Maybe<Scalars['Decimal']['output']>;
  partner: Scalars['String']['output'];
  revenue_method: Scalars['String']['output'];
  share?: Maybe<Scalars['Decimal']['output']>;
};

export type ExchangeThirdPartyRevenueCreateParams = {
  cpm_cap?: InputMaybe<Scalars['Decimal']['input']>;
  partner: Scalars['String']['input'];
  revenue_method: ThirdPartyRevenueMethod;
  share?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ExchangeThirdPartyRevenueUpdateParams = {
  cpm_cap?: InputMaybe<Scalars['Decimal']['input']>;
  partner: Scalars['String']['input'];
  revenue_method: ThirdPartyRevenueMethod;
  share?: InputMaybe<Scalars['Decimal']['input']>;
};

export type FilterEntry = {
  __typename?: 'FilterEntry';
  impressions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Input allowing to provide filtering parameters for this query, e.g {key: "age__gte", value: "18"} */
export type FilterParam = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** CPM range in whole currency units, presented as a range (no midpoint). */
export type ForecastCpmBand = {
  __typename?: 'ForecastCpmBand';
  currency: Scalars['String']['output'];
  lower: Scalars['Float']['output'];
  upper: Scalars['Float']['output'];
};

export type ForecastMeta = {
  __typename?: 'ForecastMeta';
  /** Data day the forecast is based on. Null while placeholder responses are served. */
  data_as_of?: Maybe<Scalars['String']['output']>;
  /** Which forecaster implementation answered: stub-v1 until the DS forecaster v0 ships. */
  forecast_version: Scalars['String']['output'];
  lookback_days?: Maybe<Scalars['Int']['output']>;
  /** Echo of the X-Request-Id header; the correlation key across both systems. */
  request_id: Scalars['String']['output'];
  /** Echo of the X-Schema-Version header. */
  schema_version: Scalars['String']['output'];
  /**
   * The package_targeting paths the forecast uses, so a client can skip
   * re-running the forecast when only targeting outside them changes. Null
   * until the forecaster sends it.
   */
  supported_targeting_dimensions?: Maybe<Array<Scalars['String']['output']>>;
};

/** Overall deliverability read. Null viability means no forecast was possible. */
export const ForecastViability = {
  Green: 'GREEN',
  Red: 'RED',
  Yellow: 'YELLOW'
} as const;

export type ForecastViability = typeof ForecastViability[keyof typeof ForecastViability];
/**
 * Volume band with an explicit midpoint. While the forecaster produces a
 * single estimate, lower == mid == upper; the UI shows mid as a point estimate.
 */
export type ForecastVolumeBand = {
  __typename?: 'ForecastVolumeBand';
  lower: Scalars['Float']['output'];
  mid: Scalars['Float']['output'];
  /** The period the band covers, e.g. "day". */
  period: Scalars['String']['output'];
  upper: Scalars['Float']['output'];
};

export type ForecastWarning = {
  __typename?: 'ForecastWarning';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FrequencyCapping = {
  __typename?: 'FrequencyCapping';
  impressions_limit: Scalars['String']['output'];
  time_period_unit: FrequencyCappingTimePeriodUnit;
  time_period_value: Scalars['Int']['output'];
};

export type FrequencyCappingInput = {
  impressions_limit: Scalars['String']['input'];
  time_period_unit: FrequencyCappingTimePeriodUnit;
  time_period_value: Scalars['Int']['input'];
};

export const FrequencyCappingTimePeriodUnit = {
  Day: 'day',
  Hour: 'hour',
  Month: 'month',
  Week: 'week'
} as const;

export type FrequencyCappingTimePeriodUnit = typeof FrequencyCappingTimePeriodUnit[keyof typeof FrequencyCappingTimePeriodUnit];
export const Gender = {
  Female: 'FEMALE',
  Male: 'MALE'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];
export type GeoSearchOutput = {
  __typename?: 'GeoSearchOutput';
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  continent?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  msa?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  type_id: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvPackageSearchOutput = {
  __typename?: 'InvPackageSearchOutput';
  account_uid?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent_name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  type_full?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type InvSearchOperatorOutput = {
  __typename?: 'InvSearchOperatorOutput';
  account_uid?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instance_uid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent_name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  type_full?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type InventoryBundle = {
  __typename?: 'InventoryBundle';
  appId?: Maybe<Scalars['String']['output']>;
  appInfoContentRating?: Maybe<Scalars['String']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  avgBidCpm?: Maybe<Scalars['Float']['output']>;
  avgOxWinRate?: Maybe<Scalars['Float']['output']>;
  avgPubWinRate?: Maybe<Scalars['Float']['output']>;
  avgViewability?: Maybe<Scalars['Float']['output']>;
  avgVtr?: Maybe<Scalars['Float']['output']>;
  bundleId?: Maybe<Scalars['String']['output']>;
  calculatedBidGuidance?: Maybe<Scalars['Float']['output']>;
  calculatedCostPerImpression?: Maybe<Scalars['Float']['output']>;
  calculatedCtr?: Maybe<Scalars['Float']['output']>;
  calculatedRevenuePerImpression?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  compositeScore?: Maybe<Scalars['Float']['output']>;
  contentRating?: Maybe<Scalars['String']['output']>;
  coppa?: Maybe<Scalars['Boolean']['output']>;
  costPerformanceScore?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developer?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  domainReach?: Maybe<Scalars['Float']['output']>;
  downloads?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  geography?: Maybe<Array<Scalars['String']['output']>>;
  iabDeviceType?: Maybe<Array<Scalars['String']['output']>>;
  iabMediaSubtype?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  isDirect?: Maybe<Array<Scalars['String']['output']>>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  marketSource?: Maybe<Scalars['String']['output']>;
  marketStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  performanceScore?: Maybe<Scalars['Float']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  publisherAccountId?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratingCount?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  regions?: Maybe<Array<Scalars['String']['output']>>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  relevance?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  storeUrl?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Array<Scalars['String']['output']>>;
  totalBidSpendInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCompleteFirstOccurrence?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprAllRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprClicks?: Maybe<Scalars['Float']['output']>;
  totalCprMarketDemandPartnerSpendInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprMarketPublisherRevenueInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprMarketRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprPrivateMarketImpressions?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalDealVolumeDealInfo?: Maybe<Scalars['Float']['output']>;
  totalFills?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalImpressions?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalImpressionsWithClickMacro?: Maybe<Scalars['Float']['output']>;
  totalNonZeroBids?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalNonZeroBidsValueInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalStartFirstOccurrence?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalViewabilityMeasures?: Maybe<Scalars['Float']['output']>;
  totalViewables?: Maybe<Scalars['Float']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  videoPlcmt?: Maybe<Array<Scalars['String']['output']>>;
};

export type InventoryBundleSearchResultBody = {
  __typename?: 'InventoryBundleSearchResultBody';
  bundles: Array<InventoryBundle>;
  cumulativeData: Array<CumulativeBundleSegment>;
  keywords: Array<Maybe<Scalars['String']['output']>>;
  totalRecords: Scalars['Int']['output'];
};

export type InventoryBundleSearchTextResultBody = {
  __typename?: 'InventoryBundleSearchTextResultBody';
  bundles: Array<InventoryBundle>;
  cumulativeData: Array<CumulativeBundleSegment>;
  input?: Maybe<InventoryBundleSearchTextReturnInputs>;
  keywords: Array<Maybe<Scalars['String']['output']>>;
  totalRecords: Scalars['Int']['output'];
};

export type InventoryDomain = {
  __typename?: 'InventoryDomain';
  avgBidCpm?: Maybe<Scalars['Float']['output']>;
  avgOxWinRate?: Maybe<Scalars['Float']['output']>;
  avgPubWinRate?: Maybe<Scalars['Float']['output']>;
  avgViewability?: Maybe<Scalars['Float']['output']>;
  avgVtr?: Maybe<Scalars['Float']['output']>;
  calculatedBidGuidance?: Maybe<Scalars['Float']['output']>;
  calculatedCostPerImpression?: Maybe<Scalars['Float']['output']>;
  calculatedCtr?: Maybe<Scalars['Float']['output']>;
  calculatedRevenuePerImpression?: Maybe<Scalars['Float']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  compositeScore?: Maybe<Scalars['Float']['output']>;
  contentStyles?: Maybe<Array<Scalars['String']['output']>>;
  costPerformanceScore?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domainName: Scalars['String']['output'];
  domainReach?: Maybe<Scalars['Float']['output']>;
  geography?: Maybe<Array<Scalars['String']['output']>>;
  iabDeviceType?: Maybe<Array<Scalars['String']['output']>>;
  iabMediaSubtype?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  intendedAudience?: Maybe<Scalars['String']['output']>;
  isDirect?: Maybe<Array<Scalars['String']['output']>>;
  performanceScore?: Maybe<Scalars['Float']['output']>;
  publisherAccountId?: Maybe<Array<Scalars['String']['output']>>;
  relevance?: Maybe<Scalars['Float']['output']>;
  safetyTier?: Maybe<Array<Scalars['String']['output']>>;
  score?: Maybe<Scalars['Float']['output']>;
  totalBidSpendInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCompleteFirstOccurrence?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprAllRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprClicks?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprMarketDemandPartnerSpendInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprMarketPublisherRevenueInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprMarketRequests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalCprPrivateMarketImpressions?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalDealVolumeDealInfo?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalFills?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalImpressions?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalImpressionsWithClickMacro?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalNonZeroBids?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalNonZeroBidsValueInUsd?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalStartFirstOccurrence?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalViewabilityMeasures?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  totalViewables?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  videoPlcmt?: Maybe<Array<Scalars['String']['output']>>;
};

export type InventoryDomainSearchResultBody = {
  __typename?: 'InventoryDomainSearchResultBody';
  cumulativeData: Array<CumulativeDomainSegment>;
  domains: Array<InventoryDomain>;
  keywords: Array<Maybe<Scalars['String']['output']>>;
  totalRecords: Scalars['Int']['output'];
};

export type InventoryDomainSearchTextResultBody = {
  __typename?: 'InventoryDomainSearchTextResultBody';
  cumulativeData?: Maybe<Array<Maybe<CumulativeDomainSegment>>>;
  domains?: Maybe<Array<Maybe<InventoryDomain>>>;
  input?: Maybe<InventoryDomainSearchTextReturnInputs>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type ManagementRetargetingSegmentCreateInput = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  activation_threshold?: InputMaybe<Scalars['Int']['input']>;
  disposition: RetargetingSegmentDisposition;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  signals: RetargetingSegmentSignalsInput;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type ManagementRetargetingSegmentUpdateInput = {
  activation_threshold?: InputMaybe<Scalars['Int']['input']>;
  disposition?: InputMaybe<RetargetingSegmentDisposition>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  signals?: InputMaybe<RetargetingSegmentSignalsInput>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<RetargetingSegmentStatus>;
};

export type ManagementSegmentCreateInput = {
  retargeting?: InputMaybe<RetargetingSegmentCreateInput>;
};

export type ManagementSegmentUpdateInput = {
  retargeting?: InputMaybe<RetargetingSegmentUpdateInput>;
};

export type ManagementSegmentsOutput = {
  __typename?: 'ManagementSegmentsOutput';
  has_more: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  objects: Array<MngBaseSegment>;
  offset: Scalars['Int']['output'];
};

export const MarkupType = {
  Html: 'HTML',
  Vast: 'VAST'
} as const;

export type MarkupType = typeof MarkupType[keyof typeof MarkupType];
export type MatchedSegment = {
  __typename?: 'MatchedSegment';
  id: Scalars['ID']['output'];
  matchedKeyword: Scalars['String']['output'];
  score: Scalars['numeric']['output'];
};

export type MngBaseSegment = {
  account_id?: Maybe<Scalars['String']['output']>;
  account_uid: Scalars['String']['output'];
  created_date: Scalars['timestamptz']['output'];
  deleted: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instance_uid: Scalars['String']['output'];
  modified_date: Scalars['timestamptz']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  type_full: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
  v?: Maybe<Scalars['String']['output']>;
};

/**
 * Base-field envelope for future management segment type_full values that are
 * not yet modeled as concrete GraphQL types.
 */
export type MngUnknownSegment = BaseSegment & MngBaseSegment & RoutedSegment & {
  __typename?: 'MngUnknownSegment';
  account_id?: Maybe<Scalars['String']['output']>;
  account_uid: Scalars['String']['output'];
  created_date: Scalars['timestamptz']['output'];
  deleted: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instance_uid: Scalars['String']['output'];
  modified_date: Scalars['timestamptz']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  type_full: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
  v?: Maybe<Scalars['String']['output']>;
};

export type ModifySegmentResponse = {
  __typename?: 'ModifySegmentResponse';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type Monetizing = {
  __typename?: 'Monetizing';
  account_id: Scalars['String']['output'];
  account_uid: Scalars['String']['output'];
  budget?: Maybe<Scalars['Decimal']['output']>;
  budget_type: BudgetType;
  cadences: Array<Maybe<Cadence>>;
  created_date: Scalars['timestamptz']['output'];
  deleted: Scalars['String']['output'];
  flight_end?: Maybe<Scalars['timestamptz']['output']>;
  flight_start?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['String']['output'];
  instance_uid: Scalars['String']['output'];
  modified_date: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  pacing_mode: PacingMode;
  region: MonetizingRegion;
  revision: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  v: Scalars['String']['output'];
};

export const MonetizingRegion = {
  Asia: 'ASIA',
  Eu: 'EU',
  Us: 'US'
} as const;

export type MonetizingRegion = typeof MonetizingRegion[keyof typeof MonetizingRegion];
export type Mutation = {
  __typename?: 'Mutation';
  activateAudience?: Maybe<Scalars['JSON']['output']>;
  activateAudienceV2?: Maybe<Scalars['JSON']['output']>;
  activateBidderCreative: BidderCreative;
  activateBidderLineItem: BidderLineItem;
  activateBidderOrder: BidderOrder;
  addBidderLineItemCreatives: BidderLineItem;
  addUsersToSegment: ModifySegmentResponse;
  /** Archive a network account in MGMT API, and return the modified account, the id is the account id in the MGMT API */
  archiveAccountNetwork?: Maybe<Scalars['ExchangeJSON']['output']>;
  archiveBidderCreative: Scalars['String']['output'];
  archiveBidderLineItem: Scalars['String']['output'];
  archiveBidderOrder: Scalars['String']['output'];
  archiveDeal: Scalars['String']['output'];
  archiveDealAndPackage: Scalars['String']['output'];
  archiveLookalikeObjectAndSegments?: Maybe<Lookalike_Definition>;
  archiveManagementSegment?: Maybe<Scalars['String']['output']>;
  archivePackage?: Maybe<Scalars['String']['output']>;
  archivePixel: Scalars['String']['output'];
  archiveSignal: Scalars['String']['output'];
  audienceShareCreate: Array<Maybe<AudienceShareResult>>;
  audienceShareDelete: Array<AudienceShareDeleteResult>;
  audienceShareUpdate: Array<Maybe<AudienceShareResult>>;
  /** Bulk update RBO config for multiple deals. Set rbo_config to null to disable/clear RBO. */
  bulkUpdateDealRboConfig: Array<BulkRboUpdateResult>;
  cancelDealInsightsJob: CancelDealInsightsJobResponse;
  cloneAudience?: Maybe<Audience>;
  clonePackage: Package;
  /** Create a network account in MGMT API, and return the modified account */
  createAccountNetwork?: Maybe<Scalars['ExchangeJSON']['output']>;
  createBidderCreative: BidderCreative;
  createBidderLineItem: BidderLineItem;
  createBidderOrder: BidderOrder;
  createDeal: ExchangeDeal;
  createDealAndPackage: ExchangeDeal;
  createDealForecastingJob?: Maybe<Scalars['ExchangeJSON']['output']>;
  createDealInsightsJob: CreateDealInsightsJobResponse;
  createDealTroubleshootingFactJob: CreateDealTroubleshootingJobResponse;
  createDealTroubleshootingNRTJob: CreateDealTroubleshootingJobResponse;
  createInventorylist?: Maybe<Scalars['ExchangeJSON']['output']>;
  createLog?: Maybe<LogResponse>;
  createLookalikeObjects?: Maybe<Lookalike_Definition>;
  createManagementSegment?: Maybe<MngBaseSegment>;
  createPackage: Package;
  createPixel: Pixel;
  createServiceAccountUnderParentAccount?: Maybe<Scalars['JSON']['output']>;
  createSignal: Signal;
  createUserUnderParentAccount?: Maybe<Scalars['JSON']['output']>;
  createUserUnderRootAccount?: Maybe<Scalars['JSON']['output']>;
  curatedDealBuyerDiscountCreate: Scalars['ExchangeJSON']['output'];
  curatedDealBuyerDiscountDelete: Scalars['ExchangeJSON']['output'];
  curatedDealBuyerDiscountUpdate: Scalars['ExchangeJSON']['output'];
  dealInsightsFilterOptions: DealInsightsFilterOptionsResponse;
  dealTroubleshootingAgentAsyncQuery: DealTroubleshootingAgentAsyncQueryResponse;
  dealTroubleshootingAgentRegisterFeedback: DealTroubleshootingAgentRegisterFeedbackResponse;
  deleteInventorylist?: Maybe<Scalars['ExchangeJSON']['output']>;
  deleteMgmtUser?: Maybe<Scalars['ExchangeJSON']['output']>;
  /** delete data from the table: "account" */
  delete_account?: Maybe<Account_Mutation_Response>;
  /** delete single row from the table: "account" */
  delete_account_by_pk?: Maybe<Account>;
  /** delete data from the table: "account_feature_flags" */
  delete_account_feature_flags?: Maybe<Account_Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "account_feature_flags" */
  delete_account_feature_flags_by_pk?: Maybe<Account_Feature_Flags>;
  /** delete data from the table: "account_provider" */
  delete_account_provider?: Maybe<Account_Provider_Mutation_Response>;
  /** delete single row from the table: "account_provider" */
  delete_account_provider_by_pk?: Maybe<Account_Provider>;
  /** delete data from the table: "audience" */
  delete_audience?: Maybe<Audience_Mutation_Response>;
  /** delete single row from the table: "audience" */
  delete_audience_by_pk?: Maybe<Audience>;
  /** delete data from the table: "audience_segment" */
  delete_audience_segment?: Maybe<Audience_Segment_Mutation_Response>;
  /** delete single row from the table: "audience_segment" */
  delete_audience_segment_by_pk?: Maybe<Audience_Segment>;
  /** delete data from the table: "bq_resource" */
  delete_bq_resource?: Maybe<Bq_Resource_Mutation_Response>;
  /** delete single row from the table: "bq_resource" */
  delete_bq_resource_by_pk?: Maybe<Bq_Resource>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<Country_Mutation_Response>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "export" */
  delete_export?: Maybe<Export_Mutation_Response>;
  /** delete single row from the table: "export" */
  delete_export_by_pk?: Maybe<Export>;
  /** delete data from the table: "export_status_timeline" */
  delete_export_status_timeline?: Maybe<Export_Status_Timeline_Mutation_Response>;
  /** delete single row from the table: "export_status_timeline" */
  delete_export_status_timeline_by_pk?: Maybe<Export_Status_Timeline>;
  /** delete data from the table: "feature_flags" */
  delete_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "feature_flags" */
  delete_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** delete data from the table: "lookalike_definition" */
  delete_lookalike_definition?: Maybe<Lookalike_Definition_Mutation_Response>;
  /** delete single row from the table: "lookalike_definition" */
  delete_lookalike_definition_by_pk?: Maybe<Lookalike_Definition>;
  /** delete data from the table: "lookalike_job_run" */
  delete_lookalike_job_run?: Maybe<Lookalike_Job_Run_Mutation_Response>;
  /** delete single row from the table: "lookalike_job_run" */
  delete_lookalike_job_run_by_pk?: Maybe<Lookalike_Job_Run>;
  /** delete data from the table: "lookalike_seed_source" */
  delete_lookalike_seed_source?: Maybe<Lookalike_Seed_Source_Mutation_Response>;
  /** delete single row from the table: "lookalike_seed_source" */
  delete_lookalike_seed_source_by_pk?: Maybe<Lookalike_Seed_Source>;
  /** delete data from the table: "lookalike_segment_seed_aggregate" */
  delete_lookalike_segment_seed_aggregate?: Maybe<Lookalike_Segment_Seed_Aggregate_Mutation_Response>;
  /** delete single row from the table: "lookalike_segment_seed_aggregate" */
  delete_lookalike_segment_seed_aggregate_by_pk?: Maybe<Lookalike_Segment_Seed_Aggregate>;
  /** delete data from the table: "lookalike_segment_similarity" */
  delete_lookalike_segment_similarity?: Maybe<Lookalike_Segment_Similarity_Mutation_Response>;
  /** delete single row from the table: "lookalike_segment_similarity" */
  delete_lookalike_segment_similarity_by_pk?: Maybe<Lookalike_Segment_Similarity>;
  /** delete data from the table: "provider" */
  delete_provider?: Maybe<Provider_Mutation_Response>;
  /** delete single row from the table: "provider" */
  delete_provider_by_pk?: Maybe<Provider>;
  /** delete data from the table: "region" */
  delete_region?: Maybe<Region_Mutation_Response>;
  /** delete single row from the table: "region" */
  delete_region_by_pk?: Maybe<Region>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "segment" */
  delete_segment?: Maybe<Segment_Mutation_Response>;
  /** delete single row from the table: "segment" */
  delete_segment_by_pk?: Maybe<Segment>;
  /** delete data from the table: "segment_country" */
  delete_segment_country?: Maybe<Segment_Country_Mutation_Response>;
  /** delete single row from the table: "segment_country" */
  delete_segment_country_by_pk?: Maybe<Segment_Country>;
  /** delete data from the table: "segment_region" */
  delete_segment_region?: Maybe<Segment_Region_Mutation_Response>;
  /** delete single row from the table: "segment_region" */
  delete_segment_region_by_pk?: Maybe<Segment_Region>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  exportAudience?: Maybe<Scalars['JSON']['output']>;
  exportAudienceBulk?: Maybe<Scalars['JSON']['output']>;
  generate_reach_report_overall?: Maybe<AudienceReportStatusResponse>;
  generate_reach_report_publisher?: Maybe<AudienceReportStatusResponse>;
  /** insert data into the table: "account" */
  insert_account?: Maybe<Account_Mutation_Response>;
  /** insert data into the table: "account_feature_flags" */
  insert_account_feature_flags?: Maybe<Account_Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "account_feature_flags" */
  insert_account_feature_flags_one?: Maybe<Account_Feature_Flags>;
  /** insert a single row into the table: "account" */
  insert_account_one?: Maybe<Account>;
  /** insert data into the table: "account_provider" */
  insert_account_provider?: Maybe<Account_Provider_Mutation_Response>;
  /** insert a single row into the table: "account_provider" */
  insert_account_provider_one?: Maybe<Account_Provider>;
  /** insert data into the table: "audience" */
  insert_audience?: Maybe<Audience_Mutation_Response>;
  /** insert a single row into the table: "audience" */
  insert_audience_one?: Maybe<Audience>;
  /** insert data into the table: "audience_segment" */
  insert_audience_segment?: Maybe<Audience_Segment_Mutation_Response>;
  /** insert a single row into the table: "audience_segment" */
  insert_audience_segment_one?: Maybe<Audience_Segment>;
  /** insert data into the table: "bq_resource" */
  insert_bq_resource?: Maybe<Bq_Resource_Mutation_Response>;
  /** insert a single row into the table: "bq_resource" */
  insert_bq_resource_one?: Maybe<Bq_Resource>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<Country_Mutation_Response>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "export" */
  insert_export?: Maybe<Export_Mutation_Response>;
  /** insert a single row into the table: "export" */
  insert_export_one?: Maybe<Export>;
  /** insert data into the table: "export_status_timeline" */
  insert_export_status_timeline?: Maybe<Export_Status_Timeline_Mutation_Response>;
  /** insert a single row into the table: "export_status_timeline" */
  insert_export_status_timeline_one?: Maybe<Export_Status_Timeline>;
  /** insert data into the table: "feature_flags" */
  insert_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "feature_flags" */
  insert_feature_flags_one?: Maybe<Feature_Flags>;
  /** insert data into the table: "lookalike_definition" */
  insert_lookalike_definition?: Maybe<Lookalike_Definition_Mutation_Response>;
  /** insert a single row into the table: "lookalike_definition" */
  insert_lookalike_definition_one?: Maybe<Lookalike_Definition>;
  /** insert data into the table: "lookalike_job_run" */
  insert_lookalike_job_run?: Maybe<Lookalike_Job_Run_Mutation_Response>;
  /** insert a single row into the table: "lookalike_job_run" */
  insert_lookalike_job_run_one?: Maybe<Lookalike_Job_Run>;
  /** insert data into the table: "lookalike_seed_source" */
  insert_lookalike_seed_source?: Maybe<Lookalike_Seed_Source_Mutation_Response>;
  /** insert a single row into the table: "lookalike_seed_source" */
  insert_lookalike_seed_source_one?: Maybe<Lookalike_Seed_Source>;
  /** insert data into the table: "lookalike_segment_seed_aggregate" */
  insert_lookalike_segment_seed_aggregate?: Maybe<Lookalike_Segment_Seed_Aggregate_Mutation_Response>;
  /** insert a single row into the table: "lookalike_segment_seed_aggregate" */
  insert_lookalike_segment_seed_aggregate_one?: Maybe<Lookalike_Segment_Seed_Aggregate>;
  /** insert data into the table: "lookalike_segment_similarity" */
  insert_lookalike_segment_similarity?: Maybe<Lookalike_Segment_Similarity_Mutation_Response>;
  /** insert a single row into the table: "lookalike_segment_similarity" */
  insert_lookalike_segment_similarity_one?: Maybe<Lookalike_Segment_Similarity>;
  /** insert data into the table: "provider" */
  insert_provider?: Maybe<Provider_Mutation_Response>;
  /** insert a single row into the table: "provider" */
  insert_provider_one?: Maybe<Provider>;
  /** insert data into the table: "region" */
  insert_region?: Maybe<Region_Mutation_Response>;
  /** insert a single row into the table: "region" */
  insert_region_one?: Maybe<Region>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<Role_Mutation_Response>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "segment" */
  insert_segment?: Maybe<Segment_Mutation_Response>;
  /** insert data into the table: "segment_country" */
  insert_segment_country?: Maybe<Segment_Country_Mutation_Response>;
  /** insert a single row into the table: "segment_country" */
  insert_segment_country_one?: Maybe<Segment_Country>;
  /** insert a single row into the table: "segment" */
  insert_segment_one?: Maybe<Segment>;
  /** insert data into the table: "segment_region" */
  insert_segment_region?: Maybe<Segment_Region_Mutation_Response>;
  /** insert a single row into the table: "segment_region" */
  insert_segment_region_one?: Maybe<Segment_Region>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /**
   * Adds the AQUA_API feature flag to the given account so it becomes visible as an Aqua advertiser.
   * Idempotent: re-linking an already-linked account is a no-op. Internal admins only.
   */
  link_account_as_aqua_advertiser?: Maybe<Account>;
  modifyPackage: Package;
  pauseBidderCreative: BidderCreative;
  pauseBidderLineItem: BidderLineItem;
  pauseBidderOrder: BidderOrder;
  /**  For error, please fill in 'auc_score' field and 'message' key and value in error field.  Leave segmentConfigs null.  */
  postBulkCreateUpdateLookalikeSegmentsOrReportError?: Maybe<Lookalike_Definition>;
  publisherProfileContactRequest: PublisherProfileContactRequestResponse;
  removeBidderLineItemCreatives: BidderLineItem;
  removeUsersFromSegment: ModifySegmentResponse;
  routedSegmentArchive: Scalars['String']['output'];
  routedSegmentCreate: RoutedSegment;
  routedSegmentUpdate: RoutedSegment;
  /**
   * Send a message in a Deal Prompt conversation.
   *
   * Returns immediately with `sessionId` and `invocationId`. Poll
   * `dealPromptSession` until a message with the matching
   * `invocationId` appears to retrieve the agent's response.
   *
   * If `sessionId` is omitted a new session is created lazily.
   */
  sendDealPromptMessage: SendDealPromptMessageResponse;
  /** Lookup the given network account in the MGMT API, and set the exchange_account_network_id, exchange_account_network_revision_applied and exchange_account_network for the hasura account for 'id' */
  setAccountNetwork?: Maybe<Scalars['ExchangeJSON']['output']>;
  /** Given an account id, and the default values, set the third party fees defaults for that account and return the modified account */
  setThirdPartyFeesDefaults?: Maybe<Scalars['ExchangeJSON']['output']>;
  triggerLookalikePipeline?: Maybe<Scalars['JSON']['output']>;
  /** Update a network account in MGMT API, and return the modified account, the id is the account id in the MGMT API */
  updateAccountNetwork?: Maybe<Scalars['ExchangeJSON']['output']>;
  updateBidderCreative: BidderCreative;
  updateBidderLineItem: BidderLineItem;
  updateBidderOrder: BidderOrder;
  updateDeal: ExchangeDeal;
  updateDealAndPackage: ExchangeDeal;
  updateInventorylist?: Maybe<Scalars['ExchangeJSON']['output']>;
  updateLookalikeObjectsAndSegments?: Maybe<Lookalike_Definition>;
  updateManagementSegment?: Maybe<MngBaseSegment>;
  updatePixel: Pixel;
  /** update data of the table: "account" */
  update_account?: Maybe<Account_Mutation_Response>;
  /** update single row of the table: "account" */
  update_account_by_pk?: Maybe<Account>;
  /** update data of the table: "account_feature_flags" */
  update_account_feature_flags?: Maybe<Account_Feature_Flags_Mutation_Response>;
  /** update single row of the table: "account_feature_flags" */
  update_account_feature_flags_by_pk?: Maybe<Account_Feature_Flags>;
  /** update multiples rows of table: "account_feature_flags" */
  update_account_feature_flags_many?: Maybe<Array<Maybe<Account_Feature_Flags_Mutation_Response>>>;
  /** update multiples rows of table: "account" */
  update_account_many?: Maybe<Array<Maybe<Account_Mutation_Response>>>;
  /** update data of the table: "account_provider" */
  update_account_provider?: Maybe<Account_Provider_Mutation_Response>;
  /** update single row of the table: "account_provider" */
  update_account_provider_by_pk?: Maybe<Account_Provider>;
  /** update multiples rows of table: "account_provider" */
  update_account_provider_many?: Maybe<Array<Maybe<Account_Provider_Mutation_Response>>>;
  /** update data of the table: "audience" */
  update_audience?: Maybe<Audience_Mutation_Response>;
  /** update single row of the table: "audience" */
  update_audience_by_pk?: Maybe<Audience>;
  /** update multiples rows of table: "audience" */
  update_audience_many?: Maybe<Array<Maybe<Audience_Mutation_Response>>>;
  /** update data of the table: "audience_segment" */
  update_audience_segment?: Maybe<Audience_Segment_Mutation_Response>;
  /** update single row of the table: "audience_segment" */
  update_audience_segment_by_pk?: Maybe<Audience_Segment>;
  /** update multiples rows of table: "audience_segment" */
  update_audience_segment_many?: Maybe<Array<Maybe<Audience_Segment_Mutation_Response>>>;
  /** update data of the table: "bq_resource" */
  update_bq_resource?: Maybe<Bq_Resource_Mutation_Response>;
  /** update single row of the table: "bq_resource" */
  update_bq_resource_by_pk?: Maybe<Bq_Resource>;
  /** update multiples rows of table: "bq_resource" */
  update_bq_resource_many?: Maybe<Array<Maybe<Bq_Resource_Mutation_Response>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<Country_Mutation_Response>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<Country_Mutation_Response>>>;
  /** update data of the table: "export" */
  update_export?: Maybe<Export_Mutation_Response>;
  /** update single row of the table: "export" */
  update_export_by_pk?: Maybe<Export>;
  /** update multiples rows of table: "export" */
  update_export_many?: Maybe<Array<Maybe<Export_Mutation_Response>>>;
  /** update data of the table: "export_status_timeline" */
  update_export_status_timeline?: Maybe<Export_Status_Timeline_Mutation_Response>;
  /** update single row of the table: "export_status_timeline" */
  update_export_status_timeline_by_pk?: Maybe<Export_Status_Timeline>;
  /** update multiples rows of table: "export_status_timeline" */
  update_export_status_timeline_many?: Maybe<Array<Maybe<Export_Status_Timeline_Mutation_Response>>>;
  /** update data of the table: "feature_flags" */
  update_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** update single row of the table: "feature_flags" */
  update_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** update multiples rows of table: "feature_flags" */
  update_feature_flags_many?: Maybe<Array<Maybe<Feature_Flags_Mutation_Response>>>;
  /** update data of the table: "lookalike_definition" */
  update_lookalike_definition?: Maybe<Lookalike_Definition_Mutation_Response>;
  /** update single row of the table: "lookalike_definition" */
  update_lookalike_definition_by_pk?: Maybe<Lookalike_Definition>;
  /** update multiples rows of table: "lookalike_definition" */
  update_lookalike_definition_many?: Maybe<Array<Maybe<Lookalike_Definition_Mutation_Response>>>;
  /** update data of the table: "lookalike_job_run" */
  update_lookalike_job_run?: Maybe<Lookalike_Job_Run_Mutation_Response>;
  /** update single row of the table: "lookalike_job_run" */
  update_lookalike_job_run_by_pk?: Maybe<Lookalike_Job_Run>;
  /** update multiples rows of table: "lookalike_job_run" */
  update_lookalike_job_run_many?: Maybe<Array<Maybe<Lookalike_Job_Run_Mutation_Response>>>;
  /** update data of the table: "lookalike_seed_source" */
  update_lookalike_seed_source?: Maybe<Lookalike_Seed_Source_Mutation_Response>;
  /** update single row of the table: "lookalike_seed_source" */
  update_lookalike_seed_source_by_pk?: Maybe<Lookalike_Seed_Source>;
  /** update multiples rows of table: "lookalike_seed_source" */
  update_lookalike_seed_source_many?: Maybe<Array<Maybe<Lookalike_Seed_Source_Mutation_Response>>>;
  /** update data of the table: "lookalike_segment_seed_aggregate" */
  update_lookalike_segment_seed_aggregate?: Maybe<Lookalike_Segment_Seed_Aggregate_Mutation_Response>;
  /** update single row of the table: "lookalike_segment_seed_aggregate" */
  update_lookalike_segment_seed_aggregate_by_pk?: Maybe<Lookalike_Segment_Seed_Aggregate>;
  /** update multiples rows of table: "lookalike_segment_seed_aggregate" */
  update_lookalike_segment_seed_aggregate_many?: Maybe<Array<Maybe<Lookalike_Segment_Seed_Aggregate_Mutation_Response>>>;
  /** update data of the table: "lookalike_segment_similarity" */
  update_lookalike_segment_similarity?: Maybe<Lookalike_Segment_Similarity_Mutation_Response>;
  /** update single row of the table: "lookalike_segment_similarity" */
  update_lookalike_segment_similarity_by_pk?: Maybe<Lookalike_Segment_Similarity>;
  /** update multiples rows of table: "lookalike_segment_similarity" */
  update_lookalike_segment_similarity_many?: Maybe<Array<Maybe<Lookalike_Segment_Similarity_Mutation_Response>>>;
  /** update data of the table: "provider" */
  update_provider?: Maybe<Provider_Mutation_Response>;
  /** update single row of the table: "provider" */
  update_provider_by_pk?: Maybe<Provider>;
  /** update multiples rows of table: "provider" */
  update_provider_many?: Maybe<Array<Maybe<Provider_Mutation_Response>>>;
  /** update data of the table: "region" */
  update_region?: Maybe<Region_Mutation_Response>;
  /** update single row of the table: "region" */
  update_region_by_pk?: Maybe<Region>;
  /** update multiples rows of table: "region" */
  update_region_many?: Maybe<Array<Maybe<Region_Mutation_Response>>>;
  /** update data of the table: "role" */
  update_role?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update multiples rows of table: "role" */
  update_role_many?: Maybe<Array<Maybe<Role_Mutation_Response>>>;
  /** update data of the table: "segment" */
  update_segment?: Maybe<Segment_Mutation_Response>;
  /** update single row of the table: "segment" */
  update_segment_by_pk?: Maybe<Segment>;
  /** update data of the table: "segment_country" */
  update_segment_country?: Maybe<Segment_Country_Mutation_Response>;
  /** update single row of the table: "segment_country" */
  update_segment_country_by_pk?: Maybe<Segment_Country>;
  /** update multiples rows of table: "segment_country" */
  update_segment_country_many?: Maybe<Array<Maybe<Segment_Country_Mutation_Response>>>;
  /** update multiples rows of table: "segment" */
  update_segment_many?: Maybe<Array<Maybe<Segment_Mutation_Response>>>;
  /** update data of the table: "segment_region" */
  update_segment_region?: Maybe<Segment_Region_Mutation_Response>;
  /** update single row of the table: "segment_region" */
  update_segment_region_by_pk?: Maybe<Segment_Region>;
  /** update multiples rows of table: "segment_region" */
  update_segment_region_many?: Maybe<Array<Maybe<Segment_Region_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
};


export type MutationActivateAudienceArgs = {
  audienceId: Scalars['uuid']['input'];
};


export type MutationActivateAudienceV2Args = {
  audienceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationActivateBidderCreativeArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationActivateBidderLineItemArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationActivateBidderOrderArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddBidderLineItemCreativesArgs = {
  creativeIds: Array<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  lineItemId: Scalars['String']['input'];
};


export type MutationAddUsersToSegmentArgs = {
  data: UserDataInput;
  segmentId: Scalars['uuid']['input'];
};


export type MutationArchiveAccountNetworkArgs = {
  exchange_account_network_id: Scalars['String']['input'];
};


export type MutationArchiveBidderCreativeArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveBidderLineItemArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveBidderOrderArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveDealArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveDealAndPackageArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveLookalikeObjectAndSegmentsArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationArchiveManagementSegmentArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchivePackageArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchivePixelArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveSignalArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAudienceShareCreateArgs = {
  input: Array<AudienceShareCreateParams>;
};


export type MutationAudienceShareDeleteArgs = {
  input: Array<Scalars['uuid']['input']>;
};


export type MutationAudienceShareUpdateArgs = {
  input: Array<AudienceShareUpdateParams>;
};


export type MutationBulkUpdateDealRboConfigArgs = {
  input: Array<BulkRboConfigInput>;
};


export type MutationCancelDealInsightsJobArgs = {
  job_id: Scalars['String']['input'];
};


export type MutationCloneAudienceArgs = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type MutationClonePackageArgs = {
  contextual_segment_format?: InputMaybe<ContextualSegmentFormat>;
  id: Scalars['String']['input'];
  package?: InputMaybe<PackageUpdateParams>;
};


export type MutationCreateAccountNetworkArgs = {
  account: AccountNetworkCreateParams;
};


export type MutationCreateBidderCreativeArgs = {
  input: BidderCreativeCreateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBidderLineItemArgs = {
  input: BidderLineItemCreateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBidderOrderArgs = {
  input: BidderOrderCreateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDealArgs = {
  deal: DealCreateInput;
  deal_id_prefix?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDealAndPackageArgs = {
  contextual_segment_format?: InputMaybe<ContextualSegmentFormat>;
  deal: ExchangeDealCreateParams;
  deal_id_prefix?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<PackageCreateParams>;
};


export type MutationCreateDealForecastingJobArgs = {
  deal: ExchangeDealForecastingDealParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  package: PackageCreateParams;
};


export type MutationCreateDealInsightsJobArgs = {
  ad_duration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adsize?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyer_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  charts: DealInsightsChartsInput;
  domain_bundle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dsp_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date: Scalars['timestamptz']['input'];
  media_subtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ox_deal_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pub_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date: Scalars['timestamptz']['input'];
  type_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateDealTroubleshootingFactJobArgs = {
  deal_id: Scalars['String']['input'];
  dsp_id?: InputMaybe<Scalars['String']['input']>;
  end_date: Scalars['timestamptz']['input'];
  resolution?: InputMaybe<DealTroubleshootingTimeResolutionEnum>;
  start_date: Scalars['timestamptz']['input'];
};


export type MutationCreateDealTroubleshootingNrtJobArgs = {
  deal_id: Scalars['String']['input'];
  dsp_id?: InputMaybe<Scalars['String']['input']>;
  lookback_hours?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateInventorylistArgs = {
  payload: Scalars['ExchangeJSON']['input'];
};


export type MutationCreateLogArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  msg?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLookalikeObjectsArgs = {
  definition: Lookalike_Definition_Insert_Input;
  disableTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  seedSegmentIds: Array<Scalars['uuid']['input']>;
};


export type MutationCreateManagementSegmentArgs = {
  input: ManagementSegmentCreateInput;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePackageArgs = {
  contextual_segment_format?: InputMaybe<ContextualSegmentFormat>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  package: PackageCreateParams;
};


export type MutationCreatePixelArgs = {
  input: PixelCreateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateServiceAccountUnderParentAccountArgs = {
  expiresIn: Scalars['Duration']['input'];
  name: Scalars['String']['input'];
  parent_account_id: Scalars['String']['input'];
  rateLimit?: InputMaybe<RateLimit>;
};


export type MutationCreateSignalArgs = {
  input: SignalCreateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserUnderParentAccountArgs = {
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  parent_account_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserUnderRootAccountArgs = {
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCuratedDealBuyerDiscountCreateArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['ExchangeJSON']['input'];
};


export type MutationCuratedDealBuyerDiscountDeleteArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};


export type MutationCuratedDealBuyerDiscountUpdateArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['ExchangeJSON']['input'];
  uid: Scalars['ID']['input'];
};


export type MutationDealInsightsFilterOptionsArgs = {
  ad_duration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adsize?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyer_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain_bundle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dsp_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date: Scalars['timestamptz']['input'];
  media_subtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ox_deal_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pub_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date: Scalars['timestamptz']['input'];
  type_name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDealTroubleshootingAgentAsyncQueryArgs = {
  deal_id: Scalars['String']['input'];
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_message: Scalars['String']['input'];
};


export type MutationDealTroubleshootingAgentRegisterFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  deal_id: Scalars['String']['input'];
  langfuse_trace_id: Scalars['String']['input'];
  score: Scalars['Boolean']['input'];
};


export type MutationDeleteInventorylistArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMgmtUserArgs = {
  firebaseId: Scalars['ID']['input'];
};


export type MutationDelete_AccountArgs = {
  where: Account_Bool_Exp;
};


export type MutationDelete_Account_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Account_Feature_FlagsArgs = {
  where: Account_Feature_Flags_Bool_Exp;
};


export type MutationDelete_Account_Feature_Flags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Account_ProviderArgs = {
  where: Account_Provider_Bool_Exp;
};


export type MutationDelete_Account_Provider_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_AudienceArgs = {
  where: Audience_Bool_Exp;
};


export type MutationDelete_Audience_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Audience_SegmentArgs = {
  where: Audience_Segment_Bool_Exp;
};


export type MutationDelete_Audience_Segment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Bq_ResourceArgs = {
  where: Bq_Resource_Bool_Exp;
};


export type MutationDelete_Bq_Resource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_CountryArgs = {
  where: Country_Bool_Exp;
};


export type MutationDelete_Country_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type MutationDelete_ExportArgs = {
  where: Export_Bool_Exp;
};


export type MutationDelete_Export_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Export_Status_TimelineArgs = {
  where: Export_Status_Timeline_Bool_Exp;
};


export type MutationDelete_Export_Status_Timeline_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Feature_FlagsArgs = {
  where: Feature_Flags_Bool_Exp;
};


export type MutationDelete_Feature_Flags_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type MutationDelete_Lookalike_DefinitionArgs = {
  where: Lookalike_Definition_Bool_Exp;
};


export type MutationDelete_Lookalike_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Lookalike_Job_RunArgs = {
  where: Lookalike_Job_Run_Bool_Exp;
};


export type MutationDelete_Lookalike_Job_Run_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Lookalike_Seed_SourceArgs = {
  where: Lookalike_Seed_Source_Bool_Exp;
};


export type MutationDelete_Lookalike_Seed_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Lookalike_Segment_Seed_AggregateArgs = {
  where: Lookalike_Segment_Seed_Aggregate_Bool_Exp;
};


export type MutationDelete_Lookalike_Segment_Seed_Aggregate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Lookalike_Segment_SimilarityArgs = {
  where: Lookalike_Segment_Similarity_Bool_Exp;
};


export type MutationDelete_Lookalike_Segment_Similarity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_ProviderArgs = {
  where: Provider_Bool_Exp;
};


export type MutationDelete_Provider_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type MutationDelete_RegionArgs = {
  where: Region_Bool_Exp;
};


export type MutationDelete_Region_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type MutationDelete_RoleArgs = {
  where: Role_Bool_Exp;
};


export type MutationDelete_Role_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type MutationDelete_SegmentArgs = {
  where: Segment_Bool_Exp;
};


export type MutationDelete_Segment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationDelete_Segment_CountryArgs = {
  where: Segment_Country_Bool_Exp;
};


export type MutationDelete_Segment_Country_By_PkArgs = {
  country_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};


export type MutationDelete_Segment_RegionArgs = {
  where: Segment_Region_Bool_Exp;
};


export type MutationDelete_Segment_Region_By_PkArgs = {
  region_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};


export type MutationDelete_UserArgs = {
  where: User_Bool_Exp;
};


export type MutationDelete_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationExportAudienceArgs = {
  audienceId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Export_Audience_Config_Input>;
};


export type MutationExportAudienceBulkArgs = {
  exportBulkConfig?: InputMaybe<Array<InputMaybe<Export_Bulk_Audience_Config_Input>>>;
};


export type MutationGenerate_Reach_Report_OverallArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationGenerate_Reach_Report_PublisherArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationInsert_AccountArgs = {
  objects: Array<Account_Insert_Input>;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


export type MutationInsert_Account_Feature_FlagsArgs = {
  objects: Array<Account_Feature_Flags_Insert_Input>;
  on_conflict?: InputMaybe<Account_Feature_Flags_On_Conflict>;
};


export type MutationInsert_Account_Feature_Flags_OneArgs = {
  object: Account_Feature_Flags_Insert_Input;
  on_conflict?: InputMaybe<Account_Feature_Flags_On_Conflict>;
};


export type MutationInsert_Account_OneArgs = {
  object: Account_Insert_Input;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


export type MutationInsert_Account_ProviderArgs = {
  objects: Array<Account_Provider_Insert_Input>;
  on_conflict?: InputMaybe<Account_Provider_On_Conflict>;
};


export type MutationInsert_Account_Provider_OneArgs = {
  object: Account_Provider_Insert_Input;
  on_conflict?: InputMaybe<Account_Provider_On_Conflict>;
};


export type MutationInsert_AudienceArgs = {
  objects: Array<Audience_Insert_Input>;
  on_conflict?: InputMaybe<Audience_On_Conflict>;
};


export type MutationInsert_Audience_OneArgs = {
  object: Audience_Insert_Input;
  on_conflict?: InputMaybe<Audience_On_Conflict>;
};


export type MutationInsert_Audience_SegmentArgs = {
  objects: Array<Audience_Segment_Insert_Input>;
  on_conflict?: InputMaybe<Audience_Segment_On_Conflict>;
};


export type MutationInsert_Audience_Segment_OneArgs = {
  object: Audience_Segment_Insert_Input;
  on_conflict?: InputMaybe<Audience_Segment_On_Conflict>;
};


export type MutationInsert_Bq_ResourceArgs = {
  objects: Array<Bq_Resource_Insert_Input>;
  on_conflict?: InputMaybe<Bq_Resource_On_Conflict>;
};


export type MutationInsert_Bq_Resource_OneArgs = {
  object: Bq_Resource_Insert_Input;
  on_conflict?: InputMaybe<Bq_Resource_On_Conflict>;
};


export type MutationInsert_CountryArgs = {
  objects: Array<Country_Insert_Input>;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


export type MutationInsert_Country_OneArgs = {
  object: Country_Insert_Input;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


export type MutationInsert_ExportArgs = {
  objects: Array<Export_Insert_Input>;
  on_conflict?: InputMaybe<Export_On_Conflict>;
};


export type MutationInsert_Export_OneArgs = {
  object: Export_Insert_Input;
  on_conflict?: InputMaybe<Export_On_Conflict>;
};


export type MutationInsert_Export_Status_TimelineArgs = {
  objects: Array<Export_Status_Timeline_Insert_Input>;
  on_conflict?: InputMaybe<Export_Status_Timeline_On_Conflict>;
};


export type MutationInsert_Export_Status_Timeline_OneArgs = {
  object: Export_Status_Timeline_Insert_Input;
  on_conflict?: InputMaybe<Export_Status_Timeline_On_Conflict>;
};


export type MutationInsert_Feature_FlagsArgs = {
  objects: Array<Feature_Flags_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


export type MutationInsert_Feature_Flags_OneArgs = {
  object: Feature_Flags_Insert_Input;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


export type MutationInsert_Lookalike_DefinitionArgs = {
  objects: Array<Lookalike_Definition_Insert_Input>;
  on_conflict?: InputMaybe<Lookalike_Definition_On_Conflict>;
};


export type MutationInsert_Lookalike_Definition_OneArgs = {
  object: Lookalike_Definition_Insert_Input;
  on_conflict?: InputMaybe<Lookalike_Definition_On_Conflict>;
};


export type MutationInsert_Lookalike_Job_RunArgs = {
  objects: Array<Lookalike_Job_Run_Insert_Input>;
  on_conflict?: InputMaybe<Lookalike_Job_Run_On_Conflict>;
};


export type MutationInsert_Lookalike_Job_Run_OneArgs = {
  object: Lookalike_Job_Run_Insert_Input;
  on_conflict?: InputMaybe<Lookalike_Job_Run_On_Conflict>;
};


export type MutationInsert_Lookalike_Seed_SourceArgs = {
  objects: Array<Lookalike_Seed_Source_Insert_Input>;
  on_conflict?: InputMaybe<Lookalike_Seed_Source_On_Conflict>;
};


export type MutationInsert_Lookalike_Seed_Source_OneArgs = {
  object: Lookalike_Seed_Source_Insert_Input;
  on_conflict?: InputMaybe<Lookalike_Seed_Source_On_Conflict>;
};


export type MutationInsert_Lookalike_Segment_Seed_AggregateArgs = {
  objects: Array<Lookalike_Segment_Seed_Aggregate_Insert_Input>;
  on_conflict?: InputMaybe<Lookalike_Segment_Seed_Aggregate_On_Conflict>;
};


export type MutationInsert_Lookalike_Segment_Seed_Aggregate_OneArgs = {
  object: Lookalike_Segment_Seed_Aggregate_Insert_Input;
  on_conflict?: InputMaybe<Lookalike_Segment_Seed_Aggregate_On_Conflict>;
};


export type MutationInsert_Lookalike_Segment_SimilarityArgs = {
  objects: Array<Lookalike_Segment_Similarity_Insert_Input>;
  on_conflict?: InputMaybe<Lookalike_Segment_Similarity_On_Conflict>;
};


export type MutationInsert_Lookalike_Segment_Similarity_OneArgs = {
  object: Lookalike_Segment_Similarity_Insert_Input;
  on_conflict?: InputMaybe<Lookalike_Segment_Similarity_On_Conflict>;
};


export type MutationInsert_ProviderArgs = {
  objects: Array<Provider_Insert_Input>;
  on_conflict?: InputMaybe<Provider_On_Conflict>;
};


export type MutationInsert_Provider_OneArgs = {
  object: Provider_Insert_Input;
  on_conflict?: InputMaybe<Provider_On_Conflict>;
};


export type MutationInsert_RegionArgs = {
  objects: Array<Region_Insert_Input>;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


export type MutationInsert_Region_OneArgs = {
  object: Region_Insert_Input;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


export type MutationInsert_RoleArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


export type MutationInsert_Role_OneArgs = {
  object: Role_Insert_Input;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


export type MutationInsert_SegmentArgs = {
  objects: Array<Segment_Insert_Input>;
  on_conflict?: InputMaybe<Segment_On_Conflict>;
};


export type MutationInsert_Segment_CountryArgs = {
  objects: Array<Segment_Country_Insert_Input>;
  on_conflict?: InputMaybe<Segment_Country_On_Conflict>;
};


export type MutationInsert_Segment_Country_OneArgs = {
  object: Segment_Country_Insert_Input;
  on_conflict?: InputMaybe<Segment_Country_On_Conflict>;
};


export type MutationInsert_Segment_OneArgs = {
  object: Segment_Insert_Input;
  on_conflict?: InputMaybe<Segment_On_Conflict>;
};


export type MutationInsert_Segment_RegionArgs = {
  objects: Array<Segment_Region_Insert_Input>;
  on_conflict?: InputMaybe<Segment_Region_On_Conflict>;
};


export type MutationInsert_Segment_Region_OneArgs = {
  object: Segment_Region_Insert_Input;
  on_conflict?: InputMaybe<Segment_Region_On_Conflict>;
};


export type MutationInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


export type MutationInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


export type MutationLink_Account_As_Aqua_AdvertiserArgs = {
  account_id: Scalars['uuid']['input'];
};


export type MutationModifyPackageArgs = {
  contextual_segment_format?: InputMaybe<ContextualSegmentFormat>;
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  package: PackageUpdateParams;
};


export type MutationPauseBidderCreativeArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPauseBidderLineItemArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPauseBidderOrderArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPostBulkCreateUpdateLookalikeSegmentsOrReportErrorArgs = {
  definitionSet: Lookalike_Definition_Set_Input;
  id: Scalars['uuid']['input'];
  segmentConfigs?: InputMaybe<Array<Lookalike_Segment_Config_Input>>;
};


export type MutationPublisherProfileContactRequestArgs = {
  id: Scalars['String']['input'];
  input: PublisherProfileContactRequestInput;
};


export type MutationRemoveBidderLineItemCreativesArgs = {
  creativeIds: Array<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  lineItemId: Scalars['String']['input'];
};


export type MutationRemoveUsersFromSegmentArgs = {
  data: UserDataInput;
  segmentId: Scalars['uuid']['input'];
};


export type MutationRoutedSegmentArchiveArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  type_full?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRoutedSegmentCreateArgs = {
  input: RoutedSegmentCreateInput;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRoutedSegmentUpdateArgs = {
  id: Scalars['String']['input'];
  input: RoutedSegmentUpdateInput;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendDealPromptMessageArgs = {
  input: SendDealPromptMessageInput;
};


export type MutationSetAccountNetworkArgs = {
  exchange_account_network_id: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
};


export type MutationSetThirdPartyFeesDefaultsArgs = {
  params: ThirdPartyFeesDefaultsInput;
};


export type MutationTriggerLookalikePipelineArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationUpdateAccountNetworkArgs = {
  account: AccountNetworkUpdateParams;
  exchange_account_network_id: Scalars['String']['input'];
};


export type MutationUpdateBidderCreativeArgs = {
  id: Scalars['String']['input'];
  input: BidderCreativeUpdateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBidderLineItemArgs = {
  id: Scalars['String']['input'];
  input: BidderLineItemUpdateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBidderOrderArgs = {
  id: Scalars['String']['input'];
  input: BidderOrderUpdateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDealArgs = {
  deal: DealUpdateInput;
};


export type MutationUpdateDealAndPackageArgs = {
  contextual_segment_format?: InputMaybe<ContextualSegmentFormat>;
  deal?: InputMaybe<ExchangeDealUpdateParams>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<PackageUpdateParams>;
};


export type MutationUpdateInventorylistArgs = {
  payload: Scalars['ExchangeJSON']['input'];
};


export type MutationUpdateLookalikeObjectsAndSegmentsArgs = {
  definitionSet: Lookalike_Definition_Set_Input;
  disableTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['uuid']['input'];
  seedSegmentIdsSet: Array<Scalars['uuid']['input']>;
};


export type MutationUpdateManagementSegmentArgs = {
  id: Scalars['String']['input'];
  input: ManagementSegmentUpdateInput;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePixelArgs = {
  id: Scalars['String']['input'];
  input: PixelUpdateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdate_AccountArgs = {
  _append?: InputMaybe<Account_Append_Input>;
  _delete_at_path?: InputMaybe<Account_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Account_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Account_Delete_Key_Input>;
  _inc?: InputMaybe<Account_Inc_Input>;
  _prepend?: InputMaybe<Account_Prepend_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  where: Account_Bool_Exp;
};


export type MutationUpdate_Account_By_PkArgs = {
  _append?: InputMaybe<Account_Append_Input>;
  _delete_at_path?: InputMaybe<Account_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Account_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Account_Delete_Key_Input>;
  _inc?: InputMaybe<Account_Inc_Input>;
  _prepend?: InputMaybe<Account_Prepend_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  pk_columns: Account_Pk_Columns_Input;
};


export type MutationUpdate_Account_Feature_FlagsArgs = {
  _set?: InputMaybe<Account_Feature_Flags_Set_Input>;
  where: Account_Feature_Flags_Bool_Exp;
};


export type MutationUpdate_Account_Feature_Flags_By_PkArgs = {
  _set?: InputMaybe<Account_Feature_Flags_Set_Input>;
  pk_columns: Account_Feature_Flags_Pk_Columns_Input;
};


export type MutationUpdate_Account_Feature_Flags_ManyArgs = {
  updates: Array<Account_Feature_Flags_Updates>;
};


export type MutationUpdate_Account_ManyArgs = {
  updates: Array<Account_Updates>;
};


export type MutationUpdate_Account_ProviderArgs = {
  _set?: InputMaybe<Account_Provider_Set_Input>;
  where: Account_Provider_Bool_Exp;
};


export type MutationUpdate_Account_Provider_By_PkArgs = {
  _set?: InputMaybe<Account_Provider_Set_Input>;
  pk_columns: Account_Provider_Pk_Columns_Input;
};


export type MutationUpdate_Account_Provider_ManyArgs = {
  updates: Array<Account_Provider_Updates>;
};


export type MutationUpdate_AudienceArgs = {
  _append?: InputMaybe<Audience_Append_Input>;
  _delete_at_path?: InputMaybe<Audience_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audience_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audience_Delete_Key_Input>;
  _inc?: InputMaybe<Audience_Inc_Input>;
  _prepend?: InputMaybe<Audience_Prepend_Input>;
  _set?: InputMaybe<Audience_Set_Input>;
  where: Audience_Bool_Exp;
};


export type MutationUpdate_Audience_By_PkArgs = {
  _append?: InputMaybe<Audience_Append_Input>;
  _delete_at_path?: InputMaybe<Audience_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audience_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audience_Delete_Key_Input>;
  _inc?: InputMaybe<Audience_Inc_Input>;
  _prepend?: InputMaybe<Audience_Prepend_Input>;
  _set?: InputMaybe<Audience_Set_Input>;
  pk_columns: Audience_Pk_Columns_Input;
};


export type MutationUpdate_Audience_ManyArgs = {
  updates: Array<Audience_Updates>;
};


export type MutationUpdate_Audience_SegmentArgs = {
  _set?: InputMaybe<Audience_Segment_Set_Input>;
  where: Audience_Segment_Bool_Exp;
};


export type MutationUpdate_Audience_Segment_By_PkArgs = {
  _set?: InputMaybe<Audience_Segment_Set_Input>;
  pk_columns: Audience_Segment_Pk_Columns_Input;
};


export type MutationUpdate_Audience_Segment_ManyArgs = {
  updates: Array<Audience_Segment_Updates>;
};


export type MutationUpdate_Bq_ResourceArgs = {
  _set?: InputMaybe<Bq_Resource_Set_Input>;
  where: Bq_Resource_Bool_Exp;
};


export type MutationUpdate_Bq_Resource_By_PkArgs = {
  _set?: InputMaybe<Bq_Resource_Set_Input>;
  pk_columns: Bq_Resource_Pk_Columns_Input;
};


export type MutationUpdate_Bq_Resource_ManyArgs = {
  updates: Array<Bq_Resource_Updates>;
};


export type MutationUpdate_CountryArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  where: Country_Bool_Exp;
};


export type MutationUpdate_Country_By_PkArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  pk_columns: Country_Pk_Columns_Input;
};


export type MutationUpdate_Country_ManyArgs = {
  updates: Array<Country_Updates>;
};


export type MutationUpdate_ExportArgs = {
  _append?: InputMaybe<Export_Append_Input>;
  _delete_at_path?: InputMaybe<Export_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Export_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Export_Delete_Key_Input>;
  _prepend?: InputMaybe<Export_Prepend_Input>;
  _set?: InputMaybe<Export_Set_Input>;
  where: Export_Bool_Exp;
};


export type MutationUpdate_Export_By_PkArgs = {
  _append?: InputMaybe<Export_Append_Input>;
  _delete_at_path?: InputMaybe<Export_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Export_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Export_Delete_Key_Input>;
  _prepend?: InputMaybe<Export_Prepend_Input>;
  _set?: InputMaybe<Export_Set_Input>;
  pk_columns: Export_Pk_Columns_Input;
};


export type MutationUpdate_Export_ManyArgs = {
  updates: Array<Export_Updates>;
};


export type MutationUpdate_Export_Status_TimelineArgs = {
  _set?: InputMaybe<Export_Status_Timeline_Set_Input>;
  where: Export_Status_Timeline_Bool_Exp;
};


export type MutationUpdate_Export_Status_Timeline_By_PkArgs = {
  _set?: InputMaybe<Export_Status_Timeline_Set_Input>;
  pk_columns: Export_Status_Timeline_Pk_Columns_Input;
};


export type MutationUpdate_Export_Status_Timeline_ManyArgs = {
  updates: Array<Export_Status_Timeline_Updates>;
};


export type MutationUpdate_Feature_FlagsArgs = {
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  where: Feature_Flags_Bool_Exp;
};


export type MutationUpdate_Feature_Flags_By_PkArgs = {
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  pk_columns: Feature_Flags_Pk_Columns_Input;
};


export type MutationUpdate_Feature_Flags_ManyArgs = {
  updates: Array<Feature_Flags_Updates>;
};


export type MutationUpdate_Lookalike_DefinitionArgs = {
  _append?: InputMaybe<Lookalike_Definition_Append_Input>;
  _delete_at_path?: InputMaybe<Lookalike_Definition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lookalike_Definition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lookalike_Definition_Delete_Key_Input>;
  _inc?: InputMaybe<Lookalike_Definition_Inc_Input>;
  _prepend?: InputMaybe<Lookalike_Definition_Prepend_Input>;
  _set?: InputMaybe<Lookalike_Definition_Set_Input>;
  where: Lookalike_Definition_Bool_Exp;
};


export type MutationUpdate_Lookalike_Definition_By_PkArgs = {
  _append?: InputMaybe<Lookalike_Definition_Append_Input>;
  _delete_at_path?: InputMaybe<Lookalike_Definition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lookalike_Definition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lookalike_Definition_Delete_Key_Input>;
  _inc?: InputMaybe<Lookalike_Definition_Inc_Input>;
  _prepend?: InputMaybe<Lookalike_Definition_Prepend_Input>;
  _set?: InputMaybe<Lookalike_Definition_Set_Input>;
  pk_columns: Lookalike_Definition_Pk_Columns_Input;
};


export type MutationUpdate_Lookalike_Definition_ManyArgs = {
  updates: Array<Lookalike_Definition_Updates>;
};


export type MutationUpdate_Lookalike_Job_RunArgs = {
  _append?: InputMaybe<Lookalike_Job_Run_Append_Input>;
  _delete_at_path?: InputMaybe<Lookalike_Job_Run_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lookalike_Job_Run_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lookalike_Job_Run_Delete_Key_Input>;
  _inc?: InputMaybe<Lookalike_Job_Run_Inc_Input>;
  _prepend?: InputMaybe<Lookalike_Job_Run_Prepend_Input>;
  _set?: InputMaybe<Lookalike_Job_Run_Set_Input>;
  where: Lookalike_Job_Run_Bool_Exp;
};


export type MutationUpdate_Lookalike_Job_Run_By_PkArgs = {
  _append?: InputMaybe<Lookalike_Job_Run_Append_Input>;
  _delete_at_path?: InputMaybe<Lookalike_Job_Run_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lookalike_Job_Run_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lookalike_Job_Run_Delete_Key_Input>;
  _inc?: InputMaybe<Lookalike_Job_Run_Inc_Input>;
  _prepend?: InputMaybe<Lookalike_Job_Run_Prepend_Input>;
  _set?: InputMaybe<Lookalike_Job_Run_Set_Input>;
  pk_columns: Lookalike_Job_Run_Pk_Columns_Input;
};


export type MutationUpdate_Lookalike_Job_Run_ManyArgs = {
  updates: Array<Lookalike_Job_Run_Updates>;
};


export type MutationUpdate_Lookalike_Seed_SourceArgs = {
  _set?: InputMaybe<Lookalike_Seed_Source_Set_Input>;
  where: Lookalike_Seed_Source_Bool_Exp;
};


export type MutationUpdate_Lookalike_Seed_Source_By_PkArgs = {
  _set?: InputMaybe<Lookalike_Seed_Source_Set_Input>;
  pk_columns: Lookalike_Seed_Source_Pk_Columns_Input;
};


export type MutationUpdate_Lookalike_Seed_Source_ManyArgs = {
  updates: Array<Lookalike_Seed_Source_Updates>;
};


export type MutationUpdate_Lookalike_Segment_Seed_AggregateArgs = {
  _set?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Set_Input>;
  where: Lookalike_Segment_Seed_Aggregate_Bool_Exp;
};


export type MutationUpdate_Lookalike_Segment_Seed_Aggregate_By_PkArgs = {
  _set?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Set_Input>;
  pk_columns: Lookalike_Segment_Seed_Aggregate_Pk_Columns_Input;
};


export type MutationUpdate_Lookalike_Segment_Seed_Aggregate_ManyArgs = {
  updates: Array<Lookalike_Segment_Seed_Aggregate_Updates>;
};


export type MutationUpdate_Lookalike_Segment_SimilarityArgs = {
  _inc?: InputMaybe<Lookalike_Segment_Similarity_Inc_Input>;
  _set?: InputMaybe<Lookalike_Segment_Similarity_Set_Input>;
  where: Lookalike_Segment_Similarity_Bool_Exp;
};


export type MutationUpdate_Lookalike_Segment_Similarity_By_PkArgs = {
  _inc?: InputMaybe<Lookalike_Segment_Similarity_Inc_Input>;
  _set?: InputMaybe<Lookalike_Segment_Similarity_Set_Input>;
  pk_columns: Lookalike_Segment_Similarity_Pk_Columns_Input;
};


export type MutationUpdate_Lookalike_Segment_Similarity_ManyArgs = {
  updates: Array<Lookalike_Segment_Similarity_Updates>;
};


export type MutationUpdate_ProviderArgs = {
  _append?: InputMaybe<Provider_Append_Input>;
  _delete_at_path?: InputMaybe<Provider_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Provider_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Provider_Delete_Key_Input>;
  _inc?: InputMaybe<Provider_Inc_Input>;
  _prepend?: InputMaybe<Provider_Prepend_Input>;
  _set?: InputMaybe<Provider_Set_Input>;
  where: Provider_Bool_Exp;
};


export type MutationUpdate_Provider_By_PkArgs = {
  _append?: InputMaybe<Provider_Append_Input>;
  _delete_at_path?: InputMaybe<Provider_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Provider_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Provider_Delete_Key_Input>;
  _inc?: InputMaybe<Provider_Inc_Input>;
  _prepend?: InputMaybe<Provider_Prepend_Input>;
  _set?: InputMaybe<Provider_Set_Input>;
  pk_columns: Provider_Pk_Columns_Input;
};


export type MutationUpdate_Provider_ManyArgs = {
  updates: Array<Provider_Updates>;
};


export type MutationUpdate_RegionArgs = {
  _set?: InputMaybe<Region_Set_Input>;
  where: Region_Bool_Exp;
};


export type MutationUpdate_Region_By_PkArgs = {
  _set?: InputMaybe<Region_Set_Input>;
  pk_columns: Region_Pk_Columns_Input;
};


export type MutationUpdate_Region_ManyArgs = {
  updates: Array<Region_Updates>;
};


export type MutationUpdate_RoleArgs = {
  _append?: InputMaybe<Role_Append_Input>;
  _delete_at_path?: InputMaybe<Role_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Role_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Role_Delete_Key_Input>;
  _prepend?: InputMaybe<Role_Prepend_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


export type MutationUpdate_Role_By_PkArgs = {
  _append?: InputMaybe<Role_Append_Input>;
  _delete_at_path?: InputMaybe<Role_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Role_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Role_Delete_Key_Input>;
  _prepend?: InputMaybe<Role_Prepend_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


export type MutationUpdate_Role_ManyArgs = {
  updates: Array<Role_Updates>;
};


export type MutationUpdate_SegmentArgs = {
  _append?: InputMaybe<Segment_Append_Input>;
  _delete_at_path?: InputMaybe<Segment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Segment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Segment_Delete_Key_Input>;
  _inc?: InputMaybe<Segment_Inc_Input>;
  _prepend?: InputMaybe<Segment_Prepend_Input>;
  _set?: InputMaybe<Segment_Set_Input>;
  where: Segment_Bool_Exp;
};


export type MutationUpdate_Segment_By_PkArgs = {
  _append?: InputMaybe<Segment_Append_Input>;
  _delete_at_path?: InputMaybe<Segment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Segment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Segment_Delete_Key_Input>;
  _inc?: InputMaybe<Segment_Inc_Input>;
  _prepend?: InputMaybe<Segment_Prepend_Input>;
  _set?: InputMaybe<Segment_Set_Input>;
  pk_columns: Segment_Pk_Columns_Input;
};


export type MutationUpdate_Segment_CountryArgs = {
  _set?: InputMaybe<Segment_Country_Set_Input>;
  where: Segment_Country_Bool_Exp;
};


export type MutationUpdate_Segment_Country_By_PkArgs = {
  _set?: InputMaybe<Segment_Country_Set_Input>;
  pk_columns: Segment_Country_Pk_Columns_Input;
};


export type MutationUpdate_Segment_Country_ManyArgs = {
  updates: Array<Segment_Country_Updates>;
};


export type MutationUpdate_Segment_ManyArgs = {
  updates: Array<Segment_Updates>;
};


export type MutationUpdate_Segment_RegionArgs = {
  _set?: InputMaybe<Segment_Region_Set_Input>;
  where: Segment_Region_Bool_Exp;
};


export type MutationUpdate_Segment_Region_By_PkArgs = {
  _set?: InputMaybe<Segment_Region_Set_Input>;
  pk_columns: Segment_Region_Pk_Columns_Input;
};


export type MutationUpdate_Segment_Region_ManyArgs = {
  updates: Array<Segment_Region_Updates>;
};


export type MutationUpdate_UserArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


export type MutationUpdate_User_By_PkArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


export type MutationUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};

/**
 * One UTC day of validated fires, for the 30-day chart. The newest two hours are
 * aggregated from raw events when the query runs. Older hours come from the hourly counts table.
 */
export type NamedPixelDailyFireCount = {
  __typename?: 'NamedPixelDailyFireCount';
  fire_count: Scalars['String']['output'];
  fire_date: Scalars['String']['output'];
};

/**
 * Validated fires of one Named Pixel. Refused fires are not included.
 * Counts are the raw sum of hour buckets. Each window opens at the start of the
 * hour that contains now minus 24 hours or 30 days, so that hour is included.
 * The newest two hours are aggregated from raw events when the query runs. Older
 * hours come from the hourly counts table. A pixel already in pixel_dim includes
 * the current hour. A new pixel can lag up to an hour, until pixel_dim refreshes.
 * first_fire_at is the earliest fire still retained, not the first fire ever.
 */
export type NamedPixelFireFact = {
  __typename?: 'NamedPixelFireFact';
  daily_fire_counts: Array<NamedPixelDailyFireCount>;
  fire_count_24h: Scalars['String']['output'];
  fire_count_30d: Scalars['String']['output'];
  first_fire_at?: Maybe<Scalars['String']['output']>;
  last_fire_at?: Maybe<Scalars['String']['output']>;
  observed_events: Array<NamedPixelObservedEvent>;
  pixel_id: Scalars['String']['output'];
};

export type NamedPixelObservedEvent = {
  __typename?: 'NamedPixelObservedEvent';
  event_type: Scalars['String']['output'];
  /** Validated fires of this event in the last 30 days. */
  fire_count: Scalars['String']['output'];
  first_fire_at: Scalars['String']['output'];
  last_fire_at: Scalars['String']['output'];
};

export type NormalizedDefinition = {
  __typename?: 'NormalizedDefinition';
  includes: NormalizedDefinitionGroups;
};

export type NormalizedDefinitionGroup = {
  __typename?: 'NormalizedDefinitionGroup';
  countries?: Maybe<Array<Scalars['String']['output']>>;
  demographic_age?: Maybe<NormalizedDefinitionSegmentGroup>;
  demographic_gender?: Maybe<NormalizedDefinitionSegmentGroup>;
  direct?: Maybe<NormalizedDefinitionSegmentGroup>;
  location?: Maybe<NormalizedDefinitionSegmentGroup>;
  lookalike?: Maybe<NormalizedDefinitionSegmentGroup>;
  /** @deprecated This field is no longer populated. Use segmentScores.matchedKeyword for matched keyword information. */
  matched_keywords?: Maybe<Array<Scalars['String']['output']>>;
  operator: NormalizedDefinitionOperator;
  predefined?: Maybe<NormalizedDefinitionSegmentGroup>;
  region?: Maybe<Scalars['String']['output']>;
};

export type NormalizedDefinitionGroupInput = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  demographic_age?: InputMaybe<NormalizedDefinitionSegmentGroupInput>;
  demographic_gender?: InputMaybe<NormalizedDefinitionSegmentGroupInput>;
  direct?: InputMaybe<NormalizedDefinitionSegmentGroupInput>;
  location?: InputMaybe<NormalizedDefinitionSegmentGroupInput>;
  lookalike?: InputMaybe<NormalizedDefinitionSegmentGroupInput>;
  operator: NormalizedDefinitionOperator;
  predefined?: InputMaybe<NormalizedDefinitionSegmentGroupInput>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type NormalizedDefinitionGroups = {
  __typename?: 'NormalizedDefinitionGroups';
  groups: Array<NormalizedDefinitionGroup>;
  operator: NormalizedDefinitionOperator;
};

export type NormalizedDefinitionGroupsInput = {
  groups: Array<NormalizedDefinitionGroupInput>;
  operator: NormalizedDefinitionOperator;
};

export type NormalizedDefinitionInput = {
  includes: NormalizedDefinitionGroupsInput;
};

export const NormalizedDefinitionOperator = {
  Intersect: 'INTERSECT',
  Union: 'UNION'
} as const;

export type NormalizedDefinitionOperator = typeof NormalizedDefinitionOperator[keyof typeof NormalizedDefinitionOperator];
export type NormalizedDefinitionSegment = {
  __typename?: 'NormalizedDefinitionSegment';
  id: Scalars['uuid']['output'];
};

export type NormalizedDefinitionSegmentGroup = {
  __typename?: 'NormalizedDefinitionSegmentGroup';
  operator: NormalizedDefinitionOperator;
  segments: Array<NormalizedDefinitionSegment>;
};

export type NormalizedDefinitionSegmentGroupInput = {
  operator: NormalizedDefinitionOperator;
  segments: Array<NormalizedDefinitionSegmentInput>;
};

export type NormalizedDefinitionSegmentInput = {
  id: Scalars['uuid']['input'];
};

export type OpenxCuratedPackage = {
  __typename?: 'OpenxCuratedPackage';
  audience_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  obj: Scalars['ExchangeJSON']['output'];
  uid: Scalars['String']['output'];
};

export type OptionsByPathResult = {
  __typename?: 'OptionsByPathResult';
  extra: Scalars['ExchangeJSON']['output'];
  filter: Scalars['ExchangeJSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type Pacing = {
  __typename?: 'Pacing';
  budget?: Maybe<Scalars['Decimal']['output']>;
  budget_mode: BudgetMode;
  budget_type: BudgetType;
  cadences?: Maybe<Array<Cadence>>;
  flight_end: Scalars['timestamptz']['output'];
  flight_start: Scalars['timestamptz']['output'];
  mode: PacingMode;
  region: MonetizingRegion;
};

export const PacingMode = {
  Asap: 'ASAP',
  Evenly: 'EVENLY'
} as const;

export type PacingMode = typeof PacingMode[keyof typeof PacingMode];
export type PacingParams = {
  budget?: InputMaybe<Scalars['Decimal']['input']>;
  budget_mode?: InputMaybe<BudgetMode>;
  budget_type?: InputMaybe<BudgetType>;
  cadences?: InputMaybe<Array<CadenceParams>>;
  flight_end?: InputMaybe<Scalars['timestamptz']['input']>;
  flight_start?: InputMaybe<Scalars['timestamptz']['input']>;
  mode?: InputMaybe<PacingMode>;
  region?: InputMaybe<MonetizingRegion>;
};

/** Package represents the targeting criteria and/or URL lists that are applicable to the deal. */
export type Package = {
  __typename?: 'Package';
  /** The ID of the package that this package was cloned from */
  cloned_from?: Maybe<Scalars['String']['output']>;
  /**
   * Fees owed to the contextual data partners whose segments this package
   * includes in targeting.contextual_segment. Segments of the package account's
   * own contextual providers cost nothing and are left out. Generated by the
   * Management API from the targeting and recomputed only when
   * targeting.contextual_segment changes. NULL when nothing is owed. Read-only.
   */
  contextual_pricing?: Maybe<PackageContextualPricing>;
  /** The date when the Package was created. */
  created_date: Scalars['timestamptz']['output'];
  /** Merchandising Details - Domains or App names. */
  domains?: Maybe<Scalars['String']['output']>;
  /** Scale estimates for curated packages. Internal OpenX use only. */
  estimates?: Maybe<PackageEstimates>;
  /** The unique identifier for the Package. */
  id: Scalars['String']['output'];
  /**
   * The instance this Package lives on. Pass it as `instance_uid` on any follow-up call
   * about it: an id only resolves on its own instance.
   */
  instance_uid?: Maybe<Scalars['String']['output']>;
  /** This will be true if the package is archived, and false otherwise */
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Package is curated and only managed by curators, if true then only curators can manage this package, otherwise package behaves normally.
   * For internal OpenX use only.
   */
  is_curated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Package is locked for editing by external users.
   * For internal OpenX use only.
   */
  locked_internal?: Maybe<Scalars['Boolean']['output']>;
  /** Merchandising Details - Package Logo link. */
  logo?: Maybe<Scalars['String']['output']>;
  /** The date when the Package was last modified. */
  modified_date: Scalars['timestamptz']['output'];
  /** The name of the Package */
  name: Scalars['String']['output'];
  /** Any notes about the Package */
  notes?: Maybe<Scalars['String']['output']>;
  /** Private Market Package setup. */
  private_market?: Maybe<PackagePrivateMarket>;
  /** Rate Card Price. */
  rate_card_cpm?: Maybe<Scalars['Decimal4']['output']>;
  /** Targeting criteria using audience, content, context and placement attributes. */
  targeting: Targeting;
  /** The unique uid identifier for the Package. */
  uid: Scalars['String']['output'];
  /** Targeting using a URL (domain) allowlist or blocklist. */
  url_targeting?: Maybe<UrlTargeting>;
  /** Merchandising Details - Sample URLs. */
  urls?: Maybe<Scalars['JSON']['output']>;
};

export type PackageByIdOutput = {
  __typename?: 'PackageByIdOutput';
  audience?: Maybe<Audience>;
  audience_id?: Maybe<Scalars['String']['output']>;
  deal_uid?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['String']['output'];
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  exchange_account_network_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_curated?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  obj: Scalars['ExchangeJSON']['output'];
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type PackageContextualPricing = {
  __typename?: 'PackageContextualPricing';
  /**
   * How the fees of the organizations owed combine: "INTERSECT" or "UNION".
   * Always "UNION" in practice, since an impression matching a segment of any
   * one provider matches the package.
   */
  operator?: Maybe<Scalars['String']['output']>;
  /**
   * What each organization owning a targeted sellable segment is owed, keyed by
   * the exchange partner id to be paid. Format:
   * {"<account_id>": {"account_id": "<id>", "price_cpm": "<decimal>", "price_pom": "<decimal>"}}
   * where price_cpm is the highest CPM among that organization's targeted
   * segments and price_pom the highest PoM share. Both are decimal strings with
   * two decimal places.
   */
  pricing_by_org?: Maybe<Scalars['JSON']['output']>;
  /**
   * What the organizations in pricing_by_org are owed altogether: the average
   * of their prices for UNION, the sum for INTERSECT, rounded half up to the cent.
   */
  totals?: Maybe<PackageContextualPricingTotals>;
};

export type PackageContextualPricingTotals = {
  __typename?: 'PackageContextualPricingTotals';
  /** CPM owed to the organizations altogether. */
  price_cpm?: Maybe<Scalars['Decimal2']['output']>;
  /** PoM share owed to the organizations altogether. */
  price_pom?: Maybe<Scalars['Decimal2']['output']>;
};

export type PackageCreateParams = {
  /**
   * The account which owns the package, will default to logged in user's account
   * For internal OpenX use only.
   */
  account_uid?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the package that this package was cloned from */
  cloned_from?: InputMaybe<Scalars['String']['input']>;
  /** Merchandising Details - Domains or App names. */
  domains?: InputMaybe<Scalars['String']['input']>;
  /** Scale estimates for curated packages. Internal OpenX use only. */
  estimates?: InputMaybe<PackageEstimatesCreateUpdateParams>;
  /**
   * Package is curated and only managed by curators, if true then only curators can manage this package, otherwise package behaves normally.
   * For internal OpenX use only.
   */
  is_curated?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Package is locked for editing by external users.
   * For internal OpenX use only.
   */
  locked_internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Merchandising Details - Package Logo link. */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** The name of the Package */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Any notes about the Package */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Private Market Package setup. */
  private_market?: InputMaybe<PackagePrivateMarketCreateParams>;
  /** Rate Card Price. */
  rate_card_cpm?: InputMaybe<Scalars['Decimal4']['input']>;
  /** The associated Targeting object. */
  targeting?: InputMaybe<TargetingCreateParams>;
  /** Targeting using a URL (domain) allowlist or blocklist. */
  url_targeting?: InputMaybe<UrlTargetingCreateParams>;
  /** Merchandising Details - Sample URLs. */
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackageEstimates = {
  __typename?: 'PackageEstimates';
  cpm?: Maybe<PackageEstimatesCpm>;
  market_requests?: Maybe<PackageEstimatesMarketRequests>;
  reach?: Maybe<PackageEstimatesReach>;
};

export type PackageEstimatesCpm = {
  __typename?: 'PackageEstimatesCPM';
  /** High end estimate of the CPM range. */
  high: Scalars['Decimal2']['output'];
  /** Low end estimate of the CPM range. */
  low: Scalars['Decimal2']['output'];
};

/** Curated Package Estimates setup. */
export type PackageEstimatesCpmCreateUpdateParams = {
  /** High end estimate of the CPM range. */
  high: Scalars['Decimal2']['input'];
  /** Low end estimate of the CPM range. */
  low: Scalars['Decimal2']['input'];
};

export type PackageEstimatesCreateUpdateParams = {
  cpm?: InputMaybe<PackageEstimatesCpmCreateUpdateParams>;
  market_requests?: InputMaybe<PackageEstimatesMarketRequestsCreateUpdateParams>;
  reach?: InputMaybe<PackageEstimatesReachCreateUpdateParams>;
};

export type PackageEstimatesMarketRequests = {
  __typename?: 'PackageEstimatesMarketRequests';
  /** High end estimate of the market requests. */
  high: Scalars['Decimal2']['output'];
  /** Low end estimate of the market requests. */
  low: Scalars['Decimal2']['output'];
};

export type PackageEstimatesMarketRequestsCreateUpdateParams = {
  /** High end estimate of the market requests. */
  high: Scalars['Decimal2']['input'];
  /** Low end estimate of the market requests. */
  low: Scalars['Decimal2']['input'];
};

export type PackageEstimatesReach = {
  __typename?: 'PackageEstimatesReach';
  /** High end estimate of the reach range. */
  high: Scalars['Decimal2']['output'];
  /** Low end estimate of the reach range. */
  low: Scalars['Decimal2']['output'];
};

export type PackageEstimatesReachCreateUpdateParams = {
  /** High end estimate of the reach range. */
  high: Scalars['Decimal2']['input'];
  /** Low end estimate of the reach range. */
  low: Scalars['Decimal2']['input'];
};

/** Private Market Package setup. */
export type PackagePrivateMarket = {
  __typename?: 'PackagePrivateMarket';
  /** Default cpm for participants, can be overridden either per demand_partner/buyer in participants. */
  default_discounted_cpm?: Maybe<Scalars['Decimal4']['output']>;
  /** Default cpm for demand_partner/buyers listed in participants field, it's the rate associated with Private Auction deals. */
  default_rate_card_cpm?: Maybe<Scalars['Decimal4']['output']>;
  /** Must be "1" (true) or "0" (false). If "1", the package is discoverable to all demand_partner/buyers with default_rate_card_cpm or an overridden cpm. */
  discoverable: Scalars['String']['output'];
};

/** Private Market Package setup. */
export type PackagePrivateMarketCreateParams = {
  /** Default cpm for participants, can be overridden either per demand_partner/buyer in participants. */
  default_discounted_cpm?: InputMaybe<Scalars['Decimal4']['input']>;
  /** Default cpm for demand_partner/buyers listed in participants field, it's the rate associated with Private Auction deals. */
  default_rate_card_cpm?: InputMaybe<Scalars['Decimal4']['input']>;
  /** Must be "1" (true) or "0" (false). If "1", the package is discoverable to all demand_partner/buyers with default_rate_card_cpm or an overridden cpm. */
  discoverable: Scalars['String']['input'];
};

/** Private Market Package setup. */
export type PackagePrivateMarketUpdateParams = {
  /** Default cpm for participants, can be overridden either per demand_partner/buyer in participants. */
  default_discounted_cpm?: InputMaybe<Scalars['Decimal4']['input']>;
  /** Default cpm for demand_partner/buyers listed in participants field, it's the rate associated with Private Auction deals. */
  default_rate_card_cpm?: InputMaybe<Scalars['Decimal4']['input']>;
  /** Must be "1" (true) or "0" (false). If "1", the package is discoverable to all demand_partner/buyers with default_rate_card_cpm or an overridden cpm. */
  discoverable: Scalars['String']['input'];
};

export type PackageUpdateParams = {
  /**
   * The id of the deal associated with the package
   * For internal OpenX use only.
   */
  deal_id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The uid of the deal associated with the package
   * For internal OpenX use only.
   */
  deal_uid?: InputMaybe<Scalars['String']['input']>;
  /** Merchandising Details - Domains or App names. */
  domains?: InputMaybe<Scalars['String']['input']>;
  /** Scale estimates for curated packages. Internal OpenX use only. */
  estimates?: InputMaybe<PackageEstimatesCreateUpdateParams>;
  /**
   * Package is curated and only managed by curators, if true then only curators can manage this package, otherwise package behaves normally.
   * For internal OpenX use only.
   */
  is_curated?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Package is locked for editing by external users.
   * For internal OpenX use only.
   */
  locked_internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Merchandising Details - Package Logo link. */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** The name of the Package */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Any notes about the Package */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Private Market Package setup. */
  private_market?: InputMaybe<PackagePrivateMarketUpdateParams>;
  /** Rate Card Price. */
  rate_card_cpm?: InputMaybe<Scalars['Decimal4']['input']>;
  /**
   * The associated Targeting object. With rendering_context it is complete and replaces the
   * package's targeting as a whole. Without rendering_context it is partial and is applied to the
   * package's current targeting as a JSON Merge Patch (RFC 7386): objects merge, a value passed
   * replaces the current one, a field passed as null is cleared, and anything left out is kept,
   * so one field of one dimension can be changed on its own. Leave targeting out to change other
   * fields without touching it.
   */
  targeting?: InputMaybe<TargetingUpdateParams>;
  /**
   * Targeting using a URL (domain) allowlist or blocklist. Replaces the current one when passed;
   * leave it out to keep it.
   */
  url_targeting?: InputMaybe<UrlTargetingUpdateParams>;
  /** Merchandising Details - Sample URLs. */
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PackagesOutput = {
  __typename?: 'PackagesOutput';
  has_more: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  objects: Array<PackageByIdOutput>;
  offset: Scalars['Int']['output'];
};

export type PackagesUsedByOutput = {
  __typename?: 'PackagesUsedByOutput';
  deals_referenced?: Maybe<Scalars['Int']['output']>;
  deals_with_rbo?: Maybe<Scalars['Int']['output']>;
  deals_with_rbo_dynamic?: Maybe<Scalars['Int']['output']>;
  floorrules_referenced?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
};

export type Pixel = {
  __typename?: 'Pixel';
  account_id: Scalars['String']['output'];
  account_uid: Scalars['String']['output'];
  created_date: Scalars['timestamptz']['output'];
  event_type: SignalEventType;
  id: Scalars['String']['output'];
  /** The instance this object lives on. */
  instance_uid?: Maybe<Scalars['String']['output']>;
  modified_date: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type PixelCreateParams = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  event_type: SignalEventType;
  name: Scalars['String']['input'];
};

export type PixelUpdateParams = {
  name: Scalars['String']['input'];
};

/**
 * Predefined (Hasura-backed) routed segment projection.
 * Shares the RoutedSegment-compatible field shapes so it can coexist with
 * the management segment types behind the routed surface without violating
 * GraphQL's overlapping-field (SameResponseShape) rule.
 */
export type PredefinedSegment = BaseSegment & RoutedSegment & {
  __typename?: 'PredefinedSegment';
  account: Account;
  account_id?: Maybe<Scalars['String']['output']>;
  allowed_accounts?: Maybe<Scalars['JSON']['output']>;
  allowed_countries?: Maybe<Scalars['JSON']['output']>;
  bq_location?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  computed_price_cpm?: Maybe<Scalars['Float']['output']>;
  computed_price_pom?: Maybe<Scalars['Float']['output']>;
  countries: Array<Segment_Country>;
  countries_aggregate: Segment_Country_Aggregate;
  created_date: Scalars['timestamptz']['output'];
  deleted: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gcs_file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_leaf?: Maybe<Scalars['Boolean']['output']>;
  is_nav_only?: Maybe<Scalars['Boolean']['output']>;
  lookalike_definition_id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_segment?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['JSON']['output']>;
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  propensity?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_id?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  regions: Array<Segment_Region>;
  regions_aggregate: Segment_Region_Aggregate;
  seed_aggregate_segment_id?: Maybe<Scalars['String']['output']>;
  segment_audiences: Array<Audience_Segment>;
  segment_audiences_aggregate: Audience_Segment_Aggregate;
  segment_category?: Maybe<Scalars['String']['output']>;
  segment_group_id?: Maybe<Scalars['String']['output']>;
  segment_source?: Maybe<Scalars['String']['output']>;
  segment_source_description?: Maybe<Scalars['String']['output']>;
  segment_sub_category?: Maybe<Scalars['String']['output']>;
  segment_type?: Maybe<Scalars['String']['output']>;
  sellable?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  source_bq_tables?: Maybe<Scalars['JSON']['output']>;
  source_detailed_counts?: Maybe<Scalars['JSON']['output']>;
  source_matched_count?: Maybe<Scalars['Int']['output']>;
  source_provided_count?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  sub_category?: Maybe<Scalars['String']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_full: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
};

export const Product = {
  Direct: 'DIRECT',
  Select: 'SELECT'
} as const;

export type Product = typeof Product[keyof typeof Product];
export type ProductAccount = {
  __typename?: 'ProductAccount';
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instance_uid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PublisherProfile = {
  __typename?: 'PublisherProfile';
  obj?: Maybe<Scalars['ExchangeJSON']['output']>;
};

export type PublisherProfileContactRequestInput = {
  advertiser_brand?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['String']['input']>;
  deal_type: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  targeting_details?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherProfileContactRequestResponse = {
  __typename?: 'PublisherProfileContactRequestResponse';
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /**
   * Advertisers for a target account, sorted by name. Defaults to the caller's own
   * account when `accountId` is omitted; when supplied, the caller must be that
   * account or one of its descendants.
   */
  accountAdvertisers: Array<AdvertiserForCaller>;
  /** The account info for the caller, derived from their API key. */
  accountForCaller: AccountForCaller;
  /** fetch aggregated fields from the table: "account" */
  account_aggregate: Account_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  account_by_pk?: Maybe<Account>;
  /** fetch data from the table: "account_feature_flags" */
  account_feature_flags: Array<Account_Feature_Flags>;
  /** fetch aggregated fields from the table: "account_feature_flags" */
  account_feature_flags_aggregate: Account_Feature_Flags_Aggregate;
  /** fetch data from the table: "account_feature_flags" using primary key columns */
  account_feature_flags_by_pk?: Maybe<Account_Feature_Flags>;
  /** fetch data from the table: "account_list" */
  account_list: Array<Account_List>;
  /** fetch aggregated fields from the table: "account_list" */
  account_list_aggregate: Account_List_Aggregate;
  /** fetch data from the table: "account_provider" */
  account_provider: Array<Account_Provider>;
  /** fetch aggregated fields from the table: "account_provider" */
  account_provider_aggregate: Account_Provider_Aggregate;
  /** fetch data from the table: "account_provider" using primary key columns */
  account_provider_by_pk?: Maybe<Account_Provider>;
  /**
   * Accounts the caller can use for one product, sorted by name, with the instance each lives
   * on: the caller's own account and its descendants, or every account for an internal user.
   * Empty for a caller not provisioned for the product.
   */
  accountsForProduct: Array<ProductAccount>;
  /**
   * Batch search/validate for App Groups (Friendly App Names).
   * Backed by ox-api-core POST /appgroup/search (pg_trgm similarity).
   * Replaces client-side FlexSearch — covers both autocomplete (1 name) and bulk
   * validation (up to 2000 names) in a single round-trip.
   *
   * Prefer this query over optionsByPath(path: "deal.package.targeting.app_group"),
   * which performs a full dataset fetch and is considered legacy for search/validation
   * use cases.
   */
  appGroupSearch: Array<AppGroupSearchResult>;
  /** fetch data from the table: "audience" */
  audience: Array<Audience>;
  audienceSegmentExcelGenerate: AudienceSegmentExcelGenerateResult;
  audienceSegmentSearch: AudienceSegmentCombinedResult;
  /**
   * Options available to the caller for the audience segment search filters: regions, segment search modes,
   * data partners, categories and sub-categories.
   */
  audienceSegmentSearchOptions: AudienceSegmentSearchOptions;
  audienceSegmentSearchText: AudienceSegmentSearchTextResult;
  audienceSharesByAudience: Array<Maybe<AudienceShare>>;
  audienceUsedBy: AudienceUsedByOutput;
  /** fetch aggregated fields from the table: "audience" */
  audience_aggregate: Audience_Aggregate;
  /** fetch data from the table: "audience" using primary key columns */
  audience_by_pk?: Maybe<Audience>;
  audience_categories_reach_all?: Maybe<Array<Maybe<Audience_Categories_Reach_All>>>;
  audience_reach: Audience_Reach;
  /**
   * Lists audience rows matching a searchOptionsByPath('audience') filter: field, field__op, q and
   * sort, over the same fields. Archived rows are hidden unless the filter names is_archived.
   * Without sort, rows come back in Hasura's default order. `where` is ANDed with the filter.
   * Paging goes in `limit` and `offset`, not in the filter.
   */
  audience_search: Array<Audience>;
  /** fetch data from the table: "audience_segment" */
  audience_segment: Array<Audience_Segment>;
  /** fetch aggregated fields from the table: "audience_segment" */
  audience_segment_aggregate: Audience_Segment_Aggregate;
  /** fetch data from the table: "audience_segment" using primary key columns */
  audience_segment_by_pk?: Maybe<Audience_Segment>;
  /**
   * List audit trail entries for the specified MGMT API object.
   * Backed by ox-api-core GET /audittrail. Permissions are gated by the referenced object,
   * not by the audit trail itself.
   */
  auditTrail: AuditTrailOutput;
  /**
   * Delivery metrics for a set of the caller's Aqua advertisers in one request,
   * one row per requested id, in request order. An id that is not one of the
   * caller's advertisers yields a null row. FULL_FLIGHT is rejected, since an
   * advertiser has no flight; at most 100 ids per request.
   */
  bidderAdvertisersDelivery: Array<Maybe<BidderAdvertiserDelivery>>;
  bidderCreativeById?: Maybe<BidderCreative>;
  bidderCreatives?: Maybe<BidderCreativeMgmtResponse>;
  bidderLineItemById?: Maybe<BidderLineItem>;
  bidderLineItemCreatives: Array<BidderCreative>;
  /**
   * What a line item needs to know about a deal before linking it, by exchange
   * deal ID: whether it is programmatic guaranteed and which region it delivers
   * in. Resolved server side so deals created outside OA are recognised. Null
   * when no deal has that ID.
   */
  bidderLineItemDealSummary?: Maybe<BidderLineItemDealSummary>;
  /**
   * Forecast for a line item: pass line_item_id for a saved line item (its
   * stored targeting is resolved server side), or context plus the raw
   * targeting documents for a draft under edit. Both entry points produce
   * identical forecaster requests. The targeting documents are untyped on
   * purpose — they pass through to the DS forecaster verbatim, and a typed
   * projection would silently drop fields this service doesn't know about.
   */
  bidderLineItemForecast: BidderLineItemForecast;
  bidderLineItems: Array<BidderLineItem>;
  /**
   * Delivery metrics and pacing for a page of line items in one request,
   * one row per distinct requested id. An id that resolves to no line item
   * yields a row with null fields rather than failing the page. Accepts at
   * most 100 distinct ids per call; more is a UserInputError.
   */
  bidderLineItemsDelivery: Array<BidderLineItemDelivery>;
  bidderOrderById?: Maybe<BidderOrder>;
  bidderOrderLineItems: Array<BidderLineItem>;
  bidderOrders: Array<BidderOrder>;
  /**
   * Delivery metrics and pacing for a page of orders in one request, one row
   * per distinct requested id. An id that resolves to no order yields a row
   * with null fields rather than failing the page.
   */
  bidderOrdersDelivery: Array<BidderOrderDelivery>;
  /** fetch data from the table: "bq_resource" */
  bq_resource: Array<Bq_Resource>;
  /** fetch aggregated fields from the table: "bq_resource" */
  bq_resource_aggregate: Bq_Resource_Aggregate;
  /** fetch data from the table: "bq_resource" using primary key columns */
  bq_resource_by_pk?: Maybe<Bq_Resource>;
  /**
   * The results of earlier WISSP searches by the `resultsKey` each returned, in the order of `resultsKeys`.
   * Each entry is the search's `{ input, output }`, or null when its results are no longer stored (they expire
   * after 30 days, 7 in devint and QA). Fails when any key belongs to a search made by another user.
   * Takes at most 100 `resultsKeys`, a repeated key counting each time.
   */
  cachedSearchResults: Array<Maybe<Scalars['JSON']['output']>>;
  calculateOrf: AudienceSegmentSetMetrics;
  checkUserPermissions?: Maybe<CheckUserPermissionsResponse>;
  computePricing?: Maybe<Scalars['JSON']['output']>;
  contextualEstimate?: Maybe<ContextualEstimateResult>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  curatedDealBuyerDiscount: Scalars['ExchangeJSON']['output'];
  dealById: DealByIdOutput;
  /**
   * Delivery counters for one deal, by its numeric id. The deal is its own
   * grain. Null when the caller cannot read the deal, or for FULL_FLIGHT on a
   * deal with no start date.
   */
  dealDelivery?: Maybe<DeliveryMetrics>;
  /**
   * Delivery for every deal carrying one OX display code, summed. A display code is
   * not unique: a grouped deal is several deals carrying the same code, so this is
   * the code's total rather than one deal's. Every deal the caller can read under
   * the code is loaded and summed; dealDelivery reads one of them by its numeric id.
   * Rates derive from the summed counters. Null when no readable deal carries the code, or when FULL_FLIGHT is
   * asked and a deal behind the code has no start date.
   */
  dealDeliveryByCode?: Maybe<DeliveryMetrics>;
  dealForecastingCreateJob?: Maybe<Scalars['ExchangeJSON']['output']>;
  dealForecastingGetJob?: Maybe<Scalars['ExchangeJSON']['output']>;
  dealForecastingJob?: Maybe<Scalars['ExchangeJSON']['output']>;
  /** Fetch info about a group of deals with the same external deal id */
  dealGroupInfo: Array<DealGroupInfoOutput>;
  dealHealthScoreRootCauses?: Maybe<Scalars['ExchangeJSON']['output']>;
  dealInsightsJob: DealInsightsOutput;
  dealLanding: DealLandingOutput;
  /**
   * Simplified prompt-based bundles (mobile apps) discovery. Runs an AI-assisted search
   * seeded by the user's free-text `query` (and optional filters), and returns a flat
   * list of matching bundles sorted by relevance.
   */
  dealPromptBundlesSearch: DealPromptBundlesSearchResult;
  /**
   * Simplified prompt-based domains discovery. Runs an AI-assisted search seeded by
   * the user's free-text `query` (and optional filters), and returns a flat list of
   * matching domains sorted by relevance.
   */
  dealPromptDomainsSearch: DealPromptSearchResult;
  dealPromptSession: DealPromptConversation;
  dealPromptSessions: Array<DealPromptSession>;
  /** Fetch rbo info of the deal */
  dealRboInfo: Array<DealRboInfoOutput>;
  dealTroubleshootingAgentSessionHistory?: Maybe<DealTroubleshootingAgentSessionHistoryMessage>;
  dealTroubleshootingAgentSessionList?: Maybe<DealTroubleshootingAgentSessionListMessage>;
  dealTroubleshootingJob: DealTroubleshootingOutput;
  deals: DealsOutput;
  enrichEstimate?: Maybe<Scalars['JSON']['output']>;
  /** fetch data from the table: "export" */
  export: Array<Export>;
  /** fetch aggregated fields from the table: "export" */
  export_aggregate: Export_Aggregate;
  /** fetch data from the table: "export" using primary key columns */
  export_by_pk?: Maybe<Export>;
  /** fetch data from the table: "export_status_timeline" */
  export_status_timeline: Array<Export_Status_Timeline>;
  /** fetch aggregated fields from the table: "export_status_timeline" */
  export_status_timeline_aggregate: Export_Status_Timeline_Aggregate;
  /** fetch data from the table: "export_status_timeline" using primary key columns */
  export_status_timeline_by_pk?: Maybe<Export_Status_Timeline>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  geoSearch: Array<GeoSearchOutput>;
  getMgmtSession?: Maybe<Scalars['ExchangeJSON']['output']>;
  getMonetizing: Monetizing;
  /** Given a partner_id lookup the account in the MGMT API and return the account object */
  getPartnerAccount?: Maybe<Scalars['ExchangeJSON']['output']>;
  getSession?: Maybe<Scalars['JSON']['output']>;
  getShareableOpenxAudience?: Maybe<Scalars['Boolean']['output']>;
  getUdsAccountId?: Maybe<Scalars['String']['output']>;
  invOperatorSearch: Array<InvSearchOperatorOutput>;
  invPackageSearch: Array<InvPackageSearchOutput>;
  inventoryBundleSearch: InventoryBundleSearchResult;
  inventoryBundleSearchText: InventoryBundleSearchTextResult;
  inventoryDomainFilterOptions: InventoryDomainFilterOptionsResult;
  inventoryDomainSearch: InventoryDomainSearchResult;
  inventoryDomainSearchText: InventoryDomainSearchTextResult;
  inventorylist?: Maybe<Scalars['ExchangeJSON']['output']>;
  /**
   * Accounts an internal admin is allowed to link as Aqua advertisers. Returns accounts that do not yet
   * have the AQUA_API feature flag. Internal admins only.
   */
  linkable_aqua_candidate_accounts: Array<Account>;
  /** fetch data from the table: "lookalike_definition" */
  lookalike_definition: Array<Lookalike_Definition>;
  /** fetch aggregated fields from the table: "lookalike_definition" */
  lookalike_definition_aggregate: Lookalike_Definition_Aggregate;
  /** fetch data from the table: "lookalike_definition" using primary key columns */
  lookalike_definition_by_pk?: Maybe<Lookalike_Definition>;
  /** fetch data from the table: "lookalike_job_run" */
  lookalike_job_run: Array<Lookalike_Job_Run>;
  /** fetch aggregated fields from the table: "lookalike_job_run" */
  lookalike_job_run_aggregate: Lookalike_Job_Run_Aggregate;
  /** fetch data from the table: "lookalike_job_run" using primary key columns */
  lookalike_job_run_by_pk?: Maybe<Lookalike_Job_Run>;
  /** fetch data from the table: "lookalike_seed_source" */
  lookalike_seed_source: Array<Lookalike_Seed_Source>;
  /** fetch aggregated fields from the table: "lookalike_seed_source" */
  lookalike_seed_source_aggregate: Lookalike_Seed_Source_Aggregate;
  /** fetch data from the table: "lookalike_seed_source" using primary key columns */
  lookalike_seed_source_by_pk?: Maybe<Lookalike_Seed_Source>;
  /** fetch data from the table: "lookalike_segment_seed_aggregate" */
  lookalike_segment_seed_aggregate: Array<Lookalike_Segment_Seed_Aggregate>;
  /** fetch aggregated fields from the table: "lookalike_segment_seed_aggregate" */
  lookalike_segment_seed_aggregate_aggregate: Lookalike_Segment_Seed_Aggregate_Aggregate;
  /** fetch data from the table: "lookalike_segment_seed_aggregate" using primary key columns */
  lookalike_segment_seed_aggregate_by_pk?: Maybe<Lookalike_Segment_Seed_Aggregate>;
  /** fetch data from the table: "lookalike_segment_similarity" */
  lookalike_segment_similarity: Array<Lookalike_Segment_Similarity>;
  /** fetch aggregated fields from the table: "lookalike_segment_similarity" */
  lookalike_segment_similarity_aggregate: Lookalike_Segment_Similarity_Aggregate;
  /** fetch data from the table: "lookalike_segment_similarity" using primary key columns */
  lookalike_segment_similarity_by_pk?: Maybe<Lookalike_Segment_Similarity>;
  managementSegmentById?: Maybe<MngBaseSegment>;
  managementSegments: ManagementSegmentsOutput;
  managementSegmentsCount: Scalars['Int']['output'];
  /**
   * Validated fire facts for the caller's Named Pixels. The accounts are the
   * Aqua advertisers the caller can access and are not an argument. pixelIds
   * limits the read to the pixels on this page, or the one pixel being opened.
   * The newest two hours are aggregated from raw events when the query runs.
   * Older hours come from the hourly counts table. A pixel already in pixel_dim
   * includes the current hour. A new pixel can lag up to an hour, until pixel_dim
   * refreshes. The window opens at the start of the boundary hour, so that hour
   * is included.
   */
  namedPixelFireFacts: Array<NamedPixelFireFact>;
  openxCuratedPackage: OpenxCuratedPackage;
  openxCuratedPackages: Array<OpenxCuratedPackage>;
  optionsByPath: Array<Maybe<OptionsByPathResult>>;
  packageById: PackageByIdOutput;
  /**
   * Preview the contextual_pricing a package targeting contextual_segment would be given, without saving
   * anything. Backed by ox-api-core POST /package/contextual_pricing, which prices it as saving the package
   * does. Null when nothing is owed: no contextual segment is included, all included belong to the
   * account's own contextual providers, or none of the rest is sellable.
   */
  packageContextualPricing?: Maybe<PackageContextualPricing>;
  packageUsedBy?: Maybe<Array<Maybe<PackagesUsedByOutput>>>;
  packages: PackagesOutput;
  ping?: Maybe<Scalars['String']['output']>;
  pixelById?: Maybe<Pixel>;
  pixel_event_metrics: Array<Pixel_Event_Metric>;
  pixels: Array<Pixel>;
  provider: Array<Provider>;
  /** fetch aggregated fields from the table: "provider" */
  provider_aggregate: Provider_Aggregate;
  /** fetch data from the table: "provider" using primary key columns */
  provider_by_pk?: Maybe<Provider>;
  publisherProfile?: Maybe<Array<PublisherProfile>>;
  publisherProfileByPk?: Maybe<PublisherProfile>;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  region_aggregate: Region_Aggregate;
  /** fetch data from the table: "region" using primary key columns */
  region_by_pk?: Maybe<Region>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /**
   * Additive routed lookup by id. UUID values route to Hasura predefined
   * segments; exchange ids and exchange_uids route to Management.
   */
  routedSegmentById?: Maybe<RoutedSegment>;
  /**
   * Additive routed segment list. This keeps route selection explicit and
   * returns concrete source object types.
   */
  routedSegments: Array<RoutedSegment>;
  /**
   * Superset of optionsByPath that adds pagination metadata.
   *
   * audience and segment are searched in OpenAudience (Hasura) as the caller, so the caller's
   * audience and segment permissions apply. They take the same flat filter as the entity paths
   * (field, field__op, q, limit, offset, sort) over a fixed set of fields; a filter on any other
   * field is rejected. account_id takes the Management API numeric account id or uid, and
   * extra.account_id reports it the same way. Archived rows are hidden unless the filter names
   * is_archived. % and _ in text matches are literal. A member's audience search returns their own
   * account's audiences only. Only the OpenX Select and corporate instances are served: naming, or
   * being signed in to, another instance fails. They return an exact total_count.
   *
   * Entity paths (bidder_order, bidder_lineitem, bidder_creative, deal,
   * package) search Management API REST list endpoints. Filter keys are
   * forwarded verbatim as query params, so any searchable field works,
   * including Django-style operators: name__contains, status__in,
   * start_date__gte, id__in, ... Unknown filter keys are ignored by the
   * Management API; unknown operators are rejected. Reserved keys inside
   * filter: limit (default 50, capped at 500), offset, sort (-field for
   * descending); fields and overload are not supported.
   *
   * deal.package.targeting.contextual.segments is paged the same way, against
   * GET /contextual_segment. It takes the filters of its optionsByPath variant
   * (account_id, scope, provider_id, q, min_cpm, max_cpm, min_pom, max_pom)
   * and returns an exact total_count.
   *
   * Every other optionsByPath path also works here: its usual flat, complete
   * result list is wrapped with has_next_page: false.
   */
  searchOptionsByPath: SearchOptionsByPathResult;
  segment: Array<Segment>;
  /**
   * Compatibility field for the original Hasura-only segment primary-key lookup.
   * This field does not route to Management and does not accept type_full.
   */
  segmentByIdV1?: Maybe<Segment>;
  /**
   * Internal/debug compatibility lookup for management id or uid.
   * Additive routed clients should prefer routedSegmentById.
   */
  segmentByIdV2?: Maybe<MngBaseSegment>;
  /**
   * Export all segments matching the provided Hasura filters to an XLSX file.
   * Uses the same filter arguments as the segment list query, but ignores any UI limit
   * and fetches all matching rows server-side.
   */
  segmentExcelExport: SegmentExcelExportResult;
  /** fetch aggregated fields from the table: "segment" */
  segment_aggregate: Segment_Aggregate;
  /** fetch data from the table: "segment" using primary key columns */
  segment_by_pk?: Maybe<Segment>;
  /** fetch data from the table: "segment_country" */
  segment_country: Array<Segment_Country>;
  /** fetch aggregated fields from the table: "segment_country" */
  segment_country_aggregate: Segment_Country_Aggregate;
  /** fetch data from the table: "segment_country" using primary key columns */
  segment_country_by_pk?: Maybe<Segment_Country>;
  /** fetch data from the table: "segment_region" */
  segment_region: Array<Segment_Region>;
  /** fetch aggregated fields from the table: "segment_region" */
  segment_region_aggregate: Segment_Region_Aggregate;
  /** fetch data from the table: "segment_region" using primary key columns */
  segment_region_by_pk?: Maybe<Segment_Region>;
  /**
   * Lists segment rows matching a searchOptionsByPath('segment') filter: field, field__op, q and
   * sort, over the same fields. Archived rows are hidden unless the filter names is_archived.
   * Without sort, rows come back in Hasura's default order. `where` is ANDed with the filter.
   * Paging goes in `limit` and `offset`, not in the filter.
   */
  segment_search: Array<Segment>;
  /**
   * V1 compatibility field for the original Hasura-only segment query.
   * This field does not route to Management and does not accept type_full.
   */
  segmentsV1: Array<Segment>;
  /**
   * V1 compatibility field for the original Hasura-only segment count.
   * This field does not route to Management and does not accept type_full.
   */
  segmentsV1Count: Scalars['Int']['output'];
  /**
   * Internal/debug compatibility list for management-backed segment reads.
   * Additive routed clients should prefer routedSegments.
   */
  segmentsV2: Array<MngBaseSegment>;
  /**
   * Management-only segment count. Route selection belongs in
   * where.type_full using canonical dotted segment.* values. Predefined
   * remains on Hasura until the Management subtype is implemented.
   */
  segmentsV2Count: Scalars['Int']['output'];
  sf_account_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  signalById?: Maybe<Signal>;
  signals: Array<Signal>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /**
   * User locations available to the caller's account for a region. Defaults to US, as Deal Prompt does
   * when no region is selected.
   */
  userLocations: UserLocations;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
};


export type QueryAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type QueryAccountAdvertisersArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountForCallerArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type QueryAccount_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAccount_Feature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Feature_Flags_Order_By>>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};


export type QueryAccount_Feature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Feature_Flags_Order_By>>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};


export type QueryAccount_Feature_Flags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAccount_ListArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  distinct_on?: InputMaybe<Array<Account_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_List_Order_By>>;
  where?: InputMaybe<Account_List_Bool_Exp>;
};


export type QueryAccount_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_List_Order_By>>;
  where?: InputMaybe<Account_List_Bool_Exp>;
};


export type QueryAccount_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


export type QueryAccount_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


export type QueryAccount_Provider_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAccountsForProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  product: Product;
};


export type QueryAppGroupSearchArgs = {
  names: Array<Scalars['String']['input']>;
  suggestion_limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudienceArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


export type QueryAudienceSegmentExcelGenerateArgs = {
  input: AudienceSegmentExcelGenerateInput;
};


export type QueryAudienceSegmentSearchArgs = {
  input: AudienceSegmentSearchInput;
};


export type QueryAudienceSegmentSearchOptionsArgs = {
  input?: InputMaybe<AudienceSegmentSearchOptionsInput>;
};


export type QueryAudienceSegmentSearchTextArgs = {
  input: AudienceSegmentSearchTextInput;
};


export type QueryAudienceSharesByAudienceArgs = {
  audience_external_openaudience_id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudienceUsedByArgs = {
  audience_ids: Array<Scalars['String']['input']>;
};


export type QueryAudience_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


export type QueryAudience_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAudience_Categories_Reach_AllArgs = {
  id: Scalars['String']['input'];
};


export type QueryAudience_ReachArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  sfAccountName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAudience_SearchArgs = {
  filter?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


export type QueryAudience_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


export type QueryAudience_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


export type QueryAudience_Segment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryAuditTrailArgs = {
  fields?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  obj_id: Scalars['String']['input'];
  obj_type: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBidderAdvertisersDeliveryArgs = {
  ids: Array<Scalars['ID']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DeliveryRange>;
};


export type QueryBidderCreativeByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBidderCreativesArgs = {
  filter?: InputMaybe<Array<FilterParam>>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBidderLineItemByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBidderLineItemCreativesArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  line_item_id: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBidderLineItemDealSummaryArgs = {
  deal_id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBidderLineItemForecastArgs = {
  context?: InputMaybe<BidderLineItemForecastContextParams>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  line_item_id?: InputMaybe<Scalars['String']['input']>;
  package_targeting?: InputMaybe<Scalars['JSON']['input']>;
  url_targeting?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBidderLineItemsArgs = {
  delivery_status?: InputMaybe<BidderDeliveryStatus>;
  delivery_status_not_in?: InputMaybe<Array<BidderDeliveryStatus>>;
  filter?: InputMaybe<Array<FilterParam>>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_delivery_status_not_in?: InputMaybe<Array<BidderDeliveryStatus>>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBidderLineItemsDeliveryArgs = {
  ids: Array<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DeliveryRange>;
};


export type QueryBidderOrderByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBidderOrderLineItemsArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_id: Scalars['ID']['input'];
};


export type QueryBidderOrdersArgs = {
  advertiser_id?: InputMaybe<Scalars['String']['input']>;
  delivery_status?: InputMaybe<BidderDeliveryStatus>;
  end_date_from?: InputMaybe<Scalars['String']['input']>;
  end_date_to?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<FilterParam>>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start_date_from?: InputMaybe<Scalars['String']['input']>;
  start_date_to?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BidderOrderStatus>;
};


export type QueryBidderOrdersDeliveryArgs = {
  ids: Array<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DeliveryRange>;
};


export type QueryBq_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Bq_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bq_Resource_Order_By>>;
  where?: InputMaybe<Bq_Resource_Bool_Exp>;
};


export type QueryBq_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bq_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bq_Resource_Order_By>>;
  where?: InputMaybe<Bq_Resource_Bool_Exp>;
};


export type QueryBq_Resource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryCachedSearchResultsArgs = {
  resultsKeys: Array<Scalars['String']['input']>;
};


export type QueryCalculateOrfArgs = {
  input: CalculateOrfInput;
};


export type QueryCheckUserPermissionsArgs = {
  uid: Scalars['String']['input'];
};


export type QueryComputePricingArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  export_type?: InputMaybe<Scalars['String']['input']>;
  normalized_definition?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryContextualEstimateArgs = {
  targeting: Scalars['JSON']['input'];
};


export type QueryCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type QueryCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type QueryCountry_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type QueryCuratedDealBuyerDiscountArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<CuratedDealBuyerDiscountInput>;
};


export type QueryDealByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDealDeliveryArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DeliveryRange>;
};


export type QueryDealDeliveryByCodeArgs = {
  deal_id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DeliveryRange>;
};


export type QueryDealForecastingCreateJobArgs = {
  deal: ExchangeDealForecastingDealParams;
  package: PackageCreateParams;
};


export type QueryDealForecastingGetJobArgs = {
  job_id: Scalars['String']['input'];
};


export type QueryDealForecastingJobArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  job_id: Scalars['String']['input'];
};


export type QueryDealGroupInfoArgs = {
  deal_ids: Array<Scalars['String']['input']>;
};


export type QueryDealHealthScoreRootCausesArgs = {
  deal_ids: Array<Scalars['String']['input']>;
};


export type QueryDealInsightsJobArgs = {
  job_id: Scalars['String']['input'];
};


export type QueryDealLandingArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDealPromptBundlesSearchArgs = {
  input: DealPromptSearchInput;
};


export type QueryDealPromptDomainsSearchArgs = {
  input: DealPromptSearchInput;
};


export type QueryDealPromptSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryDealRboInfoArgs = {
  deal_id: Scalars['String']['input'];
};


export type QueryDealTroubleshootingAgentSessionHistoryArgs = {
  deal_id: Scalars['String']['input'];
  include_agent_steps?: InputMaybe<Scalars['Boolean']['input']>;
  session_id: Scalars['String']['input'];
};


export type QueryDealTroubleshootingAgentSessionListArgs = {
  deal_id: Scalars['String']['input'];
};


export type QueryDealTroubleshootingJobArgs = {
  deal_id: Scalars['String']['input'];
  job_id: Scalars['String']['input'];
};


export type QueryDealsArgs = {
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrichEstimateArgs = {
  export_type?: InputMaybe<Scalars['String']['input']>;
  hll_mode?: InputMaybe<Scalars['String']['input']>;
  normalized_definition?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryExportArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


export type QueryExport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


export type QueryExport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryExport_Status_TimelineArgs = {
  distinct_on?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Status_Timeline_Order_By>>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};


export type QueryExport_Status_Timeline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Status_Timeline_Order_By>>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};


export type QueryExport_Status_Timeline_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type QueryFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type QueryFeature_Flags_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type QueryGeoSearchArgs = {
  isRawQuery?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  phrase: Scalars['String']['input'];
};


export type QueryGetMonetizingArgs = {
  monetizing_uid: Scalars['String']['input'];
};


export type QueryGetPartnerAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetShareableOpenxAudienceArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryGetUdsAccountIdArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvOperatorSearchArgs = {
  instance_uid: Scalars['String']['input'];
  isRawQuery?: InputMaybe<Scalars['Boolean']['input']>;
  phrase: Scalars['String']['input'];
};


export type QueryInvPackageSearchArgs = {
  account_uid: Scalars['String']['input'];
  isRawQuery?: InputMaybe<Scalars['Boolean']['input']>;
  phrase: Scalars['String']['input'];
};


export type QueryInventoryBundleSearchArgs = {
  input: InventoryBundleSearchInput;
};


export type QueryInventoryBundleSearchTextArgs = {
  input: InventoryBundleSearchInput;
};


export type QueryInventoryDomainSearchArgs = {
  input: InventoryDomainSearchInput;
};


export type QueryInventoryDomainSearchTextArgs = {
  input: InventoryDomainSearchInput;
};


export type QueryInventorylistArgs = {
  account_uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  type_full?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLinkable_Aqua_Candidate_AccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLookalike_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Definition_Order_By>>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};


export type QueryLookalike_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Definition_Order_By>>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};


export type QueryLookalike_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryLookalike_Job_RunArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Job_Run_Order_By>>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};


export type QueryLookalike_Job_Run_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Job_Run_Order_By>>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};


export type QueryLookalike_Job_Run_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryLookalike_Seed_SourceArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Seed_Source_Order_By>>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};


export type QueryLookalike_Seed_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Seed_Source_Order_By>>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};


export type QueryLookalike_Seed_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryLookalike_Segment_Seed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
};


export type QueryLookalike_Segment_Seed_Aggregate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
};


export type QueryLookalike_Segment_Seed_Aggregate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryLookalike_Segment_SimilarityArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Similarity_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};


export type QueryLookalike_Segment_Similarity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Similarity_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};


export type QueryLookalike_Segment_Similarity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryManagementSegmentByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  type_full?: InputMaybe<Scalars['String']['input']>;
};


export type QueryManagementSegmentsArgs = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type_full: Scalars['String']['input'];
};


export type QueryManagementSegmentsCountArgs = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type_full: Scalars['String']['input'];
};


export type QueryNamedPixelFireFactsArgs = {
  pixelIds: Array<Scalars['String']['input']>;
};


export type QueryOpenxCuratedPackageArgs = {
  id: Scalars['String']['input'];
};


export type QueryOptionsByPathArgs = {
  filter?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
};


export type QueryPackageByIdArgs = {
  contextual_segment_format?: InputMaybe<ContextualSegmentFormat>;
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPackageContextualPricingArgs = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  contextual_segment: TargetingContextualSegmentCreateParams;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPackageUsedByArgs = {
  objects: Array<Scalars['String']['input']>;
  package_uid: Array<Scalars['String']['input']>;
};


export type QueryPackagesArgs = {
  contextual_segment_format?: InputMaybe<ContextualSegmentFormat>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPixelByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPixel_Event_MetricsArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryPixelsArgs = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<SignalEventType>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProviderArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type QueryProvider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type QueryProvider_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherProfileArgs = {
  filter?: InputMaybe<Array<FilterParam>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublisherProfileByPkArgs = {
  id: Scalars['String']['input'];
};


export type QueryRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type QueryRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type QueryRegion_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type QueryRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type QueryRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type QueryRole_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type QueryRoutedSegmentByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  type_full?: InputMaybe<SegmentTypeFull>;
};


export type QueryRoutedSegmentsArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  type_full?: InputMaybe<SegmentTypeFull>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type QuerySearchOptionsByPathArgs = {
  filter?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
};


export type QuerySegmentArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type QuerySegmentByIdV1Args = {
  id: Scalars['uuid']['input'];
};


export type QuerySegmentByIdV2Args = {
  id: Scalars['String']['input'];
  type_full?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySegmentExcelExportArgs = {
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type QuerySegment_AggregateArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type QuerySegment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerySegment_CountryArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


export type QuerySegment_Country_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


export type QuerySegment_Country_By_PkArgs = {
  country_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};


export type QuerySegment_RegionArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


export type QuerySegment_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


export type QuerySegment_Region_By_PkArgs = {
  region_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};


export type QuerySegment_SearchArgs = {
  filter?: InputMaybe<Scalars['ExchangeJSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type QuerySegmentsV1Args = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type QuerySegmentsV1CountArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type QuerySegmentsV2Args = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<SegmentWhereInput>;
};


export type QuerySegmentsV2CountArgs = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SegmentWhereInput>;
};


export type QuerySf_Account_NamesArgs = {
  id: Scalars['String']['input'];
};


export type QuerySignalByIdArgs = {
  id: Scalars['String']['input'];
  instance_uid?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySignalsArgs = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<SignalEventType>;
  filter?: InputMaybe<Array<FilterParam>>;
  instance_uid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type QueryUserLocationsArgs = {
  regionCode?: RegionCode;
};


export type QueryUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type QueryUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** Rate Limit for API Keys */
export type RateLimit = {
  /** Allowed count per interval, this should be a positive integer */
  count: Scalars['Int']['input'];
  /**
   * Interval is an ISO8601 duration, and is the time window for which the count
   * is accumulated and eventually results in blocking requests until the next
   * interval.  Example, with a count of 1000 and a duration of "PT24H" you would
   * get to make 1000 request per 24 hours.  An alternative way to express this could also
   * be an interval of "P1D".
   */
  interval: Scalars['Duration']['input'];
};

export type RboConfig = {
  __typename?: 'RboConfig';
  channel?: Maybe<Scalars['String']['output']>;
  custom_score_name?: Maybe<Scalars['String']['output']>;
  daily_goal_target?: Maybe<Scalars['StringOrInt']['output']>;
  drop_percent?: Maybe<Scalars['StringOrInt']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  hourly_target?: Maybe<Scalars['StringOrInt']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  initialized_at?: Maybe<Scalars['timestamptz']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tactic?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['String']['output']>;
};

export type RboConfigCreateParams = {
  channel?: InputMaybe<Scalars['String']['input']>;
  custom_score_name?: InputMaybe<Scalars['String']['input']>;
  daily_goal_target?: InputMaybe<Scalars['StringOrInt']['input']>;
  drop_percent?: InputMaybe<Scalars['StringOrInt']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  hourly_target?: InputMaybe<Scalars['StringOrInt']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  initialized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tactic?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
};

export type RboConfigUpdateParams = {
  channel?: InputMaybe<Scalars['String']['input']>;
  custom_score_name?: InputMaybe<Scalars['String']['input']>;
  daily_goal_target?: InputMaybe<Scalars['StringOrInt']['input']>;
  drop_percent?: InputMaybe<Scalars['StringOrInt']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  hourly_target?: InputMaybe<Scalars['StringOrInt']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  initialized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tactic?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
};

/** A region Segments can be scoped to. Matches the codes in the region table and the WISSP audience search. */
export const RegionCode = {
  Afr: 'AFR',
  Apac: 'APAC',
  Ca: 'CA',
  Eu: 'EU',
  Latam: 'LATAM',
  Us: 'US'
} as const;

export type RegionCode = typeof RegionCode[keyof typeof RegionCode];
export type RetargetingSegment = BaseSegment & MngBaseSegment & RoutedSegment & {
  __typename?: 'RetargetingSegment';
  account_id?: Maybe<Scalars['String']['output']>;
  account_uid: Scalars['String']['output'];
  activation_threshold?: Maybe<Scalars['Int']['output']>;
  created_date: Scalars['timestamptz']['output'];
  deleted: Scalars['String']['output'];
  disposition: RetargetingSegmentDisposition;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['String']['output'];
  instance_uid: Scalars['String']['output'];
  modified_date: Scalars['timestamptz']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  signals: RetargetingSegmentSignals;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  type_full: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
  v?: Maybe<Scalars['String']['output']>;
};

export type RetargetingSegmentCreateInput = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  activation_threshold?: InputMaybe<Scalars['Int']['input']>;
  disposition: RetargetingSegmentDisposition;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  signals: RetargetingSegmentSignalsInput;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

export const RetargetingSegmentDisposition = {
  Suppress: 'suppress',
  Target: 'target'
} as const;

export type RetargetingSegmentDisposition = typeof RetargetingSegmentDisposition[keyof typeof RetargetingSegmentDisposition];
export const RetargetingSegmentLookback = {
  P1D: 'P1D',
  P7D: 'P7D',
  P14D: 'P14D',
  P28D: 'P28D'
} as const;

export type RetargetingSegmentLookback = typeof RetargetingSegmentLookback[keyof typeof RetargetingSegmentLookback];
export const RetargetingSegmentMatchScope = {
  Direct: 'direct',
  Expanded: 'expanded'
} as const;

export type RetargetingSegmentMatchScope = typeof RetargetingSegmentMatchScope[keyof typeof RetargetingSegmentMatchScope];
export type RetargetingSegmentSignalClause = {
  __typename?: 'RetargetingSegmentSignalClause';
  /** The event type the clause targets. It can differ from pixel.event_type when the clause was saved with its own event_type. */
  event_type?: Maybe<SignalEventType>;
  lookback: RetargetingSegmentLookback;
  match_scope?: Maybe<RetargetingSegmentMatchScope>;
  /** The Named Pixel the clause targets. Null for legacy signals that have no pixel. */
  pixel?: Maybe<Pixel>;
  /** The id of the Named Pixel the clause targets. Null for legacy signals that have no pixel. Send it back with event_type as the clause's input. */
  pixel_id?: Maybe<Scalars['String']['output']>;
  retargeting_signal?: Maybe<Signal>;
  signal_id: Scalars['String']['output'];
};

export type RetargetingSegmentSignalClauseInput = {
  /** Event type for a pixel_id clause. Defaults to the pixel's event type. Each event type on a pixel has its own signal, so changing it targets a different audience. Any SignalEventType is accepted, including one that differs from the pixel's configured event type. A null value counts as not sent. Sending event_type with signal_id returns a field error at signals.include_any.event_type (or signals.exclude_any.event_type). */
  event_type?: InputMaybe<SignalEventType>;
  lookback: RetargetingSegmentLookback;
  match_scope?: InputMaybe<RetargetingSegmentMatchScope>;
  /** Exactly one of pixel_id or signal_id is required. A null ID counts as not sent. A pixel_id clause uses the segment account's signal for that pixel and event_type, and creates the signal if it does not exist yet. A signal_id must reference a signal of the segment account that belongs to a Named Pixel. Signals the segment already uses are accepted even without a pixel, so an update can send existing clauses back unchanged. Sending both IDs, a pixel that is not live on the segment account, or a signal_id without a pixel returns a field error at signals. Sending neither ID returns a field error at signals.include_any.signal_id (or signals.exclude_any.signal_id). */
  pixel_id?: InputMaybe<Scalars['StringOrInt']['input']>;
  signal_id?: InputMaybe<Scalars['StringOrInt']['input']>;
};

export type RetargetingSegmentSignals = {
  __typename?: 'RetargetingSegmentSignals';
  exclude_any: Array<RetargetingSegmentSignalClause>;
  include_any: Array<RetargetingSegmentSignalClause>;
};

export type RetargetingSegmentSignalsInput = {
  exclude_any?: InputMaybe<Array<RetargetingSegmentSignalClauseInput>>;
  include_any: Array<RetargetingSegmentSignalClauseInput>;
};

/** Lifecycle status for management-backed retargeting segments. */
export const RetargetingSegmentStatus = {
  Active: 'active',
  BackfillRequested: 'backfill_requested',
  Backfilling: 'backfilling',
  Deleted: 'deleted',
  Pending: 'pending'
} as const;

export type RetargetingSegmentStatus = typeof RetargetingSegmentStatus[keyof typeof RetargetingSegmentStatus];
export type RetargetingSegmentUpdateInput = {
  activation_threshold?: InputMaybe<Scalars['Int']['input']>;
  disposition?: InputMaybe<RetargetingSegmentDisposition>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  signals?: InputMaybe<RetargetingSegmentSignalsInput>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<RetargetingSegmentStatus>;
};

/**
 * Additive routed segment surface.
 * Returns the concrete backing object type for the selected source while
 * allowing direct selection of shared routed fields.
 */
export type RoutedSegment = {
  account_id?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['timestamptz']['output'];
  deleted: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  type_full: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
};

export type RoutedSegmentCreateInput = {
  predefined?: InputMaybe<Segment_Insert_Input>;
  retargeting?: InputMaybe<ManagementRetargetingSegmentCreateInput>;
};

export type RoutedSegmentUpdateInput = {
  predefined?: InputMaybe<Segment_Set_Input>;
  retargeting?: InputMaybe<ManagementRetargetingSegmentUpdateInput>;
};

/**
 * optionsByPath rows wrapped with pagination metadata, for paths that page
 * through Management API list endpoints.
 */
export type SearchOptionsByPathResult = {
  __typename?: 'SearchOptionsByPathResult';
  has_next_page: Scalars['Boolean']['output'];
  results: Array<OptionsByPathResult>;
  /**
   * Exact total match count when the backend can provide one cheaply, e.g. the
   * contextual segments search. Null for the entity searches (bidder_order,
   * bidder_lineitem, bidder_creative, deal, package): their list endpoints only
   * report has_more, so page until has_next_page is false if an exact count is
   * needed.
   */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export const SegmentPartnerRevenueMethod = {
  Cpm: 'CPM',
  PoM: 'PoM'
} as const;

export type SegmentPartnerRevenueMethod = typeof SegmentPartnerRevenueMethod[keyof typeof SegmentPartnerRevenueMethod];
export const SegmentSearchMode = {
  Marketplace: 'MARKETPLACE',
  OpenxProprietary: 'OPENX_PROPRIETARY',
  OwnOnly: 'OWN_ONLY'
} as const;

export type SegmentSearchMode = typeof SegmentSearchMode[keyof typeof SegmentSearchMode];
export const SegmentTypeFull = {
  SegmentPredefined: 'segment_predefined',
  SegmentRetargeting: 'segment_retargeting'
} as const;

export type SegmentTypeFull = typeof SegmentTypeFull[keyof typeof SegmentTypeFull];
export type SegmentTypeFullComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SegmentWhereInput = {
  _and?: InputMaybe<Array<SegmentWhereInput>>;
  _not?: InputMaybe<SegmentWhereInput>;
  _or?: InputMaybe<Array<SegmentWhereInput>>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_leaf?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  sub_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  type_full?: InputMaybe<SegmentTypeFullComparisonExp>;
};

export type SendDealPromptMessageInput = {
  /** Optional — if omitted a new session is created lazily. */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type SendDealPromptMessageResponse = {
  __typename?: 'SendDealPromptMessageResponse';
  invocationId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type Signal = {
  __typename?: 'Signal';
  account_id: Scalars['String']['output'];
  account_uid: Scalars['String']['output'];
  created_date: Scalars['timestamptz']['output'];
  event_type: SignalEventType;
  id: Scalars['String']['output'];
  /** The instance this object lives on. */
  instance_uid?: Maybe<Scalars['String']['output']>;
  modified_date: Scalars['timestamptz']['output'];
  /** Pixel the signal is scoped to. Null for account-level signals. */
  pixel_id?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type SignalCreateParams = {
  account_uid?: InputMaybe<Scalars['String']['input']>;
  event_type: SignalEventType;
  /** Optional. Must reference a live pixel on the same account. Write-once. */
  pixel_id?: InputMaybe<Scalars['String']['input']>;
};

export const SignalEventType = {
  Api: 'api',
  Atc: 'atc',
  Atw: 'atw',
  Cp: 'cp',
  Creg: 'creg',
  Ct: 'ct',
  Dn: 'dn',
  Fl: 'fl',
  Ic: 'ic',
  Ld: 'ld',
  P: 'p',
  Pv: 'pv',
  S: 's',
  Sa: 'sa',
  Sch: 'sch',
  St: 'st',
  Sub: 'sub',
  Vc: 'vc'
} as const;

export type SignalEventType = typeof SignalEventType[keyof typeof SignalEventType];
/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Targeting specifies the request-time traffic filters that are used to target the deal. */
export type Targeting = {
  __typename?: 'Targeting';
  /** Target mobile applications inventory */
  app_inventory?: Maybe<TargetingAppInventory>;
  /** attention param that describes the level of user attention expected for the ad placement, must be "1" or null  */
  attention?: Maybe<Scalars['String']['output']>;
  /** Targeting object specifying an Audience. */
  audience?: Maybe<TargetingAudience>;
  /** Target inventory based on brand safety data */
  brand_safety?: Maybe<TargetingBrandSafety>;
  /** Targeting object specifying some supply-side inventory content (adunit, page, site, etc). */
  content?: Maybe<TargetingContent>;
  /** Targeting object specifying contextual segments to target or block. */
  contextual_segment?: Maybe<TargetingContextualSegment>;
  /** Targeting object specifying custom key/value pairs. */
  custom?: Maybe<TargetingCustom>;
  /** Targeting object specifying one or more domain categories. */
  domain?: Maybe<TargetingDomain>;
  /** Boolean if true, the package will not be matched against indirect inventory */
  exclude_non_direct?: Maybe<Scalars['Boolean']['output']>;
  /** Targeting object specifying inferred geolocation at request time. */
  geographic?: Maybe<TargetingGeographic>;
  /** Value of 1, the package will include open bidding inventory */
  include_open_bidding_inventory?: Maybe<Scalars['String']['output']>;
  /** Attributes used for Content object targeting defined in OpenRTB v2.5 spec */
  instream_content?: Maybe<TargetingInstreamContent>;
  /** Specifies whether targeting specs must all match ('AND') or if only one is required ('OR'). */
  inter_dimension_operator: Scalars['String']['output'];
  /** Targeting object specifying inventory formats. */
  inventory_format?: Maybe<TargetingInventoryFormat>;
  /** Target inventory quality */
  inventory_quality?: Maybe<TargetingInventoryQuality>;
  /** OpenX additional categories and keywords - allows to target or block specific inventory tagged with internal metacategories, and to target/block specific keywords on pages, based on OpenX Contextual service. */
  metacategory?: Maybe<TargetingMetaCategory>;
  /** Targeting object specifying the rendering context. Replaces the legacy `inventory_format` field. */
  rendering_context?: Maybe<TargetingRenderingContext>;
  /** Targeting object specifying a Retargeting Segment. */
  retargeting_segment?: Maybe<TargetingSegmentRetargeting>;
  /** Targeting object specifying technographic characteristics of the request. */
  technographic?: Maybe<TargetingTechnographic>;
  /** Targeting object specifying video characteristics. */
  video?: Maybe<TargetingVideo>;
  /** Targeting object specifying viewability characteristics. */
  viewability?: Maybe<TargetingViewability>;
  /** vpvh param (co-viewing likelihood), must be "true" or null */
  vpvh?: Maybe<Scalars['String']['output']>;
  /** Targeting object specifying VTR (view-through rate) characteristics. */
  vtr?: Maybe<TargetingVtr>;
};

/** Specifies an ad placement type for targeting (ie, display vs video). */
export type TargetingAdPlacement = {
  __typename?: 'TargetingAdPlacement';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more ad placement types.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.inventory_format.ad_placement")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingAdPlacementCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more ad placement types.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.inventory_format.ad_placement")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingAdPlacementUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more ad placement types.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.inventory_format.ad_placement")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Specifies an ad placement type for targeting (ie, display vs video). */
export type TargetingAdPlacementV2 = {
  __typename?: 'TargetingAdPlacementV2';
  /** Must be "==". */
  op: Scalars['String']['output'];
  /**
   * Targets a single ad placement type.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.ad_placement")`.)
   */
  val: Scalars['String']['output'];
};

export type TargetingAdPlacementV2CreateParams = {
  /** Must be "==". */
  op: Scalars['String']['input'];
  /**
   * Targets a single ad placement type.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.ad_placement")`.)
   */
  val: Scalars['String']['input'];
};

export type TargetingAdPlacementV2UpdateParams = {
  /** Must be "==". */
  op: Scalars['String']['input'];
  /**
   * Targets a single ad placement type.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.ad_placement")`.)
   */
  val: Scalars['String']['input'];
};

/** Specifies video inventory by its maximum duration. */
export type TargetingAdunitMaxDuration = {
  __typename?: 'TargetingAdunitMaxDuration';
  /** Must be one of "<=", "==", "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more linear video duration options.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.adunit_max_duration")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingAdunitMaxDurationCreateParams = {
  /** Must be one of "<=", "==", "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more linear video duration options.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.adunit_max_duration")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/**
 * Defines a range for the maximum duration (in seconds) of a video ad unit.
 * To match an exact duration, set both `start` and `end` to the same value.
 */
export type TargetingAdunitMaxDurationRange = {
  __typename?: 'TargetingAdunitMaxDurationRange';
  /**
   * The maximum duration of the range, in seconds (1–360).
   * Leave empty for an open-ended range.
   */
  end?: Maybe<Scalars['String']['output']>;
  /** The minimum duration of the range, in seconds (1–360). */
  start: Scalars['String']['output'];
};

/**
 * Defines a range for the maximum duration (in seconds) of a video ad unit.
 * To match an exact duration, set both `start` and `end` to the same value.
 */
export type TargetingAdunitMaxDurationRangeCreateParams = {
  /**
   * The maximum duration of the range, in seconds (1–360).
   * Leave empty for an open-ended range.
   */
  end?: InputMaybe<Scalars['String']['input']>;
  /** The minimum duration of the range, in seconds (1–360). */
  start: Scalars['String']['input'];
};

/**
 * Defines a range for the maximum duration (in seconds) of a video ad unit.
 * To match an exact duration, set both `start` and `end` to the same value.
 */
export type TargetingAdunitMaxDurationRangeUpdateParams = {
  /**
   * The maximum duration of the range, in seconds (1–360).
   * Leave empty for an open-ended range.
   */
  end?: InputMaybe<Scalars['String']['input']>;
  /** The minimum duration of the range, in seconds (1–360). */
  start: Scalars['String']['input'];
};

export type TargetingAdunitMaxDurationUpdateParams = {
  /** Must be one of "<=", "==", "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more linear video duration options.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.adunit_max_duration")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Specifies an API framework for targeting. */
export type TargetingApiFramework = {
  __typename?: 'TargetingApiFramework';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more video API frameworks.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.api_framework")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingApiFrameworkCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more video API frameworks.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.api_framework")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingApiFrameworkUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more video API frameworks.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.api_framework")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Enables to define targeting dimensions related to app bundles and app groups. */
export type TargetingAppInventory = {
  __typename?: 'TargetingAppInventory';
  /** Targeting object specifying one or more AppBundle IDs. */
  app_bundle_id?: Maybe<TargetingContentAppBundleId>;
  /** The operator to apply to app inventory criteria defined in this object, must be "AND" or "OR". */
  app_inventory_inter_dimension_operator?: Maybe<Scalars['String']['output']>;
  /** Targeting object specifying one or more App Groups (Friendly App Names). */
  appgroup?: Maybe<TargetingAppInventoryAppGroup>;
};

/** Targeting based on AppGroup ID. Appgroup aggregates multiple AppInfo objects under single ID. */
export type TargetingAppInventoryAppGroup = {
  __typename?: 'TargetingAppInventoryAppGroup';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more app groups (Friendly App Names).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.app_group")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

/** Targeting based on AppGroup ID. Appgroup aggregates multiple AppInfo objects under single ID. */
export type TargetingAppInventoryAppGroupCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more app groups (Friendly App Names).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.app_group")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Targeting based on AppGroup ID. Appgroup aggregates multiple AppInfo objects under single ID. */
export type TargetingAppInventoryAppGroupUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more app groups (Friendly App Names).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.app_group")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingAppInventoryCreateParams = {
  /** Object specifying one or more AppBundle IDs. */
  app_bundle_id?: InputMaybe<TargetingContentAppBundleIdCreateParams>;
  /** The operator to apply to app inventory criteria defined in this object, must be "AND" or "OR". */
  app_inventory_inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** Object specifying one or more App Groups (Friendly App Names). */
  appgroup?: InputMaybe<TargetingAppInventoryAppGroupCreateParams>;
};

export type TargetingAppInventoryUpdateParams = {
  /** Object specifying one or more AppBundle IDs. */
  app_bundle_id?: InputMaybe<TargetingContentAppBundleIdUpdateParams>;
  /** The operator to apply to app inventory criteria defined in this object, must be "AND" or "OR". */
  app_inventory_inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** Object specifying one or more App Groups (Friendly App Names). */
  appgroup?: InputMaybe<TargetingAppInventoryAppGroupUpdateParams>;
};

/** Represents an activated Audience that is used as the target of the deal. */
export type TargetingAudience = {
  __typename?: 'TargetingAudience';
  /** OpenXSelect custom audience to be targeted by this deal. */
  openaudience_custom?: Maybe<TargetingOpenaudienceCustom>;
};

export type TargetingAudienceCreateParams = {
  /** OpenXSelect custom audience to be targeted by this deal. */
  openaudience_custom?: InputMaybe<TargetingOpenaudienceCustomCreateParams>;
};

export type TargetingAudienceUpdateParams = {
  /** OpenXSelect custom audience to be targeted by this deal. */
  openaudience_custom?: InputMaybe<TargetingOpenaudienceCustomUpdateParams>;
};

/** Enables you to define brand safety targeting dimensions used to exclude inventory that does not meet brand safety requirements. */
export type TargetingBrandSafety = {
  __typename?: 'TargetingBrandSafety';
  /** Target against DoubleVerify brand safety segments. */
  dv_segments?: Maybe<TargetingBrandSafetyDvSegments>;
};

/** Enables you to define brand safety targeting dimensions used to exclude inventory that does not meet brand safety requirements. */
export type TargetingBrandSafetyCreateParams = {
  /** Target against DoubleVerify brand safety segments. */
  dv_segments?: InputMaybe<TargetingBrandSafetyDvSegmentsCreateParams>;
};

/** Target against DoubleVerify brand safety segments. */
export type TargetingBrandSafetyDvSegments = {
  __typename?: 'TargetingBrandSafetyDvSegments';
  /** Must be "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * One or more DoubleVerify brand safety segments to exclude.
   * Use a comma-delimited list to specify multiple segments.
   */
  val?: Maybe<Scalars['String']['output']>;
};

/** Target against DoubleVerify brand safety segments. */
export type TargetingBrandSafetyDvSegmentsCreateParams = {
  /** Must be "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * One or more DoubleVerify brand safety segments to exclude.
   * Use a comma-delimited list to specify multiple segments.
   */
  val?: InputMaybe<Scalars['String']['input']>;
};

/** Target against DoubleVerify brand safety segments. */
export type TargetingBrandSafetyDvSegmentsUpdateParams = {
  /** Must be "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * One or more DoubleVerify brand safety segments to exclude.
   * Use a comma-delimited list to specify multiple segments.
   */
  val?: InputMaybe<Scalars['String']['input']>;
};

/** Enables you to define brand safety targeting dimensions used to exclude inventory that does not meet brand safety requirements. */
export type TargetingBrandSafetyUpdateParams = {
  /** Target against DoubleVerify brand safety segments. */
  dv_segments?: InputMaybe<TargetingBrandSafetyDvSegmentsUpdateParams>;
};

/** Specifies a browser for targeting, derived from User-Agent headers or similar client hints. */
export type TargetingBrowser = {
  __typename?: 'TargetingBrowser';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more browsers.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.browser")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingBrowserCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more browsers.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.browser")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingBrowserUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more browsers.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.browser")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Used to target inventory via content attributes. */
export type TargetingContent = {
  __typename?: 'TargetingContent';
  /**
   * Inventory items to be included/excluded arranged by customer ID for display purposes.
   * For internal OpenX use only.
   */
  _idsByInstances?: Maybe<Scalars['JSON']['output']>;
  /** Content Targeting object specifying one or more Publisher IDs. */
  account?: Maybe<TargetingContentPublisherId>;
  /** Content Targeting object specifying one or more Ad Unit Sizes. */
  adunit_size?: Maybe<TargetingContentAdunitSize>;
  /** The operator to apply to content criteria defined in this object, must be "AND" or "OR". */
  content_inter_dimension_operator?: Maybe<Scalars['String']['output']>;
  /**
   * Content Targeting object specifying one or more inventory items to be excluded.
   * For internal OpenX use only.
   */
  excludes?: Maybe<TargetingContentInventory>;
  /**
   * Content Targeting object specifying one or more inventory items to be included.
   * For internal OpenX use only.
   */
  includes?: Maybe<TargetingContentInventory>;
  /** Content Targeting object specifying one or more Instance Hashes. */
  instance?: Maybe<TargetingContentInstanceHash>;
  /** OpenX Contextual Targeting Service keywords targeting */
  keywords?: Maybe<TargetingContentKeywords>;
  /** Content Targeting object specifying one or more page URLs. */
  page_url?: Maybe<TargetingContentPageUrl>;
  /**
   * Content Targeting object specifying one or more Site IDs.
   * For internal OpenX use only.
   */
  site?: Maybe<TargetingContentSite>;
};

/** Used to specify ad unit size(s) for targeting. */
export type TargetingContentAdunitSize = {
  __typename?: 'TargetingContentAdunitSize';
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['output'];
  /**
   * The Ad Unit Size(s) to target.  Must match the `id` field returned
   * from `optionsByPath(path: "deal.package.targeting.content.adunit_size")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingContentAdunitSizeCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /**
   * The Ad Unit Size(s) to target.  Must match the `id` field returned
   * from `optionsByPath(path: "deal.package.targeting.content.adunit_size")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingContentAdunitSizeUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /**
   * The Ad Unit Size(s) to target.  Must match the `id` field returned
   * from `optionsByPath(path: "deal.package.targeting.content.adunit_size")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Used to target inventory via mobile app bundles. */
export type TargetingContentAppBundleId = {
  __typename?: 'TargetingContentAppBundleId';
  /** An optional Inventory List to target bundles. */
  inventorylist?: Maybe<TargetingContentAppBundleIdInventoryList>;
  /** Must be "AND" or "OR" */
  op: Scalars['String']['output'];
  /** One or more criteria targeting App Bundle IDs.  A maximum of 20000 may be specified. */
  val?: Maybe<Array<TargetingContentAppBundleIdItem>>;
};

export type TargetingContentAppBundleIdCreateParams = {
  /** An optional Inventory List to target bundles. */
  inventorylist?: InputMaybe<TargetingContentAppBundleIdInventoryListCreateParams>;
  /** Must be "AND" or "OR" */
  op: Scalars['String']['input'];
  /** One or more criteria targeting App Bundle IDs.  A maximum of 20000 may be specified. */
  val?: InputMaybe<Array<TargetingContentAppBundleIdItemCreateParams>>;
};

/** Used to specify Inventory List for targeting. */
export type TargetingContentAppBundleIdInventoryList = {
  __typename?: 'TargetingContentAppBundleIdInventoryList';
  /** The Inventory List used to target bundles. */
  id: Scalars['String']['output'];
  /** Currently only "allow" is supported. */
  type: Scalars['String']['output'];
};

export type TargetingContentAppBundleIdInventoryListCreateParams = {
  /** The Inventory List used to target bundles. */
  id: Scalars['String']['input'];
  /** Currently only "allow" is supported. */
  type: Scalars['String']['input'];
};

export type TargetingContentAppBundleIdInventoryListUpdateParams = {
  /** The Inventory List used to target bundles. */
  id: Scalars['String']['input'];
  /** Currently only "allow" is supported. */
  type: Scalars['String']['input'];
};

/** Used to specify mobile app bundle IDs for targeting. */
export type TargetingContentAppBundleIdItem = {
  __typename?: 'TargetingContentAppBundleIdItem';
  /** Must be "==", "NOT INTERSECTS", "INTERSECTS", "NOT =^", "!=" or "=^" */
  op: Scalars['String']['output'];
  /** The App Bundle ID to target. */
  val: Scalars['String']['output'];
};

export type TargetingContentAppBundleIdItemCreateParams = {
  /** Must be "==", "NOT INTERSECTS", "INTERSECTS", "NOT =^", "!=" or "=^" */
  op: Scalars['String']['input'];
  /** The App Bundle ID to target. */
  val: Scalars['String']['input'];
};

export type TargetingContentAppBundleIdItemUpdateParams = {
  /** Must be "==", "NOT INTERSECTS", "INTERSECTS", "NOT =^", "!=" or "=^" */
  op: Scalars['String']['input'];
  /** The App Bundle ID to target. */
  val: Scalars['String']['input'];
};

export type TargetingContentAppBundleIdUpdateParams = {
  /** An optional Inventory List to target bundles. */
  inventorylist?: InputMaybe<TargetingContentAppBundleIdInventoryListUpdateParams>;
  /** Must be "AND" or "OR" */
  op: Scalars['String']['input'];
  /** One or more criteria targeting App Bundle IDs.  A maximum of 20000 may be specified. */
  val?: InputMaybe<Array<TargetingContentAppBundleIdItemUpdateParams>>;
};

export type TargetingContentCreateParams = {
  /**
   * Inventory items to be included/excluded arranged by customer ID for display purposes.
   * For internal OpenX use only.
   */
  _idsByInstances?: InputMaybe<Scalars['JSON']['input']>;
  /** Content Targeting object specifying one or more Publisher IDs. */
  account?: InputMaybe<TargetingContentPublisherIdCreateParams>;
  /** Content Targeting object specifying one or more Ad Unit Sizes. */
  adunit_size?: InputMaybe<TargetingContentAdunitSizeCreateParams>;
  /** The operator to apply to category criteria defined in this object, must be "AND" or "OR". */
  categories_inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** The operator to apply to content criteria defined in this object, must be "AND" or "OR". */
  content_inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /**
   * Content Targeting object specifying one or more inventory items to be excluded.
   * For internal OpenX use only.
   */
  excludes?: InputMaybe<TargetingContentInventoryCreateParams>;
  /**
   * Content Targeting object specifying one or more inventory items to be included.
   * For internal OpenX use only.
   */
  includes?: InputMaybe<TargetingContentInventoryCreateParams>;
  /** Content Targeting object specifying one or more Instance Hashes. */
  instance?: InputMaybe<TargetingContentInstanceHashCreateParams>;
  /** OpenX Contextual Targeting Service keywords targeting. */
  keywords?: InputMaybe<TargetingContentKeywordsCreateParams>;
  /** Content Targeting object specifying one or more page URLs. */
  page_url?: InputMaybe<TargetingContentPageUrlCreateParams>;
  /** Content Targeting object specifying one or more Site IDs */
  site?: InputMaybe<TargetingContentSiteCreateParams>;
};

export type TargetingContentInstanceHash = {
  __typename?: 'TargetingContentInstanceHash';
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['output'];
  /**
   * The Instace Hash to target.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingContentInstanceHashCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /**
   * The Instace Hash to target.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingContentInstanceHashUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /**
   * The Instace Hash to target.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Targets inventory operated by OpenX customer instances.  For internal use only. */
export type TargetingContentInventory = {
  __typename?: 'TargetingContentInventory';
  /**
   * Target accounts operated by an OpenX customer instance.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  account?: Maybe<Scalars['String']['output']>;
  /**
   * Target adunits operated by an OpenX customer instance.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  adunit?: Maybe<Scalars['String']['output']>;
  /**
   * Target OpenX customer instances.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  instance?: Maybe<Scalars['String']['output']>;
  /**
   * Target networks operated by an OpenX customer instance.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  network?: Maybe<Scalars['String']['output']>;
  /**
   * Target pages operated by an OpenX customer instance.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  page?: Maybe<Scalars['String']['output']>;
  /**
   * Target sections operated by an OpenX customer instance.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  section?: Maybe<Scalars['String']['output']>;
  /**
   * Target sites operated by an OpenX customer instance.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  site?: Maybe<Scalars['String']['output']>;
  /**
   * Target sitesections operated by an OpenX customer instance.  For internal use only.
   * Use a comma-delimited list to specify multiple selections.
   */
  sitesection?: Maybe<Scalars['String']['output']>;
};

export type TargetingContentInventoryCreateParams = {
  /** Target accounts operated by an OpenX customer instance.  For internal use only. */
  account?: InputMaybe<Scalars['String']['input']>;
  /** Target adunits operated by an OpenX customer instance.  For internal use only. */
  adunit?: InputMaybe<Scalars['String']['input']>;
  /** Target OpenX customer instances.  For internal use only. */
  instance?: InputMaybe<Scalars['String']['input']>;
  /** Target networks operated by an OpenX customer instance.  For internal use only. */
  network?: InputMaybe<Scalars['String']['input']>;
  /** Target pages operated by an OpenX customer instance.  For internal use only. */
  page?: InputMaybe<Scalars['String']['input']>;
  /** Target sections operated by an OpenX customer instance.  For internal use only. */
  section?: InputMaybe<Scalars['String']['input']>;
  /** Target sites operated by an OpenX customer instance.  For internal use only. */
  site?: InputMaybe<Scalars['String']['input']>;
  /** Target sitesections operated by an OpenX customer instance.  For internal use only. */
  sitesection?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingContentInventoryUpdateParams = {
  /** Target accounts operated by an OpenX customer instance.  For internal use only. */
  account?: InputMaybe<Scalars['String']['input']>;
  /** Target adunits operated by an OpenX customer instance.  For internal use only. */
  adunit?: InputMaybe<Scalars['String']['input']>;
  /** Target OpenX customer instances.  For internal use only. */
  instance?: InputMaybe<Scalars['String']['input']>;
  /** Target networks operated by an OpenX customer instance.  For internal use only. */
  network?: InputMaybe<Scalars['String']['input']>;
  /** Target pages operated by an OpenX customer instance.  For internal use only. */
  page?: InputMaybe<Scalars['String']['input']>;
  /** Target sections operated by an OpenX customer instance.  For internal use only. */
  section?: InputMaybe<Scalars['String']['input']>;
  /** Target sites operated by an OpenX customer instance.  For internal use only. */
  site?: InputMaybe<Scalars['String']['input']>;
  /** Target sitesections operated by an OpenX customer instance.  For internal use only. */
  sitesection?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingContentKeywords = {
  __typename?: 'TargetingContentKeywords';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * List of keywords.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  val: Array<Scalars['String']['output']>;
};

export type TargetingContentKeywordsCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * List of keywords.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  val: Array<Scalars['String']['input']>;
};

export type TargetingContentKeywordsUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * List of keywords.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  val: Array<Scalars['String']['input']>;
};

/** Used to specify page-level URL patterns for targeting. */
export type TargetingContentPageUrl = {
  __typename?: 'TargetingContentPageUrl';
  /** Must be "AND" or "OR" */
  op: Scalars['String']['output'];
  /** One or more criteria targeting page level URLs.  A maximum of 2000 may be specified. */
  val?: Maybe<Array<TargetingContentPageUrlItem>>;
};

export type TargetingContentPageUrlCreateParams = {
  /** Must be "AND" or "OR" */
  op: Scalars['String']['input'];
  /** One or more criteria targeting page level URLs.  A maximum of 2000 may be specified. */
  val?: InputMaybe<Array<TargetingContentPageUrlItemCreateParams>>;
};

/** Represents a page-level URL pattern. */
export type TargetingContentPageUrlItem = {
  __typename?: 'TargetingContentPageUrlItem';
  /**
   * Must be "INTERSECTS", "NOT INTERSECTS", "==", "!=", "NOT =?", "=?", "=^", "NOT =^", "=$", or "NOT =$".
   * To match any page containing the specified string, use the substring operator "=?".
   */
  op: Scalars['String']['output'];
  /** The page URL to target. */
  val: Scalars['String']['output'];
};

export type TargetingContentPageUrlItemCreateParams = {
  /**
   * Must be "INTERSECTS", "NOT INTERSECTS", "==", "!=", "NOT =?", "=?", "=^", "NOT =^", "=$", or "NOT =$".
   * To match any page containing the specified string, use the substring operator "=?".
   */
  op: Scalars['String']['input'];
  /** The page URL to target. */
  val: Scalars['String']['input'];
};

export type TargetingContentPageUrlItemUpdateParams = {
  /**
   * Must be "INTERSECTS", "NOT INTERSECTS", "==", "!=", "NOT =?", "=?", "=^", "NOT =^", "=$", or "NOT =$".
   * To match any page containing the specified string, use the substring operator "=?".
   */
  op: Scalars['String']['input'];
  /** The page URL to target. */
  val: Scalars['String']['input'];
};

export type TargetingContentPageUrlUpdateParams = {
  /** Must be "AND" or "OR" */
  op: Scalars['String']['input'];
  /** One or more criteria targeting App Bundle IDs.  A maximum of 2000 may be specified. */
  val?: InputMaybe<Array<TargetingContentPageUrlItemUpdateParams>>;
};

export type TargetingContentPublisherId = {
  __typename?: 'TargetingContentPublisherId';
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['output'];
  /**
   * The Publisher ID to target.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingContentPublisherIdCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /**
   * The Publisher ID to target.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingContentPublisherIdUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /**
   * The Publisher ID to target.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Used to specify site objects for targeting. Internal OpenX use only. */
export type TargetingContentSite = {
  __typename?: 'TargetingContentSite';
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['output'];
  /** The Site object IDs. */
  val: Scalars['String']['output'];
};

export type TargetingContentSiteCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /** The Site object IDs to target. Internal OpenX use only. */
  val: Scalars['String']['input'];
};

export type TargetingContentSiteUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS" */
  op: Scalars['String']['input'];
  /** The Site object IDs to target. For Internal OpenX use only. */
  val: Scalars['String']['input'];
};

export type TargetingContentUpdateParams = {
  /**
   * Inventory items to be included/excluded arranged by customer ID for display purposes.
   * For internal OpenX use only.
   */
  _idsByInstances?: InputMaybe<Scalars['JSON']['input']>;
  /** Content Targeting object specifying one or more Publisher IDs. */
  account?: InputMaybe<TargetingContentPublisherIdUpdateParams>;
  /** Content Targeting object specifying one or more Ad Unit Sizes. */
  adunit_size?: InputMaybe<TargetingContentAdunitSizeUpdateParams>;
  /** The operator to apply to category criteria defined in this object, must be "AND" or "OR". */
  categories_inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** The operator to apply to content criteria defined in this object, must be "AND" or "OR". */
  content_inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /**
   * Content Targeting object specifying one or more inventory items to be excluded.
   * For internal OpenX use only.
   */
  excludes?: InputMaybe<TargetingContentInventoryUpdateParams>;
  /**
   * Content Targeting object specifying one or more inventory items to be included.
   * For internal OpenX use only.
   */
  includes?: InputMaybe<TargetingContentInventoryUpdateParams>;
  /** Content Targeting object specifying one or more Instance Hashes. */
  instance?: InputMaybe<TargetingContentInstanceHashUpdateParams>;
  /** OpenX Contextual Targeting Service keywords targeting. */
  keywords?: InputMaybe<TargetingContentKeywordsUpdateParams>;
  /** Content Targeting object specifying one or more page URLs. */
  page_url?: InputMaybe<TargetingContentPageUrlUpdateParams>;
  /** Content Targeting object specifying one or more Site IDs. */
  site?: InputMaybe<TargetingContentSiteUpdateParams>;
};

/** Targets inventory by contextual segments, grouped by the contextual provider owning them. */
export type TargetingContextualSegment = {
  __typename?: 'TargetingContextualSegment';
  /** Contextual segments to block. */
  excludes?: Maybe<Array<TargetingContextualSegmentItem>>;
  /** Contextual segments to target. */
  includes?: Maybe<Array<TargetingContextualSegmentItem>>;
};

/** Targets inventory by contextual segments, grouped by the contextual provider owning them. */
export type TargetingContextualSegmentCreateParams = {
  /** Contextual segments to block. */
  excludes?: InputMaybe<Array<TargetingContextualSegmentItemCreateParams>>;
  /** Contextual segments to target. */
  includes?: InputMaybe<Array<TargetingContextualSegmentItemCreateParams>>;
};

/** Specifies the contextual segments of a single contextual provider. */
export type TargetingContextualSegmentItem = {
  __typename?: 'TargetingContextualSegmentItem';
  /** Id of the contextual provider owning the segments. */
  provider: Scalars['String']['output'];
  /** One or more segment ids of the provider. */
  val: Array<Scalars['String']['output']>;
};

/** Specifies the contextual segments of a single contextual provider. */
export type TargetingContextualSegmentItemCreateParams = {
  /** Id of the contextual provider owning the segments. */
  provider: Scalars['String']['input'];
  /** One or more segment ids of the provider. */
  val: Array<Scalars['String']['input']>;
};

/** Specifies the contextual segments of a single contextual provider. */
export type TargetingContextualSegmentItemUpdateParams = {
  /** Id of the contextual provider owning the segments. */
  provider: Scalars['String']['input'];
  /** One or more segment ids of the provider. */
  val: Array<Scalars['String']['input']>;
};

/** Targets inventory by contextual segments, grouped by the contextual provider owning them. */
export type TargetingContextualSegmentUpdateParams = {
  /** Contextual segments to block. */
  excludes?: InputMaybe<Array<TargetingContextualSegmentItemUpdateParams>>;
  /** Contextual segments to target. */
  includes?: InputMaybe<Array<TargetingContextualSegmentItemUpdateParams>>;
};

export type TargetingCreateParams = {
  /** Target mobile applications inventory */
  app_inventory?: InputMaybe<TargetingAppInventoryCreateParams>;
  /** attention param that describes the level of user attention expected for the ad placement, must be "1" or null */
  attention?: InputMaybe<Scalars['String']['input']>;
  /** Targeting object specifying an Audience. */
  audience?: InputMaybe<TargetingAudienceCreateParams>;
  /** Target inventory based on brand safety data */
  brand_safety?: InputMaybe<TargetingBrandSafetyCreateParams>;
  /** Targeting object specifying some supply-side inventory content (adunit, page, site, etc). */
  content?: InputMaybe<TargetingContentCreateParams>;
  /**
   * Targeting object specifying contextual segments to target or block. Ignored unless the request
   * names `contextual_segment_format: new`; with `legacy` (the default) the `ctx_` custom variables
   * in `custom` are the source.
   */
  contextual_segment?: InputMaybe<TargetingContextualSegmentCreateParams>;
  /** Targeting object specifying custom key/value pairs. */
  custom?: InputMaybe<TargetingCustomCreateParams>;
  /** Targeting object specifying one or more domain categories. */
  domain?: InputMaybe<TargetingDomainCreateParams>;
  /** Boolean if true, the package will not be matched against indirect inventory */
  exclude_non_direct?: InputMaybe<Scalars['Boolean']['input']>;
  /** Targeting object specifying inferred geolocation at request time. */
  geographic?: InputMaybe<TargetingGeographicCreateParams>;
  /** Value of 1, the package will include open bidding inventory */
  include_open_bidding_inventory?: InputMaybe<Scalars['String']['input']>;
  /** Attributes used for Content object targeting defined in OpenRTB v2.5 spec */
  instream_content?: InputMaybe<TargetingInstreamContentCreateParams>;
  /** Specifies whether targeting specs must all match ('AND') or if only one is required ('OR'). */
  inter_dimension_operator: Scalars['String']['input'];
  /** Targeting object specifying inventory formats. */
  inventory_format?: InputMaybe<TargetingInventoryFormatCreateParams>;
  /** Target inventory quality */
  inventory_quality?: InputMaybe<TargetingInventoryQualityCreateParams>;
  /** OpenX additional categories and keywords - allows to target or block specific inventory tagged with internal metacategories, and to target/block specific keywords on pages, based on OpenX Contextual service. */
  metacategory?: InputMaybe<TargetingMetaCategoryCreateParams>;
  /** Targeting object specifying the rendering context. Replaces the legacy `inventory_format` field. */
  rendering_context: TargetingRenderingContextCreateParams;
  /** Targeting object specifying a Retargeting Segment. */
  retargeting_segment?: InputMaybe<TargetingSegmentRetargetingCreateParams>;
  /** Targeting object specifying technographic characteristics of the request. */
  technographic?: InputMaybe<TargetingTechnographicCreateParams>;
  /** Targeting object specifying video characteristics. */
  video?: InputMaybe<TargetingVideoCreateParams>;
  /** Targeting object specifying viewability characteristics. */
  viewability?: InputMaybe<TargetingViewabilityCreateParams>;
  /** vpvh param (co-viewing likelihood), must be "true" or null */
  vpvh?: InputMaybe<Scalars['String']['input']>;
  /** Targeting object specifying VTR (view-through rate) characteristics. */
  vtr?: InputMaybe<TargetingVtrCreateParams>;
};

/** Targets inventory by custom attributes, including contextual targeting. */
export type TargetingCustom = {
  __typename?: 'TargetingCustom';
  /** Must be "AND" or "OR". */
  op: Scalars['String']['output'];
  /** Target a custom variable.  Use only if instructed by OpenX. */
  val?: Maybe<Array<TargetingCustomItem>>;
};

export type TargetingCustomCreateParams = {
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
  /** Target a custom variable.  Use only if instructed by OpenX. */
  val?: InputMaybe<Array<TargetingCustomItemCreateParams>>;
};

/** Specifies a single custom attribute for targeting. */
export type TargetingCustomItem = {
  __typename?: 'TargetingCustomItem';
  /**
   * The name of the custom targeting attribute.  This will be provided by OpenX if you are
   * using custom targeting fields.
   */
  attr: Scalars['String']['output'];
  /**
   * Must be one of "AFTER", "BEFORE", "INVERSE IN", "INTERSECTS", "NOT INTERSECTS", "EQ", ">", ">=",
   * "<", "<=", "==", "!=", "NOT =?", "=?", "=^", "NOT =^", "=$", or "NOT =$".
   */
  op: Scalars['String']['output'];
  /**
   * The value to be compared with the request-time value of the custom targeting attribute.
   * Use a comma-delimited list to specify multiple selections when using a compatible operator.
   */
  val: Scalars['String']['output'];
};

export type TargetingCustomItemCreateParams = {
  /**
   * The name of the custom targeting attribute.  This will be provided by OpenX if you are
   * using custom targeting fields.
   */
  attr: Scalars['String']['input'];
  /**
   * Must be one of "AFTER", "BEFORE", "INVERSE IN", "INTERSECTS", "NOT INTERSECTS", "EQ", ">", ">=",
   * "<", "<=", "==", "!=", "NOT =?", "=?", "=^", "NOT =^", "=$", or "NOT =$".
   */
  op: Scalars['String']['input'];
  /** The value to be compared with the request-time value of the custom targeting attribute. */
  val: Scalars['String']['input'];
};

export type TargetingCustomItemUpdateParams = {
  /**
   * The name of the custom targeting attribute.  This will be provided by OpenX if you are
   * using custom targeting fields.
   */
  attr: Scalars['String']['input'];
  /**
   * Must be one of "AFTER", "BEFORE", "INVERSE IN", "INTERSECTS", "NOT INTERSECTS", "EQ", ">", ">=",
   * "<", "<=", "==", "!=", "NOT =?", "=?", "=^", "NOT =^", "=$", or "NOT =$".
   */
  op: Scalars['String']['input'];
  /** The value to be compared with the request-time value of the custom targeting attribute. */
  val: Scalars['String']['input'];
};

export type TargetingCustomUpdateParams = {
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
  /** Target a custom variable.  Use only if instructed by OpenX. */
  val?: InputMaybe<Array<TargetingCustomItemUpdateParams>>;
};

/** Specifies a device type for targeting. */
export type TargetingDeviceType = {
  __typename?: 'TargetingDeviceType';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more device types.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.device_type")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingDeviceTypeCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more device types.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.device_type")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingDeviceTypeUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more device types.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.device_type")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingDeviceTypeV2 = {
  __typename?: 'TargetingDeviceTypeV2';
  /**
   * Target one or more desktop devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.desktop_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  desktop_devices?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more mobile devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.mobile_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  mobile_devices?: Maybe<Scalars['String']['output']>;
  /** Must be "INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more tv devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.tv_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  tv_devices?: Maybe<Scalars['String']['output']>;
};

export type TargetingDeviceTypeV2CreateParams = {
  /**
   * Target one or more desktop devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.desktop_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  desktop_devices?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more mobile devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.mobile_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  mobile_devices?: InputMaybe<Scalars['String']['input']>;
  /** Must be "INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more tv devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.tv_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  tv_devices?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingDeviceTypeV2UpdateParams = {
  /**
   * Target one or more desktop devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.desktop_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  desktop_devices?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more mobile devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.mobile_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  mobile_devices?: InputMaybe<Scalars['String']['input']>;
  /** Must be "INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more tv devices.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.device_type.tv_devices")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  tv_devices?: InputMaybe<Scalars['String']['input']>;
};

/** Specifies a distribution channel for targeting (ie, site vs app). */
export type TargetingDistributionChannel = {
  __typename?: 'TargetingDistributionChannel';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more distribution channels.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.inventory_format.distribution_channel")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingDistributionChannelCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more distribution channels.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.inventory_format.distribution_channel")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingDistributionChannelUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more distribution channels.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.inventory_format.distribution_channel")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Specifies a distribution channel for targeting (ie, site vs app). */
export type TargetingDistributionChannelV2 = {
  __typename?: 'TargetingDistributionChannelV2';
  /** Must be "INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more distribution channels.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.distribution_channel")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingDistributionChannelV2CreateParams = {
  /** Must be "INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more distribution channels.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.distribution_channel")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingDistributionChannelV2UpdateParams = {
  /** Must be "INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more distribution channels.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.rendering_context.distribution_channel")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Targets domains by content category. */
export type TargetingDomain = {
  __typename?: 'TargetingDomain';
  /** Target domains matching (legacy) OpenX categories. */
  categories?: Maybe<TargetingDomainCategories>;
  /** Target domains matching content categories from the IAB v2 taxonomy. */
  categories_iab_v2?: Maybe<TargetingDomainCategoriesIabV2>;
  /** If set must be one of "AND" or "OR". */
  inter_dimension_operator?: Maybe<Scalars['String']['output']>;
};

/** Specifies a domain content category using the OpenX taxonomy. */
export type TargetingDomainCategories = {
  __typename?: 'TargetingDomainCategories';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * One or more OpenX domain categories to target.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.domain.categories")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingDomainCategoriesCreateParams = {
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
  /**
   * One or more OpenX domain categories to target.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.domain.categories")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Specifies a domain content category using the IAB v2 taxonomy. */
export type TargetingDomainCategoriesIabV2 = {
  __typename?: 'TargetingDomainCategoriesIabV2';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * One or more IAB v2 domain categories to target.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.domain.categories_iab_v2")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingDomainCategoriesIabV2CreateParams = {
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
  /**
   * One or more IAB v2 domain categories to target.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.domain.categories_iab_v2")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingDomainCategoriesIabV2UpdateParams = {
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
  /**
   * One or more IAB v2 domain categories to target.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.domain.categories_iab_v2")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingDomainCategoriesUpdateParams = {
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
  /**
   * One or more OpenX domain categories to target.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.domain.categories")`.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingDomainCreateParams = {
  /** Target domains matching (legacy) OpenX categories. */
  categories?: InputMaybe<TargetingDomainCategoriesCreateParams>;
  /** Target domains matching content categories from the IAB v2 taxonomy. */
  categories_iab_v2?: InputMaybe<TargetingDomainCategoriesIabV2CreateParams>;
  /** If set must be one of "AND" or "OR". */
  inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** If set must be one of "AND" or "OR". */
  op?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingDomainUpdateParams = {
  /** Target domains matching (legacy) OpenX categories. */
  categories?: InputMaybe<TargetingDomainCategoriesUpdateParams>;
  /** Target domains matching content categories from the IAB v2 taxonomy. */
  categories_iab_v2?: InputMaybe<TargetingDomainCategoriesIabV2UpdateParams>;
  /** If set must be one of "AND" or "OR". */
  inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** If set must be one of "AND" or "OR". */
  op?: InputMaybe<Scalars['String']['input']>;
};

/** Targets requests by the location of the user at request-time. */
export type TargetingGeographic = {
  __typename?: 'TargetingGeographic';
  /** Geographic Targeting object specifying one or more locations defined by latitude, longitude, and radius to be included. */
  circles?: Maybe<TargetingGeographicCircles>;
  /** Geographic Targeting object specifying one or more locations defined by latitude, longitude, and radius to be included - v2 */
  circles_v2?: Maybe<TargetingGeographicCirclesV2>;
  /** Geographic Targeting object specifying one or more request-time locations to be excluded. */
  excludes?: Maybe<TargetingGeographicItem>;
  /** Geographic Targeting object specifying one or more request-time locations to be included. */
  includes?: Maybe<TargetingGeographicItem>;
};

export type TargetingGeographicCircles = {
  __typename?: 'TargetingGeographicCircles';
  /** Must be "<" */
  op: Scalars['String']['output'];
  /** Geographic Targeting Array of latitude, longitude, and radius objects { lat: string, lon: string, rad: string} */
  val: Array<TargetingGeographicCirclesVal>;
};

export type TargetingGeographicCirclesCreateParams = {
  /** Must be "<" */
  op: Scalars['String']['input'];
  /** Geographic Targeting Array of latitude, longitude, and radius objects { lat: string, lon: string, rad: string} */
  val: Scalars['String']['input'];
};

export type TargetingGeographicCirclesUpdateParams = {
  /** Must be "<" */
  op: Scalars['String']['input'];
  /** Geographic Targeting Array of latitude, longitude, and radius objects { lat: string, lon: string, rad: string} */
  val: Scalars['String']['input'];
};

export type TargetingGeographicCirclesV2 = {
  __typename?: 'TargetingGeographicCirclesV2';
  /** Geographic Targeting Array of latitude, longitude, and radius objects { lat: string, lon: string, rad: string} */
  val: Array<TargetingGeographicCirclesV2Val>;
};

export type TargetingGeographicCirclesV2CreateParams = {
  /** Geographic Targeting Array of latitude, longitude, and radius objects { lat: string, lon: string, rad: string} */
  val: Array<TargetingGeographicCirclesV2InputVal>;
};

export type TargetingGeographicCirclesV2InputVal = {
  /** Geographic Targeting object property of latitude */
  lat: Scalars['Decimal6']['input'];
  /** Geographic Targeting object property of longitude */
  lon: Scalars['Decimal6']['input'];
  /** Geographic Targeting object property of radius */
  rad: Scalars['Decimal']['input'];
};

export type TargetingGeographicCirclesV2UpdateParams = {
  /** Geographic Targeting Array of latitude, longitude, and radius objects { lat: string, lon: string, rad: string} */
  val: Array<TargetingGeographicCirclesV2InputVal>;
};

export type TargetingGeographicCirclesV2Val = {
  __typename?: 'TargetingGeographicCirclesV2Val';
  /** Geographic Targeting object property of latitude */
  lat: Scalars['Decimal6']['output'];
  /** Geographic Targeting object property of longitude */
  lon: Scalars['Decimal6']['output'];
  /** Geographic Targeting object property of radius */
  rad: Scalars['Decimal']['output'];
};

export type TargetingGeographicCirclesVal = {
  __typename?: 'TargetingGeographicCirclesVal';
  /** Geographic Targeting object property of latitude */
  lat: Scalars['Float']['output'];
  /** Geographic Targeting object property of longitude */
  lon: Scalars['Float']['output'];
  /** Geographic Targeting object property of radius */
  rad: Scalars['Float']['output'];
};

export type TargetingGeographicCreateParams = {
  /** Geographic Targeting object specifying one or more circle locations to be included. */
  circles?: InputMaybe<TargetingGeographicCirclesCreateParams>;
  /** Geographic Targeting object specifying one or more locations defined by latitude, longitude, and radius to be included - v2 */
  circles_v2?: InputMaybe<TargetingGeographicCirclesV2CreateParams>;
  /** Geographic Targeting object specifying one or more request-time locations to be excluded. */
  excludes?: InputMaybe<TargetingGeographicItemCreateParams>;
  /** Geographic Targeting object specifying one or more request-time locations to be included. */
  includes?: InputMaybe<TargetingGeographicItemCreateParams>;
};

/** Specifies a geographic location for targeting. */
export type TargetingGeographicItem = {
  __typename?: 'TargetingGeographicItem';
  /**
   * Target one or more cities.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.city",
   * filter: { city: $wildcard })`, where `$wildcard` represents a wildcard expression
   * such as "los*".
   * Use a comma-delimited list to specify multiple selections.
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more continents.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.continent",
   * filter: { continent: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  continent?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more countries.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.country",
   * filter: { country: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more DMAs.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.dma",
   * filter: { dma: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  dma?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more MSAs.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.msa",
   * filter: { msa: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  msa?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more Postal/ZIP Codes.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.postal_code",
   * filter: { postal_code: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  postal_code?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more regions.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.region",
   * filter: { region: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  region?: Maybe<Scalars['String']['output']>;
  /**
   * Target one or more states.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.state",
   * filter: { state: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  state?: Maybe<Scalars['String']['output']>;
};

export type TargetingGeographicItemCreateParams = {
  /**
   * Target one or more cities.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.city",
   * filter: { city: $wildcard })`, where `$wildcard` represents a wildcard expression
   * such as "los*".
   * Use a comma-delimited list to specify multiple selections.
   */
  city?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more continents.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.continent",
   * filter: { continent: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  continent?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more countries.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.country",
   * filter: { country: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  country?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more DMAs.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.dma",
   * filter: { dma: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  dma?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more MSAs.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.msa",
   * filter: { msa: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  msa?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more Postal/ZIP Codes.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.postal_code",
   * filter: { postal_code: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more regions.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.region",
   * filter: { region: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  region?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more states.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.state",
   * filter: { state: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  state?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingGeographicItemUpdateParams = {
  /**
   * Target one or more cities.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.city",
   * filter: { city: $wildcard })`, where `$wildcard` represents a wildcard expression
   * such as "los*".
   * Use a comma-delimited list to specify multiple selections.
   */
  city?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more continents.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.continent",
   * filter: { continent: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  continent?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more countries.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.country",
   * filter: { country: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  country?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more DMAs.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.dma",
   * filter: { dma: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  dma?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more MSAs.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.msa",
   * filter: { msa: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  msa?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more Postal/ZIP Codes.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.postal_code",
   * filter: { postal_code: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more regions.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.region",
   * filter: { region: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  region?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target one or more states.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.geographic.state",
   * filter: { state: $wildcard })`, where `$wildcard` represents a wildcard expression.
   * Use a comma-delimited list to specify multiple selections.
   */
  state?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingGeographicUpdateParams = {
  /** Geographic Targeting object specifying one or more circle locations to be included. */
  circles?: InputMaybe<TargetingGeographicCirclesUpdateParams>;
  /** Geographic Targeting object specifying one or more locations defined by latitude, longitude, and radius to be included - v2 */
  circles_v2?: InputMaybe<TargetingGeographicCirclesV2UpdateParams>;
  /** Geographic Targeting object specifying one or more request-time locations to be excluded. */
  excludes?: InputMaybe<TargetingGeographicItemUpdateParams>;
  /** Geographic Targeting object specifying one or more request-time locations to be included. */
  includes?: InputMaybe<TargetingGeographicItemUpdateParams>;
};

/** Attributes used for Content object targeting defined in OpenRTB v2.5 spec */
export type TargetingInstreamContent = {
  __typename?: 'TargetingInstreamContent';
  /**
   * Channel on which an ad will be displayed. According to OpenRTB v2.6 spec This object describes the channel
   * an ad will be displayed on. A Channel is defined as the entity that curates
   * a content library, or stream within a brand name for viewers.
   */
  channel?: Maybe<TargetingInstreamContentChannel>;
  /** Rating of the content (e.g. according to the MPAA classification). */
  contentrating?: Maybe<TargetingInstreamContentContentrating>;
  /** Episode number. */
  episode?: Maybe<TargetingInstreamContentEpisode>;
  /** Genre that best describes the content. */
  genre?: Maybe<TargetingInstreamContentGenre>;
  /** Specifies whether Content targeting dimensions must all match ('AND') or if only one is required ('OR').  The default is 'AND'. */
  inter_dimension_operator?: Maybe<Scalars['String']['output']>;
  /** Content language using ISO-639-1 standard. */
  language?: Maybe<TargetingInstreamContentLanguage>;
  /** Setting this to "1" will target live content only. Setting this to "0" will target non-live content only. */
  livestream?: Maybe<Scalars['String']['output']>;
  /** Attributes used for targeting of Network object nested in Content object defined in OpenRTB v2.6 spec */
  network?: Maybe<TargetingInstreamContentNetwork>;
  /**
   * Content series. Video Examples: “The Office” (television), “Star Wars” (movie), or “Arby ‘N’ The Chief”
   * (made for web). Non-Video Example: “Ecocentric” (Time Magazine blog).
   */
  series?: Maybe<TargetingInstreamContentSeries>;
};

/** Channel on which an ad will be displayed. */
export type TargetingInstreamContentChannel = {
  __typename?: 'TargetingInstreamContentChannel';
  name: TargetingInstreamContentChannelName;
};

/** Channel the content is on (e.g., a local channel like “WABC-TV") */
export type TargetingInstreamContentChannelCreateParams = {
  name: TargetingInstreamContentChannelNameCreateParams;
};

/** Channel name on which an ad will be displayed. */
export type TargetingInstreamContentChannelName = {
  __typename?: 'TargetingInstreamContentChannelName';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * The field is freeform string without any suggestions. Is case sensitive.
   * Channel the content is on (e.g., a local channel like 'WABC-TV')
   */
  val: Array<Scalars['String']['output']>;
};

/** Channel the content is on (e.g., a local channel like “WABC-TV") */
export type TargetingInstreamContentChannelNameCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * The field is freeform string without any suggestions. Is case sensitive.
   * Channel the content is on (e.g., a local channel like 'WABC-TV')
   */
  val: Array<Scalars['String']['input']>;
};

/** Channel name on which an ad will be displayed. */
export type TargetingInstreamContentChannelNameUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * The field is freeform string without any suggestions. Is case sensitive.
   * Channel the content is on (e.g., a local channel like 'WABC-TV')
   */
  val: Array<Scalars['String']['input']>;
};

/** Channel the content is on (e.g., a local channel like “WABC-TV") */
export type TargetingInstreamContentChannelUpdateParams = {
  name: TargetingInstreamContentChannelNameUpdateParams;
};

/** Rating of the content (e.g. according to the MPAA classification). */
export type TargetingInstreamContentContentrating = {
  __typename?: 'TargetingInstreamContentContentrating';
  /**
   * The rating of the content (e.g. according to the MPAA classification).
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.contentrating")`,
   * e.g. "PG-13".
   */
  allow?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The rating of the content (e.g. according to the MPAA classification).
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.contentrating")`,
   * e.g. "PG-13".
   */
  block?: Maybe<Array<Scalars['String']['output']>>;
};

/** Rating of the content (e.g. according to the MPAA classification). */
export type TargetingInstreamContentContentratingCreateParams = {
  /**
   * The rating of the content (e.g. according to the MPAA classification).
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.contentrating")`,
   * e.g. "PG-13".
   */
  allow?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The rating of the content (e.g. according to the MPAA classification).
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.contentrating")`,
   * e.g. "PG-13".
   */
  block?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Rating of the content (e.g. according to the MPAA classification). */
export type TargetingInstreamContentContentratingUpdateParams = {
  /**
   * The rating of the content (e.g. according to the MPAA classification).
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.contentrating")`,
   * e.g. "PG-13".
   */
  allow?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The rating of the content (e.g. according to the MPAA classification).
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.contentrating")`,
   * e.g. "PG-13".
   */
  block?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Attributes used for Content object targeting defined in OpenRTB v2.5 spec */
export type TargetingInstreamContentCreateParams = {
  /**
   * Channel on which an ad will be displayed. According to OpenRTB v2.6 spec This object describes the channel
   * an ad will be displayed on. A Channel is defined as the entity that curates
   * a content library, or stream within a brand name for viewers.
   */
  channel?: InputMaybe<TargetingInstreamContentChannelCreateParams>;
  /** Rating of the content (e.g. according to the MPAA classification). */
  contentrating?: InputMaybe<TargetingInstreamContentContentratingCreateParams>;
  /** Episode number. */
  episode?: InputMaybe<TargetingInstreamContentEpisodeCreateParams>;
  /** Genre that best describes the content. */
  genre?: InputMaybe<TargetingInstreamContentGenreCreateParams>;
  /** Specifies whether Content targeting dimensions must all match ('AND') or if only one is required ('OR').  The default is 'AND'. */
  inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** Content language using ISO-639-1 standard. */
  language?: InputMaybe<TargetingInstreamContentLanguageCreateParams>;
  /** Setting this to "1" will target live content only. Setting this to "0" will target non-live content only. */
  livestream?: InputMaybe<Scalars['String']['input']>;
  /** Network the content is on (e.g., a TV network like “ABC") */
  network?: InputMaybe<TargetingInstreamContentNetworkCreateParams>;
  /**
   * Content series. Video Examples: “The Office” (television), “Star Wars” (movie), or “Arby ‘N’ The Chief”
   * (made for web). Non-Video Example: “Ecocentric” (Time Magazine blog).
   */
  series?: InputMaybe<TargetingInstreamContentSeriesCreateParams>;
};

/** Episode number. */
export type TargetingInstreamContentEpisode = {
  __typename?: 'TargetingInstreamContentEpisode';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /** List of episode numbers between 0 and 99999. */
  val: Array<Scalars['String']['output']>;
};

/** Episode number. */
export type TargetingInstreamContentEpisodeCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /** List of episode numbers between 0 and 99999. */
  val: Array<Scalars['String']['input']>;
};

/** Episode number. */
export type TargetingInstreamContentEpisodeUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /** List of episode numbers between 0 and 99999. */
  val: Array<Scalars['String']['input']>;
};

/** Genre that best describes the content. */
export type TargetingInstreamContentGenre = {
  __typename?: 'TargetingInstreamContentGenre';
  /**
   * Suggestions options contain a list of the most popular genres received by OpenX in Ad Requests. It is not complete nor standardized.
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.genre")`,
   * e.g. "Comedy".
   */
  allow?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Suggestions options contain a list of the most popular genres received by OpenX in Ad Requests. It is not complete nor standardized.
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.genre")`,
   * e.g. "Comedy".
   */
  block?: Maybe<Array<Scalars['String']['output']>>;
};

/** Genre that best describes the content. */
export type TargetingInstreamContentGenreCreateParams = {
  /**
   * Suggestions options contain a list of the most popular genres received by OpenX in Ad Requests. It is not complete nor standardized.
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.genre")`,
   * e.g. "Comedy".
   */
  allow?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Suggestions options contain a list of the most popular genres received by OpenX in Ad Requests. It is not complete nor standardized.
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.genre")`,
   * e.g. "Comedy".
   */
  block?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Genre that best describes the content. */
export type TargetingInstreamContentGenreUpdateParams = {
  /**
   * Suggestions options contain a list of the most popular genres received by OpenX in Ad Requests. It is not complete nor standardized.
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.genre")`,
   * e.g. "Comedy".
   */
  allow?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Suggestions options contain a list of the most popular genres received by OpenX in Ad Requests. It is not complete nor standardized.
   * Must match the `name` field (not `id`) returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.genre")`,
   * e.g. "Comedy".
   */
  block?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Content language using ISO-639-1 standard. */
export type TargetingInstreamContentLanguage = {
  __typename?: 'TargetingInstreamContentLanguage';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Language(s) of the content using ISO-639-1 standard.
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.language")`.)
   */
  val: Array<Scalars['String']['output']>;
};

/** Content language using ISO-639-1 standard. */
export type TargetingInstreamContentLanguageCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Language(s) of the content using ISO-639-1 standard.
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.language")`.
   */
  val: Array<Scalars['String']['input']>;
};

/** Content language using ISO-639-1 standard. */
export type TargetingInstreamContentLanguageUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Language(s) of the content using ISO-639-1 standard.
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.instream_content.language")`.
   */
  val: Array<Scalars['String']['input']>;
};

/** Attributes used for targeting of Network object nested in Content object defined in OpenRTB v2.6 spec */
export type TargetingInstreamContentNetwork = {
  __typename?: 'TargetingInstreamContentNetwork';
  name: TargetingInstreamContentNetworkName;
};

/** Attributes used for targeting of Network object nested in Content object defined in OpenRTB v2.6 spec */
export type TargetingInstreamContentNetworkCreateParams = {
  name: TargetingInstreamContentNetworkNameCreateParams;
};

/** Network name the content is on (e.g., a TV network like “ABC") */
export type TargetingInstreamContentNetworkName = {
  __typename?: 'TargetingInstreamContentNetworkName';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * The field is freeform string without any suggestions. Is case-insensitive.
   * Network the content is on (e.g., a TV network like “ABC")
   */
  val: Array<Scalars['String']['output']>;
};

/** Network name the content is on (e.g., a TV network like “ABC") */
export type TargetingInstreamContentNetworkNameCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * The field is freeform string without any suggestions. Is case-insensitive.
   * Network the content is on (e.g., a TV network like “ABC")
   */
  val: Array<Scalars['String']['input']>;
};

/** Network name the content is on (e.g., a TV network like “ABC") */
export type TargetingInstreamContentNetworkNameUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * The field is freeform string without any suggestions. Is case-insensitive.
   * Network the content is on (e.g., a TV network like “ABC")
   */
  val: Array<Scalars['String']['input']>;
};

/** Attributes used for targeting of Network object nested in Content object defined in OpenRTB v2.6 spec */
export type TargetingInstreamContentNetworkUpdateParams = {
  name: TargetingInstreamContentNetworkNameUpdateParams;
};

/** Content series. Video Examples: “The Office” (television), “Star Wars” (movie), or “Arby ‘N’ The Chief” (made for web). Non-Video Example: “Ecocentric” (Time Magazine blog). */
export type TargetingInstreamContentSeries = {
  __typename?: 'TargetingInstreamContentSeries';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /** The field is freeform string without any suggestions. Is case-insensitive. */
  val: Array<Scalars['String']['output']>;
};

/** Content series. Video Examples: “The Office” (television), “Star Wars” (movie), or “Arby ‘N’ The Chief” (made for web). Non-Video Example: “Ecocentric” (Time Magazine blog). */
export type TargetingInstreamContentSeriesCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /** The field is freeform string without any suggestions. Is case-insensitive. */
  val: Array<Scalars['String']['input']>;
};

/** Content series. Video Examples: “The Office” (television), “Star Wars” (movie), or “Arby ‘N’ The Chief” (made for web). Non-Video Example: “Ecocentric” (Time Magazine blog). */
export type TargetingInstreamContentSeriesUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /** The field is freeform string without any suggestions. Is case-insensitive. */
  val: Array<Scalars['String']['input']>;
};

/** Attributes used for Content object targeting defined in OpenRTB v2.5 spec */
export type TargetingInstreamContentUpdateParams = {
  /**
   * Channel on which an ad will be displayed. According to OpenRTB v2.6 spec This object describes the channel
   * an ad will be displayed on. A Channel is defined as the entity that curates
   * a content library, or stream within a brand name for viewers.
   */
  channel?: InputMaybe<TargetingInstreamContentChannelUpdateParams>;
  /** Rating of the content (e.g. according to the MPAA classification). */
  contentrating?: InputMaybe<TargetingInstreamContentContentratingUpdateParams>;
  /** Episode number. */
  episode?: InputMaybe<TargetingInstreamContentEpisodeUpdateParams>;
  /** Genre that best describes the content. */
  genre?: InputMaybe<TargetingInstreamContentGenreUpdateParams>;
  /** Specifies whether Content targeting dimensions must all match ('AND') or if only one is required ('OR').  The default is 'AND'. */
  inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** Content language using ISO-639-1 standard. */
  language?: InputMaybe<TargetingInstreamContentLanguageUpdateParams>;
  /** Setting this to "1" will target live content only. Setting this to "0" will target non-live content only. */
  livestream?: InputMaybe<Scalars['String']['input']>;
  /** Network the content is on (e.g., a TV network like “ABC") */
  network?: InputMaybe<TargetingInstreamContentNetworkUpdateParams>;
  /**
   * Content series. Video Examples: “The Office” (television), “Star Wars” (movie), or “Arby ‘N’ The Chief”
   * (made for web). Non-Video Example: “Ecocentric” (Time Magazine blog).
   */
  series?: InputMaybe<TargetingInstreamContentSeriesUpdateParams>;
};

/** Targets inventory using the IAB Inventory Format taxonomy (ie, display vs video,  app vs web). */
export type TargetingInventoryFormat = {
  __typename?: 'TargetingInventoryFormat';
  /** Target an ad placement type as defined by IAB (ie, display vs video). */
  ad_placement?: Maybe<TargetingAdPlacement>;
  /** Target a distribution channel as defined by IAB (ie, site vs app). */
  distribution_channel?: Maybe<TargetingDistributionChannel>;
  /** Must be "AND" or "OR". */
  op: Scalars['String']['output'];
};

export type TargetingInventoryFormatCreateParams = {
  /** Target an ad placement type as defined by IAB (ie, display vs video). */
  ad_placement?: InputMaybe<TargetingAdPlacementCreateParams>;
  /** Target a distribution channel as defined by IAB (ie, site vs app). */
  distribution_channel?: InputMaybe<TargetingDistributionChannelCreateParams>;
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
};

export type TargetingInventoryFormatUpdateParams = {
  /** Target an ad placement type as defined by IAB (ie, display vs video). */
  ad_placement?: InputMaybe<TargetingAdPlacementUpdateParams>;
  /** Target a distribution channel as defined by IAB (ie, site vs app). */
  distribution_channel?: InputMaybe<TargetingDistributionChannelUpdateParams>;
  /** Must be "AND" or "OR". */
  op: Scalars['String']['input'];
};

/** Targets inventory at or above a defined inventory quality metric. */
export type TargetingInventoryQuality = {
  __typename?: 'TargetingInventoryQuality';
  /** Specify the IQ score threshold */
  iq_score: TargetingIqScore;
};

/** Targets inventory at or above a defined inventory quality metric. */
export type TargetingInventoryQualityCreateParams = {
  /** Specify the IQ score threshold */
  iq_score: TargetingIqScoreCreateParams;
};

/** Targets inventory at or above a defined inventory quality metric. */
export type TargetingInventoryQualityUpdateParams = {
  /** Specify the IQ score threshold */
  iq_score: TargetingIqScoreUpdateParams;
};

/** Targets inventory at or above a defined IQ score metric. */
export type TargetingIqScore = {
  __typename?: 'TargetingIqScore';
  /** Must be ">=". */
  op: Scalars['String']['output'];
  /** Only the value "30.00" is allowed (must be provided with two decimal places). */
  val: Scalars['Decimal2']['output'];
};

/** Targets inventory at or above a defined IQ score metric. */
export type TargetingIqScoreCreateParams = {
  /** Must be ">=". */
  op: Scalars['String']['input'];
  /** Only the value "30.00" is allowed (must be provided with two decimal places). */
  val: Scalars['Decimal2']['input'];
};

/** Targets inventory at or above a defined IQ score metric. */
export type TargetingIqScoreUpdateParams = {
  /** Must be ">=". */
  op: Scalars['String']['input'];
  /** Only the value "30.00" is allowed (must be provided with two decimal places). */
  val: Scalars['Decimal2']['input'];
};

/** Specifies a language for targeting, derived from request headers or similar client hints. */
export type TargetingLanguage = {
  __typename?: 'TargetingLanguage';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more languages.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.language")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingLanguageCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more languages.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.language")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingLanguageUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more languages.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.language")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** OpenX additional categories and keywords - allows to target or block specific inventory tagged with internal metacategories, and to target/block specific keywords on pages, based on OpenX Contextual service. */
export type TargetingMetaCategory = {
  __typename?: 'TargetingMetaCategory';
  /** If true, traffic should be blocked for inventory tagged with mfa metacategory */
  exclude_mfa?: Maybe<Scalars['Boolean']['output']>;
  /** The list of metacategory exclusions */
  excludes?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of metacategory inclusions */
  includes?: Maybe<TargetingMetacategoryIncludesOutput>;
  /** Logical connective (operator) between metacategory (`includes` and `excludes`) clauses and `keywords`. Can be `OR` (default) or `AND`. NOTE: `exclude_mfa` is always applied with `AND` operator, regardless of this setting. */
  inter_dimension_operator?: Maybe<Scalars['String']['output']>;
  /** OpenX Contextual Targeting Service keywords targeting. At least one keyword has to be provided in either `includes` or `excludes` list. */
  keywords?: Maybe<TargetingMetaCategoryKeywords>;
};

export type TargetingMetaCategoryCreateParams = {
  /** If true, traffic should be blocked for inventory tagged with mfa metacategory */
  exclude_mfa?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of metacategory exclusions */
  excludes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The list of metacategory inclusions */
  includes?: InputMaybe<TargetingMetacategoryIncludesInputParams>;
  /** Logical connective (operator) between metacategory (`includes` and `excludes`) clauses and `keywords`. Can be `OR` (default) or `AND`. NOTE: `exclude_mfa` is always applied with `AND` operator, regardless of this setting. */
  inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** OpenX Contextual Targeting Service keywords targeting. At least one keyword has to be provided in either `includes` or `excludes` list. */
  keywords?: InputMaybe<TargetingMetaCategoryKeywordsCreateParams>;
};

/** OpenX Contextual Targeting Service keywords targeting. At least one keyword has to be provided in either `includes` or `excludes` list. */
export type TargetingMetaCategoryKeywords = {
  __typename?: 'TargetingMetaCategoryKeywords';
  /**
   * List of keywords to block. Must contain alphabetic characters and hyphens only.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  excludes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * List of keywords to target. Must contain alphabetic characters and hyphens only.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  includes?: Maybe<Array<Scalars['String']['output']>>;
};

export type TargetingMetaCategoryKeywordsCreateParams = {
  /**
   * List of keywords to block. Must contain alphabetic characters and hyphens only.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  excludes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * List of keywords to target. Must contain alphabetic characters and hyphens only.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TargetingMetaCategoryKeywordsUpdateParams = {
  /**
   * List of keywords to block. Must contain alphabetic characters and hyphens only.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  excludes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * List of keywords to target. Must contain alphabetic characters and hyphens only.
   *
   * Use a comma-delimited list to specify multiple selections, up to 2000 items.
   */
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TargetingMetaCategoryUpdateParams = {
  /** If true, traffic should be blocked for inventory tagged with mfa metacategory */
  exclude_mfa?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of metacategory exclusions */
  excludes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The list of metacategory inclusions */
  includes?: InputMaybe<TargetingMetacategoryIncludesInputParams>;
  /** Logical connective (operator) between metacategory (`includes` and `excludes`) clauses and `keywords`. Can be `OR` (default) or `AND`. NOTE: `exclude_mfa` is always applied with `AND` operator, regardless of this setting. */
  inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** OpenX Contextual Targeting Service keywords targeting. At least one keyword has to be provided in either `includes` or `excludes` list. */
  keywords?: InputMaybe<TargetingMetaCategoryKeywordsUpdateParams>;
};

export type TargetingMetacategoryIncludesInputParams = {
  /** AND/OR selector for match all/match at least 1. */
  op: Scalars['String']['input'];
  /** List of metacategories to target */
  val: Array<Scalars['String']['input']>;
};

export type TargetingMetacategoryIncludesOutput = {
  __typename?: 'TargetingMetacategoryIncludesOutput';
  /** AND/OR selector for match all/match at least 1. */
  op: Scalars['String']['output'];
  /** List of metacategories to target */
  val: Array<Scalars['String']['output']>;
};

/** Represents an audience created in the OpenXSelect platform, when used for deal targeting. */
export type TargetingOpenaudienceCustom = {
  __typename?: 'TargetingOpenaudienceCustom';
  /** Must be "INTERSECTS" or "INVERSE IN". */
  op: Scalars['String']['output'];
  /**
   * The OpenXSelect Audience UUID, prefixed with "openaudience-".  Must match the `id` field returned
   * from `optionsByPath(path: "deal.package.targeting.audience.openaudience_custom")`.
   */
  val?: Maybe<Scalars['String']['output']>;
};

export type TargetingOpenaudienceCustomCreateParams = {
  /** Must be "INTERSECTS" or "INVERSE IN". */
  op: Scalars['String']['input'];
  /**
   * The OpenXSelect Audience UUID, prefixed with "openaudience-".  Must match the `id` field returned
   * from `optionsByPath(path: "deal.package.targeting.audience.openaudience_custom")`.
   */
  val?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingOpenaudienceCustomUpdateParams = {
  /** Must be "INTERSECTS" or "INVERSE IN". */
  op: Scalars['String']['input'];
  /**
   * The OpenXSelect Audience UUID, prefixed with "openaudience-".  Must match the `id` field returned
   * from `optionsByPath(path: "deal.package.targeting.audience.openaudience_custom")`.
   */
  val?: InputMaybe<Scalars['String']['input']>;
};

/** Specifies a device operating system for targeting, derived from User-Agent headers or similar client hints. */
export type TargetingOs = {
  __typename?: 'TargetingOs';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more operating systems.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.os")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingOsCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more operating systems.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.os")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingOsUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more operating systems.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.technographic.os")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/**
 * Targets inventory using the IAB Inventory Format taxonomy (ie, display vs video,  app vs web)
 * and the user's device characteristics derived from technographic attributes.
 *
 * This format cannot be used simultaneously with
 * TargetingInventoryFormat and TargetingTechnographic -> device_type.
 */
export type TargetingRenderingContext = {
  __typename?: 'TargetingRenderingContext';
  /** Target an ad placement type as defined by IAB (ie, display vs video). */
  ad_placement: TargetingAdPlacementV2;
  /** Target device types as defined by IAB (ie, desktop, mobile, TV). At least one device type must be specified. */
  device_type: TargetingDeviceTypeV2;
  /** Target a distribution channel as defined by IAB (ie, site vs app). */
  distribution_channel: TargetingDistributionChannelV2;
  /** Must be "AND". */
  op: Scalars['String']['output'];
};

export type TargetingRenderingContextCreateParams = {
  /** Target an ad placement type as defined by IAB (ie, display vs video). */
  ad_placement: TargetingAdPlacementV2CreateParams;
  /** Target device types as defined by IAB (ie, desktop, mobile, TV). At least one device type must be specified. */
  device_type: TargetingDeviceTypeV2CreateParams;
  /** Target a distribution channel as defined by IAB (ie, site vs app). */
  distribution_channel: TargetingDistributionChannelV2CreateParams;
  /** Must be "AND". */
  op: Scalars['String']['input'];
};

export type TargetingRenderingContextUpdateParams = {
  /** Target an ad placement type as defined by IAB (ie, display vs video). */
  ad_placement: TargetingAdPlacementV2UpdateParams;
  /** Target device types as defined by IAB (ie, desktop, mobile, TV). At least one device type must be specified. */
  device_type: TargetingDeviceTypeV2UpdateParams;
  /** Target a distribution channel as defined by IAB (ie, site vs app). */
  distribution_channel: TargetingDistributionChannelV2UpdateParams;
  /** Must be "AND". */
  op: Scalars['String']['input'];
};

/** Specifies rewarded video inventory. */
export type TargetingRewardedVideo = {
  __typename?: 'TargetingRewardedVideo';
  /** Must be "==" or "!=". */
  op: Scalars['String']['output'];
  /** Must be the string "true" to target rewarded video inventory. */
  val?: Maybe<Scalars['String']['output']>;
};

export type TargetingRewardedVideoCreateParams = {
  /** Must be "==" or "!=". */
  op: Scalars['String']['input'];
  /** Must be the string "true" to target rewarded video inventory. */
  val?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingRewardedVideoUpdateParams = {
  /** Must be "==" or "!=". */
  op: Scalars['String']['input'];
  /** Must be the string "true" to target rewarded video inventory. */
  val?: InputMaybe<Scalars['String']['input']>;
};

/** Specifies screen locations for video inventory (pre-roll, mid-roll, post-roll). */
export type TargetingScreenLocation = {
  __typename?: 'TargetingScreenLocation';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more screen locations.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.screen_location")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingScreenLocationCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more screen locations.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.screen_location")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingScreenLocationUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more screen locations.  Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.screen_location")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/** Represents a Retargeting Segment that is used for deal targeting. */
export type TargetingSegmentRetargeting = {
  __typename?: 'TargetingSegmentRetargeting';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * One or more retargeting segment IDs to target.
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingSegmentRetargetingCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['IntersectionOperation']['input'];
  /**
   * The values to be used with the operator specified in `op`.
   * For "INTERSECTS", the segment IDs that should be included.
   * For "NOT INTERSECTS", the segment IDs that should be excluded.
   */
  val?: InputMaybe<Scalars['String']['input']>;
};

export type TargetingSegmentRetargetingUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['IntersectionOperation']['input'];
  /**
   * The values to be used with the operator specified in `op`.
   * For "INTERSECTS", the segment IDs that should be included.
   * For "NOT INTERSECTS", the segment IDs that should be excluded.
   */
  val?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Specifies video skipability. A value of "0" indicates non-skippable video,
 * where a value of "1" indicates the video is skippable.
 */
export type TargetingSkip = {
  __typename?: 'TargetingSkip';
  /** Must be "==". */
  op: Scalars['String']['output'];
  /**
   * A value of "0" indicates non-skippable video,
   * where a value of "1" indicates the video is skippable.
   */
  val?: Maybe<Scalars['String']['output']>;
};

/**
 * Specifies video skipability. A value of "0" indicates non-skippable video,
 * where a value of "1" indicates the video is skippable.
 */
export type TargetingSkipCreateParams = {
  /** Must be "==". */
  op: Scalars['String']['input'];
  /**
   * A value of "0" indicates non-skippable video,
   * where a value of "1" indicates the video is skippable.
   */
  val: Scalars['String']['input'];
};

/**
 * Specifies video skipability. A value of "0" indicates non-skippable video,
 * where a value of "1" indicates the video is skippable.
 */
export type TargetingSkipUpdateParams = {
  /** Must be "==". */
  op: Scalars['String']['input'];
  /**
   * A value of "0" indicates non-skippable video,
   * where a value of "1" indicates the video is skippable.
   */
  val: Scalars['String']['input'];
};

/** Targets technographic characteristics of the user's device. */
export type TargetingTechnographic = {
  __typename?: 'TargetingTechnographic';
  /** Target by API framework. */
  api_framework?: Maybe<TargetingApiFramework>;
  /** Target by browser, derived from User-Agent headers or similar client hints. */
  browser?: Maybe<TargetingBrowser>;
  /** Target by device type. */
  device_type?: Maybe<TargetingDeviceType>;
  /** Target by language, derived from request headers or similar client hints. */
  language?: Maybe<TargetingLanguage>;
  /** Target by operating system, derived from User-Agent headers or similar client hints. */
  os?: Maybe<TargetingOs>;
};

export type TargetingTechnographicCreateParams = {
  /** Target by API framework. */
  api_framework?: InputMaybe<TargetingApiFrameworkCreateParams>;
  /** Target by browser, derived from User-Agent headers or similar client hints. */
  browser?: InputMaybe<TargetingBrowserCreateParams>;
  /** Target by device type. */
  device_type?: InputMaybe<TargetingDeviceTypeCreateParams>;
  /** Target by language, derived from request headers or similar client hints. */
  language?: InputMaybe<TargetingLanguageCreateParams>;
  /** Target by operating system, derived from User-Agent headers or similar client hints. */
  os?: InputMaybe<TargetingOsCreateParams>;
};

export type TargetingTechnographicUpdateParams = {
  /** Target by API framework. */
  api_framework?: InputMaybe<TargetingApiFrameworkUpdateParams>;
  /** Target by browser, derived from User-Agent headers or similar client hints. */
  browser?: InputMaybe<TargetingBrowserUpdateParams>;
  /** Target by device type. */
  device_type?: InputMaybe<TargetingDeviceTypeUpdateParams>;
  /** Target by language, derived from request headers or similar client hints. */
  language?: InputMaybe<TargetingLanguageUpdateParams>;
  /** Target by operating system, derived from User-Agent headers or similar client hints. */
  os?: InputMaybe<TargetingOsUpdateParams>;
};

export type TargetingUpdateParams = {
  /** Target mobile applications inventory */
  app_inventory?: InputMaybe<TargetingAppInventoryUpdateParams>;
  /** attention param that describes the level of user attention expected for the ad placement, must be "1" or null */
  attention?: InputMaybe<Scalars['String']['input']>;
  /** Targeting object specifying an Audience. */
  audience?: InputMaybe<TargetingAudienceUpdateParams>;
  /** Target inventory based on brand safety data */
  brand_safety?: InputMaybe<TargetingBrandSafetyUpdateParams>;
  /** Targeting object specifying some supply-side inventory content (adunit, page, site, etc). */
  content?: InputMaybe<TargetingContentUpdateParams>;
  /**
   * Targeting object specifying contextual segments to target or block. Ignored unless the request
   * names `contextual_segment_format: new`; with `legacy` (the default) the `ctx_` custom variables
   * in `custom` are the source.
   */
  contextual_segment?: InputMaybe<TargetingContextualSegmentUpdateParams>;
  /** Targeting object specifying custom key/value pairs. */
  custom?: InputMaybe<TargetingCustomUpdateParams>;
  /** Targeting object specifying one or more domain categories. */
  domain?: InputMaybe<TargetingDomainUpdateParams>;
  /** Boolean if true, the package will not be matched against indirect inventory */
  exclude_non_direct?: InputMaybe<Scalars['Boolean']['input']>;
  /** Targeting object specifying inferred geolocation at request time. */
  geographic?: InputMaybe<TargetingGeographicUpdateParams>;
  /** Value of 1, the package will include open bidding inventory */
  include_open_bidding_inventory?: InputMaybe<Scalars['StringOrInt']['input']>;
  /** Attributes used for Content object targeting defined in OpenRTB v2.5 spec */
  instream_content?: InputMaybe<TargetingInstreamContentUpdateParams>;
  /**
   * Specifies whether targeting specs must all match ('AND') or if only one is required ('OR').
   * Optional on a partial update: left out, the package's current operator is kept.
   */
  inter_dimension_operator?: InputMaybe<Scalars['String']['input']>;
  /** Targeting object specifying inventory formats. */
  inventory_format?: InputMaybe<TargetingInventoryFormatUpdateParams>;
  /** Target inventory quality */
  inventory_quality?: InputMaybe<TargetingInventoryQualityUpdateParams>;
  /** OpenX additional categories and keywords - allows to target or block specific inventory tagged with internal metacategories, and to target/block specific keywords on pages, based on OpenX Contextual service. */
  metacategory?: InputMaybe<TargetingMetaCategoryUpdateParams>;
  /**
   * Targeting object specifying the rendering context. Replaces the legacy `inventory_format` field.
   * Its presence marks a complete targeting, which replaces the package's targeting as a whole;
   * left out, the targeting is partial and merged into the current one, rendering context included.
   */
  rendering_context?: InputMaybe<TargetingRenderingContextUpdateParams>;
  /** Targeting object specifying a retargeting segment. */
  retargeting_segment?: InputMaybe<TargetingSegmentRetargetingUpdateParams>;
  /** Targeting object specifying technographic characteristics of the request. */
  technographic?: InputMaybe<TargetingTechnographicUpdateParams>;
  /** Targeting object specifying video characteristics. */
  video?: InputMaybe<TargetingVideoUpdateParams>;
  /** Targeting object specifying viewability characteristics. */
  viewability?: InputMaybe<TargetingViewabilityUpdateParams>;
  /** vpvh param (co-viewing likelihood), must be "true" or null */
  vpvh?: InputMaybe<Scalars['String']['input']>;
  /** Targeting object specifying VTR characteristics. */
  vtr?: InputMaybe<TargetingVtrUpdateParams>;
};

/** Targets video inventory attributes. */
export type TargetingVideo = {
  __typename?: 'TargetingVideo';
  /** Target by the ad unit's maximum duration. */
  adunit_max_duration?: Maybe<TargetingAdunitMaxDuration>;
  /** Target by the ad unit's maximum duration using a range. */
  adunit_max_duration_range?: Maybe<TargetingAdunitMaxDurationRange>;
  /** Target rewarded video inventory. */
  rewarded_video?: Maybe<TargetingRewardedVideo>;
  /** Target by screen location. */
  screen_location?: Maybe<TargetingScreenLocation>;
  /** Target by video skipability. */
  skip?: Maybe<TargetingSkip>;
  /** Target by video format (pre-OpenRTB 2.x "placement" subtypes). */
  video_format?: Maybe<TargetingVideoFormat>;
  /** Target by video placement (OpenRTB 2.x "plcmt" subtypes). */
  video_plcmt?: Maybe<TargetingVideoPlcmt>;
};

export type TargetingVideoCreateParams = {
  /** Target by the ad unit's maximum duration. */
  adunit_max_duration?: InputMaybe<TargetingAdunitMaxDurationCreateParams>;
  /** Target by the ad unit's maximum duration using a range. */
  adunit_max_duration_range?: InputMaybe<TargetingAdunitMaxDurationRangeCreateParams>;
  /** Target rewarded video inventory. */
  rewarded_video?: InputMaybe<TargetingRewardedVideoCreateParams>;
  /** Target by screen location. */
  screen_location?: InputMaybe<TargetingScreenLocationCreateParams>;
  /** Target by video skipability */
  skip?: InputMaybe<TargetingSkipCreateParams>;
  /** Target by video format (pre-OpenRTB 2.0 "placement" subtypes). */
  video_format?: InputMaybe<TargetingVideoFormatCreateParams>;
  /** Target by video placement (OpenRTB 2.x "plcmt" subtypes). */
  video_plcmt?: InputMaybe<TargetingVideoPlcmtCreateParams>;
};

/**
 * Specifies video presentation formats (instream, interstitial, out-stream) using
 * the pre-OpenRTB 2.x definition of "placement" subtypes.
 */
export type TargetingVideoFormat = {
  __typename?: 'TargetingVideoFormat';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more video formats (pre-OpenRTB 2.x "placement" subtypes).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.video_format")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingVideoFormatCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more video formats (pre-OpenRTB 2.x "placement" subtypes).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.video_format")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingVideoFormatUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more video formats (pre-OpenRTB 2.x "placement" subtypes).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.video_format")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

/**
 * Specifies video placement (instream, interstitial, accompanying content, standalone)
 * using the OpenRTB 2.x definition of "plcmt" subtypes.
 */
export type TargetingVideoPlcmt = {
  __typename?: 'TargetingVideoPlcmt';
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['output'];
  /**
   * Target one or more video placements (OpenRTB 2.x "plcmt" subtypes).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.video_plcmt")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['output'];
};

export type TargetingVideoPlcmtCreateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more video placements (OpenRTB 2.x "plcmt" subtypes).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.video_plcmt")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingVideoPlcmtUpdateParams = {
  /** Must be "INTERSECTS" or "NOT INTERSECTS". */
  op: Scalars['String']['input'];
  /**
   * Target one or more video placements (OpenRTB 2.x "plcmt" subtypes).
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.video.video_plcmt")`.)
   * Use a comma-delimited list to specify multiple selections.
   */
  val: Scalars['String']['input'];
};

export type TargetingVideoUpdateParams = {
  /** Target by the ad unit's maximum duration. */
  adunit_max_duration?: InputMaybe<TargetingAdunitMaxDurationUpdateParams>;
  /** Target by the ad unit's maximum duration using a range. */
  adunit_max_duration_range?: InputMaybe<TargetingAdunitMaxDurationRangeUpdateParams>;
  /** Target rewarded video inventory. */
  rewarded_video?: InputMaybe<TargetingRewardedVideoUpdateParams>;
  /** Target by screen location. */
  screen_location?: InputMaybe<TargetingScreenLocationUpdateParams>;
  /** Target by video skipability */
  skip?: InputMaybe<TargetingSkipUpdateParams>;
  /** Target by video format (pre-OpenRTB 2.x "placement" subtypes). */
  video_format?: InputMaybe<TargetingVideoFormatUpdateParams>;
  /** Target by video format (OpenRTB 2.x "plcmt" subtypes). */
  video_plcmt?: InputMaybe<TargetingVideoPlcmtUpdateParams>;
};

/** Targets inventory at or above a defined viewability metric. */
export type TargetingViewability = {
  __typename?: 'TargetingViewability';
  /** Specify the viewability score threshold */
  viewability_score: TargetingViewabilityScore;
};

export type TargetingViewabilityCreateParams = {
  /** Specify the viewability score threshold */
  viewability_score: TargetingViewabilityScoreCreateParams;
};

/** Targets inventory at or above a defined viewability metric. */
export type TargetingViewabilityScore = {
  __typename?: 'TargetingViewabilityScore';
  /** Must be ">=". */
  op: Scalars['String']['output'];
  /**
   * Target a viewability score expressed as a decimal fraction (ie, 50% should be expressed as "0.50").
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.viewability.viewability_score")`.)
   */
  val: Scalars['String']['output'];
};

export type TargetingViewabilityScoreCreateParams = {
  /** Must be ">=". */
  op: Scalars['String']['input'];
  /**
   * Target a viewability score expressed as a decimal fraction (ie, 50% should be expressed as "0.50").
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.viewability.viewability_score")`.)
   */
  val: Scalars['String']['input'];
};

export type TargetingViewabilityScoreUpdateParams = {
  /** Must be ">=". */
  op: Scalars['String']['input'];
  /**
   * Target a viewability score expressed as a decimal fraction (ie, 50% should be expressed as "0.50").
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.viewability.viewability_score")`.)
   */
  val: Scalars['String']['input'];
};

export type TargetingViewabilityUpdateParams = {
  /** Specify the viewability score threshold */
  viewability_score: TargetingViewabilityScoreUpdateParams;
};

/** Targets inventory at or above a defined VTR (view-through rate) metric. */
export type TargetingVtr = {
  __typename?: 'TargetingVtr';
  /** Specify the VTR score threshold */
  vtr_score: TargetingVtrScore;
};

export type TargetingVtrCreateParams = {
  /** Specify the VTR (view-through rate) score threshold */
  vtr_score: TargetingVtrScoreCreateParams;
};

/** Targets inventory at or above a defined VTR (view-through rate) metric. */
export type TargetingVtrScore = {
  __typename?: 'TargetingVtrScore';
  /** Must be ">=". */
  op: Scalars['String']['output'];
  /**
   * Target a VTR score expressed as a decimal fraction (ie, 50% should be expressed as "0.50").
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.vtr.vtr_score")`.)
   */
  val: Scalars['String']['output'];
};

export type TargetingVtrScoreCreateParams = {
  /** Must be ">=". */
  op: Scalars['String']['input'];
  /**
   * Target a VTR score expressed as a decimal fraction (ie, 50% should be expressed as "0.50").
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.vtr.vtr_score")`.)
   */
  val: Scalars['String']['input'];
};

export type TargetingVtrScoreUpdateParams = {
  /** Must be ">=". */
  op: Scalars['String']['input'];
  /**
   * Target a VTR score expressed as a decimal fraction (ie, 50% should be expressed as "0.50").
   * Must match the `id` field returned from
   * `optionsByPath(path: "deal.package.targeting.vtr.vtr_score")`.)
   */
  val: Scalars['String']['input'];
};

export type TargetingVtrUpdateParams = {
  /** Specify the VTR (view-through rate) score threshold */
  vtr_score: TargetingVtrScoreUpdateParams;
};

export const ThirdPartyFeeConfigRevenueMethod = {
  Cpm: 'CPM',
  PoM: 'PoM'
} as const;

export type ThirdPartyFeeConfigRevenueMethod = typeof ThirdPartyFeeConfigRevenueMethod[keyof typeof ThirdPartyFeeConfigRevenueMethod];
export type ThirdPartyFeesDefaultsInput = {
  accountId: Scalars['String']['input'];
  default_cpm_cap?: InputMaybe<Scalars['String']['input']>;
  default_fees_description?: InputMaybe<Scalars['String']['input']>;
  default_platform_share_ox_sourced?: InputMaybe<Scalars['String']['input']>;
  default_platform_share_partner_sourced?: InputMaybe<Scalars['String']['input']>;
  default_share?: InputMaybe<Scalars['String']['input']>;
  max_cpm_cap?: InputMaybe<Scalars['String']['input']>;
  max_share?: InputMaybe<Scalars['String']['input']>;
};

export const ThirdPartyRevenueMethod = {
  Cpm: 'CPM',
  PoM: 'PoM'
} as const;

export type ThirdPartyRevenueMethod = typeof ThirdPartyRevenueMethod[keyof typeof ThirdPartyRevenueMethod];
export type TroubleshootingChartsOutput = {
  __typename?: 'TroubleshootingChartsOutput';
  stats: TroubleshootingOutputStats;
  timestamp: Scalars['timestamptz']['output'];
};

export type TroubleshootingOutputStats = {
  __typename?: 'TroubleshootingOutputStats';
  bid_cpm?: Maybe<Scalars['Float']['output']>;
  bid_requests: Scalars['Float']['output'];
  bid_responses: Scalars['Float']['output'];
  impressions: Scalars['Float']['output'];
};

/** URLTargeting is used to specify an allow-list or block-list of URLs for the deal. */
export type UrlTargeting = {
  __typename?: 'URLTargeting';
  /** Logical operator used to combine domains and app_inventory targeting criteria, must be "AND" or "OR". */
  domain_app_inventory_operator?: Maybe<Scalars['String']['output']>;
  /** Domain targeting type, must be "SUBDOMAIN" or "ROOT". */
  domain_targeting_option?: Maybe<Scalars['String']['output']>;
  /** Inventory List to target URLs. */
  inventorylist_id?: Maybe<Scalars['String']['output']>;
  /** Must be "whitelist" or "blacklist". */
  type?: Maybe<Scalars['String']['output']>;
  /** One or more domain names. */
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export type UrlTargetingCreateParams = {
  /** Logical operator used to combine domains and app_inventory targeting criteria, must be "AND" or "OR". */
  domain_app_inventory_operator?: InputMaybe<Scalars['String']['input']>;
  /** Domain targeting type, must be "SUBDOMAIN" or "ROOT". */
  domain_targeting_option?: InputMaybe<Scalars['String']['input']>;
  /** Inventory List to target URLs. */
  inventorylist_id?: InputMaybe<Scalars['String']['input']>;
  /** Must be "whitelist" or "blacklist". */
  type?: InputMaybe<Scalars['String']['input']>;
  /** One or more domain names. */
  urls?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UrlTargetingUpdateParams = {
  /** Logical operator used to combine domains and app_inventory targeting criteria, must be "AND" or "OR". */
  domain_app_inventory_operator?: InputMaybe<Scalars['String']['input']>;
  /** Domain targeting type, must be "SUBDOMAIN" or "ROOT". */
  domain_targeting_option?: InputMaybe<Scalars['String']['input']>;
  /** Inventory List to target URLs. */
  inventorylist_id?: InputMaybe<Scalars['String']['input']>;
  /** Must be "whitelist" or "blacklist". */
  type?: InputMaybe<Scalars['String']['input']>;
  /** One or more domain names. */
  urls?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserDataInput = {
  data: Array<InputMaybe<Array<Scalars['String']['input']>>>;
  headers: Array<InputMaybe<Scalars['String']['input']>>;
};

/**
 * A location an audience search can target. The id is the value written to the search: the segment name
 * for states, DMAs and congressional districts, and the ISO country code for countries.
 */
export type UserLocationOption = {
  __typename?: 'UserLocationOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Locations an audience search can target for a region. For the US region the states, DMAs and
 * congressional districts are populated and countries is empty; for any other region only
 * countries is populated.
 */
export type UserLocations = {
  __typename?: 'UserLocations';
  congressionalDistricts: Array<UserLocationOption>;
  countries: Array<UserLocationOption>;
  dmas: Array<UserLocationOption>;
  states: Array<UserLocationOption>;
};

export type ValidateAudienceFeesInput = {
  id: Scalars['String']['input'];
  is_multi_partner?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pricing?: InputMaybe<AudiencePricingInput>;
};

export type ValidateAudienceFeesResult = {
  __typename?: 'ValidateAudienceFeesResult';
  error_message?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']['input']>;
  _gt?: InputMaybe<Scalars['_text']['input']>;
  _gte?: InputMaybe<Scalars['_text']['input']>;
  _in?: InputMaybe<Array<Scalars['_text']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_text']['input']>;
  _lte?: InputMaybe<Scalars['_text']['input']>;
  _neq?: InputMaybe<Scalars['_text']['input']>;
  _nin?: InputMaybe<Array<Scalars['_text']['input']>>;
};

/** columns and relationships of "account" */
export type Account = {
  __typename?: 'account';
  allowed_countries: Scalars['jsonb']['output'];
  allowed_domains?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  allowed_providers: Array<Account_Provider>;
  /** An aggregate relationship */
  allowed_providers_aggregate: Account_Provider_Aggregate;
  /** An array relationship */
  audiences: Array<Audience>;
  /** An aggregate relationship */
  audiences_aggregate: Audience_Aggregate;
  created_date: Scalars['timestamptz']['output'];
  default_cpm_cap?: Maybe<Scalars['String']['output']>;
  default_fees_description?: Maybe<Scalars['String']['output']>;
  default_platform_share_ox_sourced?: Maybe<Scalars['String']['output']>;
  default_platform_share_partner_sourced?: Maybe<Scalars['String']['output']>;
  default_share?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Contains a list of allowed DSPs and their seat_ids. Extracted from MGMT API account object. */
  dsp_restriction?: Maybe<Array<DspRestriction>>;
  /** Contains the working mode of DSP restrictions, whether it's an allowlist or blocklist. */
  dsp_restriction_mode?: Maybe<Scalars['String']['output']>;
  exchange_account_network?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "exchange_account_network_currency" */
  exchange_account_network_currency?: Maybe<Scalars['String']['output']>;
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  exchange_account_network_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_account_network_uid?: Maybe<Scalars['String']['output']>;
  exchange_account_partner?: Maybe<Scalars['jsonb']['output']>;
  exchange_account_partner_id?: Maybe<Scalars['String']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  exports: Array<Export>;
  /** An aggregate relationship */
  exports_aggregate: Export_Aggregate;
  /** An array relationship */
  feature_flags: Array<Account_Feature_Flags>;
  /** An aggregate relationship */
  feature_flags_aggregate: Account_Feature_Flags_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_deleted: Scalars['Boolean']['output'];
  /** An array relationship */
  lookalike_definitions: Array<Lookalike_Definition>;
  /** An aggregate relationship */
  lookalike_definitions_aggregate: Lookalike_Definition_Aggregate;
  /** Default Max CPM cap */
  max_cpm_cap?: Maybe<Scalars['String']['output']>;
  /** Default Max Share */
  max_share?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Denotes what kind of organization this is. Extracted from MGMT API account object. */
  organization_type: Scalars['String']['output'];
  /** An object relationship */
  parent_account?: Maybe<Account>;
  parent_account_id?: Maybe<Scalars['uuid']['output']>;
  path_to_root: Scalars['jsonb']['output'];
  resource_id: Scalars['String']['output'];
  /** Is retargeting enabled for this account */
  retargeting_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  segments: Array<Segment>;
  /** An aggregate relationship */
  segments_aggregate: Segment_Aggregate;
  /** An array relationship */
  sub_accounts: Array<Account>;
  /** An aggregate relationship */
  sub_accounts_aggregate: Account_Aggregate;
  uds_account_id?: Maybe<Scalars['String']['output']>;
  updated_date: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
};


/** columns and relationships of "account" */
export type AccountAllowed_CountriesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account" */
export type AccountAllowed_DomainsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account" */
export type AccountAllowed_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAllowed_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAudiencesArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountAudiences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountExchange_Account_NetworkArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account" */
export type AccountExchange_Account_PartnerArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account" */
export type AccountExportsArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountExports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Feature_Flags_Order_By>>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Feature_Flags_Order_By>>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountLookalike_DefinitionsArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Definition_Order_By>>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountLookalike_Definitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Definition_Order_By>>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountPath_To_RootArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account" */
export type AccountSegmentsArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountSegments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountSub_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountSub_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "account" */
export type Account_Aggregate = {
  __typename?: 'account_aggregate';
  aggregate?: Maybe<Account_Aggregate_Fields>;
  nodes: Array<Account>;
};

export type Account_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Account_Aggregate_Bool_Exp_Count>;
};

export type Account_Aggregate_Bool_Exp_Bool_And = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account" */
export type Account_Aggregate_Fields = {
  __typename?: 'account_aggregate_fields';
  avg?: Maybe<Account_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Max_Fields>;
  min?: Maybe<Account_Min_Fields>;
  stddev?: Maybe<Account_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Sum_Fields>;
  var_pop?: Maybe<Account_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Var_Samp_Fields>;
  variance?: Maybe<Account_Variance_Fields>;
};


/** aggregate fields of "account" */
export type Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account" */
export type Account_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Max_Order_By>;
  min?: InputMaybe<Account_Min_Order_By>;
  stddev?: InputMaybe<Account_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Account_Append_Input = {
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_domains?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_network?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_partner?: InputMaybe<Scalars['jsonb']['input']>;
  path_to_root?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "account" */
export type Account_Arr_Rel_Insert_Input = {
  data: Array<Account_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_Avg_Fields = {
  __typename?: 'account_avg_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "account" */
export type Account_Avg_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account". All fields are combined with a logical 'AND'. */
export type Account_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Bool_Exp>>;
  _not?: InputMaybe<Account_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Bool_Exp>>;
  allowed_countries?: InputMaybe<Jsonb_Comparison_Exp>;
  allowed_domains?: InputMaybe<Jsonb_Comparison_Exp>;
  allowed_providers?: InputMaybe<Account_Provider_Bool_Exp>;
  allowed_providers_aggregate?: InputMaybe<Account_Provider_Aggregate_Bool_Exp>;
  audiences?: InputMaybe<Audience_Bool_Exp>;
  audiences_aggregate?: InputMaybe<Audience_Aggregate_Bool_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  exchange_account_network?: InputMaybe<Jsonb_Comparison_Exp>;
  exchange_account_network_currency?: InputMaybe<String_Comparison_Exp>;
  exchange_account_network_id?: InputMaybe<String_Comparison_Exp>;
  exchange_account_network_revision_applied?: InputMaybe<Int_Comparison_Exp>;
  exchange_account_network_uid?: InputMaybe<String_Comparison_Exp>;
  exchange_account_partner?: InputMaybe<Jsonb_Comparison_Exp>;
  exchange_account_partner_id?: InputMaybe<String_Comparison_Exp>;
  exchange_account_partner_revision_applied?: InputMaybe<Int_Comparison_Exp>;
  exports?: InputMaybe<Export_Bool_Exp>;
  exports_aggregate?: InputMaybe<Export_Aggregate_Bool_Exp>;
  feature_flags?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
  feature_flags_aggregate?: InputMaybe<Account_Feature_Flags_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  lookalike_definitions?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  lookalike_definitions_aggregate?: InputMaybe<Lookalike_Definition_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_type?: InputMaybe<String_Comparison_Exp>;
  parent_account?: InputMaybe<Account_Bool_Exp>;
  parent_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  path_to_root?: InputMaybe<Jsonb_Comparison_Exp>;
  resource_id?: InputMaybe<String_Comparison_Exp>;
  segments?: InputMaybe<Segment_Bool_Exp>;
  segments_aggregate?: InputMaybe<Segment_Aggregate_Bool_Exp>;
  sub_accounts?: InputMaybe<Account_Bool_Exp>;
  sub_accounts_aggregate?: InputMaybe<Account_Aggregate_Bool_Exp>;
  uds_account_id?: InputMaybe<String_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "account" */
export const Account_Constraint = {
  /** unique or primary key constraint on columns "exchange_account_network_id" */
  AccountExchangeAccountNetworkIdKey: 'account_exchange_account_network_id_key',
  /** unique or primary key constraint on columns "exchange_account_partner_id" */
  AccountExchangeAccountPartnerIdNonDeletedIdx: 'account_exchange_account_partner_id_non_deleted_idx',
  /** unique or primary key constraint on columns "name" */
  AccountNameKey: 'account_name_key',
  /** unique or primary key constraint on columns "id" */
  AccountPkey: 'account_pkey',
  /** unique or primary key constraint on columns "resource_id" */
  AccountResourceIdKey: 'account_resource_id_key',
  /** unique or primary key constraint on columns "uds_account_id" */
  AccountUdsAccountIdKey: 'account_uds_account_id_key'
} as const;

export type Account_Constraint = typeof Account_Constraint[keyof typeof Account_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Account_Delete_At_Path_Input = {
  allowed_countries?: InputMaybe<Array<Scalars['String']['input']>>;
  allowed_domains?: InputMaybe<Array<Scalars['String']['input']>>;
  exchange_account_network?: InputMaybe<Array<Scalars['String']['input']>>;
  exchange_account_partner?: InputMaybe<Array<Scalars['String']['input']>>;
  path_to_root?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Account_Delete_Elem_Input = {
  allowed_countries?: InputMaybe<Scalars['Int']['input']>;
  allowed_domains?: InputMaybe<Scalars['Int']['input']>;
  exchange_account_network?: InputMaybe<Scalars['Int']['input']>;
  exchange_account_partner?: InputMaybe<Scalars['Int']['input']>;
  path_to_root?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Account_Delete_Key_Input = {
  allowed_countries?: InputMaybe<Scalars['String']['input']>;
  allowed_domains?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network?: InputMaybe<Scalars['String']['input']>;
  exchange_account_partner?: InputMaybe<Scalars['String']['input']>;
  path_to_root?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "account_feature_flags" */
export type Account_Feature_Flags = {
  __typename?: 'account_feature_flags';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  value: Feature_Flags_Enum;
};

/** aggregated selection of "account_feature_flags" */
export type Account_Feature_Flags_Aggregate = {
  __typename?: 'account_feature_flags_aggregate';
  aggregate?: Maybe<Account_Feature_Flags_Aggregate_Fields>;
  nodes: Array<Account_Feature_Flags>;
};

export type Account_Feature_Flags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Account_Feature_Flags_Aggregate_Bool_Exp_Count>;
};

export type Account_Feature_Flags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_feature_flags" */
export type Account_Feature_Flags_Aggregate_Fields = {
  __typename?: 'account_feature_flags_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Feature_Flags_Max_Fields>;
  min?: Maybe<Account_Feature_Flags_Min_Fields>;
};


/** aggregate fields of "account_feature_flags" */
export type Account_Feature_Flags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account_feature_flags" */
export type Account_Feature_Flags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Feature_Flags_Max_Order_By>;
  min?: InputMaybe<Account_Feature_Flags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "account_feature_flags" */
export type Account_Feature_Flags_Arr_Rel_Insert_Input = {
  data: Array<Account_Feature_Flags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Feature_Flags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "account_feature_flags". All fields are combined with a logical 'AND'. */
export type Account_Feature_Flags_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Feature_Flags_Bool_Exp>>;
  _not?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Feature_Flags_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Feature_Flags_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_feature_flags" */
export const Account_Feature_Flags_Constraint = {
  /** unique or primary key constraint on columns "account_id", "value" */
  AccountFeatureFlagsAccountIdValueKey: 'account_feature_flags_account_id_value_key',
  /** unique or primary key constraint on columns "id" */
  AccountFeatureFlagsPkey: 'account_feature_flags_pkey'
} as const;

export type Account_Feature_Flags_Constraint = typeof Account_Feature_Flags_Constraint[keyof typeof Account_Feature_Flags_Constraint];
/** input type for inserting data into table "account_feature_flags" */
export type Account_Feature_Flags_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  /**
   * On insert_account_one, false declines inheriting this flag from the parent instead of inserting it.
   * Direct insert_account_feature_flags(_one) calls reject false outright, since there is no parent to decline from there.
   */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Feature_Flags_Enum>;
};

/** aggregate max on columns */
export type Account_Feature_Flags_Max_Fields = {
  __typename?: 'account_feature_flags_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "account_feature_flags" */
export type Account_Feature_Flags_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Feature_Flags_Min_Fields = {
  __typename?: 'account_feature_flags_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "account_feature_flags" */
export type Account_Feature_Flags_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_feature_flags" */
export type Account_Feature_Flags_Mutation_Response = {
  __typename?: 'account_feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Feature_Flags>;
};

/** on_conflict condition type for table "account_feature_flags" */
export type Account_Feature_Flags_On_Conflict = {
  constraint: Account_Feature_Flags_Constraint;
  update_columns?: Array<Account_Feature_Flags_Update_Column>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "account_feature_flags". */
export type Account_Feature_Flags_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_feature_flags */
export type Account_Feature_Flags_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "account_feature_flags" */
export const Account_Feature_Flags_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  Id: 'id',
  /** column name */
  Value: 'value'
} as const;

export type Account_Feature_Flags_Select_Column = typeof Account_Feature_Flags_Select_Column[keyof typeof Account_Feature_Flags_Select_Column];
/** input type for updating data in table "account_feature_flags" */
export type Account_Feature_Flags_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Feature_Flags_Enum>;
};

/** Streaming cursor of the table "account_feature_flags" */
export type Account_Feature_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Feature_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Feature_Flags_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Feature_Flags_Enum>;
};

/** update columns of table "account_feature_flags" */
export const Account_Feature_Flags_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  Id: 'id',
  /** column name */
  Value: 'value'
} as const;

export type Account_Feature_Flags_Update_Column = typeof Account_Feature_Flags_Update_Column[keyof typeof Account_Feature_Flags_Update_Column];
export type Account_Feature_Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Feature_Flags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Feature_Flags_Bool_Exp;
};

/** input type for incrementing numeric columns in table "account" */
export type Account_Inc_Input = {
  exchange_account_network_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_account_partner_revision_applied?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "account" */
export type Account_Insert_Input = {
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_domains?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_providers?: InputMaybe<Account_Provider_Arr_Rel_Insert_Input>;
  audiences?: InputMaybe<Audience_Arr_Rel_Insert_Input>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  default_cpm_cap?: InputMaybe<Scalars['String']['input']>;
  default_fees_description?: InputMaybe<Scalars['String']['input']>;
  default_platform_share_ox_sourced?: InputMaybe<Scalars['String']['input']>;
  default_platform_share_partner_sourced?: InputMaybe<Scalars['String']['input']>;
  default_share?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Contains a list of allowed DSPs and their seat_ids. */
  dsp_restriction?: InputMaybe<Array<DspRestrictionInput>>;
  /** Working mode of DSP restrictions, whether it's an allowlist or blocklist. */
  dsp_restriction_mode?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_network_id?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_account_network_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_account_partner?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_partner_id?: InputMaybe<Scalars['String']['input']>;
  exchange_account_partner_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exports?: InputMaybe<Export_Arr_Rel_Insert_Input>;
  feature_flags?: InputMaybe<Account_Feature_Flags_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  lookalike_definitions?: InputMaybe<Lookalike_Definition_Arr_Rel_Insert_Input>;
  /** Default Max CPM cap */
  max_cpm_cap?: InputMaybe<Scalars['String']['input']>;
  /** Default Max Share */
  max_share?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Denotes what kind of organization this is. */
  organization_type?: InputMaybe<Scalars['String']['input']>;
  parent_account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  parent_account_id?: InputMaybe<Scalars['uuid']['input']>;
  path_to_root?: InputMaybe<Scalars['jsonb']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  retargeting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  segments?: InputMaybe<Segment_Arr_Rel_Insert_Input>;
  sub_accounts?: InputMaybe<Account_Arr_Rel_Insert_Input>;
  uds_account_id?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  users?: InputMaybe<User_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "account_list" */
export type Account_List = {
  __typename?: 'account_list';
  exchange_account_partner_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "account_list_has_segments_shared_with_caller" */
  has_segments_shared_with_caller?: Maybe<Scalars['Boolean']['output']>;
  has_sellable_segments?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path_to_root?: Maybe<Scalars['jsonb']['output']>;
  sellable_segment_country_codes?: Maybe<Scalars['_text']['output']>;
  sellable_segment_region_codes?: Maybe<Scalars['_text']['output']>;
  /** A computed field, executes function "account_list_shared_segment_country_codes" */
  shared_segment_country_codes?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "account_list_shared_segment_region_codes" */
  shared_segment_region_codes?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
};


/** columns and relationships of "account_list" */
export type Account_ListPath_To_RootArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account_list" */
export type Account_ListShared_Segment_Country_CodesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account_list" */
export type Account_ListShared_Segment_Region_CodesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "account_list" */
export type Account_ListUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "account_list" */
export type Account_ListUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "account_list" */
export type Account_List_Aggregate = {
  __typename?: 'account_list_aggregate';
  aggregate?: Maybe<Account_List_Aggregate_Fields>;
  nodes: Array<Account_List>;
};

/** aggregate fields of "account_list" */
export type Account_List_Aggregate_Fields = {
  __typename?: 'account_list_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Account_List_Max_Fields>;
  min?: Maybe<Account_List_Min_Fields>;
};


/** aggregate fields of "account_list" */
export type Account_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "account_list". All fields are combined with a logical 'AND'. */
export type Account_List_Bool_Exp = {
  _and?: InputMaybe<Array<Account_List_Bool_Exp>>;
  _not?: InputMaybe<Account_List_Bool_Exp>;
  _or?: InputMaybe<Array<Account_List_Bool_Exp>>;
  exchange_account_partner_id?: InputMaybe<String_Comparison_Exp>;
  has_segments_shared_with_caller?: InputMaybe<Boolean_Comparison_Exp>;
  has_sellable_segments?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  path_to_root?: InputMaybe<Jsonb_Comparison_Exp>;
  sellable_segment_country_codes?: InputMaybe<_Text_Comparison_Exp>;
  sellable_segment_region_codes?: InputMaybe<_Text_Comparison_Exp>;
  shared_segment_country_codes?: InputMaybe<Jsonb_Comparison_Exp>;
  shared_segment_region_codes?: InputMaybe<Jsonb_Comparison_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Account_List_Max_Fields = {
  __typename?: 'account_list_max_fields';
  exchange_account_partner_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Account_List_Min_Fields = {
  __typename?: 'account_list_min_fields';
  exchange_account_partner_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "account_list". */
export type Account_List_Order_By = {
  exchange_account_partner_id?: InputMaybe<Order_By>;
  has_segments_shared_with_caller?: InputMaybe<Order_By>;
  has_sellable_segments?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  path_to_root?: InputMaybe<Order_By>;
  sellable_segment_country_codes?: InputMaybe<Order_By>;
  sellable_segment_region_codes?: InputMaybe<Order_By>;
  shared_segment_country_codes?: InputMaybe<Order_By>;
  shared_segment_region_codes?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
};

/** select columns of table "account_list" */
export const Account_List_Select_Column = {
  /** column name */
  ExchangeAccountPartnerId: 'exchange_account_partner_id',
  /** column name */
  HasSellableSegments: 'has_sellable_segments',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PathToRoot: 'path_to_root',
  /** column name */
  SellableSegmentCountryCodes: 'sellable_segment_country_codes',
  /** column name */
  SellableSegmentRegionCodes: 'sellable_segment_region_codes'
} as const;

export type Account_List_Select_Column = typeof Account_List_Select_Column[keyof typeof Account_List_Select_Column];
/** Streaming cursor of the table "account_list" */
export type Account_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_List_Stream_Cursor_Value_Input = {
  exchange_account_partner_id?: InputMaybe<Scalars['String']['input']>;
  has_sellable_segments?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path_to_root?: InputMaybe<Scalars['jsonb']['input']>;
  sellable_segment_country_codes?: InputMaybe<Scalars['_text']['input']>;
  sellable_segment_region_codes?: InputMaybe<Scalars['_text']['input']>;
};

/** aggregate max on columns */
export type Account_Max_Fields = {
  __typename?: 'account_max_fields';
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  exchange_account_network_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_account_network_uid?: Maybe<Scalars['String']['output']>;
  exchange_account_partner_id?: Maybe<Scalars['String']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_account_id?: Maybe<Scalars['uuid']['output']>;
  resource_id?: Maybe<Scalars['String']['output']>;
  uds_account_id?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "account" */
export type Account_Max_Order_By = {
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  exchange_account_network_id?: InputMaybe<Order_By>;
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_network_uid?: InputMaybe<Order_By>;
  exchange_account_partner_id?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_account_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  uds_account_id?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Min_Fields = {
  __typename?: 'account_min_fields';
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  exchange_account_network_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_account_network_uid?: Maybe<Scalars['String']['output']>;
  exchange_account_partner_id?: Maybe<Scalars['String']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_account_id?: Maybe<Scalars['uuid']['output']>;
  resource_id?: Maybe<Scalars['String']['output']>;
  uds_account_id?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "account" */
export type Account_Min_Order_By = {
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  exchange_account_network_id?: InputMaybe<Order_By>;
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_network_uid?: InputMaybe<Order_By>;
  exchange_account_partner_id?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_account_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  uds_account_id?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account" */
export type Account_Mutation_Response = {
  __typename?: 'account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account>;
};

/** input type for inserting object relation for remote table "account" */
export type Account_Obj_Rel_Insert_Input = {
  data: Account_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_On_Conflict>;
};

/** on_conflict condition type for table "account" */
export type Account_On_Conflict = {
  constraint: Account_Constraint;
  update_columns?: Array<Account_Update_Column>;
  where?: InputMaybe<Account_Bool_Exp>;
};

/** Ordering options when selecting data from "account". */
export type Account_Order_By = {
  allowed_countries?: InputMaybe<Order_By>;
  allowed_domains?: InputMaybe<Order_By>;
  allowed_providers_aggregate?: InputMaybe<Account_Provider_Aggregate_Order_By>;
  audiences_aggregate?: InputMaybe<Audience_Aggregate_Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  exchange_account_network?: InputMaybe<Order_By>;
  exchange_account_network_currency?: InputMaybe<Order_By>;
  exchange_account_network_id?: InputMaybe<Order_By>;
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_network_uid?: InputMaybe<Order_By>;
  exchange_account_partner?: InputMaybe<Order_By>;
  exchange_account_partner_id?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
  exports_aggregate?: InputMaybe<Export_Aggregate_Order_By>;
  feature_flags_aggregate?: InputMaybe<Account_Feature_Flags_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  lookalike_definitions_aggregate?: InputMaybe<Lookalike_Definition_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  organization_type?: InputMaybe<Order_By>;
  parent_account?: InputMaybe<Account_Order_By>;
  parent_account_id?: InputMaybe<Order_By>;
  path_to_root?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  segments_aggregate?: InputMaybe<Segment_Aggregate_Order_By>;
  sub_accounts_aggregate?: InputMaybe<Account_Aggregate_Order_By>;
  uds_account_id?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
};

/** primary key columns input for table: account */
export type Account_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Account_Prepend_Input = {
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_domains?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_network?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_partner?: InputMaybe<Scalars['jsonb']['input']>;
  path_to_root?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "account_provider" */
export type Account_Provider = {
  __typename?: 'account_provider';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['String']['output'];
};

/** aggregated selection of "account_provider" */
export type Account_Provider_Aggregate = {
  __typename?: 'account_provider_aggregate';
  aggregate?: Maybe<Account_Provider_Aggregate_Fields>;
  nodes: Array<Account_Provider>;
};

export type Account_Provider_Aggregate_Bool_Exp = {
  count?: InputMaybe<Account_Provider_Aggregate_Bool_Exp_Count>;
};

export type Account_Provider_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Account_Provider_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_provider" */
export type Account_Provider_Aggregate_Fields = {
  __typename?: 'account_provider_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Account_Provider_Max_Fields>;
  min?: Maybe<Account_Provider_Min_Fields>;
};


/** aggregate fields of "account_provider" */
export type Account_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "account_provider" */
export type Account_Provider_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Provider_Max_Order_By>;
  min?: InputMaybe<Account_Provider_Min_Order_By>;
};

/** input type for inserting array relation for remote table "account_provider" */
export type Account_Provider_Arr_Rel_Insert_Input = {
  data: Array<Account_Provider_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Provider_On_Conflict>;
};

/** Boolean expression to filter rows from the table "account_provider". All fields are combined with a logical 'AND'. */
export type Account_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Provider_Bool_Exp>>;
  _not?: InputMaybe<Account_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Provider_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_provider" */
export const Account_Provider_Constraint = {
  /** unique or primary key constraint on columns "provider_id", "account_id" */
  AccountProviderAccountIdProviderIdKey: 'account_provider_account_id_provider_id_key',
  /** unique or primary key constraint on columns "id" */
  AccountProviderPkey: 'account_provider_pkey'
} as const;

export type Account_Provider_Constraint = typeof Account_Provider_Constraint[keyof typeof Account_Provider_Constraint];
/** input type for inserting data into table "account_provider" */
export type Account_Provider_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Account_Provider_Max_Fields = {
  __typename?: 'account_provider_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "account_provider" */
export type Account_Provider_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Provider_Min_Fields = {
  __typename?: 'account_provider_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "account_provider" */
export type Account_Provider_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_provider" */
export type Account_Provider_Mutation_Response = {
  __typename?: 'account_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Provider>;
};

/** on_conflict condition type for table "account_provider" */
export type Account_Provider_On_Conflict = {
  constraint: Account_Provider_Constraint;
  update_columns?: Array<Account_Provider_Update_Column>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "account_provider". */
export type Account_Provider_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_provider */
export type Account_Provider_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "account_provider" */
export const Account_Provider_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  Id: 'id',
  /** column name */
  ProviderId: 'provider_id'
} as const;

export type Account_Provider_Select_Column = typeof Account_Provider_Select_Column[keyof typeof Account_Provider_Select_Column];
/** input type for updating data in table "account_provider" */
export type Account_Provider_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "account_provider" */
export type Account_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Provider_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "account_provider" */
export const Account_Provider_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  Id: 'id',
  /** column name */
  ProviderId: 'provider_id'
} as const;

export type Account_Provider_Update_Column = typeof Account_Provider_Update_Column[keyof typeof Account_Provider_Update_Column];
export type Account_Provider_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Provider_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Provider_Bool_Exp;
};

/** select columns of table "account" */
export const Account_Select_Column = {
  /** column name */
  AllowedCountries: 'allowed_countries',
  /** column name */
  AllowedDomains: 'allowed_domains',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Description: 'description',
  /** column name */
  ExchangeAccountNetwork: 'exchange_account_network',
  /** column name */
  ExchangeAccountNetworkId: 'exchange_account_network_id',
  /** column name */
  ExchangeAccountNetworkRevisionApplied: 'exchange_account_network_revision_applied',
  /** column name */
  ExchangeAccountNetworkUid: 'exchange_account_network_uid',
  /** column name */
  ExchangeAccountPartner: 'exchange_account_partner',
  /** column name */
  ExchangeAccountPartnerId: 'exchange_account_partner_id',
  /** column name */
  ExchangeAccountPartnerRevisionApplied: 'exchange_account_partner_revision_applied',
  /** column name */
  Id: 'id',
  /** column name */
  IsActive: 'is_active',
  /** column name */
  IsDeleted: 'is_deleted',
  /** column name */
  Name: 'name',
  /** column name */
  ParentAccountId: 'parent_account_id',
  /** column name */
  PathToRoot: 'path_to_root',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  UdsAccountId: 'uds_account_id',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Account_Select_Column = typeof Account_Select_Column[keyof typeof Account_Select_Column];
/** select "account_aggregate_bool_exp_bool_and_arguments_columns" columns of table "account" */
export const Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsActive: 'is_active',
  /** column name */
  IsDeleted: 'is_deleted'
} as const;

export type Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "account_aggregate_bool_exp_bool_or_arguments_columns" columns of table "account" */
export const Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsActive: 'is_active',
  /** column name */
  IsDeleted: 'is_deleted'
} as const;

export type Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "account" */
export type Account_Set_Input = {
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_domains?: InputMaybe<Scalars['jsonb']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  default_cpm_cap?: InputMaybe<Scalars['String']['input']>;
  default_fees_description?: InputMaybe<Scalars['String']['input']>;
  default_platform_share_ox_sourced?: InputMaybe<Scalars['String']['input']>;
  default_platform_share_partner_sourced?: InputMaybe<Scalars['String']['input']>;
  default_share?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Contains a list of allowed DSPs and their seat_ids. */
  dsp_restriction?: InputMaybe<Array<DspRestrictionInput>>;
  /** Working mode of DSP restrictions, whether it's an allowlist or blocklist. */
  dsp_restriction_mode?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_network_id?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_account_network_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_account_partner?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_partner_id?: InputMaybe<Scalars['String']['input']>;
  exchange_account_partner_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  feature_flags?: InputMaybe<Array<Feature_Flags_Enum>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default Max CPM cap */
  max_cpm_cap?: InputMaybe<Scalars['String']['input']>;
  /** Default Max Share */
  max_share?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Denotes what kind of organization this is. */
  organization_type?: InputMaybe<Scalars['String']['input']>;
  parent_account_id?: InputMaybe<Scalars['uuid']['input']>;
  path_to_root?: InputMaybe<Scalars['jsonb']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  retargeting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  uds_account_id?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Account_Stddev_Fields = {
  __typename?: 'account_stddev_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "account" */
export type Account_Stddev_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Stddev_Pop_Fields = {
  __typename?: 'account_stddev_pop_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "account" */
export type Account_Stddev_Pop_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Stddev_Samp_Fields = {
  __typename?: 'account_stddev_samp_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "account" */
export type Account_Stddev_Samp_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account" */
export type Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Stream_Cursor_Value_Input = {
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_domains?: InputMaybe<Scalars['jsonb']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_network_id?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_account_network_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_account_partner?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_account_partner_id?: InputMaybe<Scalars['String']['input']>;
  exchange_account_partner_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_account_id?: InputMaybe<Scalars['uuid']['input']>;
  path_to_root?: InputMaybe<Scalars['jsonb']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  uds_account_id?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Account_Sum_Fields = {
  __typename?: 'account_sum_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "account" */
export type Account_Sum_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** update columns of table "account" */
export const Account_Update_Column = {
  /** column name */
  AllowedCountries: 'allowed_countries',
  /** column name */
  AllowedDomains: 'allowed_domains',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Description: 'description',
  /** column name */
  ExchangeAccountNetwork: 'exchange_account_network',
  /** column name */
  ExchangeAccountNetworkId: 'exchange_account_network_id',
  /** column name */
  ExchangeAccountNetworkRevisionApplied: 'exchange_account_network_revision_applied',
  /** column name */
  ExchangeAccountNetworkUid: 'exchange_account_network_uid',
  /** column name */
  ExchangeAccountPartner: 'exchange_account_partner',
  /** column name */
  ExchangeAccountPartnerId: 'exchange_account_partner_id',
  /** column name */
  ExchangeAccountPartnerRevisionApplied: 'exchange_account_partner_revision_applied',
  /** column name */
  Id: 'id',
  /** column name */
  IsActive: 'is_active',
  /** column name */
  IsDeleted: 'is_deleted',
  /** column name */
  Name: 'name',
  /** column name */
  ParentAccountId: 'parent_account_id',
  /** column name */
  PathToRoot: 'path_to_root',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  UdsAccountId: 'uds_account_id',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Account_Update_Column = typeof Account_Update_Column[keyof typeof Account_Update_Column];
export type Account_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Account_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Account_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Account_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Account_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Account_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Var_Pop_Fields = {
  __typename?: 'account_var_pop_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "account" */
export type Account_Var_Pop_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Var_Samp_Fields = {
  __typename?: 'account_var_samp_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "account" */
export type Account_Var_Samp_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Variance_Fields = {
  __typename?: 'account_variance_fields';
  exchange_account_network_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_account_partner_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "account" */
export type Account_Variance_Order_By = {
  exchange_account_network_revision_applied?: InputMaybe<Order_By>;
  exchange_account_partner_revision_applied?: InputMaybe<Order_By>;
};

/** columns and relationships of "audience" */
export type Audience = {
  __typename?: 'audience';
  /** An object relationship */
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['uuid']['output']>;
  addressable_reach?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  audience_segments: Array<Audience_Segment>;
  /** An aggregate relationship */
  audience_segments_aggregate: Audience_Segment_Aggregate;
  audience_share: Array<Maybe<AudienceShare>>;
  bq_reach_table?: Maybe<Scalars['String']['output']>;
  bq_table?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['timestamptz']['output'];
  created_with?: Maybe<Scalars['String']['output']>;
  data_source: Scalars['String']['output'];
  /** complies to the current AST format and the default value passed in from UI */
  definition?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direct_audience_provider: Scalars['String']['output'];
  error?: Maybe<Scalars['jsonb']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "calc_expiry_date" */
  estimated_expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  estimated_reach?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_expired_date_if_expired" */
  expired_date?: Maybe<Scalars['timestamptz']['output']>;
  export_targets?: Maybe<Scalars['jsonb']['output']>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type: Scalars['String']['output'];
  /** An array relationship */
  exports: Array<Export>;
  /** An aggregate relationship */
  exports_aggregate: Export_Aggregate;
  id: Scalars['uuid']['output'];
  info?: Maybe<Scalars['jsonb']['output']>;
  is_archived: Scalars['Boolean']['output'];
  is_multi_partner?: Maybe<Scalars['Boolean']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  last_export?: Maybe<Export>;
  last_export_id?: Maybe<Scalars['uuid']['output']>;
  last_uds_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  normalized_definition?: Maybe<Scalars['jsonb']['output']>;
  pricing?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  provider: Provider;
  reach?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
  report_status?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "audience" */
export type AudienceAudience_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


/** columns and relationships of "audience" */
export type AudienceAudience_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


/** columns and relationships of "audience" */
export type AudienceAudience_ShareArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** columns and relationships of "audience" */
export type AudienceDefinitionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audience" */
export type AudienceErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audience" */
export type AudienceExport_TargetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audience" */
export type AudienceExportsArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


/** columns and relationships of "audience" */
export type AudienceExports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


/** columns and relationships of "audience" */
export type AudienceInfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audience" */
export type AudienceNormalized_DefinitionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audience" */
export type AudiencePricingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audience" */
export type AudienceTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceSegmentCombinedResult = {
  __typename?: 'audienceSegmentCombinedResult';
  resultsKey?: Maybe<Scalars['String']['output']>;
  segments: Array<AudienceSegmentEntry>;
  segmentsSets: Array<AudienceSegmentSet>;
};

export type AudienceSegmentEntry = {
  __typename?: 'audienceSegmentEntry';
  account_id: Scalars['ID']['output'];
  account_name: Scalars['String']['output'];
  activeIPs: Scalars['GraphQLUBigInt64']['output'];
  avgCPM: Scalars['numeric']['output'];
  category: Scalars['String']['output'];
  clickThroughRate: Scalars['numeric']['output'];
  cookies: Scalars['GraphQLUBigInt64']['output'];
  costPerUniqueReach: Scalars['numeric']['output'];
  countries: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  devicesDesktop: Scalars['GraphQLUBigInt64']['output'];
  devicesMobile: Scalars['GraphQLUBigInt64']['output'];
  devicesTV: Scalars['GraphQLUBigInt64']['output'];
  devicesTablet: Scalars['GraphQLUBigInt64']['output'];
  id: Scalars['ID']['output'];
  impressions: Scalars['GraphQLUBigInt64']['output'];
  maxCPM: Scalars['numeric']['output'];
  minCPM: Scalars['numeric']['output'];
  name: Scalars['String']['output'];
  price_cpm: Scalars['numeric']['output'];
  price_pom: Scalars['numeric']['output'];
  reach: Scalars['GraphQLUBigInt64']['output'];
  regions: Array<Scalars['String']['output']>;
  requests: Scalars['GraphQLUBigInt64']['output'];
  segment_category: Scalars['String']['output'];
  segment_subcategory: Scalars['String']['output'];
  segment_type: Scalars['String']['output'];
  sellable: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
  videoCompletions: Scalars['GraphQLUBigInt64']['output'];
  videoStarts: Scalars['GraphQLUBigInt64']['output'];
  weightedBidCpm: Scalars['numeric']['output'];
  weightedClicks: Scalars['GraphQLUBigInt64']['output'];
  weightedImpressionsWithClickMacro: Scalars['GraphQLUBigInt64']['output'];
};

export type AudienceSegmentExcelGenerateFiltersInput = {
  demographicsAge?: InputMaybe<AgeRangeInput>;
  demographicsGender?: InputMaybe<Gender>;
  userLocationCongressionalDistrict?: InputMaybe<Scalars['String']['input']>;
  userLocationCongressionalDistricts?: InputMaybe<Array<Scalars['String']['input']>>;
  userLocationDMAs?: InputMaybe<Array<Scalars['String']['input']>>;
  userLocationStates?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AudienceSegmentExcelGenerateInput = {
  segmentData: AudienceSegmentExcelGenerateInputSegmentData;
};

export type AudienceSegmentExcelGenerateInputSegment = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  segment_category: Scalars['String']['input'];
  segment_subcategory: Scalars['String']['input'];
  segment_type: Scalars['String']['input'];
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceSegmentExcelGenerateInputSegmentData = {
  filters?: InputMaybe<AudienceSegmentExcelGenerateFiltersInput>;
  mau: Scalars['Int']['input'];
  segments: Array<AudienceSegmentExcelGenerateInputSegment>;
};

export type AudienceSegmentExcelGenerateResult = {
  __typename?: 'audienceSegmentExcelGenerateResult';
  fileData: Scalars['String']['output'];
};

export type AudienceSegmentSearchCategoryOption = {
  __typename?: 'audienceSegmentSearchCategoryOption';
  /** Category to send in `filters.segmentsCategories`. */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AudienceSegmentSearchDataPartnerOption = {
  __typename?: 'audienceSegmentSearchDataPartnerOption';
  /** Data partner (account) id to send in `filters.segmentsDataPartners`. */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AudienceSegmentSearchFilters = {
  __typename?: 'audienceSegmentSearchFilters';
  country?: Maybe<Array<Scalars['String']['output']>>;
  demographicsAge?: Maybe<AgeRange>;
  demographicsGender?: Maybe<Gender>;
  goalUniqueUsersReach?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentsCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated No longer supported */
  segmentsDataPartners?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated No longer supported */
  segmentsSearchMode?: Maybe<SegmentSearchMode>;
  segmentsSubCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use userLocationCongressionalDistricts instead */
  userLocationCongressionalDistrict?: Maybe<Scalars['String']['output']>;
  userLocationCongressionalDistricts?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use userLocationDMAs instead */
  userLocationDMA?: Maybe<Scalars['String']['output']>;
  userLocationDMAs?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use userLocationStates instead */
  userLocationState?: Maybe<Scalars['String']['output']>;
  userLocationStates?: Maybe<Array<Scalars['String']['output']>>;
};

export type AudienceSegmentSearchFiltersInput = {
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  demographicsAge?: InputMaybe<AgeRangeInput>;
  demographicsGender?: InputMaybe<Gender>;
  goalUniqueUsersReach?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  segmentsCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  segmentsDataPartners?: InputMaybe<Array<Scalars['String']['input']>>;
  segmentsSearchMode?: InputMaybe<SegmentSearchMode>;
  segmentsSubCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  userLocationCongressionalDistrict?: InputMaybe<Scalars['String']['input']>;
  userLocationCongressionalDistricts?: InputMaybe<Array<Scalars['String']['input']>>;
  userLocationDMA?: InputMaybe<Scalars['String']['input']>;
  userLocationDMAs?: InputMaybe<Array<Scalars['String']['input']>>;
  userLocationState?: InputMaybe<Scalars['String']['input']>;
  userLocationStates?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AudienceSegmentSearchInput = {
  filters: AudienceSegmentSearchFiltersInput;
  tagGroups: AudienceSegmentTagGroupsInput;
};

export type AudienceSegmentSearchInputDescriptor = {
  __typename?: 'audienceSegmentSearchInputDescriptor';
  filters: AudienceSegmentSearchFilters;
  tagGroups: AudienceSegmentTagGroups;
};

export type AudienceSegmentSearchModeOption = {
  __typename?: 'audienceSegmentSearchModeOption';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Value to send as `filters.segmentsSearchMode`. Null for All Segments: send no `segmentsSearchMode`. */
  value?: Maybe<SegmentSearchMode>;
};

export type AudienceSegmentSearchOptions = {
  __typename?: 'audienceSegmentSearchOptions';
  /** Segment (IAB taxonomy) categories. */
  categories: Array<AudienceSegmentSearchCategoryOption>;
  /**
   * Data partners offered for the input's region, country and segmentsSearchMode, as in the UI's data partner
   * filter. Empty in OWN_ONLY mode.
   */
  dataPartners: Array<AudienceSegmentSearchDataPartnerOption>;
  /** Regions an audience segment search can be scoped to. */
  regions: Array<AudienceSegmentSearchRegionOption>;
  /** Segment search modes available to the caller's account. A mode absent from this list must not be sent. */
  segmentSearchModes: Array<AudienceSegmentSearchModeOption>;
  /** Segment (IAB taxonomy) sub-categories, narrowed to the input's categories when given. */
  subCategories: Array<AudienceSegmentSearchSubCategoryOption>;
};

/** Input for `audienceSegmentSearchOptions`. Every field is optional and only narrows the option lists it names. */
export type AudienceSegmentSearchOptionsInput = {
  /** Return only the sub-categories of these categories. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries the search will run in. Further scopes `dataPartners` for a non-US `region`. */
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Region the search will run in. Scopes `dataPartners` to partners with sellable segments in that region.
   * Defaults to `US`, for which data partners are not scoped by region.
   */
  region?: InputMaybe<Scalars['String']['input']>;
  /**
   * Search mode the search will run in. Scopes `dataPartners` to the partners offered in that mode. Omit for the
   * default (no mode).
   */
  segmentsSearchMode?: InputMaybe<SegmentSearchMode>;
};

export type AudienceSegmentSearchRegionOption = {
  __typename?: 'audienceSegmentSearchRegionOption';
  /** Region code to send as `filters.region`, e.g. `US`. */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AudienceSegmentSearchSubCategoryOption = {
  __typename?: 'audienceSegmentSearchSubCategoryOption';
  /** Sub-category to send in `filters.segmentsSubCategories`. */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Id of the category this sub-category belongs to. */
  parentCategoryId: Scalars['String']['output'];
};

export type AudienceSegmentSearchTextInput = {
  filters: AudienceSegmentSearchFiltersInput;
  inputText: Scalars['String']['input'];
};

export type AudienceSegmentSearchTextResult = {
  __typename?: 'audienceSegmentSearchTextResult';
  combinedResult: AudienceSegmentCombinedResult;
  generatedSearchInput: AudienceSegmentSearchInputDescriptor;
  resultsKey?: Maybe<Scalars['String']['output']>;
};

export type AudienceSegmentSet = {
  __typename?: 'audienceSegmentSet';
  matchedSegments: Array<MatchedSegment>;
  metrics: AudienceSegmentSetMetrics;
  normalized_definition?: Maybe<NormalizedDefinition>;
  /** @deprecated Use matchedSegments and normalized_definition instead */
  segmentIds: Array<Scalars['ID']['output']>;
  type: AudienceSegmentSetType;
};

export type AudienceSegmentSetMetrics = {
  __typename?: 'audienceSegmentSetMetrics';
  activeIPs: Scalars['GraphQLUBigInt64']['output'];
  avgCPM: Scalars['numeric']['output'];
  clickThroughRate: Scalars['numeric']['output'];
  cookies: Scalars['GraphQLUBigInt64']['output'];
  costPerUniqueReach: Scalars['numeric']['output'];
  devicesDesktop: Scalars['GraphQLUBigInt64']['output'];
  devicesMobile: Scalars['GraphQLUBigInt64']['output'];
  devicesTV: Scalars['GraphQLUBigInt64']['output'];
  maxCPM: Scalars['numeric']['output'];
  minCPM: Scalars['numeric']['output'];
  reach: Scalars['GraphQLUBigInt64']['output'];
  relevance: Scalars['numeric']['output'];
  totalRequests: Scalars['GraphQLUBigInt64']['output'];
  videoCompletionRate: Scalars['numeric']['output'];
};

export const AudienceSegmentSetType = {
  BestPerformance: 'BEST_PERFORMANCE',
  HighestScale: 'HIGHEST_SCALE',
  MostRelevant: 'MOST_RELEVANT'
} as const;

export type AudienceSegmentSetType = typeof AudienceSegmentSetType[keyof typeof AudienceSegmentSetType];
export type AudienceSegmentTagGroup = {
  __typename?: 'audienceSegmentTagGroup';
  tags: Array<Scalars['String']['output']>;
};

export type AudienceSegmentTagGroupInput = {
  tags: Array<Scalars['String']['input']>;
};

export type AudienceSegmentTagGroups = {
  __typename?: 'audienceSegmentTagGroups';
  groups: Array<AudienceSegmentTagGroup>;
  operator: Scalars['String']['output'];
};

export type AudienceSegmentTagGroupsInput = {
  groups: Array<AudienceSegmentTagGroupInput>;
  operator: Scalars['String']['input'];
};

/** aggregated selection of "audience" */
export type Audience_Aggregate = {
  __typename?: 'audience_aggregate';
  aggregate?: Maybe<Audience_Aggregate_Fields>;
  nodes: Array<Audience>;
};

export type Audience_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Audience_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Audience_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Audience_Aggregate_Bool_Exp_Count>;
};

export type Audience_Aggregate_Bool_Exp_Bool_And = {
  arguments: Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Audience_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Audience_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Audience_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Audience_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Audience_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Audience_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "audience" */
export type Audience_Aggregate_Fields = {
  __typename?: 'audience_aggregate_fields';
  avg?: Maybe<Audience_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Audience_Max_Fields>;
  min?: Maybe<Audience_Min_Fields>;
  stddev?: Maybe<Audience_Stddev_Fields>;
  stddev_pop?: Maybe<Audience_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Audience_Stddev_Samp_Fields>;
  sum?: Maybe<Audience_Sum_Fields>;
  var_pop?: Maybe<Audience_Var_Pop_Fields>;
  var_samp?: Maybe<Audience_Var_Samp_Fields>;
  variance?: Maybe<Audience_Variance_Fields>;
};


/** aggregate fields of "audience" */
export type Audience_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audience_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "audience" */
export type Audience_Aggregate_Order_By = {
  avg?: InputMaybe<Audience_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Audience_Max_Order_By>;
  min?: InputMaybe<Audience_Min_Order_By>;
  stddev?: InputMaybe<Audience_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Audience_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Audience_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Audience_Sum_Order_By>;
  var_pop?: InputMaybe<Audience_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Audience_Var_Samp_Order_By>;
  variance?: InputMaybe<Audience_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Audience_Append_Input = {
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  normalized_definition?: InputMaybe<Scalars['jsonb']['input']>;
  pricing?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "audience" */
export type Audience_Arr_Rel_Insert_Input = {
  data: Array<Audience_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Audience_On_Conflict>;
};

/** aggregate avg on columns */
export type Audience_Avg_Fields = {
  __typename?: 'audience_avg_fields';
  addressable_reach?: Maybe<Scalars['Float']['output']>;
  estimated_reach?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "audience" */
export type Audience_Avg_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "audience". All fields are combined with a logical 'AND'. */
export type Audience_Bool_Exp = {
  _and?: InputMaybe<Array<Audience_Bool_Exp>>;
  _not?: InputMaybe<Audience_Bool_Exp>;
  _or?: InputMaybe<Array<Audience_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  addressable_reach?: InputMaybe<Int_Comparison_Exp>;
  audience_segments?: InputMaybe<Audience_Segment_Bool_Exp>;
  audience_segments_aggregate?: InputMaybe<Audience_Segment_Aggregate_Bool_Exp>;
  bq_reach_table?: InputMaybe<String_Comparison_Exp>;
  bq_table?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_with?: InputMaybe<String_Comparison_Exp>;
  data_source?: InputMaybe<String_Comparison_Exp>;
  definition?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  direct_audience_provider?: InputMaybe<String_Comparison_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  error_code?: InputMaybe<String_Comparison_Exp>;
  estimated_expiry_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  estimated_reach?: InputMaybe<Int_Comparison_Exp>;
  expired_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  export_targets?: InputMaybe<Jsonb_Comparison_Exp>;
  export_type?: InputMaybe<String_Comparison_Exp>;
  exports?: InputMaybe<Export_Bool_Exp>;
  exports_aggregate?: InputMaybe<Export_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info?: InputMaybe<Jsonb_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_multi_partner?: InputMaybe<Boolean_Comparison_Exp>;
  job_id?: InputMaybe<String_Comparison_Exp>;
  last_export?: InputMaybe<Export_Bool_Exp>;
  last_export_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_uds_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  normalized_definition?: InputMaybe<Jsonb_Comparison_Exp>;
  pricing?: InputMaybe<Jsonb_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  reach?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  report_status?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "audience" */
export const Audience_Constraint = {
  /** unique or primary key constraint on columns "name", "account_id" */
  AudienceAccountIdNameKey: 'audience_account_id_name_key',
  /** unique or primary key constraint on columns "id" */
  AudiencePkey: 'audience_pkey'
} as const;

export type Audience_Constraint = typeof Audience_Constraint[keyof typeof Audience_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Audience_Delete_At_Path_Input = {
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Array<Scalars['String']['input']>>;
  error?: InputMaybe<Array<Scalars['String']['input']>>;
  export_targets?: InputMaybe<Array<Scalars['String']['input']>>;
  info?: InputMaybe<Array<Scalars['String']['input']>>;
  normalized_definition?: InputMaybe<Array<Scalars['String']['input']>>;
  pricing?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Audience_Delete_Elem_Input = {
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Scalars['Int']['input']>;
  error?: InputMaybe<Scalars['Int']['input']>;
  export_targets?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['Int']['input']>;
  normalized_definition?: InputMaybe<Scalars['Int']['input']>;
  pricing?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Audience_Delete_Key_Input = {
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  export_targets?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  normalized_definition?: InputMaybe<Scalars['String']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "audience" */
export type Audience_Inc_Input = {
  addressable_reach?: InputMaybe<Scalars['Int']['input']>;
  estimated_reach?: InputMaybe<Scalars['Int']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "audience" */
export type Audience_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  addressable_reach?: InputMaybe<Scalars['Int']['input']>;
  audience_segments?: InputMaybe<Audience_Segment_Arr_Rel_Insert_Input>;
  bq_reach_table?: InputMaybe<Scalars['String']['input']>;
  bq_table?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  data_source?: InputMaybe<Scalars['String']['input']>;
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direct_audience_provider?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  error_code?: InputMaybe<Scalars['String']['input']>;
  estimated_reach?: InputMaybe<Scalars['Int']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type?: InputMaybe<Scalars['String']['input']>;
  exports?: InputMaybe<Export_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_multi_partner?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['String']['input']>;
  last_export?: InputMaybe<Export_Obj_Rel_Insert_Input>;
  last_export_id?: InputMaybe<Scalars['uuid']['input']>;
  last_uds_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalized_definition?: InputMaybe<Scalars['jsonb']['input']>;
  pricing?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  report_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Audience_Max_Fields = {
  __typename?: 'audience_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  addressable_reach?: Maybe<Scalars['Int']['output']>;
  bq_reach_table?: Maybe<Scalars['String']['output']>;
  bq_table?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  created_with?: Maybe<Scalars['String']['output']>;
  data_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direct_audience_provider?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  estimated_reach?: Maybe<Scalars['Int']['output']>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  last_export_id?: Maybe<Scalars['uuid']['output']>;
  last_uds_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  report_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "audience" */
export type Audience_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  addressable_reach?: InputMaybe<Order_By>;
  bq_reach_table?: InputMaybe<Order_By>;
  bq_table?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  created_with?: InputMaybe<Order_By>;
  data_source?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direct_audience_provider?: InputMaybe<Order_By>;
  error_code?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  last_export_id?: InputMaybe<Order_By>;
  last_uds_timestamp?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Audience_Min_Fields = {
  __typename?: 'audience_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  addressable_reach?: Maybe<Scalars['Int']['output']>;
  bq_reach_table?: Maybe<Scalars['String']['output']>;
  bq_table?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  created_with?: Maybe<Scalars['String']['output']>;
  data_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direct_audience_provider?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  estimated_reach?: Maybe<Scalars['Int']['output']>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  last_export_id?: Maybe<Scalars['uuid']['output']>;
  last_uds_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  report_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "audience" */
export type Audience_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  addressable_reach?: InputMaybe<Order_By>;
  bq_reach_table?: InputMaybe<Order_By>;
  bq_table?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  created_with?: InputMaybe<Order_By>;
  data_source?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direct_audience_provider?: InputMaybe<Order_By>;
  error_code?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  last_export_id?: InputMaybe<Order_By>;
  last_uds_timestamp?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "audience" */
export type Audience_Mutation_Response = {
  __typename?: 'audience_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Audience>;
};

/** input type for inserting object relation for remote table "audience" */
export type Audience_Obj_Rel_Insert_Input = {
  data: Audience_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Audience_On_Conflict>;
};

/** on_conflict condition type for table "audience" */
export type Audience_On_Conflict = {
  constraint: Audience_Constraint;
  update_columns?: Array<Audience_Update_Column>;
  where?: InputMaybe<Audience_Bool_Exp>;
};

/** Ordering options when selecting data from "audience". */
export type Audience_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  addressable_reach?: InputMaybe<Order_By>;
  audience_segments_aggregate?: InputMaybe<Audience_Segment_Aggregate_Order_By>;
  bq_reach_table?: InputMaybe<Order_By>;
  bq_table?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  created_with?: InputMaybe<Order_By>;
  data_source?: InputMaybe<Order_By>;
  definition?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direct_audience_provider?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  error_code?: InputMaybe<Order_By>;
  estimated_expiry_date?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  expired_date?: InputMaybe<Order_By>;
  export_targets?: InputMaybe<Order_By>;
  export_type?: InputMaybe<Order_By>;
  exports_aggregate?: InputMaybe<Export_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_multi_partner?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  last_export?: InputMaybe<Export_Order_By>;
  last_export_id?: InputMaybe<Order_By>;
  last_uds_timestamp?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  normalized_definition?: InputMaybe<Order_By>;
  pricing?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  reach?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audience */
export type Audience_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Audience_Prepend_Input = {
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  normalized_definition?: InputMaybe<Scalars['jsonb']['input']>;
  pricing?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

export type Audience_Reach = {
  __typename?: 'audience_reach';
  Cookies_With_Requests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  Mobile_Devices_With_Requests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  Tablet_Devices_With_Requests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  Unique_ConnectedTVDeviceIDs_With_Requests?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
};

/** columns and relationships of "audience_segment" */
export type Audience_Segment = {
  __typename?: 'audience_segment';
  /** An object relationship */
  audience: Audience;
  audience_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  segment: Segment;
  segment_id: Scalars['uuid']['output'];
};

/** aggregated selection of "audience_segment" */
export type Audience_Segment_Aggregate = {
  __typename?: 'audience_segment_aggregate';
  aggregate?: Maybe<Audience_Segment_Aggregate_Fields>;
  nodes: Array<Audience_Segment>;
};

export type Audience_Segment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Audience_Segment_Aggregate_Bool_Exp_Count>;
};

export type Audience_Segment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Audience_Segment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "audience_segment" */
export type Audience_Segment_Aggregate_Fields = {
  __typename?: 'audience_segment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Audience_Segment_Max_Fields>;
  min?: Maybe<Audience_Segment_Min_Fields>;
};


/** aggregate fields of "audience_segment" */
export type Audience_Segment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "audience_segment" */
export type Audience_Segment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Audience_Segment_Max_Order_By>;
  min?: InputMaybe<Audience_Segment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "audience_segment" */
export type Audience_Segment_Arr_Rel_Insert_Input = {
  data: Array<Audience_Segment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Audience_Segment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "audience_segment". All fields are combined with a logical 'AND'. */
export type Audience_Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Audience_Segment_Bool_Exp>>;
  _not?: InputMaybe<Audience_Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Audience_Segment_Bool_Exp>>;
  audience?: InputMaybe<Audience_Bool_Exp>;
  audience_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  segment_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "audience_segment" */
export const Audience_Segment_Constraint = {
  /** unique or primary key constraint on columns "segment_id", "audience_id" */
  AudienceSegmentAudienceIdSegmentIdKey: 'audience_segment_audience_id_segment_id_key',
  /** unique or primary key constraint on columns "id" */
  AudienceSegmentPkey: 'audience_segment_pkey'
} as const;

export type Audience_Segment_Constraint = typeof Audience_Segment_Constraint[keyof typeof Audience_Segment_Constraint];
/** input type for inserting data into table "audience_segment" */
export type Audience_Segment_Insert_Input = {
  audience?: InputMaybe<Audience_Obj_Rel_Insert_Input>;
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segment?: InputMaybe<Segment_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Audience_Segment_Max_Fields = {
  __typename?: 'audience_segment_max_fields';
  audience_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "audience_segment" */
export type Audience_Segment_Max_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Audience_Segment_Min_Fields = {
  __typename?: 'audience_segment_min_fields';
  audience_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "audience_segment" */
export type Audience_Segment_Min_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "audience_segment" */
export type Audience_Segment_Mutation_Response = {
  __typename?: 'audience_segment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Audience_Segment>;
};

/** on_conflict condition type for table "audience_segment" */
export type Audience_Segment_On_Conflict = {
  constraint: Audience_Segment_Constraint;
  update_columns?: Array<Audience_Segment_Update_Column>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};

/** Ordering options when selecting data from "audience_segment". */
export type Audience_Segment_Order_By = {
  audience?: InputMaybe<Audience_Order_By>;
  audience_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audience_segment */
export type Audience_Segment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "audience_segment" */
export const Audience_Segment_Select_Column = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Id: 'id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Audience_Segment_Select_Column = typeof Audience_Segment_Select_Column[keyof typeof Audience_Segment_Select_Column];
/** input type for updating data in table "audience_segment" */
export type Audience_Segment_Set_Input = {
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "audience_segment" */
export type Audience_Segment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audience_Segment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audience_Segment_Stream_Cursor_Value_Input = {
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "audience_segment" */
export const Audience_Segment_Update_Column = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Id: 'id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Audience_Segment_Update_Column = typeof Audience_Segment_Update_Column[keyof typeof Audience_Segment_Update_Column];
export type Audience_Segment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Audience_Segment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Audience_Segment_Bool_Exp;
};

/** select columns of table "audience" */
export const Audience_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AddressableReach: 'addressable_reach',
  /** column name */
  BqReachTable: 'bq_reach_table',
  /** column name */
  BqTable: 'bq_table',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  CreatedWith: 'created_with',
  /** column name */
  DataSource: 'data_source',
  /** column name */
  Definition: 'definition',
  /** column name */
  Description: 'description',
  /** column name */
  DirectAudienceProvider: 'direct_audience_provider',
  /** column name */
  Error: 'error',
  /** column name */
  ErrorCode: 'error_code',
  /** column name */
  EstimatedReach: 'estimated_reach',
  /** column name */
  ExportTargets: 'export_targets',
  /** column name */
  ExportType: 'export_type',
  /** column name */
  Id: 'id',
  /** column name */
  Info: 'info',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsMultiPartner: 'is_multi_partner',
  /** column name */
  JobId: 'job_id',
  /** column name */
  LastExportId: 'last_export_id',
  /** column name */
  LastUdsTimestamp: 'last_uds_timestamp',
  /** column name */
  Name: 'name',
  /** column name */
  NormalizedDefinition: 'normalized_definition',
  /** column name */
  Pricing: 'pricing',
  /** column name */
  Reach: 'reach',
  /** column name */
  Region: 'region',
  /** column name */
  ReportStatus: 'report_status',
  /** column name */
  Status: 'status',
  /** column name */
  Tags: 'tags',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedDate: 'updated_date',
  /** column name */
  UserId: 'user_id'
} as const;

export type Audience_Select_Column = typeof Audience_Select_Column[keyof typeof Audience_Select_Column];
/** select "audience_aggregate_bool_exp_bool_and_arguments_columns" columns of table "audience" */
export const Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsMultiPartner: 'is_multi_partner'
} as const;

export type Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "audience_aggregate_bool_exp_bool_or_arguments_columns" columns of table "audience" */
export const Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsMultiPartner: 'is_multi_partner'
} as const;

export type Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Audience_Select_Column_Audience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "audience" */
export type Audience_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  addressable_reach?: InputMaybe<Scalars['Int']['input']>;
  bq_reach_table?: InputMaybe<Scalars['String']['input']>;
  bq_table?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  data_source?: InputMaybe<Scalars['String']['input']>;
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direct_audience_provider?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  error_code?: InputMaybe<Scalars['String']['input']>;
  estimated_reach?: InputMaybe<Scalars['Int']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_multi_partner?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['String']['input']>;
  last_export_id?: InputMaybe<Scalars['uuid']['input']>;
  last_uds_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalized_definition?: InputMaybe<Scalars['jsonb']['input']>;
  pricing?: InputMaybe<Scalars['jsonb']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  report_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Audience_Stddev_Fields = {
  __typename?: 'audience_stddev_fields';
  addressable_reach?: Maybe<Scalars['Float']['output']>;
  estimated_reach?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "audience" */
export type Audience_Stddev_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Audience_Stddev_Pop_Fields = {
  __typename?: 'audience_stddev_pop_fields';
  addressable_reach?: Maybe<Scalars['Float']['output']>;
  estimated_reach?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "audience" */
export type Audience_Stddev_Pop_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Audience_Stddev_Samp_Fields = {
  __typename?: 'audience_stddev_samp_fields';
  addressable_reach?: Maybe<Scalars['Float']['output']>;
  estimated_reach?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "audience" */
export type Audience_Stddev_Samp_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "audience" */
export type Audience_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audience_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audience_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  addressable_reach?: InputMaybe<Scalars['Int']['input']>;
  bq_reach_table?: InputMaybe<Scalars['String']['input']>;
  bq_table?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  data_source?: InputMaybe<Scalars['String']['input']>;
  /** complies to the current AST format and the default value passed in from UI */
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direct_audience_provider?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  error_code?: InputMaybe<Scalars['String']['input']>;
  estimated_reach?: InputMaybe<Scalars['Int']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  /** possible values: oa_match_union, passthrough, provider_edge_union applicable only if direct_audience_provider provided */
  export_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_multi_partner?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['String']['input']>;
  last_export_id?: InputMaybe<Scalars['uuid']['input']>;
  last_uds_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalized_definition?: InputMaybe<Scalars['jsonb']['input']>;
  pricing?: InputMaybe<Scalars['jsonb']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  report_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Audience_Sum_Fields = {
  __typename?: 'audience_sum_fields';
  addressable_reach?: Maybe<Scalars['Int']['output']>;
  estimated_reach?: Maybe<Scalars['Int']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "audience" */
export type Audience_Sum_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** update columns of table "audience" */
export const Audience_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AddressableReach: 'addressable_reach',
  /** column name */
  BqReachTable: 'bq_reach_table',
  /** column name */
  BqTable: 'bq_table',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  CreatedWith: 'created_with',
  /** column name */
  DataSource: 'data_source',
  /** column name */
  Definition: 'definition',
  /** column name */
  Description: 'description',
  /** column name */
  DirectAudienceProvider: 'direct_audience_provider',
  /** column name */
  Error: 'error',
  /** column name */
  ErrorCode: 'error_code',
  /** column name */
  EstimatedReach: 'estimated_reach',
  /** column name */
  ExportTargets: 'export_targets',
  /** column name */
  ExportType: 'export_type',
  /** column name */
  Id: 'id',
  /** column name */
  Info: 'info',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsMultiPartner: 'is_multi_partner',
  /** column name */
  JobId: 'job_id',
  /** column name */
  LastExportId: 'last_export_id',
  /** column name */
  LastUdsTimestamp: 'last_uds_timestamp',
  /** column name */
  Name: 'name',
  /** column name */
  NormalizedDefinition: 'normalized_definition',
  /** column name */
  Pricing: 'pricing',
  /** column name */
  Reach: 'reach',
  /** column name */
  Region: 'region',
  /** column name */
  ReportStatus: 'report_status',
  /** column name */
  Status: 'status',
  /** column name */
  Tags: 'tags',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedDate: 'updated_date',
  /** column name */
  UserId: 'user_id'
} as const;

export type Audience_Update_Column = typeof Audience_Update_Column[keyof typeof Audience_Update_Column];
export type Audience_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Audience_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Audience_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Audience_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Audience_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Audience_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Audience_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Audience_Set_Input>;
  /** filter the rows which have to be updated */
  where: Audience_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Audience_Var_Pop_Fields = {
  __typename?: 'audience_var_pop_fields';
  addressable_reach?: Maybe<Scalars['Float']['output']>;
  estimated_reach?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "audience" */
export type Audience_Var_Pop_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Audience_Var_Samp_Fields = {
  __typename?: 'audience_var_samp_fields';
  addressable_reach?: Maybe<Scalars['Float']['output']>;
  estimated_reach?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "audience" */
export type Audience_Var_Samp_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Audience_Variance_Fields = {
  __typename?: 'audience_variance_fields';
  addressable_reach?: Maybe<Scalars['Float']['output']>;
  estimated_reach?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "audience" */
export type Audience_Variance_Order_By = {
  addressable_reach?: InputMaybe<Order_By>;
  estimated_reach?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Describes any resource that we have involving BQ tables to indicate their location */
export type Bq_Resource = {
  __typename?: 'bq_resource';
  bq_location: Scalars['String']['output'];
  created_date: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  partition_date: Scalars['timestamptz']['output'];
  type: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
};

/** aggregated selection of "bq_resource" */
export type Bq_Resource_Aggregate = {
  __typename?: 'bq_resource_aggregate';
  aggregate?: Maybe<Bq_Resource_Aggregate_Fields>;
  nodes: Array<Bq_Resource>;
};

/** aggregate fields of "bq_resource" */
export type Bq_Resource_Aggregate_Fields = {
  __typename?: 'bq_resource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bq_Resource_Max_Fields>;
  min?: Maybe<Bq_Resource_Min_Fields>;
};


/** aggregate fields of "bq_resource" */
export type Bq_Resource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bq_Resource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bq_resource". All fields are combined with a logical 'AND'. */
export type Bq_Resource_Bool_Exp = {
  _and?: InputMaybe<Array<Bq_Resource_Bool_Exp>>;
  _not?: InputMaybe<Bq_Resource_Bool_Exp>;
  _or?: InputMaybe<Array<Bq_Resource_Bool_Exp>>;
  bq_location?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partition_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "bq_resource" */
export const Bq_Resource_Constraint = {
  /** unique or primary key constraint on columns "name", "type" */
  BqResourceNameTypeKey: 'bq_resource_name_type_key',
  /** unique or primary key constraint on columns "id" */
  BqResourcePkey: 'bq_resource_pkey'
} as const;

export type Bq_Resource_Constraint = typeof Bq_Resource_Constraint[keyof typeof Bq_Resource_Constraint];
/** input type for inserting data into table "bq_resource" */
export type Bq_Resource_Insert_Input = {
  bq_location?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partition_date?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Bq_Resource_Max_Fields = {
  __typename?: 'bq_resource_max_fields';
  bq_location?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partition_date?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Bq_Resource_Min_Fields = {
  __typename?: 'bq_resource_min_fields';
  bq_location?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partition_date?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "bq_resource" */
export type Bq_Resource_Mutation_Response = {
  __typename?: 'bq_resource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bq_Resource>;
};

/** on_conflict condition type for table "bq_resource" */
export type Bq_Resource_On_Conflict = {
  constraint: Bq_Resource_Constraint;
  update_columns?: Array<Bq_Resource_Update_Column>;
  where?: InputMaybe<Bq_Resource_Bool_Exp>;
};

/** Ordering options when selecting data from "bq_resource". */
export type Bq_Resource_Order_By = {
  bq_location?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partition_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bq_resource */
export type Bq_Resource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "bq_resource" */
export const Bq_Resource_Select_Column = {
  /** column name */
  BqLocation: 'bq_location',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PartitionDate: 'partition_date',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Bq_Resource_Select_Column = typeof Bq_Resource_Select_Column[keyof typeof Bq_Resource_Select_Column];
/** input type for updating data in table "bq_resource" */
export type Bq_Resource_Set_Input = {
  bq_location?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partition_date?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "bq_resource" */
export type Bq_Resource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bq_Resource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bq_Resource_Stream_Cursor_Value_Input = {
  bq_location?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partition_date?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "bq_resource" */
export const Bq_Resource_Update_Column = {
  /** column name */
  BqLocation: 'bq_location',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PartitionDate: 'partition_date',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Bq_Resource_Update_Column = typeof Bq_Resource_Update_Column[keyof typeof Bq_Resource_Update_Column];
export type Bq_Resource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bq_Resource_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bq_Resource_Bool_Exp;
};

export type CalculateOrfInput = {
  normalized_definition: NormalizedDefinitionInput;
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentMetrics: Array<CalculateOrfSegmentMetricsInput>;
};

export type CalculateOrfSegmentMetricsInput = {
  activeIPs?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  avgCPM?: InputMaybe<Scalars['numeric']['input']>;
  clickThroughRate?: InputMaybe<Scalars['numeric']['input']>;
  cookies?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  costPerUniqueReach?: InputMaybe<Scalars['numeric']['input']>;
  devicesDesktop?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  devicesMobile?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  devicesTV?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  id: Scalars['ID']['input'];
  maxCPM?: InputMaybe<Scalars['numeric']['input']>;
  minCPM?: InputMaybe<Scalars['numeric']['input']>;
  reach?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  relevance?: InputMaybe<Scalars['numeric']['input']>;
  requests?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  videoCompletions?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  videoStarts?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  weightedBidCpm?: InputMaybe<Scalars['numeric']['input']>;
  weightedClicks?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  weightedImpressionsWithClickMacro?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
};

export type CancelDealInsightsJobResponse = {
  __typename?: 'cancelDealInsightsJobResponse';
  job_id: Scalars['String']['output'];
};

/** International Audience Targeting: country */
export type Country = {
  __typename?: 'country';
  code: Scalars['String']['output'];
  /** An array relationship */
  countries: Array<Segment_Country>;
  /** An aggregate relationship */
  countries_aggregate: Segment_Country_Aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  region: Region;
  region_code: Scalars['String']['output'];
};


/** International Audience Targeting: country */
export type CountryCountriesArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


/** International Audience Targeting: country */
export type CountryCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};

/** aggregated selection of "country" */
export type Country_Aggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<Country_Aggregate_Fields>;
  nodes: Array<Country>;
};

export type Country_Aggregate_Bool_Exp = {
  count?: InputMaybe<Country_Aggregate_Bool_Exp_Count>;
};

export type Country_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Country_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "country" */
export type Country_Aggregate_Fields = {
  __typename?: 'country_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Country_Max_Fields>;
  min?: Maybe<Country_Min_Fields>;
};


/** aggregate fields of "country" */
export type Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "country" */
export type Country_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Country_Max_Order_By>;
  min?: InputMaybe<Country_Min_Order_By>;
};

/** input type for inserting array relation for remote table "country" */
export type Country_Arr_Rel_Insert_Input = {
  data: Array<Country_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Country_On_Conflict>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Bool_Exp>>;
  _not?: InputMaybe<Country_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  countries?: InputMaybe<Segment_Country_Bool_Exp>;
  countries_aggregate?: InputMaybe<Segment_Country_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "country" */
export const Country_Constraint = {
  /** unique or primary key constraint on columns "code" */
  CountryPkey: 'country_pkey'
} as const;

export type Country_Constraint = typeof Country_Constraint[keyof typeof Country_Constraint];
/** input type for inserting data into table "country" */
export type Country_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Segment_Country_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  region_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Country_Max_Fields = {
  __typename?: 'country_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region_code?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "country" */
export type Country_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_code?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Country_Min_Fields = {
  __typename?: 'country_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region_code?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "country" */
export type Country_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_code?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "country" */
export type Country_Mutation_Response = {
  __typename?: 'country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** input type for inserting object relation for remote table "country" */
export type Country_Obj_Rel_Insert_Input = {
  data: Country_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Country_On_Conflict>;
};

/** on_conflict condition type for table "country" */
export type Country_On_Conflict = {
  constraint: Country_Constraint;
  update_columns?: Array<Country_Update_Column>;
  where?: InputMaybe<Country_Bool_Exp>;
};

/** Ordering options when selecting data from "country". */
export type Country_Order_By = {
  code?: InputMaybe<Order_By>;
  countries_aggregate?: InputMaybe<Segment_Country_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  region?: InputMaybe<Region_Order_By>;
  region_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: country */
export type Country_Pk_Columns_Input = {
  code: Scalars['String']['input'];
};

/** select columns of table "country" */
export const Country_Select_Column = {
  /** column name */
  Code: 'code',
  /** column name */
  Name: 'name',
  /** column name */
  RegionCode: 'region_code'
} as const;

export type Country_Select_Column = typeof Country_Select_Column[keyof typeof Country_Select_Column];
/** input type for updating data in table "country" */
export type Country_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region_code?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "country" */
export type Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region_code?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "country" */
export const Country_Update_Column = {
  /** column name */
  Code: 'code',
  /** column name */
  Name: 'name',
  /** column name */
  RegionCode: 'region_code'
} as const;

export type Country_Update_Column = typeof Country_Update_Column[keyof typeof Country_Update_Column];
export type Country_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Bool_Exp;
};

export type CreateDealInsightsJobResponse = {
  __typename?: 'createDealInsightsJobResponse';
  job_id: Scalars['String']['output'];
};

export type CreateDealTroubleshootingJobResponse = {
  __typename?: 'createDealTroubleshootingJobResponse';
  job_id?: Maybe<Scalars['String']['output']>;
};

/** ordering argument of a cursor */
export const Cursor_Ordering = {
  /** ascending ordering of the cursor */
  Asc: 'ASC',
  /** descending ordering of the cursor */
  Desc: 'DESC'
} as const;

export type Cursor_Ordering = typeof Cursor_Ordering[keyof typeof Cursor_Ordering];
export const DateResolutionEnum = {
  Daily: 'daily',
  Monthly: 'monthly',
  Weekly: 'weekly'
} as const;

export type DateResolutionEnum = typeof DateResolutionEnum[keyof typeof DateResolutionEnum];
/** columns and relationships of "deal" */
export type Deal = {
  __typename?: 'deal';
  /** An object relationship */
  _package?: Maybe<Hasura_Package>;
  /** An object relationship */
  account?: Maybe<Account>;
  account_id: Scalars['uuid']['output'];
  /** A computed field, executes function "deal_created_date" */
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "deal_created_with" */
  created_with?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "deal_end_date" */
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['jsonb']['output']>;
  exchange_deal?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "deal_deal_id" */
  exchange_deal_id?: Maybe<Scalars['String']['output']>;
  exchange_deal_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package_id?: Maybe<Scalars['String']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "deal_modified_date" */
  modified_date?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "deal_name" */
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "deal_start_date" */
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "deal" */
export type DealErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "deal" */
export type DealExchange_DealArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type DealInsightsChartsInput = {
  audiences?: InputMaybe<DealInsightsTableInput>;
  bidrate_winrate?: InputMaybe<DealInsightsDateResolutionInput>;
  deal_stats?: InputMaybe<DealInsightsTableInput>;
  delivery_by_ad_duration?: InputMaybe<Scalars['Boolean']['input']>;
  delivery_by_ad_size?: InputMaybe<DealInsightsTableInput>;
  delivery_by_domain_bundle?: InputMaybe<DealInsightsTableInput>;
  general_stats?: InputMaybe<Scalars['Boolean']['input']>;
  geolocation?: InputMaybe<Scalars['Boolean']['input']>;
  inventory_distributions?: InputMaybe<Scalars['Boolean']['input']>;
  overview?: InputMaybe<Scalars['Boolean']['input']>;
  spend?: InputMaybe<DealInsightsDateResolutionInput>;
};

export type DealInsightsDataOutput = {
  __typename?: 'dealInsightsDataOutput';
  audiences?: Maybe<Scalars['ExchangeJSON']['output']>;
  bidrate_winrate?: Maybe<Array<Maybe<Scalars['ExchangeJSON']['output']>>>;
  data_available_until?: Maybe<Scalars['String']['output']>;
  deal_stats?: Maybe<Scalars['ExchangeJSON']['output']>;
  delivery_by_ad_duration?: Maybe<Scalars['ExchangeJSON']['output']>;
  delivery_by_ad_size?: Maybe<Scalars['ExchangeJSON']['output']>;
  delivery_by_domain_bundle?: Maybe<Scalars['ExchangeJSON']['output']>;
  general_stats_with_previous_period?: Maybe<Scalars['ExchangeJSON']['output']>;
  geolocation?: Maybe<Scalars['ExchangeJSON']['output']>;
  inventory_distributions?: Maybe<Scalars['ExchangeJSON']['output']>;
  overview?: Maybe<Scalars['ExchangeJSON']['output']>;
  spend?: Maybe<Array<Maybe<Scalars['ExchangeJSON']['output']>>>;
};

export type DealInsightsDateResolutionInput = {
  date_resolution?: InputMaybe<DateResolutionEnum>;
  include: Scalars['Boolean']['input'];
};

export type DealInsightsFilterOptionsResponse = {
  __typename?: 'dealInsightsFilterOptionsResponse';
  ad_duration?: Maybe<Array<Maybe<FilterEntry>>>;
  adsize?: Maybe<Array<Maybe<FilterEntry>>>;
  buyer_name?: Maybe<Array<Maybe<FilterEntry>>>;
  channel?: Maybe<Array<Maybe<FilterEntry>>>;
  deal?: Maybe<Array<Maybe<DealEntry>>>;
  domain_bundle?: Maybe<Array<Maybe<FilterEntry>>>;
  dsp_name?: Maybe<Array<Maybe<FilterEntry>>>;
  media_subtype?: Maybe<Array<Maybe<FilterEntry>>>;
  pub_name?: Maybe<Array<Maybe<FilterEntry>>>;
  type_name?: Maybe<Array<Maybe<FilterEntry>>>;
};

export type DealInsightsOutput = {
  __typename?: 'dealInsightsOutput';
  job_id: Scalars['String']['output'];
  output?: Maybe<DealInsightsDataOutput>;
  status: Scalars['String']['output'];
};

export type DealInsightsTableInput = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort_field: Scalars['String']['input'];
  sort_order?: InputMaybe<SortOrderEnum>;
};

/** Response for `dealPromptBundlesSearch`. */
export type DealPromptBundlesSearchResult = {
  __typename?: 'dealPromptBundlesSearchResult';
  /** The filters that were ultimately applied to the search. */
  filtersApplied: DealPromptSearchFiltersApplied;
  /** List of matching bundles sorted by `relevance` in descending order. */
  results: Array<DealPromptBundlesSearchResultItem>;
  resultsKey?: Maybe<Scalars['String']['output']>;
  /** Total number of matching bundles found (may exceed `results` length, which is capped by configuration). */
  totalResults: Scalars['Int']['output'];
};

/** A single bundle result returned by `dealPromptBundlesSearch`. */
export type DealPromptBundlesSearchResultItem = {
  __typename?: 'dealPromptBundlesSearchResultItem';
  /** Average bid CPM in USD. */
  avgBidCpm?: Maybe<Scalars['Float']['output']>;
  /** Average OpenX exchange win rate (0-1). */
  avgOxWinRate?: Maybe<Scalars['Float']['output']>;
  /** Average publisher win rate (0-1). */
  avgPubWinRate?: Maybe<Scalars['Float']['output']>;
  /** Average viewability across the lookback window (percentage). */
  avgViewability?: Maybe<Scalars['Float']['output']>;
  /** The bundle ID (e.g. `com.example.app`). */
  bundleId: Scalars['String']['output'];
  /** Platform the bundle runs on (e.g. `"ios"`, `"android"`). */
  platform?: Maybe<Scalars['String']['output']>;
  /** Relevance score (0-100, higher = better match). */
  relevance?: Maybe<Scalars['Float']['output']>;
  /** Total bid spend in USD. */
  totalBidSpendInUsd?: Maybe<Scalars['Float']['output']>;
  /** Total Curated Private Marketplace requests served. */
  totalCprMarketRequests?: Maybe<Scalars['Float']['output']>;
  /** Total impressions served. */
  totalImpressions?: Maybe<Scalars['Float']['output']>;
};

/** A single domain result returned by `dealPromptDomainsSearch`. */
export type DealPromptDomainSearchResultItem = {
  __typename?: 'dealPromptDomainSearchResultItem';
  /** Average bid CPM in USD. */
  avgBidCpm?: Maybe<Scalars['Float']['output']>;
  /** Average OpenX exchange win rate (0-1). */
  avgOxWinRate?: Maybe<Scalars['Float']['output']>;
  /** Average publisher win rate (0-1). */
  avgPubWinRate?: Maybe<Scalars['Float']['output']>;
  /** Average viewability across the lookback window (percentage). */
  avgViewability?: Maybe<Scalars['Float']['output']>;
  /** The fully qualified domain name. */
  domainName: Scalars['String']['output'];
  /** Relevance score (0-100, higher = better match). */
  relevance?: Maybe<Scalars['Float']['output']>;
  /** Total bid spend in USD. */
  totalBidSpendInUsd?: Maybe<Scalars['Float']['output']>;
  /** Total Curated Private Marketplace requests served. */
  totalCprMarketRequests?: Maybe<Scalars['Float']['output']>;
  /** Total impressions served. */
  totalImpressions?: Maybe<Scalars['Float']['output']>;
};

/** Filters effectively applied to the search (user input takes precedence over AI suggestions). */
export type DealPromptSearchFiltersApplied = {
  __typename?: 'dealPromptSearchFiltersApplied';
  /** Device types applied to the search. */
  deviceType: Array<Scalars['String']['output']>;
  /** ISO country codes applied to the search. */
  geography: Array<Scalars['String']['output']>;
  /** Media subtypes / ad formats applied to the search. */
  mediaSubtype: Array<Scalars['String']['output']>;
};

/**
 * Optional inventory filters for `dealPromptDomainsSearch`. When a list is non-empty
 * the user-provided values take precedence over the AI-suggested ones; otherwise
 * AI suggestions are used as a fallback.
 */
export type DealPromptSearchFiltersInput = {
  /**
   * Device types to include, e.g. `["desktop"]`.
   * Allowed values: `"phone"`, `"mobile/tablet"`, `"tablet"`, `"desktop"`,
   * `"set-top-box"`, `"connected tv"`.
   */
  deviceType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO country codes to include, e.g. `["US", "PL"]`. */
  geography?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Media subtypes / ad formats to include, e.g. `["Video"]`.
   * Allowed values: `"Display"`, `"Video"`, `"Native"`.
   */
  mediaSubtype?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for `dealPromptDomainsSearch`. A simplified, prompt-based domains discovery input. */
export type DealPromptSearchInput = {
  /** Optional user-provided filters merged with AI-suggested filters. */
  filters?: InputMaybe<DealPromptSearchFiltersInput>;
  /** Free-text prompt describing the inventory the user is looking for. */
  query: Scalars['String']['input'];
};

/** Response for `dealPromptDomainsSearch`. */
export type DealPromptSearchResult = {
  __typename?: 'dealPromptSearchResult';
  /** The filters that were ultimately applied to the search. */
  filtersApplied: DealPromptSearchFiltersApplied;
  /** List of matching domains sorted by `relevance` in descending order. */
  results: Array<DealPromptDomainSearchResultItem>;
  resultsKey?: Maybe<Scalars['String']['output']>;
  /** Total number of matching domains returned; equals the length of `results` (the underlying search is capped by configuration). */
  totalResults: Scalars['Int']['output'];
};

export type DealTroubleshootingDataOutput = {
  __typename?: 'dealTroubleshootingDataOutput';
  bid_responses?: Maybe<Scalars['BigInt']['output']>;
  cpm?: Maybe<Scalars['Float']['output']>;
  ctr?: Maybe<Scalars['Float']['output']>;
  eligible_bid_requests?: Maybe<Scalars['BigInt']['output']>;
  fills?: Maybe<Scalars['BigInt']['output']>;
  health_score?: Maybe<Scalars['Float']['output']>;
  impressions?: Maybe<Scalars['BigInt']['output']>;
  last_updated?: Maybe<Scalars['String']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
  targeted_bid_requests?: Maybe<Scalars['BigInt']['output']>;
  third_party_revenue?: Maybe<Scalars['Float']['output']>;
  time_series_stats?: Maybe<Array<Maybe<TroubleshootingChartsOutput>>>;
  upshot_codes?: Maybe<Scalars['ExchangeJSON']['output']>;
  viewability?: Maybe<Scalars['Float']['output']>;
  vtr?: Maybe<Scalars['Float']['output']>;
};

export type DealTroubleshootingOutput = {
  __typename?: 'dealTroubleshootingOutput';
  job_id: Scalars['String']['output'];
  output?: Maybe<DealTroubleshootingDataOutput>;
  status: Scalars['String']['output'];
};

export const DealTroubleshootingTimeResolutionEnum = {
  Daily: 'daily',
  Hourly: 'hourly'
} as const;

export type DealTroubleshootingTimeResolutionEnum = typeof DealTroubleshootingTimeResolutionEnum[keyof typeof DealTroubleshootingTimeResolutionEnum];
/** aggregated selection of "deal" */
export type Deal_Aggregate = {
  __typename?: 'deal_aggregate';
  aggregate?: Maybe<Deal_Aggregate_Fields>;
  nodes: Array<Deal>;
};

export type Deal_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Deal_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Deal_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Deal_Aggregate_Bool_Exp_Count>;
};

export type Deal_Aggregate_Bool_Exp_Bool_And = {
  arguments: Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Deal_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Deal_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Deal_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Deal_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Deal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Deal_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "deal" */
export type Deal_Aggregate_Fields = {
  __typename?: 'deal_aggregate_fields';
  avg?: Maybe<Deal_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Deal_Max_Fields>;
  min?: Maybe<Deal_Min_Fields>;
  stddev?: Maybe<Deal_Stddev_Fields>;
  stddev_pop?: Maybe<Deal_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Deal_Stddev_Samp_Fields>;
  sum?: Maybe<Deal_Sum_Fields>;
  var_pop?: Maybe<Deal_Var_Pop_Fields>;
  var_samp?: Maybe<Deal_Var_Samp_Fields>;
  variance?: Maybe<Deal_Variance_Fields>;
};


/** aggregate fields of "deal" */
export type Deal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "deal" */
export type Deal_Aggregate_Order_By = {
  avg?: InputMaybe<Deal_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Deal_Max_Order_By>;
  min?: InputMaybe<Deal_Min_Order_By>;
  stddev?: InputMaybe<Deal_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Deal_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Deal_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Deal_Sum_Order_By>;
  var_pop?: InputMaybe<Deal_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Deal_Var_Samp_Order_By>;
  variance?: InputMaybe<Deal_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Deal_Append_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "deal" */
export type Deal_Arr_Rel_Insert_Input = {
  data: Array<Deal_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Deal_On_Conflict>;
};

/** aggregate avg on columns */
export type Deal_Avg_Fields = {
  __typename?: 'deal_avg_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "deal" */
export type Deal_Avg_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "deal". All fields are combined with a logical 'AND'. */
export type Deal_Bool_Exp = {
  _and?: InputMaybe<Array<Deal_Bool_Exp>>;
  _not?: InputMaybe<Deal_Bool_Exp>;
  _or?: InputMaybe<Array<Deal_Bool_Exp>>;
  _package?: InputMaybe<Hasura_Package_Bool_Exp>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_with?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  exchange_deal?: InputMaybe<Jsonb_Comparison_Exp>;
  exchange_deal_id?: InputMaybe<String_Comparison_Exp>;
  exchange_deal_revision_applied?: InputMaybe<Int_Comparison_Exp>;
  exchange_id?: InputMaybe<String_Comparison_Exp>;
  exchange_package_id?: InputMaybe<String_Comparison_Exp>;
  exchange_package_revision_applied?: InputMaybe<Int_Comparison_Exp>;
  exchange_package_uid?: InputMaybe<String_Comparison_Exp>;
  exchange_uid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "deal" */
export const Deal_Constraint = {
  /** unique or primary key constraint on columns "id" */
  DealPkey: 'deal_pkey'
} as const;

export type Deal_Constraint = typeof Deal_Constraint[keyof typeof Deal_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Deal_Delete_At_Path_Input = {
  error?: InputMaybe<Array<Scalars['String']['input']>>;
  exchange_deal?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Deal_Delete_Elem_Input = {
  error?: InputMaybe<Scalars['Int']['input']>;
  exchange_deal?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Deal_Delete_Key_Input = {
  error?: InputMaybe<Scalars['String']['input']>;
  exchange_deal?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "deal" */
export type Deal_Inc_Input = {
  exchange_deal_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_package_revision_applied?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "deal" */
export type Deal_Insert_Input = {
  _package?: InputMaybe<Hasura_Package_Obj_Rel_Insert_Input>;
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_package_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_uid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Deal_Max_Fields = {
  __typename?: 'deal_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  exchange_deal_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package_id?: Maybe<Scalars['String']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "deal" */
export type Deal_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_id?: InputMaybe<Order_By>;
  exchange_package_id?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
  exchange_package_uid?: InputMaybe<Order_By>;
  exchange_uid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Deal_Min_Fields = {
  __typename?: 'deal_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  exchange_deal_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package_id?: Maybe<Scalars['String']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "deal" */
export type Deal_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_id?: InputMaybe<Order_By>;
  exchange_package_id?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
  exchange_package_uid?: InputMaybe<Order_By>;
  exchange_uid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "deal" */
export type Deal_Mutation_Response = {
  __typename?: 'deal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Deal>;
};

/** on_conflict condition type for table "deal" */
export type Deal_On_Conflict = {
  constraint: Deal_Constraint;
  update_columns?: Array<Deal_Update_Column>;
  where?: InputMaybe<Deal_Bool_Exp>;
};

/** Ordering options when selecting data from "deal". */
export type Deal_Order_By = {
  _package?: InputMaybe<Hasura_Package_Order_By>;
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  created_with?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  exchange_deal?: InputMaybe<Order_By>;
  exchange_deal_id?: InputMaybe<Order_By>;
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_id?: InputMaybe<Order_By>;
  exchange_package_id?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
  exchange_package_uid?: InputMaybe<Order_By>;
  exchange_uid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  modified_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "deal_package" */
export type Deal_Package = {
  __typename?: 'deal_package';
  /** An object relationship */
  _package?: Maybe<Hasura_Package>;
  /** An object relationship */
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  created_with?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['jsonb']['output']>;
  exchange_deal?: Maybe<Scalars['jsonb']['output']>;
  exchange_deal_id?: Maybe<Scalars['String']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package_id?: Maybe<Scalars['String']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  modified_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "deal_package" */
export type Deal_PackageErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "deal_package" */
export type Deal_PackageExchange_DealArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "deal_package" */
export type Deal_Package_Aggregate = {
  __typename?: 'deal_package_aggregate';
  aggregate?: Maybe<Deal_Package_Aggregate_Fields>;
  nodes: Array<Deal_Package>;
};

/** aggregate fields of "deal_package" */
export type Deal_Package_Aggregate_Fields = {
  __typename?: 'deal_package_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Deal_Package_Max_Fields>;
  min?: Maybe<Deal_Package_Min_Fields>;
};


/** aggregate fields of "deal_package" */
export type Deal_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deal_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Deal_Package_Append_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "deal_package". All fields are combined with a logical 'AND'. */
export type Deal_Package_Bool_Exp = {
  _and?: InputMaybe<Array<Deal_Package_Bool_Exp>>;
  _not?: InputMaybe<Deal_Package_Bool_Exp>;
  _or?: InputMaybe<Array<Deal_Package_Bool_Exp>>;
  _package?: InputMaybe<Hasura_Package_Bool_Exp>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_with?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  exchange_deal?: InputMaybe<Jsonb_Comparison_Exp>;
  exchange_deal_id?: InputMaybe<String_Comparison_Exp>;
  exchange_id?: InputMaybe<String_Comparison_Exp>;
  exchange_package_id?: InputMaybe<String_Comparison_Exp>;
  exchange_package_uid?: InputMaybe<String_Comparison_Exp>;
  exchange_uid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Deal_Package_Delete_At_Path_Input = {
  error?: InputMaybe<Array<Scalars['String']['input']>>;
  exchange_deal?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Deal_Package_Delete_Elem_Input = {
  error?: InputMaybe<Scalars['Int']['input']>;
  exchange_deal?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Deal_Package_Delete_Key_Input = {
  error?: InputMaybe<Scalars['String']['input']>;
  exchange_deal?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "deal_package" */
export type Deal_Package_Insert_Input = {
  _package?: InputMaybe<Hasura_Package_Obj_Rel_Insert_Input>;
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal_id?: InputMaybe<Scalars['String']['input']>;
  exchange_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_uid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  modified_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Deal_Package_Max_Fields = {
  __typename?: 'deal_package_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  created_with?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  exchange_deal_id?: Maybe<Scalars['String']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package_id?: Maybe<Scalars['String']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  modified_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Deal_Package_Min_Fields = {
  __typename?: 'deal_package_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  created_with?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  exchange_deal_id?: Maybe<Scalars['String']['output']>;
  exchange_id?: Maybe<Scalars['String']['output']>;
  exchange_package_id?: Maybe<Scalars['String']['output']>;
  exchange_package_uid?: Maybe<Scalars['String']['output']>;
  exchange_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  modified_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "deal_package" */
export type Deal_Package_Mutation_Response = {
  __typename?: 'deal_package_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Deal_Package>;
};

/** Ordering options when selecting data from "deal_package". */
export type Deal_Package_Order_By = {
  _package?: InputMaybe<Hasura_Package_Order_By>;
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  created_with?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  exchange_deal?: InputMaybe<Order_By>;
  exchange_deal_id?: InputMaybe<Order_By>;
  exchange_id?: InputMaybe<Order_By>;
  exchange_package_id?: InputMaybe<Order_By>;
  exchange_package_uid?: InputMaybe<Order_By>;
  exchange_uid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  modified_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Deal_Package_Prepend_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "deal_package" */
export const Deal_Package_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  CreatedWith: 'created_with',
  /** column name */
  EndDate: 'end_date',
  /** column name */
  Error: 'error',
  /** column name */
  ExchangeDeal: 'exchange_deal',
  /** column name */
  ExchangeDealId: 'exchange_deal_id',
  /** column name */
  ExchangeId: 'exchange_id',
  /** column name */
  ExchangePackageId: 'exchange_package_id',
  /** column name */
  ExchangePackageUid: 'exchange_package_uid',
  /** column name */
  ExchangeUid: 'exchange_uid',
  /** column name */
  Id: 'id',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  ModifiedDate: 'modified_date',
  /** column name */
  Name: 'name',
  /** column name */
  StartDate: 'start_date',
  /** column name */
  Status: 'status',
  /** column name */
  UserId: 'user_id'
} as const;

export type Deal_Package_Select_Column = typeof Deal_Package_Select_Column[keyof typeof Deal_Package_Select_Column];
/** input type for updating data in table "deal_package" */
export type Deal_Package_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal_id?: InputMaybe<Scalars['String']['input']>;
  exchange_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_uid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  modified_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "deal_package" */
export type Deal_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deal_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Deal_Package_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  created_with?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal_id?: InputMaybe<Scalars['String']['input']>;
  exchange_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_uid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  modified_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Deal_Package_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Deal_Package_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Deal_Package_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Deal_Package_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Deal_Package_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Deal_Package_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Deal_Package_Set_Input>;
  /** filter the rows which have to be updated */
  where: Deal_Package_Bool_Exp;
};

/** primary key columns input for table: deal */
export type Deal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Deal_Prepend_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "deal" */
export const Deal_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  Error: 'error',
  /** column name */
  ExchangeDeal: 'exchange_deal',
  /** column name */
  ExchangeDealRevisionApplied: 'exchange_deal_revision_applied',
  /** column name */
  ExchangeId: 'exchange_id',
  /** column name */
  ExchangePackageId: 'exchange_package_id',
  /** column name */
  ExchangePackageRevisionApplied: 'exchange_package_revision_applied',
  /** column name */
  ExchangePackageUid: 'exchange_package_uid',
  /** column name */
  ExchangeUid: 'exchange_uid',
  /** column name */
  Id: 'id',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  Status: 'status',
  /** column name */
  UserId: 'user_id'
} as const;

export type Deal_Select_Column = typeof Deal_Select_Column[keyof typeof Deal_Select_Column];
/** select "deal_aggregate_bool_exp_bool_and_arguments_columns" columns of table "deal" */
export const Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived'
} as const;

export type Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "deal_aggregate_bool_exp_bool_or_arguments_columns" columns of table "deal" */
export const Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived'
} as const;

export type Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Deal_Select_Column_Deal_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "deal" */
export type Deal_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_package_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_uid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Deal_Stddev_Fields = {
  __typename?: 'deal_stddev_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "deal" */
export type Deal_Stddev_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Deal_Stddev_Pop_Fields = {
  __typename?: 'deal_stddev_pop_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "deal" */
export type Deal_Stddev_Pop_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Deal_Stddev_Samp_Fields = {
  __typename?: 'deal_stddev_samp_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "deal" */
export type Deal_Stddev_Samp_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "deal" */
export type Deal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Deal_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal?: InputMaybe<Scalars['jsonb']['input']>;
  exchange_deal_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_id?: InputMaybe<Scalars['String']['input']>;
  exchange_package_revision_applied?: InputMaybe<Scalars['Int']['input']>;
  exchange_package_uid?: InputMaybe<Scalars['String']['input']>;
  exchange_uid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Deal_Sum_Fields = {
  __typename?: 'deal_sum_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Int']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "deal" */
export type Deal_Sum_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** update columns of table "deal" */
export const Deal_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  Error: 'error',
  /** column name */
  ExchangeDeal: 'exchange_deal',
  /** column name */
  ExchangeDealRevisionApplied: 'exchange_deal_revision_applied',
  /** column name */
  ExchangeId: 'exchange_id',
  /** column name */
  ExchangePackageId: 'exchange_package_id',
  /** column name */
  ExchangePackageRevisionApplied: 'exchange_package_revision_applied',
  /** column name */
  ExchangePackageUid: 'exchange_package_uid',
  /** column name */
  ExchangeUid: 'exchange_uid',
  /** column name */
  Id: 'id',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  Status: 'status',
  /** column name */
  UserId: 'user_id'
} as const;

export type Deal_Update_Column = typeof Deal_Update_Column[keyof typeof Deal_Update_Column];
export type Deal_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Deal_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Deal_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Deal_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Deal_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Deal_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Deal_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Deal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Deal_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Deal_Var_Pop_Fields = {
  __typename?: 'deal_var_pop_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "deal" */
export type Deal_Var_Pop_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Deal_Var_Samp_Fields = {
  __typename?: 'deal_var_samp_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "deal" */
export type Deal_Var_Samp_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Deal_Variance_Fields = {
  __typename?: 'deal_variance_fields';
  exchange_deal_revision_applied?: Maybe<Scalars['Float']['output']>;
  exchange_package_revision_applied?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "deal" */
export type Deal_Variance_Order_By = {
  exchange_deal_revision_applied?: InputMaybe<Order_By>;
  exchange_package_revision_applied?: InputMaybe<Order_By>;
};

/** Describes the export of an audience to other customers */
export type Export = {
  __typename?: 'export';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid']['output'];
  account_name?: Maybe<Scalars['String']['output']>;
  account_resource_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  audience: Audience;
  audience_id: Scalars['uuid']['output'];
  bq_job_id?: Maybe<Scalars['String']['output']>;
  bq_resource_id?: Maybe<Scalars['uuid']['output']>;
  bq_table: Scalars['String']['output'];
  bucket: Scalars['String']['output'];
  created_date: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  direct_audience_provider?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['jsonb']['output']>;
  export_id_types: Scalars['jsonb']['output'];
  /** An array relationship */
  export_status_timelines: Array<Export_Status_Timeline>;
  /** An aggregate relationship */
  export_status_timelines_aggregate: Export_Status_Timeline_Aggregate;
  export_targets?: Maybe<Scalars['jsonb']['output']>;
  export_type?: Maybe<Scalars['String']['output']>;
  file_path: Scalars['String']['output'];
  gcs_destination_uri_prefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  info?: Maybe<Scalars['jsonb']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oauid_bq_table?: Maybe<Scalars['jsonb']['output']>;
  source_bq_table?: Maybe<Scalars['jsonb']['output']>;
  status: Scalars['String']['output'];
  uds_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  updated_date: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


/** Describes the export of an audience to other customers */
export type ExportErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Describes the export of an audience to other customers */
export type ExportExport_Id_TypesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Describes the export of an audience to other customers */
export type ExportExport_Status_TimelinesArgs = {
  distinct_on?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Status_Timeline_Order_By>>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};


/** Describes the export of an audience to other customers */
export type ExportExport_Status_Timelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Status_Timeline_Order_By>>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};


/** Describes the export of an audience to other customers */
export type ExportExport_TargetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Describes the export of an audience to other customers */
export type ExportInfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Describes the export of an audience to other customers */
export type ExportOauid_Bq_TableArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Describes the export of an audience to other customers */
export type ExportSource_Bq_TableArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "export" */
export type Export_Aggregate = {
  __typename?: 'export_aggregate';
  aggregate?: Maybe<Export_Aggregate_Fields>;
  nodes: Array<Export>;
};

export type Export_Aggregate_Bool_Exp = {
  count?: InputMaybe<Export_Aggregate_Bool_Exp_Count>;
};

export type Export_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Export_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Export_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "export" */
export type Export_Aggregate_Fields = {
  __typename?: 'export_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Export_Max_Fields>;
  min?: Maybe<Export_Min_Fields>;
};


/** aggregate fields of "export" */
export type Export_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Export_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "export" */
export type Export_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Export_Max_Order_By>;
  min?: InputMaybe<Export_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Export_Append_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  export_id_types?: InputMaybe<Scalars['jsonb']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  oauid_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  source_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "export" */
export type Export_Arr_Rel_Insert_Input = {
  data: Array<Export_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Export_On_Conflict>;
};

export type Export_Audience_Config_Input = {
  export_id_types?: InputMaybe<Scalars['JSON']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "export". All fields are combined with a logical 'AND'. */
export type Export_Bool_Exp = {
  _and?: InputMaybe<Array<Export_Bool_Exp>>;
  _not?: InputMaybe<Export_Bool_Exp>;
  _or?: InputMaybe<Array<Export_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  account_resource_id?: InputMaybe<String_Comparison_Exp>;
  audience?: InputMaybe<Audience_Bool_Exp>;
  audience_id?: InputMaybe<Uuid_Comparison_Exp>;
  bq_job_id?: InputMaybe<String_Comparison_Exp>;
  bq_resource_id?: InputMaybe<Uuid_Comparison_Exp>;
  bq_table?: InputMaybe<String_Comparison_Exp>;
  bucket?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  direct_audience_provider?: InputMaybe<String_Comparison_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  export_id_types?: InputMaybe<Jsonb_Comparison_Exp>;
  export_status_timelines?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
  export_status_timelines_aggregate?: InputMaybe<Export_Status_Timeline_Aggregate_Bool_Exp>;
  export_targets?: InputMaybe<Jsonb_Comparison_Exp>;
  export_type?: InputMaybe<String_Comparison_Exp>;
  file_path?: InputMaybe<String_Comparison_Exp>;
  gcs_destination_uri_prefix?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oauid_bq_table?: InputMaybe<Jsonb_Comparison_Exp>;
  source_bq_table?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  uds_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_name?: InputMaybe<String_Comparison_Exp>;
};

export type Export_Bulk_Audience_Config_Input = {
  audienceId?: InputMaybe<Scalars['String']['input']>;
  export_id_types?: InputMaybe<Scalars['JSON']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** unique or primary key constraints on table "export" */
export const Export_Constraint = {
  /** unique or primary key constraint on columns "id" */
  ExportPkey: 'export_pkey'
} as const;

export type Export_Constraint = typeof Export_Constraint[keyof typeof Export_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Export_Delete_At_Path_Input = {
  error?: InputMaybe<Array<Scalars['String']['input']>>;
  export_id_types?: InputMaybe<Array<Scalars['String']['input']>>;
  export_targets?: InputMaybe<Array<Scalars['String']['input']>>;
  info?: InputMaybe<Array<Scalars['String']['input']>>;
  oauid_bq_table?: InputMaybe<Array<Scalars['String']['input']>>;
  source_bq_table?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Export_Delete_Elem_Input = {
  error?: InputMaybe<Scalars['Int']['input']>;
  export_id_types?: InputMaybe<Scalars['Int']['input']>;
  export_targets?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['Int']['input']>;
  oauid_bq_table?: InputMaybe<Scalars['Int']['input']>;
  source_bq_table?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Export_Delete_Key_Input = {
  error?: InputMaybe<Scalars['String']['input']>;
  export_id_types?: InputMaybe<Scalars['String']['input']>;
  export_targets?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  oauid_bq_table?: InputMaybe<Scalars['String']['input']>;
  source_bq_table?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "export" */
export type Export_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_resource_id?: InputMaybe<Scalars['String']['input']>;
  audience?: InputMaybe<Audience_Obj_Rel_Insert_Input>;
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  bq_job_id?: InputMaybe<Scalars['String']['input']>;
  bq_resource_id?: InputMaybe<Scalars['uuid']['input']>;
  bq_table?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direct_audience_provider?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  export_id_types?: InputMaybe<Scalars['jsonb']['input']>;
  export_status_timelines?: InputMaybe<Export_Status_Timeline_Arr_Rel_Insert_Input>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  export_type?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  gcs_destination_uri_prefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oauid_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  source_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uds_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Export_Max_Fields = {
  __typename?: 'export_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  account_resource_id?: Maybe<Scalars['String']['output']>;
  audience_id?: Maybe<Scalars['uuid']['output']>;
  bq_job_id?: Maybe<Scalars['String']['output']>;
  bq_resource_id?: Maybe<Scalars['uuid']['output']>;
  bq_table?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direct_audience_provider?: Maybe<Scalars['String']['output']>;
  export_type?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  gcs_destination_uri_prefix?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uds_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "export" */
export type Export_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  account_resource_id?: InputMaybe<Order_By>;
  audience_id?: InputMaybe<Order_By>;
  bq_job_id?: InputMaybe<Order_By>;
  bq_resource_id?: InputMaybe<Order_By>;
  bq_table?: InputMaybe<Order_By>;
  bucket?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direct_audience_provider?: InputMaybe<Order_By>;
  export_type?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  gcs_destination_uri_prefix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uds_timestamp?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Export_Min_Fields = {
  __typename?: 'export_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  account_resource_id?: Maybe<Scalars['String']['output']>;
  audience_id?: Maybe<Scalars['uuid']['output']>;
  bq_job_id?: Maybe<Scalars['String']['output']>;
  bq_resource_id?: Maybe<Scalars['uuid']['output']>;
  bq_table?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direct_audience_provider?: Maybe<Scalars['String']['output']>;
  export_type?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  gcs_destination_uri_prefix?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uds_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "export" */
export type Export_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  account_resource_id?: InputMaybe<Order_By>;
  audience_id?: InputMaybe<Order_By>;
  bq_job_id?: InputMaybe<Order_By>;
  bq_resource_id?: InputMaybe<Order_By>;
  bq_table?: InputMaybe<Order_By>;
  bucket?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direct_audience_provider?: InputMaybe<Order_By>;
  export_type?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  gcs_destination_uri_prefix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uds_timestamp?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "export" */
export type Export_Mutation_Response = {
  __typename?: 'export_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Export>;
};

/** input type for inserting object relation for remote table "export" */
export type Export_Obj_Rel_Insert_Input = {
  data: Export_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Export_On_Conflict>;
};

/** on_conflict condition type for table "export" */
export type Export_On_Conflict = {
  constraint: Export_Constraint;
  update_columns?: Array<Export_Update_Column>;
  where?: InputMaybe<Export_Bool_Exp>;
};

/** Ordering options when selecting data from "export". */
export type Export_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  account_resource_id?: InputMaybe<Order_By>;
  audience?: InputMaybe<Audience_Order_By>;
  audience_id?: InputMaybe<Order_By>;
  bq_job_id?: InputMaybe<Order_By>;
  bq_resource_id?: InputMaybe<Order_By>;
  bq_table?: InputMaybe<Order_By>;
  bucket?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direct_audience_provider?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  export_id_types?: InputMaybe<Order_By>;
  export_status_timelines_aggregate?: InputMaybe<Export_Status_Timeline_Aggregate_Order_By>;
  export_targets?: InputMaybe<Order_By>;
  export_type?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  gcs_destination_uri_prefix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oauid_bq_table?: InputMaybe<Order_By>;
  source_bq_table?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uds_timestamp?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: export */
export type Export_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Export_Prepend_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
  export_id_types?: InputMaybe<Scalars['jsonb']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  oauid_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  source_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "export" */
export const Export_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AccountName: 'account_name',
  /** column name */
  AccountResourceId: 'account_resource_id',
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  BqJobId: 'bq_job_id',
  /** column name */
  BqResourceId: 'bq_resource_id',
  /** column name */
  BqTable: 'bq_table',
  /** column name */
  Bucket: 'bucket',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Description: 'description',
  /** column name */
  DirectAudienceProvider: 'direct_audience_provider',
  /** column name */
  Error: 'error',
  /** column name */
  ExportIdTypes: 'export_id_types',
  /** column name */
  ExportTargets: 'export_targets',
  /** column name */
  ExportType: 'export_type',
  /** column name */
  FilePath: 'file_path',
  /** column name */
  GcsDestinationUriPrefix: 'gcs_destination_uri_prefix',
  /** column name */
  Id: 'id',
  /** column name */
  Info: 'info',
  /** column name */
  Name: 'name',
  /** column name */
  OauidBqTable: 'oauid_bq_table',
  /** column name */
  SourceBqTable: 'source_bq_table',
  /** column name */
  Status: 'status',
  /** column name */
  UdsTimestamp: 'uds_timestamp',
  /** column name */
  UpdatedDate: 'updated_date',
  /** column name */
  UserId: 'user_id',
  /** column name */
  UserName: 'user_name'
} as const;

export type Export_Select_Column = typeof Export_Select_Column[keyof typeof Export_Select_Column];
/** input type for updating data in table "export" */
export type Export_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_resource_id?: InputMaybe<Scalars['String']['input']>;
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  bq_job_id?: InputMaybe<Scalars['String']['input']>;
  bq_resource_id?: InputMaybe<Scalars['uuid']['input']>;
  bq_table?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direct_audience_provider?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  export_id_types?: InputMaybe<Scalars['jsonb']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  export_type?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  gcs_destination_uri_prefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oauid_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  source_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uds_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "export_status_timeline" */
export type Export_Status_Timeline = {
  __typename?: 'export_status_timeline';
  /** An object relationship */
  export: Export;
  export_id: Scalars['uuid']['output'];
  export_status: Scalars['String']['output'];
  export_timestamp: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "export_status_timeline" */
export type Export_Status_Timeline_Aggregate = {
  __typename?: 'export_status_timeline_aggregate';
  aggregate?: Maybe<Export_Status_Timeline_Aggregate_Fields>;
  nodes: Array<Export_Status_Timeline>;
};

export type Export_Status_Timeline_Aggregate_Bool_Exp = {
  count?: InputMaybe<Export_Status_Timeline_Aggregate_Bool_Exp_Count>;
};

export type Export_Status_Timeline_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "export_status_timeline" */
export type Export_Status_Timeline_Aggregate_Fields = {
  __typename?: 'export_status_timeline_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Export_Status_Timeline_Max_Fields>;
  min?: Maybe<Export_Status_Timeline_Min_Fields>;
};


/** aggregate fields of "export_status_timeline" */
export type Export_Status_Timeline_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "export_status_timeline" */
export type Export_Status_Timeline_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Export_Status_Timeline_Max_Order_By>;
  min?: InputMaybe<Export_Status_Timeline_Min_Order_By>;
};

/** input type for inserting array relation for remote table "export_status_timeline" */
export type Export_Status_Timeline_Arr_Rel_Insert_Input = {
  data: Array<Export_Status_Timeline_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Export_Status_Timeline_On_Conflict>;
};

/** Boolean expression to filter rows from the table "export_status_timeline". All fields are combined with a logical 'AND'. */
export type Export_Status_Timeline_Bool_Exp = {
  _and?: InputMaybe<Array<Export_Status_Timeline_Bool_Exp>>;
  _not?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
  _or?: InputMaybe<Array<Export_Status_Timeline_Bool_Exp>>;
  export?: InputMaybe<Export_Bool_Exp>;
  export_id?: InputMaybe<Uuid_Comparison_Exp>;
  export_status?: InputMaybe<String_Comparison_Exp>;
  export_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "export_status_timeline" */
export const Export_Status_Timeline_Constraint = {
  /** unique or primary key constraint on columns "id" */
  ExportStatusTimelinePkey: 'export_status_timeline_pkey'
} as const;

export type Export_Status_Timeline_Constraint = typeof Export_Status_Timeline_Constraint[keyof typeof Export_Status_Timeline_Constraint];
/** input type for inserting data into table "export_status_timeline" */
export type Export_Status_Timeline_Insert_Input = {
  export?: InputMaybe<Export_Obj_Rel_Insert_Input>;
  export_id?: InputMaybe<Scalars['uuid']['input']>;
  export_status?: InputMaybe<Scalars['String']['input']>;
  export_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Export_Status_Timeline_Max_Fields = {
  __typename?: 'export_status_timeline_max_fields';
  export_id?: Maybe<Scalars['uuid']['output']>;
  export_status?: Maybe<Scalars['String']['output']>;
  export_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "export_status_timeline" */
export type Export_Status_Timeline_Max_Order_By = {
  export_id?: InputMaybe<Order_By>;
  export_status?: InputMaybe<Order_By>;
  export_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Export_Status_Timeline_Min_Fields = {
  __typename?: 'export_status_timeline_min_fields';
  export_id?: Maybe<Scalars['uuid']['output']>;
  export_status?: Maybe<Scalars['String']['output']>;
  export_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "export_status_timeline" */
export type Export_Status_Timeline_Min_Order_By = {
  export_id?: InputMaybe<Order_By>;
  export_status?: InputMaybe<Order_By>;
  export_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "export_status_timeline" */
export type Export_Status_Timeline_Mutation_Response = {
  __typename?: 'export_status_timeline_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Export_Status_Timeline>;
};

/** on_conflict condition type for table "export_status_timeline" */
export type Export_Status_Timeline_On_Conflict = {
  constraint: Export_Status_Timeline_Constraint;
  update_columns?: Array<Export_Status_Timeline_Update_Column>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};

/** Ordering options when selecting data from "export_status_timeline". */
export type Export_Status_Timeline_Order_By = {
  export?: InputMaybe<Export_Order_By>;
  export_id?: InputMaybe<Order_By>;
  export_status?: InputMaybe<Order_By>;
  export_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: export_status_timeline */
export type Export_Status_Timeline_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "export_status_timeline" */
export const Export_Status_Timeline_Select_Column = {
  /** column name */
  ExportId: 'export_id',
  /** column name */
  ExportStatus: 'export_status',
  /** column name */
  ExportTimestamp: 'export_timestamp',
  /** column name */
  Id: 'id'
} as const;

export type Export_Status_Timeline_Select_Column = typeof Export_Status_Timeline_Select_Column[keyof typeof Export_Status_Timeline_Select_Column];
/** input type for updating data in table "export_status_timeline" */
export type Export_Status_Timeline_Set_Input = {
  export_id?: InputMaybe<Scalars['uuid']['input']>;
  export_status?: InputMaybe<Scalars['String']['input']>;
  export_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "export_status_timeline" */
export type Export_Status_Timeline_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Export_Status_Timeline_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Export_Status_Timeline_Stream_Cursor_Value_Input = {
  export_id?: InputMaybe<Scalars['uuid']['input']>;
  export_status?: InputMaybe<Scalars['String']['input']>;
  export_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "export_status_timeline" */
export const Export_Status_Timeline_Update_Column = {
  /** column name */
  ExportId: 'export_id',
  /** column name */
  ExportStatus: 'export_status',
  /** column name */
  ExportTimestamp: 'export_timestamp',
  /** column name */
  Id: 'id'
} as const;

export type Export_Status_Timeline_Update_Column = typeof Export_Status_Timeline_Update_Column[keyof typeof Export_Status_Timeline_Update_Column];
export type Export_Status_Timeline_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Export_Status_Timeline_Set_Input>;
  /** filter the rows which have to be updated */
  where: Export_Status_Timeline_Bool_Exp;
};

/** Streaming cursor of the table "export" */
export type Export_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Export_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Export_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_resource_id?: InputMaybe<Scalars['String']['input']>;
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  bq_job_id?: InputMaybe<Scalars['String']['input']>;
  bq_resource_id?: InputMaybe<Scalars['uuid']['input']>;
  bq_table?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direct_audience_provider?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  export_id_types?: InputMaybe<Scalars['jsonb']['input']>;
  export_targets?: InputMaybe<Scalars['jsonb']['input']>;
  export_type?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  gcs_destination_uri_prefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oauid_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  source_bq_table?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uds_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "export" */
export const Export_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AccountName: 'account_name',
  /** column name */
  AccountResourceId: 'account_resource_id',
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  BqJobId: 'bq_job_id',
  /** column name */
  BqResourceId: 'bq_resource_id',
  /** column name */
  BqTable: 'bq_table',
  /** column name */
  Bucket: 'bucket',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Description: 'description',
  /** column name */
  DirectAudienceProvider: 'direct_audience_provider',
  /** column name */
  Error: 'error',
  /** column name */
  ExportIdTypes: 'export_id_types',
  /** column name */
  ExportTargets: 'export_targets',
  /** column name */
  ExportType: 'export_type',
  /** column name */
  FilePath: 'file_path',
  /** column name */
  GcsDestinationUriPrefix: 'gcs_destination_uri_prefix',
  /** column name */
  Id: 'id',
  /** column name */
  Info: 'info',
  /** column name */
  Name: 'name',
  /** column name */
  OauidBqTable: 'oauid_bq_table',
  /** column name */
  SourceBqTable: 'source_bq_table',
  /** column name */
  Status: 'status',
  /** column name */
  UdsTimestamp: 'uds_timestamp',
  /** column name */
  UpdatedDate: 'updated_date',
  /** column name */
  UserId: 'user_id',
  /** column name */
  UserName: 'user_name'
} as const;

export type Export_Update_Column = typeof Export_Update_Column[keyof typeof Export_Update_Column];
export type Export_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Export_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Export_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Export_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Export_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Export_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Export_Set_Input>;
  /** filter the rows which have to be updated */
  where: Export_Bool_Exp;
};

/** columns and relationships of "feature_flags" */
export type Feature_Flags = {
  __typename?: 'feature_flags';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "feature_flags" */
export type Feature_Flags_Aggregate = {
  __typename?: 'feature_flags_aggregate';
  aggregate?: Maybe<Feature_Flags_Aggregate_Fields>;
  nodes: Array<Feature_Flags>;
};

/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_Fields = {
  __typename?: 'feature_flags_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Feature_Flags_Max_Fields>;
  min?: Maybe<Feature_Flags_Min_Fields>;
};


/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "feature_flags". All fields are combined with a logical 'AND'. */
export type Feature_Flags_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  _not?: InputMaybe<Feature_Flags_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_flags" */
export const Feature_Flags_Constraint = {
  /** unique or primary key constraint on columns "value" */
  FeatureFlagsPkey: 'feature_flags_pkey'
} as const;

export type Feature_Flags_Constraint = typeof Feature_Flags_Constraint[keyof typeof Feature_Flags_Constraint];
export const Feature_Flags_Enum = {
  /** Access to AQUA Bidder Creative, Order, and Line Item APIs */
  AquaApi: 'AQUA_API',
  /** Curated Deal Buyer Discount functionality for partner */
  CuratedDealBuyerDiscount: 'CURATED_DEAL_BUYER_DISCOUNT',
  /** Fee splitting functionality for partner */
  FeeSplittingPartner: 'FEE_SPLITTING_PARTNER'
} as const;

export type Feature_Flags_Enum = typeof Feature_Flags_Enum[keyof typeof Feature_Flags_Enum];
/** Boolean expression to compare columns of type "feature_flags_enum". All fields are combined with logical 'AND'. */
export type Feature_Flags_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Feature_Flags_Enum>;
  _in?: InputMaybe<Array<Feature_Flags_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Feature_Flags_Enum>;
  _nin?: InputMaybe<Array<Feature_Flags_Enum>>;
};

/** input type for inserting data into table "feature_flags" */
export type Feature_Flags_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Feature_Flags_Max_Fields = {
  __typename?: 'feature_flags_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Feature_Flags_Min_Fields = {
  __typename?: 'feature_flags_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "feature_flags" */
export type Feature_Flags_Mutation_Response = {
  __typename?: 'feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Flags>;
};

/** on_conflict condition type for table "feature_flags" */
export type Feature_Flags_On_Conflict = {
  constraint: Feature_Flags_Constraint;
  update_columns?: Array<Feature_Flags_Update_Column>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_flags". */
export type Feature_Flags_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_flags */
export type Feature_Flags_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "feature_flags" */
export const Feature_Flags_Select_Column = {
  /** column name */
  Description: 'description',
  /** column name */
  Value: 'value'
} as const;

export type Feature_Flags_Select_Column = typeof Feature_Flags_Select_Column[keyof typeof Feature_Flags_Select_Column];
/** input type for updating data in table "feature_flags" */
export type Feature_Flags_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "feature_flags" */
export type Feature_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Flags_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "feature_flags" */
export const Feature_Flags_Update_Column = {
  /** column name */
  Description: 'description',
  /** column name */
  Value: 'value'
} as const;

export type Feature_Flags_Update_Column = typeof Feature_Flags_Update_Column[keyof typeof Feature_Flags_Update_Column];
export type Feature_Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Flags_Bool_Exp;
};

/** Cache of package objects from MGMT DB */
export type Hasura_Package = {
  __typename?: 'hasura_package';
  /** An object relationship */
  audience?: Maybe<Audience>;
  audience_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "hasura_package_discounted_cpm" */
  discounted_cpm?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "exchange_account_network_id" */
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** A computed field, executes function "hasura_package_name" */
  name?: Maybe<Scalars['String']['output']>;
  obj: Scalars['jsonb']['output'];
  /** A computed field, executes function "hasura_package_rate_card_cpm" */
  rate_card_cpm?: Maybe<Scalars['numeric']['output']>;
  revision: Scalars['Int']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** Cache of package objects from MGMT DB */
export type Hasura_PackageObjArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "hasura_package" */
export type Hasura_Package_Aggregate = {
  __typename?: 'hasura_package_aggregate';
  aggregate?: Maybe<Hasura_Package_Aggregate_Fields>;
  nodes: Array<Hasura_Package>;
};

/** aggregate fields of "hasura_package" */
export type Hasura_Package_Aggregate_Fields = {
  __typename?: 'hasura_package_aggregate_fields';
  avg?: Maybe<Hasura_Package_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Hasura_Package_Max_Fields>;
  min?: Maybe<Hasura_Package_Min_Fields>;
  stddev?: Maybe<Hasura_Package_Stddev_Fields>;
  stddev_pop?: Maybe<Hasura_Package_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hasura_Package_Stddev_Samp_Fields>;
  sum?: Maybe<Hasura_Package_Sum_Fields>;
  var_pop?: Maybe<Hasura_Package_Var_Pop_Fields>;
  var_samp?: Maybe<Hasura_Package_Var_Samp_Fields>;
  variance?: Maybe<Hasura_Package_Variance_Fields>;
};


/** aggregate fields of "hasura_package" */
export type Hasura_Package_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hasura_Package_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Hasura_Package_Append_Input = {
  obj?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Hasura_Package_Avg_Fields = {
  __typename?: 'hasura_package_avg_fields';
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "hasura_package". All fields are combined with a logical 'AND'. */
export type Hasura_Package_Bool_Exp = {
  _and?: InputMaybe<Array<Hasura_Package_Bool_Exp>>;
  _not?: InputMaybe<Hasura_Package_Bool_Exp>;
  _or?: InputMaybe<Array<Hasura_Package_Bool_Exp>>;
  audience?: InputMaybe<Audience_Bool_Exp>;
  audience_id?: InputMaybe<Uuid_Comparison_Exp>;
  discounted_cpm?: InputMaybe<Numeric_Comparison_Exp>;
  exchange_account_network_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  obj?: InputMaybe<Jsonb_Comparison_Exp>;
  rate_card_cpm?: InputMaybe<Numeric_Comparison_Exp>;
  revision?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "hasura_package" */
export const Hasura_Package_Constraint = {
  /** unique or primary key constraint on columns  */
  PackageIxUid: 'package_ix_uid',
  /** unique or primary key constraint on columns "id" */
  PackagePkey: 'package_pkey'
} as const;

export type Hasura_Package_Constraint = typeof Hasura_Package_Constraint[keyof typeof Hasura_Package_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Hasura_Package_Delete_At_Path_Input = {
  obj?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Hasura_Package_Delete_Elem_Input = {
  obj?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Hasura_Package_Delete_Key_Input = {
  obj?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "hasura_package" */
export type Hasura_Package_Inc_Input = {
  revision?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "hasura_package" */
export type Hasura_Package_Insert_Input = {
  audience?: InputMaybe<Audience_Obj_Rel_Insert_Input>;
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  obj?: InputMaybe<Scalars['jsonb']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "hasura_package_list" */
export type Hasura_Package_List = {
  __typename?: 'hasura_package_list';
  /** An object relationship */
  audience?: Maybe<Audience>;
  audience_id?: Maybe<Scalars['uuid']['output']>;
  deal_uid?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['String']['output']>;
  discounted_cpm?: Maybe<Scalars['numeric']['output']>;
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  exchange_account_network_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_curated?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  obj?: Maybe<Scalars['jsonb']['output']>;
  rate_card_cpm?: Maybe<Scalars['numeric']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "hasura_package_list" */
export type Hasura_Package_ListObjArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "hasura_package_list" */
export type Hasura_Package_List_Aggregate = {
  __typename?: 'hasura_package_list_aggregate';
  aggregate?: Maybe<Hasura_Package_List_Aggregate_Fields>;
  nodes: Array<Hasura_Package_List>;
};

/** aggregate fields of "hasura_package_list" */
export type Hasura_Package_List_Aggregate_Fields = {
  __typename?: 'hasura_package_list_aggregate_fields';
  avg?: Maybe<Hasura_Package_List_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Hasura_Package_List_Max_Fields>;
  min?: Maybe<Hasura_Package_List_Min_Fields>;
  stddev?: Maybe<Hasura_Package_List_Stddev_Fields>;
  stddev_pop?: Maybe<Hasura_Package_List_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hasura_Package_List_Stddev_Samp_Fields>;
  sum?: Maybe<Hasura_Package_List_Sum_Fields>;
  var_pop?: Maybe<Hasura_Package_List_Var_Pop_Fields>;
  var_samp?: Maybe<Hasura_Package_List_Var_Samp_Fields>;
  variance?: Maybe<Hasura_Package_List_Variance_Fields>;
};


/** aggregate fields of "hasura_package_list" */
export type Hasura_Package_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hasura_Package_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Hasura_Package_List_Avg_Fields = {
  __typename?: 'hasura_package_list_avg_fields';
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "hasura_package_list". All fields are combined with a logical 'AND'. */
export type Hasura_Package_List_Bool_Exp = {
  _and?: InputMaybe<Array<Hasura_Package_List_Bool_Exp>>;
  _not?: InputMaybe<Hasura_Package_List_Bool_Exp>;
  _or?: InputMaybe<Array<Hasura_Package_List_Bool_Exp>>;
  audience?: InputMaybe<Audience_Bool_Exp>;
  audience_id?: InputMaybe<Uuid_Comparison_Exp>;
  deal_uid?: InputMaybe<String_Comparison_Exp>;
  deleted?: InputMaybe<String_Comparison_Exp>;
  discounted_cpm?: InputMaybe<Numeric_Comparison_Exp>;
  exchange_account_network_id?: InputMaybe<String_Comparison_Exp>;
  exchange_account_network_uid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_curated?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  obj?: InputMaybe<Jsonb_Comparison_Exp>;
  rate_card_cpm?: InputMaybe<Numeric_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Hasura_Package_List_Max_Fields = {
  __typename?: 'hasura_package_list_max_fields';
  audience_id?: Maybe<Scalars['uuid']['output']>;
  deal_uid?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['String']['output']>;
  discounted_cpm?: Maybe<Scalars['numeric']['output']>;
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  exchange_account_network_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_curated?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate_card_cpm?: Maybe<Scalars['numeric']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Hasura_Package_List_Min_Fields = {
  __typename?: 'hasura_package_list_min_fields';
  audience_id?: Maybe<Scalars['uuid']['output']>;
  deal_uid?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['String']['output']>;
  discounted_cpm?: Maybe<Scalars['numeric']['output']>;
  exchange_account_network_id?: Maybe<Scalars['String']['output']>;
  exchange_account_network_uid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_curated?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate_card_cpm?: Maybe<Scalars['numeric']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "hasura_package_list". */
export type Hasura_Package_List_Order_By = {
  audience?: InputMaybe<Audience_Order_By>;
  audience_id?: InputMaybe<Order_By>;
  deal_uid?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  discounted_cpm?: InputMaybe<Order_By>;
  exchange_account_network_id?: InputMaybe<Order_By>;
  exchange_account_network_uid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_curated?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  obj?: InputMaybe<Order_By>;
  rate_card_cpm?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "hasura_package_list" */
export const Hasura_Package_List_Select_Column = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  DealUid: 'deal_uid',
  /** column name */
  Deleted: 'deleted',
  /** column name */
  DiscountedCpm: 'discounted_cpm',
  /** column name */
  ExchangeAccountNetworkId: 'exchange_account_network_id',
  /** column name */
  ExchangeAccountNetworkUid: 'exchange_account_network_uid',
  /** column name */
  Id: 'id',
  /** column name */
  IsCurated: 'is_curated',
  /** column name */
  Name: 'name',
  /** column name */
  Obj: 'obj',
  /** column name */
  RateCardCpm: 'rate_card_cpm',
  /** column name */
  Uid: 'uid',
  /** column name */
  UserId: 'user_id'
} as const;

export type Hasura_Package_List_Select_Column = typeof Hasura_Package_List_Select_Column[keyof typeof Hasura_Package_List_Select_Column];
/** aggregate stddev on columns */
export type Hasura_Package_List_Stddev_Fields = {
  __typename?: 'hasura_package_list_stddev_fields';
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Hasura_Package_List_Stddev_Pop_Fields = {
  __typename?: 'hasura_package_list_stddev_pop_fields';
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Hasura_Package_List_Stddev_Samp_Fields = {
  __typename?: 'hasura_package_list_stddev_samp_fields';
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "hasura_package_list" */
export type Hasura_Package_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hasura_Package_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hasura_Package_List_Stream_Cursor_Value_Input = {
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  deal_uid?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['String']['input']>;
  discounted_cpm?: InputMaybe<Scalars['numeric']['input']>;
  exchange_account_network_id?: InputMaybe<Scalars['String']['input']>;
  exchange_account_network_uid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_curated?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  obj?: InputMaybe<Scalars['jsonb']['input']>;
  rate_card_cpm?: InputMaybe<Scalars['numeric']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Hasura_Package_List_Sum_Fields = {
  __typename?: 'hasura_package_list_sum_fields';
  discounted_cpm?: Maybe<Scalars['numeric']['output']>;
  rate_card_cpm?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Hasura_Package_List_Var_Pop_Fields = {
  __typename?: 'hasura_package_list_var_pop_fields';
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Hasura_Package_List_Var_Samp_Fields = {
  __typename?: 'hasura_package_list_var_samp_fields';
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Hasura_Package_List_Variance_Fields = {
  __typename?: 'hasura_package_list_variance_fields';
  discounted_cpm?: Maybe<Scalars['Float']['output']>;
  rate_card_cpm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Hasura_Package_Max_Fields = {
  __typename?: 'hasura_package_max_fields';
  audience_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Hasura_Package_Min_Fields = {
  __typename?: 'hasura_package_min_fields';
  audience_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "hasura_package" */
export type Hasura_Package_Mutation_Response = {
  __typename?: 'hasura_package_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Hasura_Package>;
};

/** input type for inserting object relation for remote table "hasura_package" */
export type Hasura_Package_Obj_Rel_Insert_Input = {
  data: Hasura_Package_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Hasura_Package_On_Conflict>;
};

/** on_conflict condition type for table "hasura_package" */
export type Hasura_Package_On_Conflict = {
  constraint: Hasura_Package_Constraint;
  update_columns?: Array<Hasura_Package_Update_Column>;
  where?: InputMaybe<Hasura_Package_Bool_Exp>;
};

/** Ordering options when selecting data from "hasura_package". */
export type Hasura_Package_Order_By = {
  audience?: InputMaybe<Audience_Order_By>;
  audience_id?: InputMaybe<Order_By>;
  discounted_cpm?: InputMaybe<Order_By>;
  exchange_account_network_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  obj?: InputMaybe<Order_By>;
  rate_card_cpm?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hasura_package */
export type Hasura_Package_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Hasura_Package_Prepend_Input = {
  obj?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "hasura_package" */
export const Hasura_Package_Select_Column = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Id: 'id',
  /** column name */
  Obj: 'obj',
  /** column name */
  Revision: 'revision',
  /** column name */
  UserId: 'user_id'
} as const;

export type Hasura_Package_Select_Column = typeof Hasura_Package_Select_Column[keyof typeof Hasura_Package_Select_Column];
/** input type for updating data in table "hasura_package" */
export type Hasura_Package_Set_Input = {
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  obj?: InputMaybe<Scalars['jsonb']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Hasura_Package_Stddev_Fields = {
  __typename?: 'hasura_package_stddev_fields';
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Hasura_Package_Stddev_Pop_Fields = {
  __typename?: 'hasura_package_stddev_pop_fields';
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Hasura_Package_Stddev_Samp_Fields = {
  __typename?: 'hasura_package_stddev_samp_fields';
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "hasura_package" */
export type Hasura_Package_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hasura_Package_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hasura_Package_Stream_Cursor_Value_Input = {
  audience_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  obj?: InputMaybe<Scalars['jsonb']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Hasura_Package_Sum_Fields = {
  __typename?: 'hasura_package_sum_fields';
  revision?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "hasura_package" */
export const Hasura_Package_Update_Column = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Id: 'id',
  /** column name */
  Obj: 'obj',
  /** column name */
  Revision: 'revision',
  /** column name */
  UserId: 'user_id'
} as const;

export type Hasura_Package_Update_Column = typeof Hasura_Package_Update_Column[keyof typeof Hasura_Package_Update_Column];
export type Hasura_Package_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Hasura_Package_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Hasura_Package_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Hasura_Package_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Hasura_Package_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hasura_Package_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Hasura_Package_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hasura_Package_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hasura_Package_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hasura_Package_Var_Pop_Fields = {
  __typename?: 'hasura_package_var_pop_fields';
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Hasura_Package_Var_Samp_Fields = {
  __typename?: 'hasura_package_var_samp_fields';
  revision?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Hasura_Package_Variance_Fields = {
  __typename?: 'hasura_package_variance_fields';
  revision?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

export type InventoryBundleSearchAppFiltersInput = {
  appInfoContentRating: Array<Scalars['String']['input']>;
  category: Array<Scalars['String']['input']>;
  contentRating: Array<Scalars['String']['input']>;
  coppa?: InputMaybe<Scalars['Boolean']['input']>;
  creator: Array<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  developer: Array<Scalars['String']['input']>;
  downloads?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  keywords: Array<Scalars['String']['input']>;
  languages: Array<Scalars['String']['input']>;
  marketSource: Array<Scalars['String']['input']>;
  marketStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  modifiedDateTime?: InputMaybe<Scalars['String']['input']>;
  name: Array<Scalars['String']['input']>;
  origin: Array<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  platform: Array<Scalars['String']['input']>;
  rating?: InputMaybe<Array<Scalars['String']['input']>>;
  ratingCount?: InputMaybe<Scalars['GraphQLUBigInt64']['input']>;
  regions: Array<Scalars['String']['input']>;
  subcategory: Array<Scalars['String']['input']>;
  updateDate?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryBundleSearchFiltersInput = {
  appFilters: InventoryBundleSearchAppFiltersInput;
  cumulativeDataFilters: InventorySearchCumulativeDataFiltersInput;
  domainFilters: InventorySearchDomainFiltersInput;
  excludeBundles: Array<Scalars['String']['input']>;
  includeBundles: Array<Scalars['String']['input']>;
  noOfDays: Scalars['Int']['input'];
  noOfResult: Scalars['Int']['input'];
  performance: InventorySearchPerformanceFilterInput;
  tierDetails: InventorySearchTierDetailsInput;
};

export type InventoryBundleSearchInput = {
  excludeQuery?: InputMaybe<Array<InventorySearchQueryInput>>;
  filters: InventoryBundleSearchFiltersInput;
  query: Array<InventorySearchQueryInput>;
  sortBy: Scalars['String']['input'];
  view: Scalars['String']['input'];
};

export type InventoryBundleSearchResult = {
  __typename?: 'inventoryBundleSearchResult';
  body: InventoryBundleSearchResultBody;
  resultsKey?: Maybe<Scalars['String']['output']>;
};

export type InventoryBundleSearchTextAppFilters = {
  __typename?: 'inventoryBundleSearchTextAppFilters';
  appInfoContentRating?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentRating?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  coppa?: Maybe<Scalars['Boolean']['output']>;
  creator?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  developer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  downloads?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  marketSource?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  marketStatus?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  modifiedDateTime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  origin?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  platform?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rating?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ratingCount?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  regions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updateDate?: Maybe<Scalars['String']['output']>;
};

export type InventoryBundleSearchTextFilters = {
  __typename?: 'inventoryBundleSearchTextFilters';
  appFilters?: Maybe<InventoryBundleSearchTextAppFilters>;
  cumulativeDataFilters?: Maybe<InventorySearchTextCumulativeDataFilters>;
  domainFilters?: Maybe<InventorySearchTextDomainFilters>;
  excludeDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includeDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  noOfDays?: Maybe<Scalars['Int']['output']>;
  noOfResult?: Maybe<Scalars['Int']['output']>;
  performance?: Maybe<InventorySearchTextPerformanceFilter>;
};

export type InventoryBundleSearchTextResult = {
  __typename?: 'inventoryBundleSearchTextResult';
  body: InventoryBundleSearchTextResultBody;
  resultsKey?: Maybe<Scalars['String']['output']>;
};

export type InventoryBundleSearchTextReturnInput = {
  __typename?: 'inventoryBundleSearchTextReturnInput';
  excludeQuery?: Maybe<Array<Maybe<InventorySearchQuery>>>;
  filters?: Maybe<InventoryBundleSearchTextFilters>;
  query?: Maybe<Array<Maybe<InventorySearchQuery>>>;
  sortBy?: Maybe<Scalars['String']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type InventoryBundleSearchTextReturnInputs = {
  __typename?: 'inventoryBundleSearchTextReturnInputs';
  combined: InventoryBundleSearchTextReturnInput;
  user: InventoryBundleSearchTextReturnInput;
  wissp?: Maybe<InventoryBundleSearchTextReturnInput>;
};

export type InventoryDomainFilterOptionsResult = {
  __typename?: 'inventoryDomainFilterOptionsResult';
  body: Scalars['JSON']['output'];
};

export type InventoryDomainSearchCategoryThresholdInput = {
  contentStyleScore: Scalars['Float']['input'];
  iabCategoryScore: Scalars['Float']['input'];
  safetyTierCompositeScore: Scalars['Float']['input'];
};

export type InventoryDomainSearchFiltersInput = {
  cumulativeDataFilters: InventorySearchCumulativeDataFiltersInput;
  domainFilters: InventorySearchDomainFiltersInput;
  excludeDomains: Array<Scalars['String']['input']>;
  includeDomains: Array<Scalars['String']['input']>;
  noOfDays: Scalars['Int']['input'];
  noOfResult: Scalars['Int']['input'];
  performance: InventorySearchPerformanceFilterInput;
  vectorFilters: InventoryDomainSearchVectorFiltersInput;
};

export type InventoryDomainSearchInput = {
  excludeQuery?: InputMaybe<Array<InventorySearchQueryInput>>;
  filters: InventoryDomainSearchFiltersInput;
  query: Array<InventorySearchQueryInput>;
  sortBy: Scalars['String']['input'];
  view: Scalars['String']['input'];
};

export type InventoryDomainSearchResult = {
  __typename?: 'inventoryDomainSearchResult';
  body: InventoryDomainSearchResultBody;
  resultsKey?: Maybe<Scalars['String']['output']>;
};

export type InventoryDomainSearchTextCategoryThreshold = {
  __typename?: 'inventoryDomainSearchTextCategoryThreshold';
  contentStyleScore?: Maybe<Scalars['Float']['output']>;
  iabCategoryScore?: Maybe<Scalars['Float']['output']>;
  safetyTierCompositeScore?: Maybe<Scalars['Float']['output']>;
};

export type InventoryDomainSearchTextFilters = {
  __typename?: 'inventoryDomainSearchTextFilters';
  cumulativeDataFilters?: Maybe<InventorySearchTextCumulativeDataFilters>;
  domainFilters?: Maybe<InventorySearchTextDomainFilters>;
  excludeDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includeDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  noOfDays?: Maybe<Scalars['Int']['output']>;
  noOfResult?: Maybe<Scalars['Int']['output']>;
  performance?: Maybe<InventorySearchTextPerformanceFilter>;
  vectorFilters?: Maybe<InventoryDomainSearchTextVectorFilters>;
};

export type InventoryDomainSearchTextResult = {
  __typename?: 'inventoryDomainSearchTextResult';
  body?: Maybe<InventoryDomainSearchTextResultBody>;
  resultsKey?: Maybe<Scalars['String']['output']>;
};

export type InventoryDomainSearchTextReturnInput = {
  __typename?: 'inventoryDomainSearchTextReturnInput';
  excludeQuery?: Maybe<Array<Maybe<InventorySearchQuery>>>;
  filters?: Maybe<InventoryDomainSearchTextFilters>;
  query?: Maybe<Array<Maybe<InventorySearchQuery>>>;
  sortBy?: Maybe<Scalars['String']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type InventoryDomainSearchTextReturnInputs = {
  __typename?: 'inventoryDomainSearchTextReturnInputs';
  combined: InventoryDomainSearchTextReturnInput;
  user: InventoryDomainSearchTextReturnInput;
  wissp?: Maybe<InventoryDomainSearchTextReturnInput>;
};

export type InventoryDomainSearchTextVectorFilters = {
  __typename?: 'inventoryDomainSearchTextVectorFilters';
  categoryThreshold?: Maybe<InventoryDomainSearchTextCategoryThreshold>;
  contentStyle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  iabCategory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  safetyTier?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tierDetails?: Maybe<InventorySearchTextTierDetails>;
};

export type InventoryDomainSearchVectorFiltersInput = {
  categoryThreshold: InventoryDomainSearchCategoryThresholdInput;
  contentStyle: Array<Scalars['String']['input']>;
  iabCategory: Array<Scalars['String']['input']>;
  safetyTier: Array<Scalars['String']['input']>;
  tierDetails: InventorySearchTierDetailsInput;
};

export type InventorySearchCumulativeDataFiltersInput = {
  marketThreshold: Scalars['GraphQLUBigInt64']['input'];
  performanceData: Scalars['String']['input'];
  reachThreshold: Scalars['GraphQLUBigInt64']['input'];
};

export type InventorySearchDomainFiltersInput = {
  contentStyle: Array<Scalars['String']['input']>;
  deviceType: Array<Scalars['String']['input']>;
  distributionChannel: Array<Scalars['String']['input']>;
  geography: Array<Scalars['String']['input']>;
  isDirect?: InputMaybe<Scalars['Boolean']['input']>;
  mediaSubtype: Array<Scalars['String']['input']>;
  publisher: Array<Scalars['String']['input']>;
  videoPlcmt: Array<Scalars['String']['input']>;
};

export type InventorySearchPerformanceDataFilterInput = {
  filterColumn: Scalars['String']['input'];
  filterThreshold: Scalars['GraphQLUBigInt64']['input'];
};

export type InventorySearchPerformanceFilterInput = {
  minReach: Scalars['Float']['input'];
  minViewability: Scalars['Float']['input'];
  performanceData: Array<InventorySearchPerformanceDataFilterInput>;
};

export type InventorySearchQuery = {
  __typename?: 'inventorySearchQuery';
  query?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

export type InventorySearchQueryInput = {
  query: Scalars['String']['input'];
};

export type InventorySearchTextCumulativeDataFilters = {
  __typename?: 'inventorySearchTextCumulativeDataFilters';
  marketThreshold?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  performanceData?: Maybe<Scalars['String']['output']>;
  reachThreshold?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
};

export type InventorySearchTextDomainFilters = {
  __typename?: 'inventorySearchTextDomainFilters';
  contentStyle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  distributionChannel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  geography?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isDirect?: Maybe<Scalars['Boolean']['output']>;
  mediaSubtype?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publisher?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  videoPlcmt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InventorySearchTextPerformanceDataFilter = {
  __typename?: 'inventorySearchTextPerformanceDataFilter';
  filterColumn?: Maybe<Scalars['String']['output']>;
  filterThreshold?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
};

export type InventorySearchTextPerformanceFilter = {
  __typename?: 'inventorySearchTextPerformanceFilter';
  minReach?: Maybe<Scalars['Float']['output']>;
  minViewability?: Maybe<Scalars['Float']['output']>;
  performanceData?: Maybe<Array<Maybe<InventorySearchTextPerformanceDataFilter>>>;
};

export type InventorySearchTextTierDetails = {
  __typename?: 'inventorySearchTextTierDetails';
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tier?: Maybe<Scalars['Int']['output']>;
};

export type InventorySearchTierDetailsInput = {
  keys: Array<Scalars['String']['input']>;
  tier: Scalars['Int']['input'];
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type LogResponse = {
  __typename?: 'logResponse';
  msg?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_Definition = {
  __typename?: 'lookalike_definition';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid']['output'];
  auc_score?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "determine_available_build_audience" */
  available_build_audience?: Maybe<Scalars['Boolean']['output']>;
  base_segment_bq_location?: Maybe<Scalars['String']['output']>;
  base_segment_reach?: Maybe<Scalars['Int']['output']>;
  created_date: Scalars['timestamptz']['output'];
  /** A computed filed using 'calculate_balanced_reach' */
  derived_balanced_reach?: Maybe<Scalars['Int']['output']>;
  /** A computed field to derive expiration_date from its lookalike `seed_aggregate` segment */
  derived_expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  is_archived: Scalars['Boolean']['output'];
  /** An object relationship */
  last_lookalike_job_run?: Maybe<Lookalike_Job_Run>;
  last_lookalike_job_run_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  lookalike_job_runs: Array<Lookalike_Job_Run>;
  /** An aggregate relationship */
  lookalike_job_runs_aggregate: Lookalike_Job_Run_Aggregate;
  lookalike_name: Scalars['String']['output'];
  /** An array relationship */
  lookalike_seed_sources: Array<Lookalike_Seed_Source>;
  /** An aggregate relationship */
  lookalike_seed_sources_aggregate: Lookalike_Seed_Source_Aggregate;
  lookalike_seeds_aggregate_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lookalike_segment_seed_aggregate?: Maybe<Lookalike_Segment_Seed_Aggregate>;
  /** An array relationship */
  lookalike_segment_similarities: Array<Lookalike_Segment_Similarity>;
  /** An aggregate relationship */
  lookalike_segment_similarities_aggregate: Lookalike_Segment_Similarity_Aggregate;
  /** An object relationship */
  provider: Provider;
  provider_id: Scalars['String']['output'];
  seeds_estimated_reach?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  updated_date: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_DefinitionErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_DefinitionLookalike_Job_RunsArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Job_Run_Order_By>>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};


/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_DefinitionLookalike_Job_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Job_Run_Order_By>>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};


/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_DefinitionLookalike_Seed_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Seed_Source_Order_By>>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};


/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_DefinitionLookalike_Seed_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Seed_Source_Order_By>>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};


/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_DefinitionLookalike_Segment_SimilaritiesArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Similarity_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};


/** 'lookalike_definition' entails the information capturing in lookalike creation process .  It is the parent of 'lookalike_definition_segment' */
export type Lookalike_DefinitionLookalike_Segment_Similarities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Similarity_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};

/** aggregated selection of "lookalike_definition" */
export type Lookalike_Definition_Aggregate = {
  __typename?: 'lookalike_definition_aggregate';
  aggregate?: Maybe<Lookalike_Definition_Aggregate_Fields>;
  nodes: Array<Lookalike_Definition>;
};

export type Lookalike_Definition_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lookalike_Definition_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lookalike_Definition_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lookalike_Definition_Aggregate_Bool_Exp_Count>;
};

export type Lookalike_Definition_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lookalike_Definition_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lookalike_Definition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lookalike_definition" */
export type Lookalike_Definition_Aggregate_Fields = {
  __typename?: 'lookalike_definition_aggregate_fields';
  avg?: Maybe<Lookalike_Definition_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lookalike_Definition_Max_Fields>;
  min?: Maybe<Lookalike_Definition_Min_Fields>;
  stddev?: Maybe<Lookalike_Definition_Stddev_Fields>;
  stddev_pop?: Maybe<Lookalike_Definition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lookalike_Definition_Stddev_Samp_Fields>;
  sum?: Maybe<Lookalike_Definition_Sum_Fields>;
  var_pop?: Maybe<Lookalike_Definition_Var_Pop_Fields>;
  var_samp?: Maybe<Lookalike_Definition_Var_Samp_Fields>;
  variance?: Maybe<Lookalike_Definition_Variance_Fields>;
};


/** aggregate fields of "lookalike_definition" */
export type Lookalike_Definition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lookalike_definition" */
export type Lookalike_Definition_Aggregate_Order_By = {
  avg?: InputMaybe<Lookalike_Definition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lookalike_Definition_Max_Order_By>;
  min?: InputMaybe<Lookalike_Definition_Min_Order_By>;
  stddev?: InputMaybe<Lookalike_Definition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lookalike_Definition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lookalike_Definition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lookalike_Definition_Sum_Order_By>;
  var_pop?: InputMaybe<Lookalike_Definition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lookalike_Definition_Var_Samp_Order_By>;
  variance?: InputMaybe<Lookalike_Definition_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Lookalike_Definition_Append_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "lookalike_definition" */
export type Lookalike_Definition_Arr_Rel_Insert_Input = {
  data: Array<Lookalike_Definition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lookalike_Definition_On_Conflict>;
};

/** aggregate avg on columns */
export type Lookalike_Definition_Avg_Fields = {
  __typename?: 'lookalike_definition_avg_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
  base_segment_reach?: Maybe<Scalars['Float']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Avg_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lookalike_definition". All fields are combined with a logical 'AND'. */
export type Lookalike_Definition_Bool_Exp = {
  _and?: InputMaybe<Array<Lookalike_Definition_Bool_Exp>>;
  _not?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  _or?: InputMaybe<Array<Lookalike_Definition_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  auc_score?: InputMaybe<Numeric_Comparison_Exp>;
  available_build_audience?: InputMaybe<Boolean_Comparison_Exp>;
  base_segment_bq_location?: InputMaybe<String_Comparison_Exp>;
  base_segment_reach?: InputMaybe<Int_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  derived_balanced_reach?: InputMaybe<Int_Comparison_Exp>;
  derived_expiry_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  last_lookalike_job_run?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
  last_lookalike_job_run_id?: InputMaybe<Uuid_Comparison_Exp>;
  lookalike_job_runs?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
  lookalike_job_runs_aggregate?: InputMaybe<Lookalike_Job_Run_Aggregate_Bool_Exp>;
  lookalike_name?: InputMaybe<String_Comparison_Exp>;
  lookalike_seed_sources?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
  lookalike_seed_sources_aggregate?: InputMaybe<Lookalike_Seed_Source_Aggregate_Bool_Exp>;
  lookalike_seeds_aggregate_name?: InputMaybe<String_Comparison_Exp>;
  lookalike_segment_seed_aggregate?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
  lookalike_segment_similarities?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
  lookalike_segment_similarities_aggregate?: InputMaybe<Lookalike_Segment_Similarity_Aggregate_Bool_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  seeds_estimated_reach?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lookalike_definition" */
export const Lookalike_Definition_Constraint = {
  /** unique or primary key constraint on columns "lookalike_name", "account_id" */
  LookalikeDefinitionAccountIdLookalikeNameKey: 'lookalike_definition_account_id_lookalike_name_key',
  /** unique or primary key constraint on columns "id" */
  LookalikeDefinitionPkey: 'lookalike_definition_pkey'
} as const;

export type Lookalike_Definition_Constraint = typeof Lookalike_Definition_Constraint[keyof typeof Lookalike_Definition_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Lookalike_Definition_Delete_At_Path_Input = {
  error?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Lookalike_Definition_Delete_Elem_Input = {
  error?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Lookalike_Definition_Delete_Key_Input = {
  error?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "lookalike_definition" */
export type Lookalike_Definition_Inc_Input = {
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
  base_segment_reach?: InputMaybe<Scalars['Int']['input']>;
  seeds_estimated_reach?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lookalike_definition" */
export type Lookalike_Definition_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
  base_segment_bq_location?: InputMaybe<Scalars['String']['input']>;
  base_segment_reach?: InputMaybe<Scalars['Int']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  last_lookalike_job_run?: InputMaybe<Lookalike_Job_Run_Obj_Rel_Insert_Input>;
  last_lookalike_job_run_id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_job_runs?: InputMaybe<Lookalike_Job_Run_Arr_Rel_Insert_Input>;
  lookalike_name?: InputMaybe<Scalars['String']['input']>;
  lookalike_seed_sources?: InputMaybe<Lookalike_Seed_Source_Arr_Rel_Insert_Input>;
  lookalike_seeds_aggregate_name?: InputMaybe<Scalars['String']['input']>;
  lookalike_segment_seed_aggregate?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Obj_Rel_Insert_Input>;
  lookalike_segment_similarities?: InputMaybe<Lookalike_Segment_Similarity_Arr_Rel_Insert_Input>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  seeds_estimated_reach?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Lookalike_Definition_Max_Fields = {
  __typename?: 'lookalike_definition_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  auc_score?: Maybe<Scalars['numeric']['output']>;
  base_segment_bq_location?: Maybe<Scalars['String']['output']>;
  base_segment_reach?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_lookalike_job_run_id?: Maybe<Scalars['uuid']['output']>;
  lookalike_name?: Maybe<Scalars['String']['output']>;
  lookalike_seeds_aggregate_name?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  auc_score?: InputMaybe<Order_By>;
  base_segment_bq_location?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_lookalike_job_run_id?: InputMaybe<Order_By>;
  lookalike_name?: InputMaybe<Order_By>;
  lookalike_seeds_aggregate_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lookalike_Definition_Min_Fields = {
  __typename?: 'lookalike_definition_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  auc_score?: Maybe<Scalars['numeric']['output']>;
  base_segment_bq_location?: Maybe<Scalars['String']['output']>;
  base_segment_reach?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_lookalike_job_run_id?: Maybe<Scalars['uuid']['output']>;
  lookalike_name?: Maybe<Scalars['String']['output']>;
  lookalike_seeds_aggregate_name?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  auc_score?: InputMaybe<Order_By>;
  base_segment_bq_location?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_lookalike_job_run_id?: InputMaybe<Order_By>;
  lookalike_name?: InputMaybe<Order_By>;
  lookalike_seeds_aggregate_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lookalike_definition" */
export type Lookalike_Definition_Mutation_Response = {
  __typename?: 'lookalike_definition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lookalike_Definition>;
};

/** input type for inserting object relation for remote table "lookalike_definition" */
export type Lookalike_Definition_Obj_Rel_Insert_Input = {
  data: Lookalike_Definition_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lookalike_Definition_On_Conflict>;
};

/** on_conflict condition type for table "lookalike_definition" */
export type Lookalike_Definition_On_Conflict = {
  constraint: Lookalike_Definition_Constraint;
  update_columns?: Array<Lookalike_Definition_Update_Column>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};

/** Ordering options when selecting data from "lookalike_definition". */
export type Lookalike_Definition_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  auc_score?: InputMaybe<Order_By>;
  available_build_audience?: InputMaybe<Order_By>;
  base_segment_bq_location?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  derived_balanced_reach?: InputMaybe<Order_By>;
  derived_expiry_date?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  last_lookalike_job_run?: InputMaybe<Lookalike_Job_Run_Order_By>;
  last_lookalike_job_run_id?: InputMaybe<Order_By>;
  lookalike_job_runs_aggregate?: InputMaybe<Lookalike_Job_Run_Aggregate_Order_By>;
  lookalike_name?: InputMaybe<Order_By>;
  lookalike_seed_sources_aggregate?: InputMaybe<Lookalike_Seed_Source_Aggregate_Order_By>;
  lookalike_seeds_aggregate_name?: InputMaybe<Order_By>;
  lookalike_segment_seed_aggregate?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Order_By>;
  lookalike_segment_similarities_aggregate?: InputMaybe<Lookalike_Segment_Similarity_Aggregate_Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lookalike_definition */
export type Lookalike_Definition_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Lookalike_Definition_Prepend_Input = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "lookalike_definition" */
export const Lookalike_Definition_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AucScore: 'auc_score',
  /** column name */
  BaseSegmentBqLocation: 'base_segment_bq_location',
  /** column name */
  BaseSegmentReach: 'base_segment_reach',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Error: 'error',
  /** column name */
  Id: 'id',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  LastLookalikeJobRunId: 'last_lookalike_job_run_id',
  /** column name */
  LookalikeName: 'lookalike_name',
  /** column name */
  LookalikeSeedsAggregateName: 'lookalike_seeds_aggregate_name',
  /** column name */
  ProviderId: 'provider_id',
  /** column name */
  SeedsEstimatedReach: 'seeds_estimated_reach',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedDate: 'updated_date',
  /** column name */
  UserId: 'user_id'
} as const;

export type Lookalike_Definition_Select_Column = typeof Lookalike_Definition_Select_Column[keyof typeof Lookalike_Definition_Select_Column];
/** select "lookalike_definition_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lookalike_definition" */
export const Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived'
} as const;

export type Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "lookalike_definition_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lookalike_definition" */
export const Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived'
} as const;

export type Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Lookalike_Definition_Select_Column_Lookalike_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "lookalike_definition" */
export type Lookalike_Definition_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
  base_segment_bq_location?: InputMaybe<Scalars['String']['input']>;
  base_segment_reach?: InputMaybe<Scalars['Int']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  last_lookalike_job_run_id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_name?: InputMaybe<Scalars['String']['input']>;
  lookalike_seeds_aggregate_name?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  seeds_estimated_reach?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Lookalike_Definition_Stddev_Fields = {
  __typename?: 'lookalike_definition_stddev_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
  base_segment_reach?: Maybe<Scalars['Float']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Stddev_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lookalike_Definition_Stddev_Pop_Fields = {
  __typename?: 'lookalike_definition_stddev_pop_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
  base_segment_reach?: Maybe<Scalars['Float']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Stddev_Pop_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lookalike_Definition_Stddev_Samp_Fields = {
  __typename?: 'lookalike_definition_stddev_samp_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
  base_segment_reach?: Maybe<Scalars['Float']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Stddev_Samp_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lookalike_definition" */
export type Lookalike_Definition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lookalike_Definition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lookalike_Definition_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
  base_segment_bq_location?: InputMaybe<Scalars['String']['input']>;
  base_segment_reach?: InputMaybe<Scalars['Int']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  last_lookalike_job_run_id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_name?: InputMaybe<Scalars['String']['input']>;
  lookalike_seeds_aggregate_name?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  seeds_estimated_reach?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Lookalike_Definition_Sum_Fields = {
  __typename?: 'lookalike_definition_sum_fields';
  auc_score?: Maybe<Scalars['numeric']['output']>;
  base_segment_reach?: Maybe<Scalars['Int']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Sum_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** update columns of table "lookalike_definition" */
export const Lookalike_Definition_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AucScore: 'auc_score',
  /** column name */
  BaseSegmentBqLocation: 'base_segment_bq_location',
  /** column name */
  BaseSegmentReach: 'base_segment_reach',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Error: 'error',
  /** column name */
  Id: 'id',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  LastLookalikeJobRunId: 'last_lookalike_job_run_id',
  /** column name */
  LookalikeName: 'lookalike_name',
  /** column name */
  LookalikeSeedsAggregateName: 'lookalike_seeds_aggregate_name',
  /** column name */
  ProviderId: 'provider_id',
  /** column name */
  SeedsEstimatedReach: 'seeds_estimated_reach',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedDate: 'updated_date',
  /** column name */
  UserId: 'user_id'
} as const;

export type Lookalike_Definition_Update_Column = typeof Lookalike_Definition_Update_Column[keyof typeof Lookalike_Definition_Update_Column];
export type Lookalike_Definition_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Lookalike_Definition_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Lookalike_Definition_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Lookalike_Definition_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Lookalike_Definition_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lookalike_Definition_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Lookalike_Definition_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lookalike_Definition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lookalike_Definition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lookalike_Definition_Var_Pop_Fields = {
  __typename?: 'lookalike_definition_var_pop_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
  base_segment_reach?: Maybe<Scalars['Float']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Var_Pop_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lookalike_Definition_Var_Samp_Fields = {
  __typename?: 'lookalike_definition_var_samp_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
  base_segment_reach?: Maybe<Scalars['Float']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Var_Samp_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lookalike_Definition_Variance_Fields = {
  __typename?: 'lookalike_definition_variance_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
  base_segment_reach?: Maybe<Scalars['Float']['output']>;
  seeds_estimated_reach?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lookalike_definition" */
export type Lookalike_Definition_Variance_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  base_segment_reach?: InputMaybe<Order_By>;
  seeds_estimated_reach?: InputMaybe<Order_By>;
};

/** Tracking refresh history of each dse experiment_run and custom_jobs */
export type Lookalike_Job_Run = {
  __typename?: 'lookalike_job_run';
  auc_score?: Maybe<Scalars['numeric']['output']>;
  created_date: Scalars['timestamptz']['output'];
  error?: Maybe<Scalars['String']['output']>;
  experiment_run_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lookalike_definition: Lookalike_Definition;
  lookalike_definition_id: Scalars['uuid']['output'];
  predict_duration?: Maybe<Scalars['interval']['output']>;
  seed_oaid_grouping?: Maybe<Scalars['jsonb']['output']>;
  seed_sample_table?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
  train_duration?: Maybe<Scalars['interval']['output']>;
  updated_date: Scalars['timestamptz']['output'];
};


/** Tracking refresh history of each dse experiment_run and custom_jobs */
export type Lookalike_Job_RunSeed_Oaid_GroupingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "lookalike_job_run" */
export type Lookalike_Job_Run_Aggregate = {
  __typename?: 'lookalike_job_run_aggregate';
  aggregate?: Maybe<Lookalike_Job_Run_Aggregate_Fields>;
  nodes: Array<Lookalike_Job_Run>;
};

export type Lookalike_Job_Run_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lookalike_Job_Run_Aggregate_Bool_Exp_Count>;
};

export type Lookalike_Job_Run_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lookalike_job_run" */
export type Lookalike_Job_Run_Aggregate_Fields = {
  __typename?: 'lookalike_job_run_aggregate_fields';
  avg?: Maybe<Lookalike_Job_Run_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lookalike_Job_Run_Max_Fields>;
  min?: Maybe<Lookalike_Job_Run_Min_Fields>;
  stddev?: Maybe<Lookalike_Job_Run_Stddev_Fields>;
  stddev_pop?: Maybe<Lookalike_Job_Run_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lookalike_Job_Run_Stddev_Samp_Fields>;
  sum?: Maybe<Lookalike_Job_Run_Sum_Fields>;
  var_pop?: Maybe<Lookalike_Job_Run_Var_Pop_Fields>;
  var_samp?: Maybe<Lookalike_Job_Run_Var_Samp_Fields>;
  variance?: Maybe<Lookalike_Job_Run_Variance_Fields>;
};


/** aggregate fields of "lookalike_job_run" */
export type Lookalike_Job_Run_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lookalike_job_run" */
export type Lookalike_Job_Run_Aggregate_Order_By = {
  avg?: InputMaybe<Lookalike_Job_Run_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lookalike_Job_Run_Max_Order_By>;
  min?: InputMaybe<Lookalike_Job_Run_Min_Order_By>;
  stddev?: InputMaybe<Lookalike_Job_Run_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lookalike_Job_Run_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lookalike_Job_Run_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lookalike_Job_Run_Sum_Order_By>;
  var_pop?: InputMaybe<Lookalike_Job_Run_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lookalike_Job_Run_Var_Samp_Order_By>;
  variance?: InputMaybe<Lookalike_Job_Run_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Lookalike_Job_Run_Append_Input = {
  seed_oaid_grouping?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "lookalike_job_run" */
export type Lookalike_Job_Run_Arr_Rel_Insert_Input = {
  data: Array<Lookalike_Job_Run_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lookalike_Job_Run_On_Conflict>;
};

/** aggregate avg on columns */
export type Lookalike_Job_Run_Avg_Fields = {
  __typename?: 'lookalike_job_run_avg_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Avg_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lookalike_job_run". All fields are combined with a logical 'AND'. */
export type Lookalike_Job_Run_Bool_Exp = {
  _and?: InputMaybe<Array<Lookalike_Job_Run_Bool_Exp>>;
  _not?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
  _or?: InputMaybe<Array<Lookalike_Job_Run_Bool_Exp>>;
  auc_score?: InputMaybe<Numeric_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  experiment_run_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  lookalike_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  predict_duration?: InputMaybe<Interval_Comparison_Exp>;
  seed_oaid_grouping?: InputMaybe<Jsonb_Comparison_Exp>;
  seed_sample_table?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<String_Comparison_Exp>;
  train_duration?: InputMaybe<Interval_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lookalike_job_run" */
export const Lookalike_Job_Run_Constraint = {
  /** unique or primary key constraint on columns "experiment_run_id" */
  LookalikeJobRunExperimentRunIdKey: 'lookalike_job_run_experiment_run_id_key',
  /** unique or primary key constraint on columns "id" */
  LookalikeJobRunPkey: 'lookalike_job_run_pkey'
} as const;

export type Lookalike_Job_Run_Constraint = typeof Lookalike_Job_Run_Constraint[keyof typeof Lookalike_Job_Run_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Lookalike_Job_Run_Delete_At_Path_Input = {
  seed_oaid_grouping?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Lookalike_Job_Run_Delete_Elem_Input = {
  seed_oaid_grouping?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Lookalike_Job_Run_Delete_Key_Input = {
  seed_oaid_grouping?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "lookalike_job_run" */
export type Lookalike_Job_Run_Inc_Input = {
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "lookalike_job_run" */
export type Lookalike_Job_Run_Insert_Input = {
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  experiment_run_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Obj_Rel_Insert_Input>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  predict_duration?: InputMaybe<Scalars['interval']['input']>;
  seed_oaid_grouping?: InputMaybe<Scalars['jsonb']['input']>;
  seed_sample_table?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  train_duration?: InputMaybe<Scalars['interval']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Lookalike_Job_Run_Max_Fields = {
  __typename?: 'lookalike_job_run_max_fields';
  auc_score?: Maybe<Scalars['numeric']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  experiment_run_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  seed_sample_table?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Max_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  experiment_run_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  seed_sample_table?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lookalike_Job_Run_Min_Fields = {
  __typename?: 'lookalike_job_run_min_fields';
  auc_score?: Maybe<Scalars['numeric']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  experiment_run_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  seed_sample_table?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Min_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  experiment_run_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  seed_sample_table?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lookalike_job_run" */
export type Lookalike_Job_Run_Mutation_Response = {
  __typename?: 'lookalike_job_run_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lookalike_Job_Run>;
};

/** input type for inserting object relation for remote table "lookalike_job_run" */
export type Lookalike_Job_Run_Obj_Rel_Insert_Input = {
  data: Lookalike_Job_Run_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lookalike_Job_Run_On_Conflict>;
};

/** on_conflict condition type for table "lookalike_job_run" */
export type Lookalike_Job_Run_On_Conflict = {
  constraint: Lookalike_Job_Run_Constraint;
  update_columns?: Array<Lookalike_Job_Run_Update_Column>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};

/** Ordering options when selecting data from "lookalike_job_run". */
export type Lookalike_Job_Run_Order_By = {
  auc_score?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  experiment_run_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  predict_duration?: InputMaybe<Order_By>;
  seed_oaid_grouping?: InputMaybe<Order_By>;
  seed_sample_table?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  train_duration?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lookalike_job_run */
export type Lookalike_Job_Run_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Lookalike_Job_Run_Prepend_Input = {
  seed_oaid_grouping?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "lookalike_job_run" */
export const Lookalike_Job_Run_Select_Column = {
  /** column name */
  AucScore: 'auc_score',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Error: 'error',
  /** column name */
  ExperimentRunId: 'experiment_run_id',
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  PredictDuration: 'predict_duration',
  /** column name */
  SeedOaidGrouping: 'seed_oaid_grouping',
  /** column name */
  SeedSampleTable: 'seed_sample_table',
  /** column name */
  Status: 'status',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TrainDuration: 'train_duration',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Lookalike_Job_Run_Select_Column = typeof Lookalike_Job_Run_Select_Column[keyof typeof Lookalike_Job_Run_Select_Column];
/** input type for updating data in table "lookalike_job_run" */
export type Lookalike_Job_Run_Set_Input = {
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  experiment_run_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  predict_duration?: InputMaybe<Scalars['interval']['input']>;
  seed_oaid_grouping?: InputMaybe<Scalars['jsonb']['input']>;
  seed_sample_table?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  train_duration?: InputMaybe<Scalars['interval']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Lookalike_Job_Run_Stddev_Fields = {
  __typename?: 'lookalike_job_run_stddev_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Stddev_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lookalike_Job_Run_Stddev_Pop_Fields = {
  __typename?: 'lookalike_job_run_stddev_pop_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Stddev_Pop_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lookalike_Job_Run_Stddev_Samp_Fields = {
  __typename?: 'lookalike_job_run_stddev_samp_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Stddev_Samp_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lookalike_job_run" */
export type Lookalike_Job_Run_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lookalike_Job_Run_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lookalike_Job_Run_Stream_Cursor_Value_Input = {
  auc_score?: InputMaybe<Scalars['numeric']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  experiment_run_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  predict_duration?: InputMaybe<Scalars['interval']['input']>;
  seed_oaid_grouping?: InputMaybe<Scalars['jsonb']['input']>;
  seed_sample_table?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  train_duration?: InputMaybe<Scalars['interval']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Lookalike_Job_Run_Sum_Fields = {
  __typename?: 'lookalike_job_run_sum_fields';
  auc_score?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Sum_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** update columns of table "lookalike_job_run" */
export const Lookalike_Job_Run_Update_Column = {
  /** column name */
  AucScore: 'auc_score',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Error: 'error',
  /** column name */
  ExperimentRunId: 'experiment_run_id',
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  PredictDuration: 'predict_duration',
  /** column name */
  SeedOaidGrouping: 'seed_oaid_grouping',
  /** column name */
  SeedSampleTable: 'seed_sample_table',
  /** column name */
  Status: 'status',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TrainDuration: 'train_duration',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Lookalike_Job_Run_Update_Column = typeof Lookalike_Job_Run_Update_Column[keyof typeof Lookalike_Job_Run_Update_Column];
export type Lookalike_Job_Run_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Lookalike_Job_Run_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Lookalike_Job_Run_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Lookalike_Job_Run_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Lookalike_Job_Run_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lookalike_Job_Run_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Lookalike_Job_Run_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lookalike_Job_Run_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lookalike_Job_Run_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lookalike_Job_Run_Var_Pop_Fields = {
  __typename?: 'lookalike_job_run_var_pop_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Var_Pop_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lookalike_Job_Run_Var_Samp_Fields = {
  __typename?: 'lookalike_job_run_var_samp_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Var_Samp_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lookalike_Job_Run_Variance_Fields = {
  __typename?: 'lookalike_job_run_variance_fields';
  auc_score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lookalike_job_run" */
export type Lookalike_Job_Run_Variance_Order_By = {
  auc_score?: InputMaybe<Order_By>;
};

/** This defines the association between lookalike_definition and lookalike `seed source` segments. `lookalike_seed_source` is NOT dedicated to one lookalike_definition. */
export type Lookalike_Seed_Source = {
  __typename?: 'lookalike_seed_source';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lookalike_definition: Lookalike_Definition;
  lookalike_definition_id: Scalars['uuid']['output'];
  /** An object relationship */
  segment: Segment;
  segment_id: Scalars['uuid']['output'];
};

/** aggregated selection of "lookalike_seed_source" */
export type Lookalike_Seed_Source_Aggregate = {
  __typename?: 'lookalike_seed_source_aggregate';
  aggregate?: Maybe<Lookalike_Seed_Source_Aggregate_Fields>;
  nodes: Array<Lookalike_Seed_Source>;
};

export type Lookalike_Seed_Source_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lookalike_Seed_Source_Aggregate_Bool_Exp_Count>;
};

export type Lookalike_Seed_Source_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lookalike_seed_source" */
export type Lookalike_Seed_Source_Aggregate_Fields = {
  __typename?: 'lookalike_seed_source_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lookalike_Seed_Source_Max_Fields>;
  min?: Maybe<Lookalike_Seed_Source_Min_Fields>;
};


/** aggregate fields of "lookalike_seed_source" */
export type Lookalike_Seed_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lookalike_Seed_Source_Max_Order_By>;
  min?: InputMaybe<Lookalike_Seed_Source_Min_Order_By>;
};

/** input type for inserting array relation for remote table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Arr_Rel_Insert_Input = {
  data: Array<Lookalike_Seed_Source_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lookalike_Seed_Source_On_Conflict>;
};

/** Boolean expression to filter rows from the table "lookalike_seed_source". All fields are combined with a logical 'AND'. */
export type Lookalike_Seed_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Lookalike_Seed_Source_Bool_Exp>>;
  _not?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Lookalike_Seed_Source_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  lookalike_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  segment_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lookalike_seed_source" */
export const Lookalike_Seed_Source_Constraint = {
  /** unique or primary key constraint on columns "lookalike_definition_id", "segment_id" */
  LookalikeSeedSourceLookalikeDefinitionIdSegmentIdKey: 'lookalike_seed_source_lookalike_definition_id_segment_id_key',
  /** unique or primary key constraint on columns "id" */
  LookalikeSeedSourcePkey: 'lookalike_seed_source_pkey'
} as const;

export type Lookalike_Seed_Source_Constraint = typeof Lookalike_Seed_Source_Constraint[keyof typeof Lookalike_Seed_Source_Constraint];
/** input type for inserting data into table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Obj_Rel_Insert_Input>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment?: InputMaybe<Segment_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Lookalike_Seed_Source_Max_Fields = {
  __typename?: 'lookalike_seed_source_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lookalike_Seed_Source_Min_Fields = {
  __typename?: 'lookalike_seed_source_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Mutation_Response = {
  __typename?: 'lookalike_seed_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lookalike_Seed_Source>;
};

/** on_conflict condition type for table "lookalike_seed_source" */
export type Lookalike_Seed_Source_On_Conflict = {
  constraint: Lookalike_Seed_Source_Constraint;
  update_columns?: Array<Lookalike_Seed_Source_Update_Column>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "lookalike_seed_source". */
export type Lookalike_Seed_Source_Order_By = {
  id?: InputMaybe<Order_By>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lookalike_seed_source */
export type Lookalike_Seed_Source_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lookalike_seed_source" */
export const Lookalike_Seed_Source_Select_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Lookalike_Seed_Source_Select_Column = typeof Lookalike_Seed_Source_Select_Column[keyof typeof Lookalike_Seed_Source_Select_Column];
/** input type for updating data in table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "lookalike_seed_source" */
export type Lookalike_Seed_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lookalike_Seed_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lookalike_Seed_Source_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "lookalike_seed_source" */
export const Lookalike_Seed_Source_Update_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Lookalike_Seed_Source_Update_Column = typeof Lookalike_Seed_Source_Update_Column[keyof typeof Lookalike_Seed_Source_Update_Column];
export type Lookalike_Seed_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lookalike_Seed_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lookalike_Seed_Source_Bool_Exp;
};

export type Lookalike_Segment_Config_Input = {
  /** The BigQuery location of its segment table */
  bq_location: Scalars['String']['input'];
  /** The timestamp when its segment table expire */
  expiration_date: Scalars['timestamptz']['input'];
  /** The OAIDs number in its segment table */
  reach: Scalars['Int']['input'];
  /**
   * The lookalike segment identifier, one of `Seed`, `High`, `Balanced`, `Scaled`,
   * `Seed`: Seed aggregate segment,
   * `High`: High Similarity/ Perpensity segment,
   * `Balanced`: Balanced Similarity/ Perpensity segment,
   * `Scaled`: Scaled Similarity/ Perpensity segment,
   */
  segment_identifier: Scalars['String']['input'];
  /** The similarity score threshold in order for the identifier OAID to be included.  It is only applied to similarity segments */
  similarity_score_threshold?: InputMaybe<Scalars['Decimal']['input']>;
  /** The source_bq_tables of user ID types.  It is only applied to the seed aggregate segment */
  source_bq_tables?: InputMaybe<Scalars['JSON']['input']>;
};

/** This defines the association between lookalike_definition and lookalike `seed_aggregate` segments. `lookalike_segment_seed_aggregate` is dedicated to one lookalike definition. */
export type Lookalike_Segment_Seed_Aggregate = {
  __typename?: 'lookalike_segment_seed_aggregate';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lookalike_definition: Lookalike_Definition;
  lookalike_definition_id: Scalars['uuid']['output'];
  /** An object relationship */
  segment: Segment;
  segment_id: Scalars['uuid']['output'];
};

/** aggregated selection of "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Aggregate = {
  __typename?: 'lookalike_segment_seed_aggregate_aggregate';
  aggregate?: Maybe<Lookalike_Segment_Seed_Aggregate_Aggregate_Fields>;
  nodes: Array<Lookalike_Segment_Seed_Aggregate>;
};

/** aggregate fields of "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Aggregate_Fields = {
  __typename?: 'lookalike_segment_seed_aggregate_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Lookalike_Segment_Seed_Aggregate_Max_Fields>;
  min?: Maybe<Lookalike_Segment_Seed_Aggregate_Min_Fields>;
};


/** aggregate fields of "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "lookalike_segment_seed_aggregate". All fields are combined with a logical 'AND'. */
export type Lookalike_Segment_Seed_Aggregate_Bool_Exp = {
  _and?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Bool_Exp>>;
  _not?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
  _or?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  lookalike_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  segment_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lookalike_segment_seed_aggregate" */
export const Lookalike_Segment_Seed_Aggregate_Constraint = {
  /** unique or primary key constraint on columns "lookalike_definition_id" */
  LookalikeSegmentSeedAggregateLookalikeDefinitionIdKey: 'lookalike_segment_seed_aggregate_lookalike_definition_id_key',
  /** unique or primary key constraint on columns "id" */
  LookalikeSegmentSeedAggregatePkey: 'lookalike_segment_seed_aggregate_pkey',
  /** unique or primary key constraint on columns "segment_id" */
  LookalikeSegmentSeedAggregateSegmentIdKey: 'lookalike_segment_seed_aggregate_segment_id_key'
} as const;

export type Lookalike_Segment_Seed_Aggregate_Constraint = typeof Lookalike_Segment_Seed_Aggregate_Constraint[keyof typeof Lookalike_Segment_Seed_Aggregate_Constraint];
/** input type for inserting data into table "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Obj_Rel_Insert_Input>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment?: InputMaybe<Segment_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Lookalike_Segment_Seed_Aggregate_Max_Fields = {
  __typename?: 'lookalike_segment_seed_aggregate_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Lookalike_Segment_Seed_Aggregate_Min_Fields = {
  __typename?: 'lookalike_segment_seed_aggregate_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Mutation_Response = {
  __typename?: 'lookalike_segment_seed_aggregate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lookalike_Segment_Seed_Aggregate>;
};

/** input type for inserting object relation for remote table "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Obj_Rel_Insert_Input = {
  data: Lookalike_Segment_Seed_Aggregate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lookalike_Segment_Seed_Aggregate_On_Conflict>;
};

/** on_conflict condition type for table "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_On_Conflict = {
  constraint: Lookalike_Segment_Seed_Aggregate_Constraint;
  update_columns?: Array<Lookalike_Segment_Seed_Aggregate_Update_Column>;
  where?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
};

/** Ordering options when selecting data from "lookalike_segment_seed_aggregate". */
export type Lookalike_Segment_Seed_Aggregate_Order_By = {
  id?: InputMaybe<Order_By>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lookalike_segment_seed_aggregate */
export type Lookalike_Segment_Seed_Aggregate_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lookalike_segment_seed_aggregate" */
export const Lookalike_Segment_Seed_Aggregate_Select_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Lookalike_Segment_Seed_Aggregate_Select_Column = typeof Lookalike_Segment_Seed_Aggregate_Select_Column[keyof typeof Lookalike_Segment_Seed_Aggregate_Select_Column];
/** input type for updating data in table "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "lookalike_segment_seed_aggregate" */
export type Lookalike_Segment_Seed_Aggregate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lookalike_Segment_Seed_Aggregate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lookalike_Segment_Seed_Aggregate_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "lookalike_segment_seed_aggregate" */
export const Lookalike_Segment_Seed_Aggregate_Update_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Lookalike_Segment_Seed_Aggregate_Update_Column = typeof Lookalike_Segment_Seed_Aggregate_Update_Column[keyof typeof Lookalike_Segment_Seed_Aggregate_Update_Column];
export type Lookalike_Segment_Seed_Aggregate_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lookalike_Segment_Seed_Aggregate_Bool_Exp;
};

/** This defines the association between lookalike_definition and lookalike `similarity` segments.   `lookalike_segment_similarity` is dedicated to one lookalike definition. */
export type Lookalike_Segment_Similarity = {
  __typename?: 'lookalike_segment_similarity';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lookalike_definition: Lookalike_Definition;
  lookalike_definition_id: Scalars['uuid']['output'];
  /** An object relationship */
  segment: Segment;
  segment_id: Scalars['uuid']['output'];
  similarity_level: Scalars['String']['output'];
  similarity_score_threshold: Scalars['numeric']['output'];
};

/** aggregated selection of "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Aggregate = {
  __typename?: 'lookalike_segment_similarity_aggregate';
  aggregate?: Maybe<Lookalike_Segment_Similarity_Aggregate_Fields>;
  nodes: Array<Lookalike_Segment_Similarity>;
};

export type Lookalike_Segment_Similarity_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lookalike_Segment_Similarity_Aggregate_Bool_Exp_Count>;
};

export type Lookalike_Segment_Similarity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Aggregate_Fields = {
  __typename?: 'lookalike_segment_similarity_aggregate_fields';
  avg?: Maybe<Lookalike_Segment_Similarity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lookalike_Segment_Similarity_Max_Fields>;
  min?: Maybe<Lookalike_Segment_Similarity_Min_Fields>;
  stddev?: Maybe<Lookalike_Segment_Similarity_Stddev_Fields>;
  stddev_pop?: Maybe<Lookalike_Segment_Similarity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lookalike_Segment_Similarity_Stddev_Samp_Fields>;
  sum?: Maybe<Lookalike_Segment_Similarity_Sum_Fields>;
  var_pop?: Maybe<Lookalike_Segment_Similarity_Var_Pop_Fields>;
  var_samp?: Maybe<Lookalike_Segment_Similarity_Var_Samp_Fields>;
  variance?: Maybe<Lookalike_Segment_Similarity_Variance_Fields>;
};


/** aggregate fields of "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Aggregate_Order_By = {
  avg?: InputMaybe<Lookalike_Segment_Similarity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lookalike_Segment_Similarity_Max_Order_By>;
  min?: InputMaybe<Lookalike_Segment_Similarity_Min_Order_By>;
  stddev?: InputMaybe<Lookalike_Segment_Similarity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lookalike_Segment_Similarity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lookalike_Segment_Similarity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lookalike_Segment_Similarity_Sum_Order_By>;
  var_pop?: InputMaybe<Lookalike_Segment_Similarity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lookalike_Segment_Similarity_Var_Samp_Order_By>;
  variance?: InputMaybe<Lookalike_Segment_Similarity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Arr_Rel_Insert_Input = {
  data: Array<Lookalike_Segment_Similarity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lookalike_Segment_Similarity_On_Conflict>;
};

/** aggregate avg on columns */
export type Lookalike_Segment_Similarity_Avg_Fields = {
  __typename?: 'lookalike_segment_similarity_avg_fields';
  similarity_score_threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Avg_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lookalike_segment_similarity". All fields are combined with a logical 'AND'. */
export type Lookalike_Segment_Similarity_Bool_Exp = {
  _and?: InputMaybe<Array<Lookalike_Segment_Similarity_Bool_Exp>>;
  _not?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
  _or?: InputMaybe<Array<Lookalike_Segment_Similarity_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Bool_Exp>;
  lookalike_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  segment_id?: InputMaybe<Uuid_Comparison_Exp>;
  similarity_level?: InputMaybe<String_Comparison_Exp>;
  similarity_score_threshold?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "lookalike_segment_similarity" */
export const Lookalike_Segment_Similarity_Constraint = {
  /** unique or primary key constraint on columns "similarity_level", "lookalike_definition_id" */
  LookalikeSegmentSimilarityLookalikeDefinitionIdSimilaKey: 'lookalike_segment_similarity_lookalike_definition_id_simila_key',
  /** unique or primary key constraint on columns "id" */
  LookalikeSegmentSimilarityPkey: 'lookalike_segment_similarity_pkey',
  /** unique or primary key constraint on columns "segment_id" */
  LookalikeSegmentSimilaritySegmentIdKey: 'lookalike_segment_similarity_segment_id_key'
} as const;

export type Lookalike_Segment_Similarity_Constraint = typeof Lookalike_Segment_Similarity_Constraint[keyof typeof Lookalike_Segment_Similarity_Constraint];
/** input type for incrementing numeric columns in table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Inc_Input = {
  similarity_score_threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Obj_Rel_Insert_Input>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment?: InputMaybe<Segment_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity_level?: InputMaybe<Scalars['String']['input']>;
  similarity_score_threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Lookalike_Segment_Similarity_Max_Fields = {
  __typename?: 'lookalike_segment_similarity_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
  similarity_level?: Maybe<Scalars['String']['output']>;
  similarity_score_threshold?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  similarity_level?: InputMaybe<Order_By>;
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lookalike_Segment_Similarity_Min_Fields = {
  __typename?: 'lookalike_segment_similarity_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
  similarity_level?: Maybe<Scalars['String']['output']>;
  similarity_score_threshold?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
  similarity_level?: InputMaybe<Order_By>;
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Mutation_Response = {
  __typename?: 'lookalike_segment_similarity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lookalike_Segment_Similarity>;
};

/** on_conflict condition type for table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_On_Conflict = {
  constraint: Lookalike_Segment_Similarity_Constraint;
  update_columns?: Array<Lookalike_Segment_Similarity_Update_Column>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};

/** Ordering options when selecting data from "lookalike_segment_similarity". */
export type Lookalike_Segment_Similarity_Order_By = {
  id?: InputMaybe<Order_By>;
  lookalike_definition?: InputMaybe<Lookalike_Definition_Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  segment_id?: InputMaybe<Order_By>;
  similarity_level?: InputMaybe<Order_By>;
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lookalike_segment_similarity */
export type Lookalike_Segment_Similarity_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lookalike_segment_similarity" */
export const Lookalike_Segment_Similarity_Select_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  SimilarityLevel: 'similarity_level',
  /** column name */
  SimilarityScoreThreshold: 'similarity_score_threshold'
} as const;

export type Lookalike_Segment_Similarity_Select_Column = typeof Lookalike_Segment_Similarity_Select_Column[keyof typeof Lookalike_Segment_Similarity_Select_Column];
/** input type for updating data in table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity_level?: InputMaybe<Scalars['String']['input']>;
  similarity_score_threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Lookalike_Segment_Similarity_Stddev_Fields = {
  __typename?: 'lookalike_segment_similarity_stddev_fields';
  similarity_score_threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Stddev_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lookalike_Segment_Similarity_Stddev_Pop_Fields = {
  __typename?: 'lookalike_segment_similarity_stddev_pop_fields';
  similarity_score_threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Stddev_Pop_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lookalike_Segment_Similarity_Stddev_Samp_Fields = {
  __typename?: 'lookalike_segment_similarity_stddev_samp_fields';
  similarity_score_threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Stddev_Samp_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lookalike_Segment_Similarity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lookalike_Segment_Similarity_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
  similarity_level?: InputMaybe<Scalars['String']['input']>;
  similarity_score_threshold?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Lookalike_Segment_Similarity_Sum_Fields = {
  __typename?: 'lookalike_segment_similarity_sum_fields';
  similarity_score_threshold?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Sum_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** update columns of table "lookalike_segment_similarity" */
export const Lookalike_Segment_Similarity_Update_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  SimilarityLevel: 'similarity_level',
  /** column name */
  SimilarityScoreThreshold: 'similarity_score_threshold'
} as const;

export type Lookalike_Segment_Similarity_Update_Column = typeof Lookalike_Segment_Similarity_Update_Column[keyof typeof Lookalike_Segment_Similarity_Update_Column];
export type Lookalike_Segment_Similarity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lookalike_Segment_Similarity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lookalike_Segment_Similarity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lookalike_Segment_Similarity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lookalike_Segment_Similarity_Var_Pop_Fields = {
  __typename?: 'lookalike_segment_similarity_var_pop_fields';
  similarity_score_threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Var_Pop_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lookalike_Segment_Similarity_Var_Samp_Fields = {
  __typename?: 'lookalike_segment_similarity_var_samp_fields';
  similarity_score_threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Var_Samp_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lookalike_Segment_Similarity_Variance_Fields = {
  __typename?: 'lookalike_segment_similarity_variance_fields';
  similarity_score_threshold?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lookalike_segment_similarity" */
export type Lookalike_Segment_Similarity_Variance_Order_By = {
  similarity_score_threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export const Order_By = {
  /** in ascending order, nulls last */
  Asc: 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst: 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast: 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc: 'desc',
  /** in descending order, nulls first */
  DescNullsFirst: 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast: 'desc_nulls_last'
} as const;

export type Order_By = typeof Order_By[keyof typeof Order_By];
export type Pixel_Event_Metric = {
  __typename?: 'pixel_event_metric';
  event_type: Scalars['String']['output'];
  event_type_label: Scalars['String']['output'];
  fires_30d?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
  last_fire_at?: Maybe<Scalars['String']['output']>;
  unique_30d?: Maybe<Scalars['GraphQLUBigInt64']['output']>;
};

/** columns and relationships of "provider" */
export type Provider = {
  __typename?: 'provider';
  accept_audience_files_path?: Maybe<Scalars['String']['output']>;
  accept_audience_files_pattern_match?: Maybe<Scalars['String']['output']>;
  accept_audience_files_pattern_replace?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_path?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_pattern_match?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_pattern_replace?: Maybe<Scalars['String']['output']>;
  airflow_aws_conn_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  allowed_accounts: Array<Account_Provider>;
  /** An aggregate relationship */
  allowed_accounts_aggregate: Account_Provider_Aggregate;
  allowed_export_types: Scalars['jsonb']['output'];
  check_audience_files_path?: Maybe<Scalars['String']['output']>;
  check_taxonomy_files_path?: Maybe<Scalars['String']['output']>;
  direct_oaid_mapping_params?: Maybe<Scalars['jsonb']['output']>;
  field_delimiter: Scalars['String']['output'];
  file_format: Scalars['String']['output'];
  file_includes_header: Scalars['Boolean']['output'];
  /** A computed field, executes function "provider_has_segments_shared_with_caller" */
  has_segments_shared_with_caller?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "provider_has_sellable_segments" */
  has_sellable_segments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  joiner_provider_account_id?: Maybe<Scalars['uuid']['output']>;
  load_account_identifier?: Maybe<Scalars['String']['output']>;
  load_audience_files_source_types?: Maybe<Scalars['String']['output']>;
  load_audience_source_files_matching?: Maybe<Scalars['String']['output']>;
  load_audience_source_files_pattern?: Maybe<Scalars['String']['output']>;
  load_audience_source_partition_prefix?: Maybe<Scalars['String']['output']>;
  load_enable_validate_audience_headers?: Maybe<Scalars['Int']['output']>;
  load_folder_account_identifier_map?: Maybe<Scalars['String']['output']>;
  load_lookback_days?: Maybe<Scalars['Int']['output']>;
  load_taxonomy_file_path?: Maybe<Scalars['String']['output']>;
  load_taxonomy_files_matching?: Maybe<Scalars['String']['output']>;
  load_taxonomy_files_pattern?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oaid_namespace?: Maybe<Scalars['jsonb']['output']>;
  provider_diff_config?: Maybe<Scalars['jsonb']['output']>;
  provider_salt?: Maybe<Scalars['uuid']['output']>;
  raw_gcs_bucket?: Maybe<Scalars['String']['output']>;
  ready_gcs_bucket?: Maybe<Scalars['String']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Int']['output']>;
  segment_creation_method: Scalars['String']['output'];
  segment_delimiter?: Maybe<Scalars['String']['output']>;
  segment_external_id_prefix?: Maybe<Scalars['String']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Int']['output']>;
  segment_inbox_matches?: Maybe<Scalars['String']['output']>;
  segment_inbox_path?: Maybe<Scalars['String']['output']>;
  segment_inbox_taxonomy?: Maybe<Scalars['Boolean']['output']>;
  source_bucket?: Maybe<Scalars['String']['output']>;
  source_line_regexp_replace?: Maybe<Scalars['jsonb']['output']>;
  source_prefix?: Maybe<Scalars['String']['output']>;
  source_region?: Maybe<Scalars['String']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_inbox_matches?: Maybe<Scalars['String']['output']>;
  universe_inbox_path?: Maybe<Scalars['String']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_outbox_matches?: Maybe<Scalars['String']['output']>;
  universe_outbox_path?: Maybe<Scalars['String']['output']>;
  update_type: Scalars['String']['output'];
};


/** columns and relationships of "provider" */
export type ProviderAllowed_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


/** columns and relationships of "provider" */
export type ProviderAllowed_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


/** columns and relationships of "provider" */
export type ProviderAllowed_Export_TypesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "provider" */
export type ProviderDirect_Oaid_Mapping_ParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "provider" */
export type ProviderOaid_NamespaceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "provider" */
export type ProviderProvider_Diff_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "provider" */
export type ProviderSource_Line_Regexp_ReplaceArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "provider" */
export type Provider_Aggregate = {
  __typename?: 'provider_aggregate';
  aggregate?: Maybe<Provider_Aggregate_Fields>;
  nodes: Array<Provider>;
};

/** aggregate fields of "provider" */
export type Provider_Aggregate_Fields = {
  __typename?: 'provider_aggregate_fields';
  avg?: Maybe<Provider_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Provider_Max_Fields>;
  min?: Maybe<Provider_Min_Fields>;
  stddev?: Maybe<Provider_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Sum_Fields>;
  var_pop?: Maybe<Provider_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Var_Samp_Fields>;
  variance?: Maybe<Provider_Variance_Fields>;
};


/** aggregate fields of "provider" */
export type Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Provider_Append_Input = {
  allowed_export_types?: InputMaybe<Scalars['jsonb']['input']>;
  direct_oaid_mapping_params?: InputMaybe<Scalars['jsonb']['input']>;
  oaid_namespace?: InputMaybe<Scalars['jsonb']['input']>;
  provider_diff_config?: InputMaybe<Scalars['jsonb']['input']>;
  source_line_regexp_replace?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Provider_Avg_Fields = {
  __typename?: 'provider_avg_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Float']['output']>;
  load_lookback_days?: Maybe<Scalars['Float']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Float']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "provider". All fields are combined with a logical 'AND'. */
export type Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Bool_Exp>>;
  _not?: InputMaybe<Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Bool_Exp>>;
  accept_audience_files_path?: InputMaybe<String_Comparison_Exp>;
  accept_audience_files_pattern_match?: InputMaybe<String_Comparison_Exp>;
  accept_audience_files_pattern_replace?: InputMaybe<String_Comparison_Exp>;
  accept_taxonomy_files_path?: InputMaybe<String_Comparison_Exp>;
  accept_taxonomy_files_pattern_match?: InputMaybe<String_Comparison_Exp>;
  accept_taxonomy_files_pattern_replace?: InputMaybe<String_Comparison_Exp>;
  airflow_aws_conn_id?: InputMaybe<String_Comparison_Exp>;
  allowed_accounts?: InputMaybe<Account_Provider_Bool_Exp>;
  allowed_accounts_aggregate?: InputMaybe<Account_Provider_Aggregate_Bool_Exp>;
  allowed_export_types?: InputMaybe<Jsonb_Comparison_Exp>;
  check_audience_files_path?: InputMaybe<String_Comparison_Exp>;
  check_taxonomy_files_path?: InputMaybe<String_Comparison_Exp>;
  direct_oaid_mapping_params?: InputMaybe<Jsonb_Comparison_Exp>;
  field_delimiter?: InputMaybe<String_Comparison_Exp>;
  file_format?: InputMaybe<String_Comparison_Exp>;
  file_includes_header?: InputMaybe<Boolean_Comparison_Exp>;
  has_segments_shared_with_caller?: InputMaybe<Boolean_Comparison_Exp>;
  has_sellable_segments?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  joiner_provider_account_id?: InputMaybe<Uuid_Comparison_Exp>;
  load_account_identifier?: InputMaybe<String_Comparison_Exp>;
  load_audience_files_source_types?: InputMaybe<String_Comparison_Exp>;
  load_audience_source_files_matching?: InputMaybe<String_Comparison_Exp>;
  load_audience_source_files_pattern?: InputMaybe<String_Comparison_Exp>;
  load_audience_source_partition_prefix?: InputMaybe<String_Comparison_Exp>;
  load_enable_validate_audience_headers?: InputMaybe<Int_Comparison_Exp>;
  load_folder_account_identifier_map?: InputMaybe<String_Comparison_Exp>;
  load_lookback_days?: InputMaybe<Int_Comparison_Exp>;
  load_taxonomy_file_path?: InputMaybe<String_Comparison_Exp>;
  load_taxonomy_files_matching?: InputMaybe<String_Comparison_Exp>;
  load_taxonomy_files_pattern?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oaid_namespace?: InputMaybe<Jsonb_Comparison_Exp>;
  provider_diff_config?: InputMaybe<Jsonb_Comparison_Exp>;
  provider_salt?: InputMaybe<Uuid_Comparison_Exp>;
  raw_gcs_bucket?: InputMaybe<String_Comparison_Exp>;
  ready_gcs_bucket?: InputMaybe<String_Comparison_Exp>;
  s3_upload_inactivity_period_seconds?: InputMaybe<Int_Comparison_Exp>;
  segment_creation_method?: InputMaybe<String_Comparison_Exp>;
  segment_delimiter?: InputMaybe<String_Comparison_Exp>;
  segment_external_id_prefix?: InputMaybe<String_Comparison_Exp>;
  segment_inbox_drop?: InputMaybe<Int_Comparison_Exp>;
  segment_inbox_matches?: InputMaybe<String_Comparison_Exp>;
  segment_inbox_path?: InputMaybe<String_Comparison_Exp>;
  segment_inbox_taxonomy?: InputMaybe<Boolean_Comparison_Exp>;
  source_bucket?: InputMaybe<String_Comparison_Exp>;
  source_line_regexp_replace?: InputMaybe<Jsonb_Comparison_Exp>;
  source_prefix?: InputMaybe<String_Comparison_Exp>;
  source_region?: InputMaybe<String_Comparison_Exp>;
  universe_inbox_drop?: InputMaybe<Int_Comparison_Exp>;
  universe_inbox_matches?: InputMaybe<String_Comparison_Exp>;
  universe_inbox_path?: InputMaybe<String_Comparison_Exp>;
  universe_outbox_drop?: InputMaybe<Int_Comparison_Exp>;
  universe_outbox_matches?: InputMaybe<String_Comparison_Exp>;
  universe_outbox_path?: InputMaybe<String_Comparison_Exp>;
  update_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider" */
export const Provider_Constraint = {
  /** unique or primary key constraint on columns  */
  ProviderNameLowerIdx: 'provider_name_lower_idx',
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey: 'providers_pkey'
} as const;

export type Provider_Constraint = typeof Provider_Constraint[keyof typeof Provider_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Provider_Delete_At_Path_Input = {
  allowed_export_types?: InputMaybe<Array<Scalars['String']['input']>>;
  direct_oaid_mapping_params?: InputMaybe<Array<Scalars['String']['input']>>;
  oaid_namespace?: InputMaybe<Array<Scalars['String']['input']>>;
  provider_diff_config?: InputMaybe<Array<Scalars['String']['input']>>;
  source_line_regexp_replace?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Provider_Delete_Elem_Input = {
  allowed_export_types?: InputMaybe<Scalars['Int']['input']>;
  direct_oaid_mapping_params?: InputMaybe<Scalars['Int']['input']>;
  oaid_namespace?: InputMaybe<Scalars['Int']['input']>;
  provider_diff_config?: InputMaybe<Scalars['Int']['input']>;
  source_line_regexp_replace?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Provider_Delete_Key_Input = {
  allowed_export_types?: InputMaybe<Scalars['String']['input']>;
  direct_oaid_mapping_params?: InputMaybe<Scalars['String']['input']>;
  oaid_namespace?: InputMaybe<Scalars['String']['input']>;
  provider_diff_config?: InputMaybe<Scalars['String']['input']>;
  source_line_regexp_replace?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "provider" */
export type Provider_Inc_Input = {
  load_enable_validate_audience_headers?: InputMaybe<Scalars['Int']['input']>;
  load_lookback_days?: InputMaybe<Scalars['Int']['input']>;
  s3_upload_inactivity_period_seconds?: InputMaybe<Scalars['Int']['input']>;
  segment_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_outbox_drop?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "provider" */
export type Provider_Insert_Input = {
  accept_audience_files_path?: InputMaybe<Scalars['String']['input']>;
  accept_audience_files_pattern_match?: InputMaybe<Scalars['String']['input']>;
  accept_audience_files_pattern_replace?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_path?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_pattern_match?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_pattern_replace?: InputMaybe<Scalars['String']['input']>;
  airflow_aws_conn_id?: InputMaybe<Scalars['String']['input']>;
  allowed_accounts?: InputMaybe<Account_Provider_Arr_Rel_Insert_Input>;
  allowed_export_types?: InputMaybe<Scalars['jsonb']['input']>;
  check_audience_files_path?: InputMaybe<Scalars['String']['input']>;
  check_taxonomy_files_path?: InputMaybe<Scalars['String']['input']>;
  direct_oaid_mapping_params?: InputMaybe<Scalars['jsonb']['input']>;
  field_delimiter?: InputMaybe<Scalars['String']['input']>;
  file_format?: InputMaybe<Scalars['String']['input']>;
  file_includes_header?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  joiner_provider_account_id?: InputMaybe<Scalars['uuid']['input']>;
  load_account_identifier?: InputMaybe<Scalars['String']['input']>;
  load_audience_files_source_types?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_files_matching?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_files_pattern?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_partition_prefix?: InputMaybe<Scalars['String']['input']>;
  load_enable_validate_audience_headers?: InputMaybe<Scalars['Int']['input']>;
  load_folder_account_identifier_map?: InputMaybe<Scalars['String']['input']>;
  load_lookback_days?: InputMaybe<Scalars['Int']['input']>;
  load_taxonomy_file_path?: InputMaybe<Scalars['String']['input']>;
  load_taxonomy_files_matching?: InputMaybe<Scalars['String']['input']>;
  load_taxonomy_files_pattern?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oaid_namespace?: InputMaybe<Scalars['jsonb']['input']>;
  provider_diff_config?: InputMaybe<Scalars['jsonb']['input']>;
  provider_salt?: InputMaybe<Scalars['uuid']['input']>;
  raw_gcs_bucket?: InputMaybe<Scalars['String']['input']>;
  ready_gcs_bucket?: InputMaybe<Scalars['String']['input']>;
  s3_upload_inactivity_period_seconds?: InputMaybe<Scalars['Int']['input']>;
  segment_creation_method?: InputMaybe<Scalars['String']['input']>;
  segment_delimiter?: InputMaybe<Scalars['String']['input']>;
  segment_external_id_prefix?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  segment_inbox_matches?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_path?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_taxonomy?: InputMaybe<Scalars['Boolean']['input']>;
  source_bucket?: InputMaybe<Scalars['String']['input']>;
  source_line_regexp_replace?: InputMaybe<Scalars['jsonb']['input']>;
  source_prefix?: InputMaybe<Scalars['String']['input']>;
  source_region?: InputMaybe<Scalars['String']['input']>;
  universe_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_inbox_matches?: InputMaybe<Scalars['String']['input']>;
  universe_inbox_path?: InputMaybe<Scalars['String']['input']>;
  universe_outbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_outbox_matches?: InputMaybe<Scalars['String']['input']>;
  universe_outbox_path?: InputMaybe<Scalars['String']['input']>;
  update_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Provider_Max_Fields = {
  __typename?: 'provider_max_fields';
  accept_audience_files_path?: Maybe<Scalars['String']['output']>;
  accept_audience_files_pattern_match?: Maybe<Scalars['String']['output']>;
  accept_audience_files_pattern_replace?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_path?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_pattern_match?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_pattern_replace?: Maybe<Scalars['String']['output']>;
  airflow_aws_conn_id?: Maybe<Scalars['String']['output']>;
  check_audience_files_path?: Maybe<Scalars['String']['output']>;
  check_taxonomy_files_path?: Maybe<Scalars['String']['output']>;
  field_delimiter?: Maybe<Scalars['String']['output']>;
  file_format?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  joiner_provider_account_id?: Maybe<Scalars['uuid']['output']>;
  load_account_identifier?: Maybe<Scalars['String']['output']>;
  load_audience_files_source_types?: Maybe<Scalars['String']['output']>;
  load_audience_source_files_matching?: Maybe<Scalars['String']['output']>;
  load_audience_source_files_pattern?: Maybe<Scalars['String']['output']>;
  load_audience_source_partition_prefix?: Maybe<Scalars['String']['output']>;
  load_enable_validate_audience_headers?: Maybe<Scalars['Int']['output']>;
  load_folder_account_identifier_map?: Maybe<Scalars['String']['output']>;
  load_lookback_days?: Maybe<Scalars['Int']['output']>;
  load_taxonomy_file_path?: Maybe<Scalars['String']['output']>;
  load_taxonomy_files_matching?: Maybe<Scalars['String']['output']>;
  load_taxonomy_files_pattern?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider_salt?: Maybe<Scalars['uuid']['output']>;
  raw_gcs_bucket?: Maybe<Scalars['String']['output']>;
  ready_gcs_bucket?: Maybe<Scalars['String']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Int']['output']>;
  segment_creation_method?: Maybe<Scalars['String']['output']>;
  segment_delimiter?: Maybe<Scalars['String']['output']>;
  segment_external_id_prefix?: Maybe<Scalars['String']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Int']['output']>;
  segment_inbox_matches?: Maybe<Scalars['String']['output']>;
  segment_inbox_path?: Maybe<Scalars['String']['output']>;
  source_bucket?: Maybe<Scalars['String']['output']>;
  source_prefix?: Maybe<Scalars['String']['output']>;
  source_region?: Maybe<Scalars['String']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_inbox_matches?: Maybe<Scalars['String']['output']>;
  universe_inbox_path?: Maybe<Scalars['String']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_outbox_matches?: Maybe<Scalars['String']['output']>;
  universe_outbox_path?: Maybe<Scalars['String']['output']>;
  update_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Provider_Min_Fields = {
  __typename?: 'provider_min_fields';
  accept_audience_files_path?: Maybe<Scalars['String']['output']>;
  accept_audience_files_pattern_match?: Maybe<Scalars['String']['output']>;
  accept_audience_files_pattern_replace?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_path?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_pattern_match?: Maybe<Scalars['String']['output']>;
  accept_taxonomy_files_pattern_replace?: Maybe<Scalars['String']['output']>;
  airflow_aws_conn_id?: Maybe<Scalars['String']['output']>;
  check_audience_files_path?: Maybe<Scalars['String']['output']>;
  check_taxonomy_files_path?: Maybe<Scalars['String']['output']>;
  field_delimiter?: Maybe<Scalars['String']['output']>;
  file_format?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  joiner_provider_account_id?: Maybe<Scalars['uuid']['output']>;
  load_account_identifier?: Maybe<Scalars['String']['output']>;
  load_audience_files_source_types?: Maybe<Scalars['String']['output']>;
  load_audience_source_files_matching?: Maybe<Scalars['String']['output']>;
  load_audience_source_files_pattern?: Maybe<Scalars['String']['output']>;
  load_audience_source_partition_prefix?: Maybe<Scalars['String']['output']>;
  load_enable_validate_audience_headers?: Maybe<Scalars['Int']['output']>;
  load_folder_account_identifier_map?: Maybe<Scalars['String']['output']>;
  load_lookback_days?: Maybe<Scalars['Int']['output']>;
  load_taxonomy_file_path?: Maybe<Scalars['String']['output']>;
  load_taxonomy_files_matching?: Maybe<Scalars['String']['output']>;
  load_taxonomy_files_pattern?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider_salt?: Maybe<Scalars['uuid']['output']>;
  raw_gcs_bucket?: Maybe<Scalars['String']['output']>;
  ready_gcs_bucket?: Maybe<Scalars['String']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Int']['output']>;
  segment_creation_method?: Maybe<Scalars['String']['output']>;
  segment_delimiter?: Maybe<Scalars['String']['output']>;
  segment_external_id_prefix?: Maybe<Scalars['String']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Int']['output']>;
  segment_inbox_matches?: Maybe<Scalars['String']['output']>;
  segment_inbox_path?: Maybe<Scalars['String']['output']>;
  source_bucket?: Maybe<Scalars['String']['output']>;
  source_prefix?: Maybe<Scalars['String']['output']>;
  source_region?: Maybe<Scalars['String']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_inbox_matches?: Maybe<Scalars['String']['output']>;
  universe_inbox_path?: Maybe<Scalars['String']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_outbox_matches?: Maybe<Scalars['String']['output']>;
  universe_outbox_path?: Maybe<Scalars['String']['output']>;
  update_type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "provider" */
export type Provider_Mutation_Response = {
  __typename?: 'provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider>;
};

/** input type for inserting object relation for remote table "provider" */
export type Provider_Obj_Rel_Insert_Input = {
  data: Provider_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_On_Conflict>;
};

/** on_conflict condition type for table "provider" */
export type Provider_On_Conflict = {
  constraint: Provider_Constraint;
  update_columns?: Array<Provider_Update_Column>;
  where?: InputMaybe<Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "provider". */
export type Provider_Order_By = {
  accept_audience_files_path?: InputMaybe<Order_By>;
  accept_audience_files_pattern_match?: InputMaybe<Order_By>;
  accept_audience_files_pattern_replace?: InputMaybe<Order_By>;
  accept_taxonomy_files_path?: InputMaybe<Order_By>;
  accept_taxonomy_files_pattern_match?: InputMaybe<Order_By>;
  accept_taxonomy_files_pattern_replace?: InputMaybe<Order_By>;
  airflow_aws_conn_id?: InputMaybe<Order_By>;
  allowed_accounts_aggregate?: InputMaybe<Account_Provider_Aggregate_Order_By>;
  allowed_export_types?: InputMaybe<Order_By>;
  check_audience_files_path?: InputMaybe<Order_By>;
  check_taxonomy_files_path?: InputMaybe<Order_By>;
  direct_oaid_mapping_params?: InputMaybe<Order_By>;
  field_delimiter?: InputMaybe<Order_By>;
  file_format?: InputMaybe<Order_By>;
  file_includes_header?: InputMaybe<Order_By>;
  has_segments_shared_with_caller?: InputMaybe<Order_By>;
  has_sellable_segments?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  joiner_provider_account_id?: InputMaybe<Order_By>;
  load_account_identifier?: InputMaybe<Order_By>;
  load_audience_files_source_types?: InputMaybe<Order_By>;
  load_audience_source_files_matching?: InputMaybe<Order_By>;
  load_audience_source_files_pattern?: InputMaybe<Order_By>;
  load_audience_source_partition_prefix?: InputMaybe<Order_By>;
  load_enable_validate_audience_headers?: InputMaybe<Order_By>;
  load_folder_account_identifier_map?: InputMaybe<Order_By>;
  load_lookback_days?: InputMaybe<Order_By>;
  load_taxonomy_file_path?: InputMaybe<Order_By>;
  load_taxonomy_files_matching?: InputMaybe<Order_By>;
  load_taxonomy_files_pattern?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oaid_namespace?: InputMaybe<Order_By>;
  provider_diff_config?: InputMaybe<Order_By>;
  provider_salt?: InputMaybe<Order_By>;
  raw_gcs_bucket?: InputMaybe<Order_By>;
  ready_gcs_bucket?: InputMaybe<Order_By>;
  s3_upload_inactivity_period_seconds?: InputMaybe<Order_By>;
  segment_creation_method?: InputMaybe<Order_By>;
  segment_delimiter?: InputMaybe<Order_By>;
  segment_external_id_prefix?: InputMaybe<Order_By>;
  segment_inbox_drop?: InputMaybe<Order_By>;
  segment_inbox_matches?: InputMaybe<Order_By>;
  segment_inbox_path?: InputMaybe<Order_By>;
  segment_inbox_taxonomy?: InputMaybe<Order_By>;
  source_bucket?: InputMaybe<Order_By>;
  source_line_regexp_replace?: InputMaybe<Order_By>;
  source_prefix?: InputMaybe<Order_By>;
  source_region?: InputMaybe<Order_By>;
  universe_inbox_drop?: InputMaybe<Order_By>;
  universe_inbox_matches?: InputMaybe<Order_By>;
  universe_inbox_path?: InputMaybe<Order_By>;
  universe_outbox_drop?: InputMaybe<Order_By>;
  universe_outbox_matches?: InputMaybe<Order_By>;
  universe_outbox_path?: InputMaybe<Order_By>;
  update_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider */
export type Provider_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Provider_Prepend_Input = {
  allowed_export_types?: InputMaybe<Scalars['jsonb']['input']>;
  direct_oaid_mapping_params?: InputMaybe<Scalars['jsonb']['input']>;
  oaid_namespace?: InputMaybe<Scalars['jsonb']['input']>;
  provider_diff_config?: InputMaybe<Scalars['jsonb']['input']>;
  source_line_regexp_replace?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "provider" */
export const Provider_Select_Column = {
  /** column name */
  AcceptAudienceFilesPath: 'accept_audience_files_path',
  /** column name */
  AcceptAudienceFilesPatternMatch: 'accept_audience_files_pattern_match',
  /** column name */
  AcceptAudienceFilesPatternReplace: 'accept_audience_files_pattern_replace',
  /** column name */
  AcceptTaxonomyFilesPath: 'accept_taxonomy_files_path',
  /** column name */
  AcceptTaxonomyFilesPatternMatch: 'accept_taxonomy_files_pattern_match',
  /** column name */
  AcceptTaxonomyFilesPatternReplace: 'accept_taxonomy_files_pattern_replace',
  /** column name */
  AirflowAwsConnId: 'airflow_aws_conn_id',
  /** column name */
  AllowedExportTypes: 'allowed_export_types',
  /** column name */
  CheckAudienceFilesPath: 'check_audience_files_path',
  /** column name */
  CheckTaxonomyFilesPath: 'check_taxonomy_files_path',
  /** column name */
  DirectOaidMappingParams: 'direct_oaid_mapping_params',
  /** column name */
  FieldDelimiter: 'field_delimiter',
  /** column name */
  FileFormat: 'file_format',
  /** column name */
  FileIncludesHeader: 'file_includes_header',
  /** column name */
  Id: 'id',
  /** column name */
  JoinerProviderAccountId: 'joiner_provider_account_id',
  /** column name */
  LoadAccountIdentifier: 'load_account_identifier',
  /** column name */
  LoadAudienceFilesSourceTypes: 'load_audience_files_source_types',
  /** column name */
  LoadAudienceSourceFilesMatching: 'load_audience_source_files_matching',
  /** column name */
  LoadAudienceSourceFilesPattern: 'load_audience_source_files_pattern',
  /** column name */
  LoadAudienceSourcePartitionPrefix: 'load_audience_source_partition_prefix',
  /** column name */
  LoadEnableValidateAudienceHeaders: 'load_enable_validate_audience_headers',
  /** column name */
  LoadFolderAccountIdentifierMap: 'load_folder_account_identifier_map',
  /** column name */
  LoadLookbackDays: 'load_lookback_days',
  /** column name */
  LoadTaxonomyFilePath: 'load_taxonomy_file_path',
  /** column name */
  LoadTaxonomyFilesMatching: 'load_taxonomy_files_matching',
  /** column name */
  LoadTaxonomyFilesPattern: 'load_taxonomy_files_pattern',
  /** column name */
  Name: 'name',
  /** column name */
  OaidNamespace: 'oaid_namespace',
  /** column name */
  ProviderDiffConfig: 'provider_diff_config',
  /** column name */
  ProviderSalt: 'provider_salt',
  /** column name */
  RawGcsBucket: 'raw_gcs_bucket',
  /** column name */
  ReadyGcsBucket: 'ready_gcs_bucket',
  /** column name */
  S3UploadInactivityPeriodSeconds: 's3_upload_inactivity_period_seconds',
  /** column name */
  SegmentCreationMethod: 'segment_creation_method',
  /** column name */
  SegmentDelimiter: 'segment_delimiter',
  /** column name */
  SegmentExternalIdPrefix: 'segment_external_id_prefix',
  /** column name */
  SegmentInboxDrop: 'segment_inbox_drop',
  /** column name */
  SegmentInboxMatches: 'segment_inbox_matches',
  /** column name */
  SegmentInboxPath: 'segment_inbox_path',
  /** column name */
  SegmentInboxTaxonomy: 'segment_inbox_taxonomy',
  /** column name */
  SourceBucket: 'source_bucket',
  /** column name */
  SourceLineRegexpReplace: 'source_line_regexp_replace',
  /** column name */
  SourcePrefix: 'source_prefix',
  /** column name */
  SourceRegion: 'source_region',
  /** column name */
  UniverseInboxDrop: 'universe_inbox_drop',
  /** column name */
  UniverseInboxMatches: 'universe_inbox_matches',
  /** column name */
  UniverseInboxPath: 'universe_inbox_path',
  /** column name */
  UniverseOutboxDrop: 'universe_outbox_drop',
  /** column name */
  UniverseOutboxMatches: 'universe_outbox_matches',
  /** column name */
  UniverseOutboxPath: 'universe_outbox_path',
  /** column name */
  UpdateType: 'update_type'
} as const;

export type Provider_Select_Column = typeof Provider_Select_Column[keyof typeof Provider_Select_Column];
/** input type for updating data in table "provider" */
export type Provider_Set_Input = {
  accept_audience_files_path?: InputMaybe<Scalars['String']['input']>;
  accept_audience_files_pattern_match?: InputMaybe<Scalars['String']['input']>;
  accept_audience_files_pattern_replace?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_path?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_pattern_match?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_pattern_replace?: InputMaybe<Scalars['String']['input']>;
  airflow_aws_conn_id?: InputMaybe<Scalars['String']['input']>;
  allowed_export_types?: InputMaybe<Scalars['jsonb']['input']>;
  check_audience_files_path?: InputMaybe<Scalars['String']['input']>;
  check_taxonomy_files_path?: InputMaybe<Scalars['String']['input']>;
  direct_oaid_mapping_params?: InputMaybe<Scalars['jsonb']['input']>;
  field_delimiter?: InputMaybe<Scalars['String']['input']>;
  file_format?: InputMaybe<Scalars['String']['input']>;
  file_includes_header?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  joiner_provider_account_id?: InputMaybe<Scalars['uuid']['input']>;
  load_account_identifier?: InputMaybe<Scalars['String']['input']>;
  load_audience_files_source_types?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_files_matching?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_files_pattern?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_partition_prefix?: InputMaybe<Scalars['String']['input']>;
  load_enable_validate_audience_headers?: InputMaybe<Scalars['Int']['input']>;
  load_folder_account_identifier_map?: InputMaybe<Scalars['String']['input']>;
  load_lookback_days?: InputMaybe<Scalars['Int']['input']>;
  load_taxonomy_file_path?: InputMaybe<Scalars['String']['input']>;
  load_taxonomy_files_matching?: InputMaybe<Scalars['String']['input']>;
  load_taxonomy_files_pattern?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oaid_namespace?: InputMaybe<Scalars['jsonb']['input']>;
  provider_diff_config?: InputMaybe<Scalars['jsonb']['input']>;
  provider_salt?: InputMaybe<Scalars['uuid']['input']>;
  raw_gcs_bucket?: InputMaybe<Scalars['String']['input']>;
  ready_gcs_bucket?: InputMaybe<Scalars['String']['input']>;
  s3_upload_inactivity_period_seconds?: InputMaybe<Scalars['Int']['input']>;
  segment_creation_method?: InputMaybe<Scalars['String']['input']>;
  segment_delimiter?: InputMaybe<Scalars['String']['input']>;
  segment_external_id_prefix?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  segment_inbox_matches?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_path?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_taxonomy?: InputMaybe<Scalars['Boolean']['input']>;
  source_bucket?: InputMaybe<Scalars['String']['input']>;
  source_line_regexp_replace?: InputMaybe<Scalars['jsonb']['input']>;
  source_prefix?: InputMaybe<Scalars['String']['input']>;
  source_region?: InputMaybe<Scalars['String']['input']>;
  universe_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_inbox_matches?: InputMaybe<Scalars['String']['input']>;
  universe_inbox_path?: InputMaybe<Scalars['String']['input']>;
  universe_outbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_outbox_matches?: InputMaybe<Scalars['String']['input']>;
  universe_outbox_path?: InputMaybe<Scalars['String']['input']>;
  update_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Provider_Stddev_Fields = {
  __typename?: 'provider_stddev_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Float']['output']>;
  load_lookback_days?: Maybe<Scalars['Float']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Float']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Provider_Stddev_Pop_Fields = {
  __typename?: 'provider_stddev_pop_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Float']['output']>;
  load_lookback_days?: Maybe<Scalars['Float']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Float']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Provider_Stddev_Samp_Fields = {
  __typename?: 'provider_stddev_samp_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Float']['output']>;
  load_lookback_days?: Maybe<Scalars['Float']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Float']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "provider" */
export type Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Stream_Cursor_Value_Input = {
  accept_audience_files_path?: InputMaybe<Scalars['String']['input']>;
  accept_audience_files_pattern_match?: InputMaybe<Scalars['String']['input']>;
  accept_audience_files_pattern_replace?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_path?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_pattern_match?: InputMaybe<Scalars['String']['input']>;
  accept_taxonomy_files_pattern_replace?: InputMaybe<Scalars['String']['input']>;
  airflow_aws_conn_id?: InputMaybe<Scalars['String']['input']>;
  allowed_export_types?: InputMaybe<Scalars['jsonb']['input']>;
  check_audience_files_path?: InputMaybe<Scalars['String']['input']>;
  check_taxonomy_files_path?: InputMaybe<Scalars['String']['input']>;
  direct_oaid_mapping_params?: InputMaybe<Scalars['jsonb']['input']>;
  field_delimiter?: InputMaybe<Scalars['String']['input']>;
  file_format?: InputMaybe<Scalars['String']['input']>;
  file_includes_header?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  joiner_provider_account_id?: InputMaybe<Scalars['uuid']['input']>;
  load_account_identifier?: InputMaybe<Scalars['String']['input']>;
  load_audience_files_source_types?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_files_matching?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_files_pattern?: InputMaybe<Scalars['String']['input']>;
  load_audience_source_partition_prefix?: InputMaybe<Scalars['String']['input']>;
  load_enable_validate_audience_headers?: InputMaybe<Scalars['Int']['input']>;
  load_folder_account_identifier_map?: InputMaybe<Scalars['String']['input']>;
  load_lookback_days?: InputMaybe<Scalars['Int']['input']>;
  load_taxonomy_file_path?: InputMaybe<Scalars['String']['input']>;
  load_taxonomy_files_matching?: InputMaybe<Scalars['String']['input']>;
  load_taxonomy_files_pattern?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oaid_namespace?: InputMaybe<Scalars['jsonb']['input']>;
  provider_diff_config?: InputMaybe<Scalars['jsonb']['input']>;
  provider_salt?: InputMaybe<Scalars['uuid']['input']>;
  raw_gcs_bucket?: InputMaybe<Scalars['String']['input']>;
  ready_gcs_bucket?: InputMaybe<Scalars['String']['input']>;
  s3_upload_inactivity_period_seconds?: InputMaybe<Scalars['Int']['input']>;
  segment_creation_method?: InputMaybe<Scalars['String']['input']>;
  segment_delimiter?: InputMaybe<Scalars['String']['input']>;
  segment_external_id_prefix?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  segment_inbox_matches?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_path?: InputMaybe<Scalars['String']['input']>;
  segment_inbox_taxonomy?: InputMaybe<Scalars['Boolean']['input']>;
  source_bucket?: InputMaybe<Scalars['String']['input']>;
  source_line_regexp_replace?: InputMaybe<Scalars['jsonb']['input']>;
  source_prefix?: InputMaybe<Scalars['String']['input']>;
  source_region?: InputMaybe<Scalars['String']['input']>;
  universe_inbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_inbox_matches?: InputMaybe<Scalars['String']['input']>;
  universe_inbox_path?: InputMaybe<Scalars['String']['input']>;
  universe_outbox_drop?: InputMaybe<Scalars['Int']['input']>;
  universe_outbox_matches?: InputMaybe<Scalars['String']['input']>;
  universe_outbox_path?: InputMaybe<Scalars['String']['input']>;
  update_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Provider_Sum_Fields = {
  __typename?: 'provider_sum_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Int']['output']>;
  load_lookback_days?: Maybe<Scalars['Int']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Int']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Int']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "provider" */
export const Provider_Update_Column = {
  /** column name */
  AcceptAudienceFilesPath: 'accept_audience_files_path',
  /** column name */
  AcceptAudienceFilesPatternMatch: 'accept_audience_files_pattern_match',
  /** column name */
  AcceptAudienceFilesPatternReplace: 'accept_audience_files_pattern_replace',
  /** column name */
  AcceptTaxonomyFilesPath: 'accept_taxonomy_files_path',
  /** column name */
  AcceptTaxonomyFilesPatternMatch: 'accept_taxonomy_files_pattern_match',
  /** column name */
  AcceptTaxonomyFilesPatternReplace: 'accept_taxonomy_files_pattern_replace',
  /** column name */
  AirflowAwsConnId: 'airflow_aws_conn_id',
  /** column name */
  AllowedExportTypes: 'allowed_export_types',
  /** column name */
  CheckAudienceFilesPath: 'check_audience_files_path',
  /** column name */
  CheckTaxonomyFilesPath: 'check_taxonomy_files_path',
  /** column name */
  DirectOaidMappingParams: 'direct_oaid_mapping_params',
  /** column name */
  FieldDelimiter: 'field_delimiter',
  /** column name */
  FileFormat: 'file_format',
  /** column name */
  FileIncludesHeader: 'file_includes_header',
  /** column name */
  Id: 'id',
  /** column name */
  JoinerProviderAccountId: 'joiner_provider_account_id',
  /** column name */
  LoadAccountIdentifier: 'load_account_identifier',
  /** column name */
  LoadAudienceFilesSourceTypes: 'load_audience_files_source_types',
  /** column name */
  LoadAudienceSourceFilesMatching: 'load_audience_source_files_matching',
  /** column name */
  LoadAudienceSourceFilesPattern: 'load_audience_source_files_pattern',
  /** column name */
  LoadAudienceSourcePartitionPrefix: 'load_audience_source_partition_prefix',
  /** column name */
  LoadEnableValidateAudienceHeaders: 'load_enable_validate_audience_headers',
  /** column name */
  LoadFolderAccountIdentifierMap: 'load_folder_account_identifier_map',
  /** column name */
  LoadLookbackDays: 'load_lookback_days',
  /** column name */
  LoadTaxonomyFilePath: 'load_taxonomy_file_path',
  /** column name */
  LoadTaxonomyFilesMatching: 'load_taxonomy_files_matching',
  /** column name */
  LoadTaxonomyFilesPattern: 'load_taxonomy_files_pattern',
  /** column name */
  Name: 'name',
  /** column name */
  OaidNamespace: 'oaid_namespace',
  /** column name */
  ProviderDiffConfig: 'provider_diff_config',
  /** column name */
  ProviderSalt: 'provider_salt',
  /** column name */
  RawGcsBucket: 'raw_gcs_bucket',
  /** column name */
  ReadyGcsBucket: 'ready_gcs_bucket',
  /** column name */
  S3UploadInactivityPeriodSeconds: 's3_upload_inactivity_period_seconds',
  /** column name */
  SegmentCreationMethod: 'segment_creation_method',
  /** column name */
  SegmentDelimiter: 'segment_delimiter',
  /** column name */
  SegmentExternalIdPrefix: 'segment_external_id_prefix',
  /** column name */
  SegmentInboxDrop: 'segment_inbox_drop',
  /** column name */
  SegmentInboxMatches: 'segment_inbox_matches',
  /** column name */
  SegmentInboxPath: 'segment_inbox_path',
  /** column name */
  SegmentInboxTaxonomy: 'segment_inbox_taxonomy',
  /** column name */
  SourceBucket: 'source_bucket',
  /** column name */
  SourceLineRegexpReplace: 'source_line_regexp_replace',
  /** column name */
  SourcePrefix: 'source_prefix',
  /** column name */
  SourceRegion: 'source_region',
  /** column name */
  UniverseInboxDrop: 'universe_inbox_drop',
  /** column name */
  UniverseInboxMatches: 'universe_inbox_matches',
  /** column name */
  UniverseInboxPath: 'universe_inbox_path',
  /** column name */
  UniverseOutboxDrop: 'universe_outbox_drop',
  /** column name */
  UniverseOutboxMatches: 'universe_outbox_matches',
  /** column name */
  UniverseOutboxPath: 'universe_outbox_path',
  /** column name */
  UpdateType: 'update_type'
} as const;

export type Provider_Update_Column = typeof Provider_Update_Column[keyof typeof Provider_Update_Column];
export type Provider_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Provider_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Provider_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Provider_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Provider_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Provider_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Provider_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Provider_Var_Pop_Fields = {
  __typename?: 'provider_var_pop_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Float']['output']>;
  load_lookback_days?: Maybe<Scalars['Float']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Float']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Provider_Var_Samp_Fields = {
  __typename?: 'provider_var_samp_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Float']['output']>;
  load_lookback_days?: Maybe<Scalars['Float']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Float']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Provider_Variance_Fields = {
  __typename?: 'provider_variance_fields';
  load_enable_validate_audience_headers?: Maybe<Scalars['Float']['output']>;
  load_lookback_days?: Maybe<Scalars['Float']['output']>;
  s3_upload_inactivity_period_seconds?: Maybe<Scalars['Float']['output']>;
  segment_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_inbox_drop?: Maybe<Scalars['Float']['output']>;
  universe_outbox_drop?: Maybe<Scalars['Float']['output']>;
};

/** International Audience Targeting: region */
export type Region = {
  __typename?: 'region';
  code: Scalars['String']['output'];
  /** An array relationship */
  countries: Array<Country>;
  /** An aggregate relationship */
  countries_aggregate: Country_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  regions: Array<Segment_Region>;
  /** An aggregate relationship */
  regions_aggregate: Segment_Region_Aggregate;
};


/** International Audience Targeting: region */
export type RegionCountriesArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


/** International Audience Targeting: region */
export type RegionCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


/** International Audience Targeting: region */
export type RegionRegionsArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


/** International Audience Targeting: region */
export type RegionRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};

/** aggregated selection of "region" */
export type Region_Aggregate = {
  __typename?: 'region_aggregate';
  aggregate?: Maybe<Region_Aggregate_Fields>;
  nodes: Array<Region>;
};

/** aggregate fields of "region" */
export type Region_Aggregate_Fields = {
  __typename?: 'region_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Region_Max_Fields>;
  min?: Maybe<Region_Min_Fields>;
};


/** aggregate fields of "region" */
export type Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp = {
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  countries?: InputMaybe<Country_Bool_Exp>;
  countries_aggregate?: InputMaybe<Country_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  regions?: InputMaybe<Segment_Region_Bool_Exp>;
  regions_aggregate?: InputMaybe<Segment_Region_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "region" */
export const Region_Constraint = {
  /** unique or primary key constraint on columns "code" */
  RegionPkey: 'region_pkey'
} as const;

export type Region_Constraint = typeof Region_Constraint[keyof typeof Region_Constraint];
/** input type for inserting data into table "region" */
export type Region_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Country_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Segment_Region_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Region_Max_Fields = {
  __typename?: 'region_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Region_Min_Fields = {
  __typename?: 'region_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "region" */
export type Region_Mutation_Response = {
  __typename?: 'region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Region>;
};

/** input type for inserting object relation for remote table "region" */
export type Region_Obj_Rel_Insert_Input = {
  data: Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_On_Conflict>;
};

/** on_conflict condition type for table "region" */
export type Region_On_Conflict = {
  constraint: Region_Constraint;
  update_columns?: Array<Region_Update_Column>;
  where?: InputMaybe<Region_Bool_Exp>;
};

/** Ordering options when selecting data from "region". */
export type Region_Order_By = {
  code?: InputMaybe<Order_By>;
  countries_aggregate?: InputMaybe<Country_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  regions_aggregate?: InputMaybe<Segment_Region_Aggregate_Order_By>;
};

/** primary key columns input for table: region */
export type Region_Pk_Columns_Input = {
  code: Scalars['String']['input'];
};

/** select columns of table "region" */
export const Region_Select_Column = {
  /** column name */
  Code: 'code',
  /** column name */
  Name: 'name'
} as const;

export type Region_Select_Column = typeof Region_Select_Column[keyof typeof Region_Select_Column];
/** input type for updating data in table "region" */
export type Region_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "region" */
export type Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Region_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "region" */
export const Region_Update_Column = {
  /** column name */
  Code: 'code',
  /** column name */
  Name: 'name'
} as const;

export type Region_Update_Column = typeof Region_Update_Column[keyof typeof Region_Update_Column];
export type Region_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Region_Set_Input>;
  /** filter the rows which have to be updated */
  where: Region_Bool_Exp;
};

/** columns and relationships of "role" */
export type Role = {
  __typename?: 'role';
  name: Scalars['String']['output'];
  permissions?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "role" */
export type RolePermissionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
};


/** aggregate fields of "role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Role_Append_Input = {
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Bool_Exp>>;
  _not?: InputMaybe<Role_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "role" */
export const Role_Constraint = {
  /** unique or primary key constraint on columns "name" */
  RolePkey: 'role_pkey'
} as const;

export type Role_Constraint = typeof Role_Constraint[keyof typeof Role_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Role_Delete_At_Path_Input = {
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Role_Delete_Elem_Input = {
  permissions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Role_Delete_Key_Input = {
  permissions?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** on_conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: InputMaybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "role". */
export type Role_Order_By = {
  name?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role */
export type Role_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Role_Prepend_Input = {
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "role" */
export const Role_Select_Column = {
  /** column name */
  Name: 'name',
  /** column name */
  Permissions: 'permissions'
} as const;

export type Role_Select_Column = typeof Role_Select_Column[keyof typeof Role_Select_Column];
/** input type for updating data in table "role" */
export type Role_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "role" */
export type Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "role" */
export const Role_Update_Column = {
  /** column name */
  Name: 'name',
  /** column name */
  Permissions: 'permissions'
} as const;

export type Role_Update_Column = typeof Role_Update_Column[keyof typeof Role_Update_Column];
export type Role_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Role_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Role_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Role_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Role_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Role_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Bool_Exp;
};

/** Tracks the Audience Segments uploaded by an Organization */
export type Segment = {
  __typename?: 'segment';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid']['output'];
  allowed_accounts?: Maybe<Scalars['jsonb']['output']>;
  allowed_countries: Scalars['jsonb']['output'];
  bq_location?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "segment_computed_price_cpm" */
  computed_price_cpm?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "segment_computed_price_pom" */
  computed_price_pom?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  countries: Array<Segment_Country>;
  /** An aggregate relationship */
  countries_aggregate: Segment_Country_Aggregate;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gcs_file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_leaf?: Maybe<Scalars['Boolean']['output']>;
  is_nav_only?: Maybe<Scalars['Boolean']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  parent_segment?: Maybe<Scalars['uuid']['output']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: Maybe<Scalars['jsonb']['output']>;
  path?: Maybe<Scalars['jsonb']['output']>;
  price_cpm?: Maybe<Scalars['numeric']['output']>;
  price_pom?: Maybe<Scalars['numeric']['output']>;
  propensity?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  provider?: Maybe<Provider>;
  provider_id?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  regions: Array<Segment_Region>;
  /** An aggregate relationship */
  regions_aggregate: Segment_Region_Aggregate;
  seed_aggregate_segment_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  segment_audiences: Array<Audience_Segment>;
  /** An aggregate relationship */
  segment_audiences_aggregate: Audience_Segment_Aggregate;
  segment_category?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "segment_fee_origin" */
  segment_fee_origin?: Maybe<Scalars['String']['output']>;
  segment_group_id?: Maybe<Scalars['String']['output']>;
  segment_source?: Maybe<Scalars['String']['output']>;
  segment_source_description?: Maybe<Scalars['String']['output']>;
  segment_sub_category?: Maybe<Scalars['String']['output']>;
  segment_type?: Maybe<Scalars['String']['output']>;
  sellable: Scalars['Boolean']['output'];
  /** A computed field, executes function "segment_sharing_type" */
  sharing_type?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  source_bq_tables: Scalars['jsonb']['output'];
  source_detailed_counts?: Maybe<Scalars['jsonb']['output']>;
  source_matched_count?: Maybe<Scalars['bigint']['output']>;
  source_provided_count?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentAllowed_AccountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentAllowed_CountriesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentCountriesArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentPartner_Custom_PricingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentPathArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentRegionsArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentSegment_AudiencesArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentSegment_Audiences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentSource_Bq_TablesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Tracks the Audience Segments uploaded by an Organization */
export type SegmentSource_Detailed_CountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentExcelExportResult = {
  __typename?: 'segmentExcelExportResult';
  fileData: Scalars['String']['output'];
};

/** aggregated selection of "segment" */
export type Segment_Aggregate = {
  __typename?: 'segment_aggregate';
  aggregate?: Maybe<Segment_Aggregate_Fields>;
  nodes: Array<Segment>;
};

export type Segment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Segment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Segment_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Segment_Aggregate_Bool_Exp_Count>;
};

export type Segment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Segment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Segment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Segment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Segment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Segment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "segment" */
export type Segment_Aggregate_Fields = {
  __typename?: 'segment_aggregate_fields';
  avg?: Maybe<Segment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Segment_Max_Fields>;
  min?: Maybe<Segment_Min_Fields>;
  stddev?: Maybe<Segment_Stddev_Fields>;
  stddev_pop?: Maybe<Segment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Segment_Stddev_Samp_Fields>;
  sum?: Maybe<Segment_Sum_Fields>;
  var_pop?: Maybe<Segment_Var_Pop_Fields>;
  var_samp?: Maybe<Segment_Var_Samp_Fields>;
  variance?: Maybe<Segment_Variance_Fields>;
};


/** aggregate fields of "segment" */
export type Segment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "segment" */
export type Segment_Aggregate_Order_By = {
  avg?: InputMaybe<Segment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Segment_Max_Order_By>;
  min?: InputMaybe<Segment_Min_Order_By>;
  stddev?: InputMaybe<Segment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Segment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Segment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Segment_Sum_Order_By>;
  var_pop?: InputMaybe<Segment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Segment_Var_Samp_Order_By>;
  variance?: InputMaybe<Segment_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Segment_Append_Input = {
  allowed_accounts?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Scalars['jsonb']['input']>;
  path?: InputMaybe<Scalars['jsonb']['input']>;
  source_bq_tables?: InputMaybe<Scalars['jsonb']['input']>;
  source_detailed_counts?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "segment" */
export type Segment_Arr_Rel_Insert_Input = {
  data: Array<Segment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Segment_On_Conflict>;
};

/** aggregate avg on columns */
export type Segment_Avg_Fields = {
  __typename?: 'segment_avg_fields';
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  source_matched_count?: Maybe<Scalars['Float']['output']>;
  source_provided_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "segment" */
export type Segment_Avg_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "segment". All fields are combined with a logical 'AND'. */
export type Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Segment_Bool_Exp>>;
  _not?: InputMaybe<Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Segment_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  allowed_accounts?: InputMaybe<Jsonb_Comparison_Exp>;
  allowed_countries?: InputMaybe<Jsonb_Comparison_Exp>;
  bq_location?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  computed_price_cpm?: InputMaybe<Numeric_Comparison_Exp>;
  computed_price_pom?: InputMaybe<Numeric_Comparison_Exp>;
  countries?: InputMaybe<Segment_Country_Bool_Exp>;
  countries_aggregate?: InputMaybe<Segment_Country_Aggregate_Bool_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expiration_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gcs_file_path?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_leaf?: InputMaybe<Boolean_Comparison_Exp>;
  is_nav_only?: InputMaybe<Boolean_Comparison_Exp>;
  lookalike_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_segment?: InputMaybe<Uuid_Comparison_Exp>;
  partner_custom_pricing?: InputMaybe<Jsonb_Comparison_Exp>;
  path?: InputMaybe<Jsonb_Comparison_Exp>;
  price_cpm?: InputMaybe<Numeric_Comparison_Exp>;
  price_pom?: InputMaybe<Numeric_Comparison_Exp>;
  propensity?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Provider_Bool_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  reach?: InputMaybe<Int_Comparison_Exp>;
  regions?: InputMaybe<Segment_Region_Bool_Exp>;
  regions_aggregate?: InputMaybe<Segment_Region_Aggregate_Bool_Exp>;
  seed_aggregate_segment_id?: InputMaybe<Uuid_Comparison_Exp>;
  segment_audiences?: InputMaybe<Audience_Segment_Bool_Exp>;
  segment_audiences_aggregate?: InputMaybe<Audience_Segment_Aggregate_Bool_Exp>;
  segment_category?: InputMaybe<String_Comparison_Exp>;
  segment_fee_origin?: InputMaybe<String_Comparison_Exp>;
  segment_group_id?: InputMaybe<String_Comparison_Exp>;
  segment_source?: InputMaybe<String_Comparison_Exp>;
  segment_source_description?: InputMaybe<String_Comparison_Exp>;
  segment_sub_category?: InputMaybe<String_Comparison_Exp>;
  segment_type?: InputMaybe<String_Comparison_Exp>;
  sellable?: InputMaybe<Boolean_Comparison_Exp>;
  sharing_type?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_bq_tables?: InputMaybe<Jsonb_Comparison_Exp>;
  source_detailed_counts?: InputMaybe<Jsonb_Comparison_Exp>;
  source_matched_count?: InputMaybe<Bigint_Comparison_Exp>;
  source_provided_count?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  sub_category?: InputMaybe<String_Comparison_Exp>;
  sub_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "segment" */
export const Segment_Constraint = {
  /** unique or primary key constraint on columns "external_id", "account_id" */
  AccountIdExternalId: 'account_id__external_id',
  /** unique or primary key constraint on columns "name", "account_id" */
  SegmentAccountIdNameKey: 'segment_account_id_name_key',
  /** unique or primary key constraint on columns "id" */
  SegmentPkey: 'segment_pkey'
} as const;

export type Segment_Constraint = typeof Segment_Constraint[keyof typeof Segment_Constraint];
/** Segment <-> country M2M relationship */
export type Segment_Country = {
  __typename?: 'segment_country';
  /** An object relationship */
  country: Country;
  country_code: Scalars['String']['output'];
  /** An object relationship */
  segment: Segment;
  segment_id: Scalars['uuid']['output'];
};

/** aggregated selection of "segment_country" */
export type Segment_Country_Aggregate = {
  __typename?: 'segment_country_aggregate';
  aggregate?: Maybe<Segment_Country_Aggregate_Fields>;
  nodes: Array<Segment_Country>;
};

export type Segment_Country_Aggregate_Bool_Exp = {
  count?: InputMaybe<Segment_Country_Aggregate_Bool_Exp_Count>;
};

export type Segment_Country_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Segment_Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Segment_Country_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "segment_country" */
export type Segment_Country_Aggregate_Fields = {
  __typename?: 'segment_country_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Segment_Country_Max_Fields>;
  min?: Maybe<Segment_Country_Min_Fields>;
};


/** aggregate fields of "segment_country" */
export type Segment_Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Segment_Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "segment_country" */
export type Segment_Country_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Segment_Country_Max_Order_By>;
  min?: InputMaybe<Segment_Country_Min_Order_By>;
};

/** input type for inserting array relation for remote table "segment_country" */
export type Segment_Country_Arr_Rel_Insert_Input = {
  data: Array<Segment_Country_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Segment_Country_On_Conflict>;
};

/** Boolean expression to filter rows from the table "segment_country". All fields are combined with a logical 'AND'. */
export type Segment_Country_Bool_Exp = {
  _and?: InputMaybe<Array<Segment_Country_Bool_Exp>>;
  _not?: InputMaybe<Segment_Country_Bool_Exp>;
  _or?: InputMaybe<Array<Segment_Country_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  segment_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "segment_country" */
export const Segment_Country_Constraint = {
  /** unique or primary key constraint on columns "country_code", "segment_id" */
  SegmentCountryPkey: 'segment_country_pkey'
} as const;

export type Segment_Country_Constraint = typeof Segment_Country_Constraint[keyof typeof Segment_Country_Constraint];
/** input type for inserting data into table "segment_country" */
export type Segment_Country_Insert_Input = {
  country?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Segment_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Segment_Country_Max_Fields = {
  __typename?: 'segment_country_max_fields';
  country_code?: Maybe<Scalars['String']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "segment_country" */
export type Segment_Country_Max_Order_By = {
  country_code?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Segment_Country_Min_Fields = {
  __typename?: 'segment_country_min_fields';
  country_code?: Maybe<Scalars['String']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "segment_country" */
export type Segment_Country_Min_Order_By = {
  country_code?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "segment_country" */
export type Segment_Country_Mutation_Response = {
  __typename?: 'segment_country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Segment_Country>;
};

/** on_conflict condition type for table "segment_country" */
export type Segment_Country_On_Conflict = {
  constraint: Segment_Country_Constraint;
  update_columns?: Array<Segment_Country_Update_Column>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};

/** Ordering options when selecting data from "segment_country". */
export type Segment_Country_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  country_code?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: segment_country */
export type Segment_Country_Pk_Columns_Input = {
  country_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};

/** select columns of table "segment_country" */
export const Segment_Country_Select_Column = {
  /** column name */
  CountryCode: 'country_code',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Segment_Country_Select_Column = typeof Segment_Country_Select_Column[keyof typeof Segment_Country_Select_Column];
/** input type for updating data in table "segment_country" */
export type Segment_Country_Set_Input = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "segment_country" */
export type Segment_Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Segment_Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Segment_Country_Stream_Cursor_Value_Input = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "segment_country" */
export const Segment_Country_Update_Column = {
  /** column name */
  CountryCode: 'country_code',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Segment_Country_Update_Column = typeof Segment_Country_Update_Column[keyof typeof Segment_Country_Update_Column];
export type Segment_Country_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Segment_Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Segment_Country_Bool_Exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Segment_Delete_At_Path_Input = {
  allowed_accounts?: InputMaybe<Array<Scalars['String']['input']>>;
  allowed_countries?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Array<Scalars['String']['input']>>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  source_bq_tables?: InputMaybe<Array<Scalars['String']['input']>>;
  source_detailed_counts?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Segment_Delete_Elem_Input = {
  allowed_accounts?: InputMaybe<Scalars['Int']['input']>;
  allowed_countries?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['Int']['input']>;
  source_bq_tables?: InputMaybe<Scalars['Int']['input']>;
  source_detailed_counts?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Segment_Delete_Key_Input = {
  allowed_accounts?: InputMaybe<Scalars['String']['input']>;
  allowed_countries?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  source_bq_tables?: InputMaybe<Scalars['String']['input']>;
  source_detailed_counts?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "segment" */
export type Segment_Inc_Input = {
  price_cpm?: InputMaybe<Scalars['numeric']['input']>;
  price_pom?: InputMaybe<Scalars['numeric']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  source_matched_count?: InputMaybe<Scalars['bigint']['input']>;
  source_provided_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "segment" */
export type Segment_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  allowed_accounts?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  bq_location?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Segment_Country_Arr_Rel_Insert_Input>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gcs_file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_leaf?: InputMaybe<Scalars['Boolean']['input']>;
  is_nav_only?: InputMaybe<Scalars['Boolean']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_segment?: InputMaybe<Scalars['uuid']['input']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Scalars['jsonb']['input']>;
  path?: InputMaybe<Scalars['jsonb']['input']>;
  price_cpm?: InputMaybe<Scalars['numeric']['input']>;
  price_pom?: InputMaybe<Scalars['numeric']['input']>;
  propensity?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  regions?: InputMaybe<Segment_Region_Arr_Rel_Insert_Input>;
  seed_aggregate_segment_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_audiences?: InputMaybe<Audience_Segment_Arr_Rel_Insert_Input>;
  segment_category?: InputMaybe<Scalars['String']['input']>;
  segment_group_id?: InputMaybe<Scalars['String']['input']>;
  segment_source?: InputMaybe<Scalars['String']['input']>;
  segment_source_description?: InputMaybe<Scalars['String']['input']>;
  segment_sub_category?: InputMaybe<Scalars['String']['input']>;
  segment_type?: InputMaybe<Scalars['String']['input']>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_bq_tables?: InputMaybe<Scalars['jsonb']['input']>;
  source_detailed_counts?: InputMaybe<Scalars['jsonb']['input']>;
  source_matched_count?: InputMaybe<Scalars['bigint']['input']>;
  source_provided_count?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Segment_Max_Fields = {
  __typename?: 'segment_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  bq_location?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gcs_file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_segment?: Maybe<Scalars['uuid']['output']>;
  price_cpm?: Maybe<Scalars['numeric']['output']>;
  price_pom?: Maybe<Scalars['numeric']['output']>;
  propensity?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  seed_aggregate_segment_id?: Maybe<Scalars['uuid']['output']>;
  segment_category?: Maybe<Scalars['String']['output']>;
  segment_group_id?: Maybe<Scalars['String']['output']>;
  segment_source?: Maybe<Scalars['String']['output']>;
  segment_source_description?: Maybe<Scalars['String']['output']>;
  segment_sub_category?: Maybe<Scalars['String']['output']>;
  segment_type?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  source_matched_count?: Maybe<Scalars['bigint']['output']>;
  source_provided_count?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "segment" */
export type Segment_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  bq_location?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gcs_file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_segment?: InputMaybe<Order_By>;
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  propensity?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  seed_aggregate_segment_id?: InputMaybe<Order_By>;
  segment_category?: InputMaybe<Order_By>;
  segment_group_id?: InputMaybe<Order_By>;
  segment_source?: InputMaybe<Order_By>;
  segment_source_description?: InputMaybe<Order_By>;
  segment_sub_category?: InputMaybe<Order_By>;
  segment_type?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_category?: InputMaybe<Order_By>;
  sub_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Segment_Min_Fields = {
  __typename?: 'segment_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  bq_location?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gcs_file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lookalike_definition_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_segment?: Maybe<Scalars['uuid']['output']>;
  price_cpm?: Maybe<Scalars['numeric']['output']>;
  price_pom?: Maybe<Scalars['numeric']['output']>;
  propensity?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  seed_aggregate_segment_id?: Maybe<Scalars['uuid']['output']>;
  segment_category?: Maybe<Scalars['String']['output']>;
  segment_group_id?: Maybe<Scalars['String']['output']>;
  segment_source?: Maybe<Scalars['String']['output']>;
  segment_source_description?: Maybe<Scalars['String']['output']>;
  segment_sub_category?: Maybe<Scalars['String']['output']>;
  segment_type?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  source_matched_count?: Maybe<Scalars['bigint']['output']>;
  source_provided_count?: Maybe<Scalars['bigint']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "segment" */
export type Segment_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  bq_location?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gcs_file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_segment?: InputMaybe<Order_By>;
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  propensity?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  seed_aggregate_segment_id?: InputMaybe<Order_By>;
  segment_category?: InputMaybe<Order_By>;
  segment_group_id?: InputMaybe<Order_By>;
  segment_source?: InputMaybe<Order_By>;
  segment_source_description?: InputMaybe<Order_By>;
  segment_sub_category?: InputMaybe<Order_By>;
  segment_type?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_category?: InputMaybe<Order_By>;
  sub_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "segment" */
export type Segment_Mutation_Response = {
  __typename?: 'segment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Segment>;
};

/** input type for inserting object relation for remote table "segment" */
export type Segment_Obj_Rel_Insert_Input = {
  data: Segment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Segment_On_Conflict>;
};

/** on_conflict condition type for table "segment" */
export type Segment_On_Conflict = {
  constraint: Segment_Constraint;
  update_columns?: Array<Segment_Update_Column>;
  where?: InputMaybe<Segment_Bool_Exp>;
};

/** Ordering options when selecting data from "segment". */
export type Segment_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  allowed_accounts?: InputMaybe<Order_By>;
  allowed_countries?: InputMaybe<Order_By>;
  bq_location?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  computed_price_cpm?: InputMaybe<Order_By>;
  computed_price_pom?: InputMaybe<Order_By>;
  countries_aggregate?: InputMaybe<Segment_Country_Aggregate_Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gcs_file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_leaf?: InputMaybe<Order_By>;
  is_nav_only?: InputMaybe<Order_By>;
  lookalike_definition_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_segment?: InputMaybe<Order_By>;
  partner_custom_pricing?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  propensity?: InputMaybe<Order_By>;
  provider?: InputMaybe<Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  regions_aggregate?: InputMaybe<Segment_Region_Aggregate_Order_By>;
  seed_aggregate_segment_id?: InputMaybe<Order_By>;
  segment_audiences_aggregate?: InputMaybe<Audience_Segment_Aggregate_Order_By>;
  segment_category?: InputMaybe<Order_By>;
  segment_fee_origin?: InputMaybe<Order_By>;
  segment_group_id?: InputMaybe<Order_By>;
  segment_source?: InputMaybe<Order_By>;
  segment_source_description?: InputMaybe<Order_By>;
  segment_sub_category?: InputMaybe<Order_By>;
  segment_type?: InputMaybe<Order_By>;
  sellable?: InputMaybe<Order_By>;
  sharing_type?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_bq_tables?: InputMaybe<Order_By>;
  source_detailed_counts?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_category?: InputMaybe<Order_By>;
  sub_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: segment */
export type Segment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Segment_Prepend_Input = {
  allowed_accounts?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Scalars['jsonb']['input']>;
  path?: InputMaybe<Scalars['jsonb']['input']>;
  source_bq_tables?: InputMaybe<Scalars['jsonb']['input']>;
  source_detailed_counts?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Segment <-> region M2M relationship */
export type Segment_Region = {
  __typename?: 'segment_region';
  /** An object relationship */
  region: Region;
  region_code: Scalars['String']['output'];
  /** An object relationship */
  segment: Segment;
  segment_id: Scalars['uuid']['output'];
};

/** aggregated selection of "segment_region" */
export type Segment_Region_Aggregate = {
  __typename?: 'segment_region_aggregate';
  aggregate?: Maybe<Segment_Region_Aggregate_Fields>;
  nodes: Array<Segment_Region>;
};

export type Segment_Region_Aggregate_Bool_Exp = {
  count?: InputMaybe<Segment_Region_Aggregate_Bool_Exp_Count>;
};

export type Segment_Region_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Segment_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Segment_Region_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "segment_region" */
export type Segment_Region_Aggregate_Fields = {
  __typename?: 'segment_region_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Segment_Region_Max_Fields>;
  min?: Maybe<Segment_Region_Min_Fields>;
};


/** aggregate fields of "segment_region" */
export type Segment_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Segment_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "segment_region" */
export type Segment_Region_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Segment_Region_Max_Order_By>;
  min?: InputMaybe<Segment_Region_Min_Order_By>;
};

/** input type for inserting array relation for remote table "segment_region" */
export type Segment_Region_Arr_Rel_Insert_Input = {
  data: Array<Segment_Region_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Segment_Region_On_Conflict>;
};

/** Boolean expression to filter rows from the table "segment_region". All fields are combined with a logical 'AND'. */
export type Segment_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Segment_Region_Bool_Exp>>;
  _not?: InputMaybe<Segment_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Segment_Region_Bool_Exp>>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_code?: InputMaybe<String_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  segment_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "segment_region" */
export const Segment_Region_Constraint = {
  /** unique or primary key constraint on columns "segment_id", "region_code" */
  SegmentRegionPkey: 'segment_region_pkey'
} as const;

export type Segment_Region_Constraint = typeof Segment_Region_Constraint[keyof typeof Segment_Region_Constraint];
/** input type for inserting data into table "segment_region" */
export type Segment_Region_Insert_Input = {
  region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  region_code?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Segment_Obj_Rel_Insert_Input>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Segment_Region_Max_Fields = {
  __typename?: 'segment_region_max_fields';
  region_code?: Maybe<Scalars['String']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "segment_region" */
export type Segment_Region_Max_Order_By = {
  region_code?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Segment_Region_Min_Fields = {
  __typename?: 'segment_region_min_fields';
  region_code?: Maybe<Scalars['String']['output']>;
  segment_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "segment_region" */
export type Segment_Region_Min_Order_By = {
  region_code?: InputMaybe<Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "segment_region" */
export type Segment_Region_Mutation_Response = {
  __typename?: 'segment_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Segment_Region>;
};

/** on_conflict condition type for table "segment_region" */
export type Segment_Region_On_Conflict = {
  constraint: Segment_Region_Constraint;
  update_columns?: Array<Segment_Region_Update_Column>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "segment_region". */
export type Segment_Region_Order_By = {
  region?: InputMaybe<Region_Order_By>;
  region_code?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  segment_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: segment_region */
export type Segment_Region_Pk_Columns_Input = {
  region_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};

/** select columns of table "segment_region" */
export const Segment_Region_Select_Column = {
  /** column name */
  RegionCode: 'region_code',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Segment_Region_Select_Column = typeof Segment_Region_Select_Column[keyof typeof Segment_Region_Select_Column];
/** input type for updating data in table "segment_region" */
export type Segment_Region_Set_Input = {
  region_code?: InputMaybe<Scalars['String']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "segment_region" */
export type Segment_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Segment_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Segment_Region_Stream_Cursor_Value_Input = {
  region_code?: InputMaybe<Scalars['String']['input']>;
  segment_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "segment_region" */
export const Segment_Region_Update_Column = {
  /** column name */
  RegionCode: 'region_code',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type Segment_Region_Update_Column = typeof Segment_Region_Update_Column[keyof typeof Segment_Region_Update_Column];
export type Segment_Region_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Segment_Region_Set_Input>;
  /** filter the rows which have to be updated */
  where: Segment_Region_Bool_Exp;
};

/** select columns of table "segment" */
export const Segment_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AllowedAccounts: 'allowed_accounts',
  /** column name */
  AllowedCountries: 'allowed_countries',
  /** column name */
  BqLocation: 'bq_location',
  /** column name */
  Category: 'category',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Description: 'description',
  /** column name */
  ExpirationDate: 'expiration_date',
  /** column name */
  ExternalId: 'external_id',
  /** column name */
  FullName: 'full_name',
  /** column name */
  GcsFilePath: 'gcs_file_path',
  /** column name */
  Id: 'id',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsLeaf: 'is_leaf',
  /** column name */
  IsNavOnly: 'is_nav_only',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Name: 'name',
  /** column name */
  ParentSegment: 'parent_segment',
  /** column name */
  PartnerCustomPricing: 'partner_custom_pricing',
  /** column name */
  Path: 'path',
  /** column name */
  PriceCpm: 'price_cpm',
  /** column name */
  PricePom: 'price_pom',
  /** column name */
  Propensity: 'propensity',
  /** column name */
  ProviderId: 'provider_id',
  /** column name */
  Reach: 'reach',
  /** column name */
  SeedAggregateSegmentId: 'seed_aggregate_segment_id',
  /** column name */
  SegmentCategory: 'segment_category',
  /** column name */
  SegmentGroupId: 'segment_group_id',
  /** column name */
  SegmentSource: 'segment_source',
  /** column name */
  SegmentSourceDescription: 'segment_source_description',
  /** column name */
  SegmentSubCategory: 'segment_sub_category',
  /** column name */
  SegmentType: 'segment_type',
  /** column name */
  Sellable: 'sellable',
  /** column name */
  Source: 'source',
  /** column name */
  SourceBqTables: 'source_bq_tables',
  /** column name */
  SourceDetailedCounts: 'source_detailed_counts',
  /** column name */
  SourceMatchedCount: 'source_matched_count',
  /** column name */
  SourceProvidedCount: 'source_provided_count',
  /** column name */
  Status: 'status',
  /** column name */
  SubCategory: 'sub_category',
  /** column name */
  SubType: 'sub_type',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Segment_Select_Column = typeof Segment_Select_Column[keyof typeof Segment_Select_Column];
/** select "segment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "segment" */
export const Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsLeaf: 'is_leaf',
  /** column name */
  IsNavOnly: 'is_nav_only',
  /** column name */
  Sellable: 'sellable'
} as const;

export type Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "segment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "segment" */
export const Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsLeaf: 'is_leaf',
  /** column name */
  IsNavOnly: 'is_nav_only',
  /** column name */
  Sellable: 'sellable'
} as const;

export type Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Segment_Select_Column_Segment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "segment" */
export type Segment_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  allowed_accounts?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  bq_location?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gcs_file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_leaf?: InputMaybe<Scalars['Boolean']['input']>;
  is_nav_only?: InputMaybe<Scalars['Boolean']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_segment?: InputMaybe<Scalars['uuid']['input']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Scalars['jsonb']['input']>;
  path?: InputMaybe<Scalars['jsonb']['input']>;
  price_cpm?: InputMaybe<Scalars['numeric']['input']>;
  price_pom?: InputMaybe<Scalars['numeric']['input']>;
  propensity?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  seed_aggregate_segment_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_category?: InputMaybe<Scalars['String']['input']>;
  segment_group_id?: InputMaybe<Scalars['String']['input']>;
  segment_source?: InputMaybe<Scalars['String']['input']>;
  segment_source_description?: InputMaybe<Scalars['String']['input']>;
  segment_sub_category?: InputMaybe<Scalars['String']['input']>;
  segment_type?: InputMaybe<Scalars['String']['input']>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_bq_tables?: InputMaybe<Scalars['jsonb']['input']>;
  source_detailed_counts?: InputMaybe<Scalars['jsonb']['input']>;
  source_matched_count?: InputMaybe<Scalars['bigint']['input']>;
  source_provided_count?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Segment_Stddev_Fields = {
  __typename?: 'segment_stddev_fields';
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  source_matched_count?: Maybe<Scalars['Float']['output']>;
  source_provided_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "segment" */
export type Segment_Stddev_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Segment_Stddev_Pop_Fields = {
  __typename?: 'segment_stddev_pop_fields';
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  source_matched_count?: Maybe<Scalars['Float']['output']>;
  source_provided_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "segment" */
export type Segment_Stddev_Pop_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Segment_Stddev_Samp_Fields = {
  __typename?: 'segment_stddev_samp_fields';
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  source_matched_count?: Maybe<Scalars['Float']['output']>;
  source_provided_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "segment" */
export type Segment_Stddev_Samp_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "segment" */
export type Segment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Segment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Segment_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  allowed_accounts?: InputMaybe<Scalars['jsonb']['input']>;
  allowed_countries?: InputMaybe<Scalars['jsonb']['input']>;
  bq_location?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gcs_file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_leaf?: InputMaybe<Scalars['Boolean']['input']>;
  is_nav_only?: InputMaybe<Scalars['Boolean']['input']>;
  lookalike_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_segment?: InputMaybe<Scalars['uuid']['input']>;
  /** Per-partner price overrides keyed by exchange_account_network_id. Format: {"<exchange_account_network_id>": {"price_pom": <numeric>, "price_cpm": <numeric>}}. NULL when there is no partner-specific pricing (empty maps are normalized to NULL). */
  partner_custom_pricing?: InputMaybe<Scalars['jsonb']['input']>;
  path?: InputMaybe<Scalars['jsonb']['input']>;
  price_cpm?: InputMaybe<Scalars['numeric']['input']>;
  price_pom?: InputMaybe<Scalars['numeric']['input']>;
  propensity?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  seed_aggregate_segment_id?: InputMaybe<Scalars['uuid']['input']>;
  segment_category?: InputMaybe<Scalars['String']['input']>;
  segment_group_id?: InputMaybe<Scalars['String']['input']>;
  segment_source?: InputMaybe<Scalars['String']['input']>;
  segment_source_description?: InputMaybe<Scalars['String']['input']>;
  segment_sub_category?: InputMaybe<Scalars['String']['input']>;
  segment_type?: InputMaybe<Scalars['String']['input']>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_bq_tables?: InputMaybe<Scalars['jsonb']['input']>;
  source_detailed_counts?: InputMaybe<Scalars['jsonb']['input']>;
  source_matched_count?: InputMaybe<Scalars['bigint']['input']>;
  source_provided_count?: InputMaybe<Scalars['bigint']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  sub_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Segment_Sum_Fields = {
  __typename?: 'segment_sum_fields';
  price_cpm?: Maybe<Scalars['numeric']['output']>;
  price_pom?: Maybe<Scalars['numeric']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  source_matched_count?: Maybe<Scalars['bigint']['output']>;
  source_provided_count?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "segment" */
export type Segment_Sum_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

/** update columns of table "segment" */
export const Segment_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  AllowedAccounts: 'allowed_accounts',
  /** column name */
  AllowedCountries: 'allowed_countries',
  /** column name */
  BqLocation: 'bq_location',
  /** column name */
  Category: 'category',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  Description: 'description',
  /** column name */
  ExpirationDate: 'expiration_date',
  /** column name */
  ExternalId: 'external_id',
  /** column name */
  FullName: 'full_name',
  /** column name */
  GcsFilePath: 'gcs_file_path',
  /** column name */
  Id: 'id',
  /** column name */
  IsArchived: 'is_archived',
  /** column name */
  IsLeaf: 'is_leaf',
  /** column name */
  IsNavOnly: 'is_nav_only',
  /** column name */
  LookalikeDefinitionId: 'lookalike_definition_id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Name: 'name',
  /** column name */
  ParentSegment: 'parent_segment',
  /** column name */
  PartnerCustomPricing: 'partner_custom_pricing',
  /** column name */
  Path: 'path',
  /** column name */
  PriceCpm: 'price_cpm',
  /** column name */
  PricePom: 'price_pom',
  /** column name */
  Propensity: 'propensity',
  /** column name */
  ProviderId: 'provider_id',
  /** column name */
  Reach: 'reach',
  /** column name */
  SeedAggregateSegmentId: 'seed_aggregate_segment_id',
  /** column name */
  SegmentCategory: 'segment_category',
  /** column name */
  SegmentGroupId: 'segment_group_id',
  /** column name */
  SegmentSource: 'segment_source',
  /** column name */
  SegmentSourceDescription: 'segment_source_description',
  /** column name */
  SegmentSubCategory: 'segment_sub_category',
  /** column name */
  SegmentType: 'segment_type',
  /** column name */
  Sellable: 'sellable',
  /** column name */
  Source: 'source',
  /** column name */
  SourceBqTables: 'source_bq_tables',
  /** column name */
  SourceDetailedCounts: 'source_detailed_counts',
  /** column name */
  SourceMatchedCount: 'source_matched_count',
  /** column name */
  SourceProvidedCount: 'source_provided_count',
  /** column name */
  Status: 'status',
  /** column name */
  SubCategory: 'sub_category',
  /** column name */
  SubType: 'sub_type',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type Segment_Update_Column = typeof Segment_Update_Column[keyof typeof Segment_Update_Column];
export type Segment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Segment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Segment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Segment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Segment_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Segment_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Segment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Segment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Segment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Segment_Var_Pop_Fields = {
  __typename?: 'segment_var_pop_fields';
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  source_matched_count?: Maybe<Scalars['Float']['output']>;
  source_provided_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "segment" */
export type Segment_Var_Pop_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Segment_Var_Samp_Fields = {
  __typename?: 'segment_var_samp_fields';
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  source_matched_count?: Maybe<Scalars['Float']['output']>;
  source_provided_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "segment" */
export type Segment_Var_Samp_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Segment_Variance_Fields = {
  __typename?: 'segment_variance_fields';
  price_cpm?: Maybe<Scalars['Float']['output']>;
  price_pom?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  source_matched_count?: Maybe<Scalars['Float']['output']>;
  source_provided_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "segment" */
export type Segment_Variance_Order_By = {
  price_cpm?: InputMaybe<Order_By>;
  price_pom?: InputMaybe<Order_By>;
  reach?: InputMaybe<Order_By>;
  source_matched_count?: InputMaybe<Order_By>;
  source_provided_count?: InputMaybe<Order_By>;
};

export const SortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type SortOrderEnum = typeof SortOrderEnum[keyof typeof SortOrderEnum];
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /** fetch aggregated fields from the table: "account" */
  account_aggregate: Account_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  account_by_pk?: Maybe<Account>;
  /** fetch data from the table: "account_feature_flags" */
  account_feature_flags: Array<Account_Feature_Flags>;
  /** fetch aggregated fields from the table: "account_feature_flags" */
  account_feature_flags_aggregate: Account_Feature_Flags_Aggregate;
  /** fetch data from the table: "account_feature_flags" using primary key columns */
  account_feature_flags_by_pk?: Maybe<Account_Feature_Flags>;
  /** fetch data from the table in a streaming manner: "account_feature_flags" */
  account_feature_flags_stream: Array<Account_Feature_Flags>;
  /** fetch data from the table: "account_list" */
  account_list: Array<Account_List>;
  /** fetch aggregated fields from the table: "account_list" */
  account_list_aggregate: Account_List_Aggregate;
  /** fetch data from the table in a streaming manner: "account_list" */
  account_list_stream: Array<Account_List>;
  /** fetch data from the table: "account_provider" */
  account_provider: Array<Account_Provider>;
  /** fetch aggregated fields from the table: "account_provider" */
  account_provider_aggregate: Account_Provider_Aggregate;
  /** fetch data from the table: "account_provider" using primary key columns */
  account_provider_by_pk?: Maybe<Account_Provider>;
  /** fetch data from the table in a streaming manner: "account_provider" */
  account_provider_stream: Array<Account_Provider>;
  /** fetch data from the table in a streaming manner: "account" */
  account_stream: Array<Account>;
  /** fetch data from the table: "audience" */
  audience: Array<Audience>;
  /** fetch aggregated fields from the table: "audience" */
  audience_aggregate: Audience_Aggregate;
  /** fetch data from the table: "audience" using primary key columns */
  audience_by_pk?: Maybe<Audience>;
  /** fetch data from the table: "audience_segment" */
  audience_segment: Array<Audience_Segment>;
  /** fetch aggregated fields from the table: "audience_segment" */
  audience_segment_aggregate: Audience_Segment_Aggregate;
  /** fetch data from the table: "audience_segment" using primary key columns */
  audience_segment_by_pk?: Maybe<Audience_Segment>;
  /** fetch data from the table in a streaming manner: "audience_segment" */
  audience_segment_stream: Array<Audience_Segment>;
  /** fetch data from the table in a streaming manner: "audience" */
  audience_stream: Array<Audience>;
  /** fetch data from the table: "bq_resource" */
  bq_resource: Array<Bq_Resource>;
  /** fetch aggregated fields from the table: "bq_resource" */
  bq_resource_aggregate: Bq_Resource_Aggregate;
  /** fetch data from the table: "bq_resource" using primary key columns */
  bq_resource_by_pk?: Maybe<Bq_Resource>;
  /** fetch data from the table in a streaming manner: "bq_resource" */
  bq_resource_stream: Array<Bq_Resource>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  /** fetch data from the table: "export" */
  export: Array<Export>;
  /** fetch aggregated fields from the table: "export" */
  export_aggregate: Export_Aggregate;
  /** fetch data from the table: "export" using primary key columns */
  export_by_pk?: Maybe<Export>;
  /** fetch data from the table: "export_status_timeline" */
  export_status_timeline: Array<Export_Status_Timeline>;
  /** fetch aggregated fields from the table: "export_status_timeline" */
  export_status_timeline_aggregate: Export_Status_Timeline_Aggregate;
  /** fetch data from the table: "export_status_timeline" using primary key columns */
  export_status_timeline_by_pk?: Maybe<Export_Status_Timeline>;
  /** fetch data from the table in a streaming manner: "export_status_timeline" */
  export_status_timeline_stream: Array<Export_Status_Timeline>;
  /** fetch data from the table in a streaming manner: "export" */
  export_stream: Array<Export>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table in a streaming manner: "feature_flags" */
  feature_flags_stream: Array<Feature_Flags>;
  /** fetch data from the table: "lookalike_definition" */
  lookalike_definition: Array<Lookalike_Definition>;
  /** fetch aggregated fields from the table: "lookalike_definition" */
  lookalike_definition_aggregate: Lookalike_Definition_Aggregate;
  /** fetch data from the table: "lookalike_definition" using primary key columns */
  lookalike_definition_by_pk?: Maybe<Lookalike_Definition>;
  /** fetch data from the table in a streaming manner: "lookalike_definition" */
  lookalike_definition_stream: Array<Lookalike_Definition>;
  /** fetch data from the table: "lookalike_job_run" */
  lookalike_job_run: Array<Lookalike_Job_Run>;
  /** fetch aggregated fields from the table: "lookalike_job_run" */
  lookalike_job_run_aggregate: Lookalike_Job_Run_Aggregate;
  /** fetch data from the table: "lookalike_job_run" using primary key columns */
  lookalike_job_run_by_pk?: Maybe<Lookalike_Job_Run>;
  /** fetch data from the table in a streaming manner: "lookalike_job_run" */
  lookalike_job_run_stream: Array<Lookalike_Job_Run>;
  /** fetch data from the table: "lookalike_seed_source" */
  lookalike_seed_source: Array<Lookalike_Seed_Source>;
  /** fetch aggregated fields from the table: "lookalike_seed_source" */
  lookalike_seed_source_aggregate: Lookalike_Seed_Source_Aggregate;
  /** fetch data from the table: "lookalike_seed_source" using primary key columns */
  lookalike_seed_source_by_pk?: Maybe<Lookalike_Seed_Source>;
  /** fetch data from the table in a streaming manner: "lookalike_seed_source" */
  lookalike_seed_source_stream: Array<Lookalike_Seed_Source>;
  /** fetch data from the table: "lookalike_segment_seed_aggregate" */
  lookalike_segment_seed_aggregate: Array<Lookalike_Segment_Seed_Aggregate>;
  /** fetch aggregated fields from the table: "lookalike_segment_seed_aggregate" */
  lookalike_segment_seed_aggregate_aggregate: Lookalike_Segment_Seed_Aggregate_Aggregate;
  /** fetch data from the table: "lookalike_segment_seed_aggregate" using primary key columns */
  lookalike_segment_seed_aggregate_by_pk?: Maybe<Lookalike_Segment_Seed_Aggregate>;
  /** fetch data from the table in a streaming manner: "lookalike_segment_seed_aggregate" */
  lookalike_segment_seed_aggregate_stream: Array<Lookalike_Segment_Seed_Aggregate>;
  /** fetch data from the table: "lookalike_segment_similarity" */
  lookalike_segment_similarity: Array<Lookalike_Segment_Similarity>;
  /** fetch aggregated fields from the table: "lookalike_segment_similarity" */
  lookalike_segment_similarity_aggregate: Lookalike_Segment_Similarity_Aggregate;
  /** fetch data from the table: "lookalike_segment_similarity" using primary key columns */
  lookalike_segment_similarity_by_pk?: Maybe<Lookalike_Segment_Similarity>;
  /** fetch data from the table in a streaming manner: "lookalike_segment_similarity" */
  lookalike_segment_similarity_stream: Array<Lookalike_Segment_Similarity>;
  /** fetch data from the table: "provider" */
  provider: Array<Provider>;
  /** fetch aggregated fields from the table: "provider" */
  provider_aggregate: Provider_Aggregate;
  /** fetch data from the table: "provider" using primary key columns */
  provider_by_pk?: Maybe<Provider>;
  /** fetch data from the table in a streaming manner: "provider" */
  provider_stream: Array<Provider>;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  region_aggregate: Region_Aggregate;
  /** fetch data from the table: "region" using primary key columns */
  region_by_pk?: Maybe<Region>;
  /** fetch data from the table in a streaming manner: "region" */
  region_stream: Array<Region>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table in a streaming manner: "role" */
  role_stream: Array<Role>;
  /** fetch data from the table: "segment" */
  segment: Array<Segment>;
  /** fetch aggregated fields from the table: "segment" */
  segment_aggregate: Segment_Aggregate;
  /** fetch data from the table: "segment" using primary key columns */
  segment_by_pk?: Maybe<Segment>;
  /** fetch data from the table: "segment_country" */
  segment_country: Array<Segment_Country>;
  /** fetch aggregated fields from the table: "segment_country" */
  segment_country_aggregate: Segment_Country_Aggregate;
  /** fetch data from the table: "segment_country" using primary key columns */
  segment_country_by_pk?: Maybe<Segment_Country>;
  /** fetch data from the table in a streaming manner: "segment_country" */
  segment_country_stream: Array<Segment_Country>;
  /** fetch data from the table: "segment_region" */
  segment_region: Array<Segment_Region>;
  /** fetch aggregated fields from the table: "segment_region" */
  segment_region_aggregate: Segment_Region_Aggregate;
  /** fetch data from the table: "segment_region" using primary key columns */
  segment_region_by_pk?: Maybe<Segment_Region>;
  /** fetch data from the table in a streaming manner: "segment_region" */
  segment_region_stream: Array<Segment_Region>;
  /** fetch data from the table in a streaming manner: "segment" */
  segment_stream: Array<Segment>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
};


export type Subscription_RootAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAccount_Feature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Feature_Flags_Order_By>>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};


export type Subscription_RootAccount_Feature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Feature_Flags_Order_By>>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};


export type Subscription_RootAccount_Feature_Flags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAccount_Feature_Flags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Feature_Flags_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Feature_Flags_Bool_Exp>;
};


export type Subscription_RootAccount_ListArgs = {
  distinct_on?: InputMaybe<Array<Account_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_List_Order_By>>;
  where?: InputMaybe<Account_List_Bool_Exp>;
};


export type Subscription_RootAccount_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_List_Order_By>>;
  where?: InputMaybe<Account_List_Bool_Exp>;
};


export type Subscription_RootAccount_List_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_List_Bool_Exp>;
};


export type Subscription_RootAccount_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


export type Subscription_RootAccount_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Account_Provider_Order_By>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


export type Subscription_RootAccount_Provider_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAccount_Provider_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Provider_Bool_Exp>;
};


export type Subscription_RootAccount_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAudienceArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


export type Subscription_RootAudience_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


export type Subscription_RootAudience_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAudience_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


export type Subscription_RootAudience_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Segment_Order_By>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


export type Subscription_RootAudience_Segment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAudience_Segment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audience_Segment_Stream_Cursor_Input>>;
  where?: InputMaybe<Audience_Segment_Bool_Exp>;
};


export type Subscription_RootAudience_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audience_Stream_Cursor_Input>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


export type Subscription_RootBq_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Bq_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bq_Resource_Order_By>>;
  where?: InputMaybe<Bq_Resource_Bool_Exp>;
};


export type Subscription_RootBq_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bq_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bq_Resource_Order_By>>;
  where?: InputMaybe<Bq_Resource_Bool_Exp>;
};


export type Subscription_RootBq_Resource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBq_Resource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bq_Resource_Stream_Cursor_Input>>;
  where?: InputMaybe<Bq_Resource_Bool_Exp>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootExportArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


export type Subscription_RootExport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Export_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Order_By>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


export type Subscription_RootExport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootExport_Status_TimelineArgs = {
  distinct_on?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Status_Timeline_Order_By>>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};


export type Subscription_RootExport_Status_Timeline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Export_Status_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Status_Timeline_Order_By>>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};


export type Subscription_RootExport_Status_Timeline_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootExport_Status_Timeline_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Export_Status_Timeline_Stream_Cursor_Input>>;
  where?: InputMaybe<Export_Status_Timeline_Bool_Exp>;
};


export type Subscription_RootExport_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Export_Stream_Cursor_Input>>;
  where?: InputMaybe<Export_Bool_Exp>;
};


export type Subscription_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootFeature_Flags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feature_Flags_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootLookalike_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Definition_Order_By>>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};


export type Subscription_RootLookalike_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Definition_Order_By>>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};


export type Subscription_RootLookalike_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLookalike_Definition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lookalike_Definition_Stream_Cursor_Input>>;
  where?: InputMaybe<Lookalike_Definition_Bool_Exp>;
};


export type Subscription_RootLookalike_Job_RunArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Job_Run_Order_By>>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};


export type Subscription_RootLookalike_Job_Run_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Job_Run_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Job_Run_Order_By>>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};


export type Subscription_RootLookalike_Job_Run_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLookalike_Job_Run_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lookalike_Job_Run_Stream_Cursor_Input>>;
  where?: InputMaybe<Lookalike_Job_Run_Bool_Exp>;
};


export type Subscription_RootLookalike_Seed_SourceArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Seed_Source_Order_By>>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};


export type Subscription_RootLookalike_Seed_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Seed_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Seed_Source_Order_By>>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};


export type Subscription_RootLookalike_Seed_Source_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLookalike_Seed_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lookalike_Seed_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Lookalike_Seed_Source_Bool_Exp>;
};


export type Subscription_RootLookalike_Segment_Seed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
};


export type Subscription_RootLookalike_Segment_Seed_Aggregate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Seed_Aggregate_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
};


export type Subscription_RootLookalike_Segment_Seed_Aggregate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLookalike_Segment_Seed_Aggregate_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lookalike_Segment_Seed_Aggregate_Stream_Cursor_Input>>;
  where?: InputMaybe<Lookalike_Segment_Seed_Aggregate_Bool_Exp>;
};


export type Subscription_RootLookalike_Segment_SimilarityArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Similarity_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};


export type Subscription_RootLookalike_Segment_Similarity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookalike_Segment_Similarity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookalike_Segment_Similarity_Order_By>>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};


export type Subscription_RootLookalike_Segment_Similarity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLookalike_Segment_Similarity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lookalike_Segment_Similarity_Stream_Cursor_Input>>;
  where?: InputMaybe<Lookalike_Segment_Similarity_Bool_Exp>;
};


export type Subscription_RootProviderArgs = {
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Subscription_RootProvider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Provider_Order_By>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Subscription_RootProvider_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootProvider_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Bool_Exp>;
};


export type Subscription_RootRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegion_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Subscription_RootRegion_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootRole_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootSegmentArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Subscription_RootSegment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Subscription_RootSegment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSegment_CountryArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


export type Subscription_RootSegment_Country_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Country_Order_By>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


export type Subscription_RootSegment_Country_By_PkArgs = {
  country_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};


export type Subscription_RootSegment_Country_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Segment_Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Segment_Country_Bool_Exp>;
};


export type Subscription_RootSegment_RegionArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


export type Subscription_RootSegment_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Segment_Region_Order_By>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


export type Subscription_RootSegment_Region_By_PkArgs = {
  region_code: Scalars['String']['input'];
  segment_id: Scalars['uuid']['input'];
};


export type Subscription_RootSegment_Region_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Segment_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Segment_Region_Bool_Exp>;
};


export type Subscription_RootSegment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Segment_Stream_Cursor_Input>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** OpenAudience users (1:1 to Firebase Auth / CICP) */
export type User = {
  __typename?: 'user';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid']['output'];
  /** An array relationship */
  audiences: Array<Audience>;
  /** An aggregate relationship */
  audiences_aggregate: Audience_Aggregate;
  created_date: Scalars['timestamptz']['output'];
  email_address: Scalars['String']['output'];
  /** When the user (or in more cases the service account) is set to expire */
  expires_at?: Maybe<Scalars['String']['output']>;
  feature_flags?: Maybe<Scalars['jsonb']['output']>;
  firebase_id: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** Whether the user is active (eg, not disabled) */
  is_active: Scalars['Boolean']['output'];
  is_service_account: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  /** Last time the user signed on */
  last_signin_time?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  terms_and_conditions_acceptance_date?: Maybe<Scalars['timestamptz']['output']>;
  terms_and_conditions_accepted: Scalars['Boolean']['output'];
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};


/** OpenAudience users (1:1 to Firebase Auth / CICP) */
export type UserAudiencesArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


/** OpenAudience users (1:1 to Firebase Auth / CICP) */
export type UserAudiences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audience_Order_By>>;
  where?: InputMaybe<Audience_Bool_Exp>;
};


/** OpenAudience users (1:1 to Firebase Auth / CICP) */
export type UserFeature_FlagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

export type User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Aggregate_Bool_Exp_Count>;
};

export type User_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user" */
export type User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "user" */
export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  audiences?: InputMaybe<Audience_Bool_Exp>;
  audiences_aggregate?: InputMaybe<Audience_Aggregate_Bool_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  feature_flags?: InputMaybe<Jsonb_Comparison_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_service_account?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  terms_and_conditions_acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  terms_and_conditions_accepted?: InputMaybe<Boolean_Comparison_Exp>;
  updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user" */
export const User_Constraint = {
  /** unique or primary key constraint on columns "email_address" */
  UserEmailAddressKey: 'user_email_address_key',
  /** unique or primary key constraint on columns "firebase_id" */
  UserFirebaseIdKey: 'user_firebase_id_key',
  /** unique or primary key constraint on columns "id" */
  UserIdKey: 'user_id_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey: 'user_pkey'
} as const;

export type User_Constraint = typeof User_Constraint[keyof typeof User_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  feature_flags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  feature_flags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  feature_flags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  audiences?: InputMaybe<Audience_Arr_Rel_Insert_Input>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_service_account?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  terms_and_conditions_acceptance_date?: InputMaybe<Scalars['timestamptz']['input']>;
  terms_and_conditions_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  terms_and_conditions_acceptance_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "user" */
export type User_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  terms_and_conditions_acceptance_date?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_date?: Maybe<Scalars['timestamptz']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  terms_and_conditions_acceptance_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_date?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "user" */
export type User_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  terms_and_conditions_acceptance_date?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  audiences_aggregate?: InputMaybe<Audience_Aggregate_Order_By>;
  created_date?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  feature_flags?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_service_account?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  terms_and_conditions_acceptance_date?: InputMaybe<Order_By>;
  terms_and_conditions_accepted?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user" */
export const User_Select_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  EmailAddress: 'email_address',
  /** column name */
  FeatureFlags: 'feature_flags',
  /** column name */
  FirebaseId: 'firebase_id',
  /** column name */
  FirstName: 'first_name',
  /** column name */
  Id: 'id',
  /** column name */
  IsServiceAccount: 'is_service_account',
  /** column name */
  LastName: 'last_name',
  /** column name */
  Role: 'role',
  /** column name */
  TermsAndConditionsAcceptanceDate: 'terms_and_conditions_acceptance_date',
  /** column name */
  TermsAndConditionsAccepted: 'terms_and_conditions_accepted',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type User_Select_Column = typeof User_Select_Column[keyof typeof User_Select_Column];
/** select "user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user" */
export const User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsServiceAccount: 'is_service_account',
  /** column name */
  TermsAndConditionsAccepted: 'terms_and_conditions_accepted'
} as const;

export type User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user" */
export const User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsServiceAccount: 'is_service_account',
  /** column name */
  TermsAndConditionsAccepted: 'terms_and_conditions_accepted'
} as const;

export type User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "user" */
export type User_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_service_account?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  terms_and_conditions_acceptance_date?: InputMaybe<Scalars['timestamptz']['input']>;
  terms_and_conditions_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_date?: InputMaybe<Scalars['timestamptz']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_service_account?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  terms_and_conditions_acceptance_date?: InputMaybe<Scalars['timestamptz']['input']>;
  terms_and_conditions_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  updated_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user" */
export const User_Update_Column = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  CreatedDate: 'created_date',
  /** column name */
  EmailAddress: 'email_address',
  /** column name */
  FeatureFlags: 'feature_flags',
  /** column name */
  FirebaseId: 'firebase_id',
  /** column name */
  FirstName: 'first_name',
  /** column name */
  Id: 'id',
  /** column name */
  IsServiceAccount: 'is_service_account',
  /** column name */
  LastName: 'last_name',
  /** column name */
  Role: 'role',
  /** column name */
  TermsAndConditionsAcceptanceDate: 'terms_and_conditions_acceptance_date',
  /** column name */
  TermsAndConditionsAccepted: 'terms_and_conditions_accepted',
  /** column name */
  UpdatedDate: 'updated_date'
} as const;

export type User_Update_Column = typeof User_Update_Column[keyof typeof User_Update_Column];
export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};
